
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree325"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree325"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("19JKY", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0d7a20026e831cb8$export$ffb0004e005737fa; }, function (v) { return $0d7a20026e831cb8$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0d7a20026e831cb8$export$34b9dba7ce09269b; }, function (v) { return $0d7a20026e831cb8$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0d7a20026e831cb8$export$25062201e9e25d76; }, function (v) { return $0d7a20026e831cb8$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0d7a20026e831cb8$export$ffb0004e005737fa;
var $0d7a20026e831cb8$export$34b9dba7ce09269b;
var $0d7a20026e831cb8$export$25062201e9e25d76;
"use strict";
var $0d7a20026e831cb8$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $0d7a20026e831cb8$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $0d7a20026e831cb8$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $0d7a20026e831cb8$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$0d7a20026e831cb8$export$ffb0004e005737fa = $0d7a20026e831cb8$var$REACT_FRAGMENT_TYPE;
$0d7a20026e831cb8$export$34b9dba7ce09269b = $0d7a20026e831cb8$var$jsxProd;
$0d7a20026e831cb8$export$25062201e9e25d76 = $0d7a20026e831cb8$var$jsxProd;

});

parcelRegister("8bG4B", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $5f5ffcb0b60a9076$export$9c16c1426311996d; }, function (v) { return $5f5ffcb0b60a9076$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $5f5ffcb0b60a9076$export$dca3b0875bd9a954; }, function (v) { return $5f5ffcb0b60a9076$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $5f5ffcb0b60a9076$export$16fa2f45be04daa8; }, function (v) { return $5f5ffcb0b60a9076$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $5f5ffcb0b60a9076$export$ffb0004e005737fa; }, function (v) { return $5f5ffcb0b60a9076$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $5f5ffcb0b60a9076$export$e2c29f18771995cb; }, function (v) { return $5f5ffcb0b60a9076$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $5f5ffcb0b60a9076$export$221d75b3f55bb0bd; }, function (v) { return $5f5ffcb0b60a9076$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $5f5ffcb0b60a9076$export$5f8d39834fd61797; }, function (v) { return $5f5ffcb0b60a9076$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $5f5ffcb0b60a9076$export$74bf444e3cd11ea5; }, function (v) { return $5f5ffcb0b60a9076$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $5f5ffcb0b60a9076$export$1ced07cd6b1985ce; }, function (v) { return $5f5ffcb0b60a9076$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $5f5ffcb0b60a9076$export$abd8e32b826d7ea7; }, function (v) { return $5f5ffcb0b60a9076$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $5f5ffcb0b60a9076$export$69a3209f1a06c04d; }, function (v) { return $5f5ffcb0b60a9076$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $5f5ffcb0b60a9076$export$8c538325882c7eec; }, function (v) { return $5f5ffcb0b60a9076$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $5f5ffcb0b60a9076$export$e530037191fcd5d7; }, function (v) { return $5f5ffcb0b60a9076$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $5f5ffcb0b60a9076$export$fd42f52fd3ae1109; }, function (v) { return $5f5ffcb0b60a9076$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $5f5ffcb0b60a9076$export$c8a8987d4410bf2d; }, function (v) { return $5f5ffcb0b60a9076$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $5f5ffcb0b60a9076$export$7d1e3a5e95ceca43; }, function (v) { return $5f5ffcb0b60a9076$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $5f5ffcb0b60a9076$export$257a8862b851cb5b; }, function (v) { return $5f5ffcb0b60a9076$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $5f5ffcb0b60a9076$export$a8257692ac88316c; }, function (v) { return $5f5ffcb0b60a9076$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $5f5ffcb0b60a9076$export$488013bae63b21da; }, function (v) { return $5f5ffcb0b60a9076$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $5f5ffcb0b60a9076$export$7c73462e0d25e514; }, function (v) { return $5f5ffcb0b60a9076$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $5f5ffcb0b60a9076$export$7568632d0d33d16d; }, function (v) { return $5f5ffcb0b60a9076$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $5f5ffcb0b60a9076$export$f93f40ac0ca7e3a8; }, function (v) { return $5f5ffcb0b60a9076$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $5f5ffcb0b60a9076$export$1f96ae73734a86cc; }, function (v) { return $5f5ffcb0b60a9076$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $5f5ffcb0b60a9076$export$9a47ced3238df325; }, function (v) { return $5f5ffcb0b60a9076$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $5f5ffcb0b60a9076$export$35808ee640e87ca7; }, function (v) { return $5f5ffcb0b60a9076$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $5f5ffcb0b60a9076$export$fae74005e78b1a27; }, function (v) { return $5f5ffcb0b60a9076$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $5f5ffcb0b60a9076$export$dc8fbce3eb94dc1e; }, function (v) { return $5f5ffcb0b60a9076$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $5f5ffcb0b60a9076$export$6a7bc4e911dc01cf; }, function (v) { return $5f5ffcb0b60a9076$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $5f5ffcb0b60a9076$export$6d9c69b0de29b591; }, function (v) { return $5f5ffcb0b60a9076$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $5f5ffcb0b60a9076$export$7f54fc3180508a52; }, function (v) { return $5f5ffcb0b60a9076$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $5f5ffcb0b60a9076$export$f680877a34711e37; }, function (v) { return $5f5ffcb0b60a9076$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $5f5ffcb0b60a9076$export$d5a552a76deda3c2; }, function (v) { return $5f5ffcb0b60a9076$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $5f5ffcb0b60a9076$export$aaabe4eda9ed9969; }, function (v) { return $5f5ffcb0b60a9076$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $5f5ffcb0b60a9076$export$e5c5a5f917a5871c; }, function (v) { return $5f5ffcb0b60a9076$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $5f5ffcb0b60a9076$export$1538c33de8887b59; }, function (v) { return $5f5ffcb0b60a9076$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $5f5ffcb0b60a9076$export$fca7f784ae7a249a; }, function (v) { return $5f5ffcb0b60a9076$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $5f5ffcb0b60a9076$export$13e3392192263954; }, function (v) { return $5f5ffcb0b60a9076$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $5f5ffcb0b60a9076$export$b8f5890fc79d6aca; }, function (v) { return $5f5ffcb0b60a9076$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $5f5ffcb0b60a9076$export$60241385465d0a34; }, function (v) { return $5f5ffcb0b60a9076$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $5f5ffcb0b60a9076$export$306c0aa65ff9ec16; }, function (v) { return $5f5ffcb0b60a9076$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $5f5ffcb0b60a9076$export$7b286972b8d8ccbf; }, function (v) { return $5f5ffcb0b60a9076$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $5f5ffcb0b60a9076$export$83d89fbfd8236492; }, function (v) { return $5f5ffcb0b60a9076$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5f5ffcb0b60a9076$export$9c16c1426311996d;
var $5f5ffcb0b60a9076$export$dca3b0875bd9a954;
var $5f5ffcb0b60a9076$export$16fa2f45be04daa8;
var $5f5ffcb0b60a9076$export$ffb0004e005737fa;
var $5f5ffcb0b60a9076$export$e2c29f18771995cb;
var $5f5ffcb0b60a9076$export$221d75b3f55bb0bd;
var $5f5ffcb0b60a9076$export$5f8d39834fd61797;
var $5f5ffcb0b60a9076$export$74bf444e3cd11ea5;
var $5f5ffcb0b60a9076$export$1ced07cd6b1985ce;
var $5f5ffcb0b60a9076$export$abd8e32b826d7ea7;
var $5f5ffcb0b60a9076$export$69a3209f1a06c04d;
var $5f5ffcb0b60a9076$export$8c538325882c7eec;
var $5f5ffcb0b60a9076$export$e530037191fcd5d7;
var $5f5ffcb0b60a9076$export$fd42f52fd3ae1109;
var $5f5ffcb0b60a9076$export$c8a8987d4410bf2d;
var $5f5ffcb0b60a9076$export$7d1e3a5e95ceca43;
var $5f5ffcb0b60a9076$export$257a8862b851cb5b;
var $5f5ffcb0b60a9076$export$a8257692ac88316c;
var $5f5ffcb0b60a9076$export$488013bae63b21da;
var $5f5ffcb0b60a9076$export$7c73462e0d25e514;
var $5f5ffcb0b60a9076$export$7568632d0d33d16d;
var $5f5ffcb0b60a9076$export$f93f40ac0ca7e3a8;
var $5f5ffcb0b60a9076$export$1f96ae73734a86cc;
var $5f5ffcb0b60a9076$export$9a47ced3238df325;
var $5f5ffcb0b60a9076$export$35808ee640e87ca7;
var $5f5ffcb0b60a9076$export$fae74005e78b1a27;
var $5f5ffcb0b60a9076$export$dc8fbce3eb94dc1e;
var $5f5ffcb0b60a9076$export$6a7bc4e911dc01cf;
var $5f5ffcb0b60a9076$export$6d9c69b0de29b591;
var $5f5ffcb0b60a9076$export$7f54fc3180508a52;
var $5f5ffcb0b60a9076$export$f680877a34711e37;
var $5f5ffcb0b60a9076$export$d5a552a76deda3c2;
var $5f5ffcb0b60a9076$export$aaabe4eda9ed9969;
var $5f5ffcb0b60a9076$export$e5c5a5f917a5871c;
var $5f5ffcb0b60a9076$export$1538c33de8887b59;
var $5f5ffcb0b60a9076$export$fca7f784ae7a249a;
var $5f5ffcb0b60a9076$export$13e3392192263954;
var $5f5ffcb0b60a9076$export$b8f5890fc79d6aca;
var $5f5ffcb0b60a9076$export$60241385465d0a34;
var $5f5ffcb0b60a9076$export$306c0aa65ff9ec16;
var $5f5ffcb0b60a9076$export$7b286972b8d8ccbf;
var $5f5ffcb0b60a9076$export$83d89fbfd8236492;
"use strict";
var $5f5ffcb0b60a9076$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $5f5ffcb0b60a9076$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $5f5ffcb0b60a9076$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $5f5ffcb0b60a9076$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $5f5ffcb0b60a9076$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $5f5ffcb0b60a9076$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $5f5ffcb0b60a9076$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $5f5ffcb0b60a9076$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $5f5ffcb0b60a9076$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $5f5ffcb0b60a9076$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $5f5ffcb0b60a9076$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $5f5ffcb0b60a9076$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $5f5ffcb0b60a9076$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $5f5ffcb0b60a9076$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $5f5ffcb0b60a9076$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$5f5ffcb0b60a9076$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $5f5ffcb0b60a9076$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $5f5ffcb0b60a9076$var$assign = Object.assign, $5f5ffcb0b60a9076$var$emptyObject = {};
function $5f5ffcb0b60a9076$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $5f5ffcb0b60a9076$var$emptyObject;
    this.updater = updater || $5f5ffcb0b60a9076$var$ReactNoopUpdateQueue;
}
$5f5ffcb0b60a9076$var$Component.prototype.isReactComponent = {};
$5f5ffcb0b60a9076$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$5f5ffcb0b60a9076$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $5f5ffcb0b60a9076$var$ComponentDummy() {}
$5f5ffcb0b60a9076$var$ComponentDummy.prototype = $5f5ffcb0b60a9076$var$Component.prototype;
function $5f5ffcb0b60a9076$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $5f5ffcb0b60a9076$var$emptyObject;
    this.updater = updater || $5f5ffcb0b60a9076$var$ReactNoopUpdateQueue;
}
var $5f5ffcb0b60a9076$var$pureComponentPrototype = $5f5ffcb0b60a9076$var$PureComponent.prototype = new $5f5ffcb0b60a9076$var$ComponentDummy();
$5f5ffcb0b60a9076$var$pureComponentPrototype.constructor = $5f5ffcb0b60a9076$var$PureComponent;
$5f5ffcb0b60a9076$var$assign($5f5ffcb0b60a9076$var$pureComponentPrototype, $5f5ffcb0b60a9076$var$Component.prototype);
$5f5ffcb0b60a9076$var$pureComponentPrototype.isPureReactComponent = !0;
var $5f5ffcb0b60a9076$var$isArrayImpl = Array.isArray;
function $5f5ffcb0b60a9076$var$noop() {}
var $5f5ffcb0b60a9076$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $5f5ffcb0b60a9076$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $5f5ffcb0b60a9076$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $5f5ffcb0b60a9076$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $5f5ffcb0b60a9076$var$cloneAndReplaceKey(oldElement, newKey) {
    return $5f5ffcb0b60a9076$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $5f5ffcb0b60a9076$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $5f5ffcb0b60a9076$var$REACT_ELEMENT_TYPE;
}
function $5f5ffcb0b60a9076$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $5f5ffcb0b60a9076$var$userProvidedKeyEscapeRegex = /\/+/g;
function $5f5ffcb0b60a9076$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $5f5ffcb0b60a9076$var$escape("" + element.key) : index.toString(36);
}
function $5f5ffcb0b60a9076$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($5f5ffcb0b60a9076$var$noop, $5f5ffcb0b60a9076$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $5f5ffcb0b60a9076$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $5f5ffcb0b60a9076$var$REACT_ELEMENT_TYPE:
                case $5f5ffcb0b60a9076$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $5f5ffcb0b60a9076$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $5f5ffcb0b60a9076$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $5f5ffcb0b60a9076$var$getElementKey(children, 0) : nameSoFar, $5f5ffcb0b60a9076$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($5f5ffcb0b60a9076$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $5f5ffcb0b60a9076$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($5f5ffcb0b60a9076$var$isValidElement(callback) && (callback = $5f5ffcb0b60a9076$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($5f5ffcb0b60a9076$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($5f5ffcb0b60a9076$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $5f5ffcb0b60a9076$var$getElementKey(nameSoFar, i), invokeCallback += $5f5ffcb0b60a9076$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $5f5ffcb0b60a9076$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $5f5ffcb0b60a9076$var$getElementKey(nameSoFar, i++), invokeCallback += $5f5ffcb0b60a9076$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $5f5ffcb0b60a9076$var$mapIntoArray($5f5ffcb0b60a9076$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $5f5ffcb0b60a9076$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $5f5ffcb0b60a9076$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $5f5ffcb0b60a9076$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $5f5ffcb0b60a9076$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $5f5ffcb0b60a9076$var$Children = {
    map: $5f5ffcb0b60a9076$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $5f5ffcb0b60a9076$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $5f5ffcb0b60a9076$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $5f5ffcb0b60a9076$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$5f5ffcb0b60a9076$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$5f5ffcb0b60a9076$export$9c16c1426311996d = $5f5ffcb0b60a9076$var$REACT_ACTIVITY_TYPE;
$5f5ffcb0b60a9076$export$dca3b0875bd9a954 = $5f5ffcb0b60a9076$var$Children;
$5f5ffcb0b60a9076$export$16fa2f45be04daa8 = $5f5ffcb0b60a9076$var$Component;
$5f5ffcb0b60a9076$export$ffb0004e005737fa = $5f5ffcb0b60a9076$var$REACT_FRAGMENT_TYPE;
$5f5ffcb0b60a9076$export$e2c29f18771995cb = $5f5ffcb0b60a9076$var$REACT_PROFILER_TYPE;
$5f5ffcb0b60a9076$export$221d75b3f55bb0bd = $5f5ffcb0b60a9076$var$PureComponent;
$5f5ffcb0b60a9076$export$5f8d39834fd61797 = $5f5ffcb0b60a9076$var$REACT_STRICT_MODE_TYPE;
$5f5ffcb0b60a9076$export$74bf444e3cd11ea5 = $5f5ffcb0b60a9076$var$REACT_SUSPENSE_TYPE;
$5f5ffcb0b60a9076$export$1ced07cd6b1985ce = $5f5ffcb0b60a9076$var$ReactSharedInternals;
$5f5ffcb0b60a9076$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$5f5ffcb0b60a9076$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$5f5ffcb0b60a9076$export$8c538325882c7eec = function() {
    return null;
};
$5f5ffcb0b60a9076$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $5f5ffcb0b60a9076$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$5f5ffcb0b60a9076$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $5f5ffcb0b60a9076$var$ReactElement(element.type, key, props);
};
$5f5ffcb0b60a9076$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $5f5ffcb0b60a9076$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $5f5ffcb0b60a9076$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$5f5ffcb0b60a9076$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$5f5ffcb0b60a9076$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $5f5ffcb0b60a9076$var$ReactElement(type, key, props);
};
$5f5ffcb0b60a9076$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$5f5ffcb0b60a9076$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $5f5ffcb0b60a9076$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$5f5ffcb0b60a9076$export$a8257692ac88316c = $5f5ffcb0b60a9076$var$isValidElement;
$5f5ffcb0b60a9076$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $5f5ffcb0b60a9076$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $5f5ffcb0b60a9076$var$lazyInitializer
    };
};
$5f5ffcb0b60a9076$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $5f5ffcb0b60a9076$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$5f5ffcb0b60a9076$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $5f5ffcb0b60a9076$var$ReactSharedInternals.T, currentTransition = {};
    $5f5ffcb0b60a9076$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $5f5ffcb0b60a9076$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($5f5ffcb0b60a9076$var$noop, $5f5ffcb0b60a9076$var$reportGlobalError);
    } catch (error) {
        $5f5ffcb0b60a9076$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $5f5ffcb0b60a9076$var$ReactSharedInternals.T = prevTransition;
    }
};
$5f5ffcb0b60a9076$export$f93f40ac0ca7e3a8 = function() {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useCacheRefresh();
};
$5f5ffcb0b60a9076$export$1f96ae73734a86cc = function(usable) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.use(usable);
};
$5f5ffcb0b60a9076$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$5f5ffcb0b60a9076$export$35808ee640e87ca7 = function(callback, deps) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$5f5ffcb0b60a9076$export$fae74005e78b1a27 = function(Context) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useContext(Context);
};
$5f5ffcb0b60a9076$export$dc8fbce3eb94dc1e = function() {};
$5f5ffcb0b60a9076$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$5f5ffcb0b60a9076$export$6d9c69b0de29b591 = function(create, deps) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useEffect(create, deps);
};
$5f5ffcb0b60a9076$export$7f54fc3180508a52 = function(callback) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$5f5ffcb0b60a9076$export$f680877a34711e37 = function() {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useId();
};
$5f5ffcb0b60a9076$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$5f5ffcb0b60a9076$export$aaabe4eda9ed9969 = function(create, deps) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$5f5ffcb0b60a9076$export$e5c5a5f917a5871c = function(create, deps) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$5f5ffcb0b60a9076$export$1538c33de8887b59 = function(create, deps) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useMemo(create, deps);
};
$5f5ffcb0b60a9076$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$5f5ffcb0b60a9076$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$5f5ffcb0b60a9076$export$b8f5890fc79d6aca = function(initialValue) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useRef(initialValue);
};
$5f5ffcb0b60a9076$export$60241385465d0a34 = function(initialState) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useState(initialState);
};
$5f5ffcb0b60a9076$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$5f5ffcb0b60a9076$export$7b286972b8d8ccbf = function() {
    return $5f5ffcb0b60a9076$var$ReactSharedInternals.H.useTransition();
};
$5f5ffcb0b60a9076$export$83d89fbfd8236492 = "19.2.7";

});

parcelRegister("3HtyS", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $2b1c5193a94af2cd$export$882461b6382ed46c; }, function (v) { return $2b1c5193a94af2cd$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $2b1c5193a94af2cd$export$757ceba2d55c277e; }, function (v) { return $2b1c5193a94af2cd$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $2b1c5193a94af2cd$export$83d89fbfd8236492; }, function (v) { return $2b1c5193a94af2cd$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $2b1c5193a94af2cd$export$882461b6382ed46c;
var $2b1c5193a94af2cd$export$757ceba2d55c277e;
var $2b1c5193a94af2cd$export$83d89fbfd8236492;
"use strict";

var $5avyM = parcelRequire("5avyM");

var $kYCgE = parcelRequire("kYCgE");

var $kt8M1 = parcelRequire("kt8M1");
function $2b1c5193a94af2cd$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $2b1c5193a94af2cd$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $2b1c5193a94af2cd$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $2b1c5193a94af2cd$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $2b1c5193a94af2cd$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $2b1c5193a94af2cd$var$assertIsMounted(fiber) {
    if ($2b1c5193a94af2cd$var$getNearestMountedFiber(fiber) !== fiber) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(188));
}
function $2b1c5193a94af2cd$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $2b1c5193a94af2cd$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $2b1c5193a94af2cd$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $2b1c5193a94af2cd$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $2b1c5193a94af2cd$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $2b1c5193a94af2cd$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $2b1c5193a94af2cd$var$assign = Object.assign, $2b1c5193a94af2cd$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $2b1c5193a94af2cd$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $2b1c5193a94af2cd$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $2b1c5193a94af2cd$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $2b1c5193a94af2cd$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $2b1c5193a94af2cd$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $2b1c5193a94af2cd$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $2b1c5193a94af2cd$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $2b1c5193a94af2cd$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $2b1c5193a94af2cd$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $2b1c5193a94af2cd$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $2b1c5193a94af2cd$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $2b1c5193a94af2cd$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $2b1c5193a94af2cd$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $2b1c5193a94af2cd$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $2b1c5193a94af2cd$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $2b1c5193a94af2cd$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$2b1c5193a94af2cd$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $2b1c5193a94af2cd$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $2b1c5193a94af2cd$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $2b1c5193a94af2cd$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $2b1c5193a94af2cd$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $2b1c5193a94af2cd$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $2b1c5193a94af2cd$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $2b1c5193a94af2cd$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $2b1c5193a94af2cd$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $2b1c5193a94af2cd$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $2b1c5193a94af2cd$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $2b1c5193a94af2cd$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $2b1c5193a94af2cd$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $2b1c5193a94af2cd$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $2b1c5193a94af2cd$var$getComponentNameFromType(type.type) || "Memo";
        case $2b1c5193a94af2cd$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $2b1c5193a94af2cd$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $2b1c5193a94af2cd$var$isArrayImpl = Array.isArray, $2b1c5193a94af2cd$var$ReactSharedInternals = $kYCgE.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2b1c5193a94af2cd$var$ReactDOMSharedInternals = $kt8M1.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $2b1c5193a94af2cd$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $2b1c5193a94af2cd$var$valueStack = [], $2b1c5193a94af2cd$var$index = -1;
function $2b1c5193a94af2cd$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $2b1c5193a94af2cd$var$pop(cursor) {
    0 > $2b1c5193a94af2cd$var$index || (cursor.current = $2b1c5193a94af2cd$var$valueStack[$2b1c5193a94af2cd$var$index], $2b1c5193a94af2cd$var$valueStack[$2b1c5193a94af2cd$var$index] = null, $2b1c5193a94af2cd$var$index--);
}
function $2b1c5193a94af2cd$var$push(cursor, value) {
    $2b1c5193a94af2cd$var$index++;
    $2b1c5193a94af2cd$var$valueStack[$2b1c5193a94af2cd$var$index] = cursor.current;
    cursor.current = value;
}
var $2b1c5193a94af2cd$var$contextStackCursor = $2b1c5193a94af2cd$var$createCursor(null), $2b1c5193a94af2cd$var$contextFiberStackCursor = $2b1c5193a94af2cd$var$createCursor(null), $2b1c5193a94af2cd$var$rootInstanceStackCursor = $2b1c5193a94af2cd$var$createCursor(null), $2b1c5193a94af2cd$var$hostTransitionProviderCursor = $2b1c5193a94af2cd$var$createCursor(null);
function $2b1c5193a94af2cd$var$pushHostContainer(fiber, nextRootInstance) {
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$rootInstanceStackCursor, nextRootInstance);
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$contextFiberStackCursor, fiber);
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $2b1c5193a94af2cd$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $2b1c5193a94af2cd$var$getOwnHostContext(nextRootInstance), fiber = $2b1c5193a94af2cd$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$contextStackCursor);
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$contextStackCursor, fiber);
}
function $2b1c5193a94af2cd$var$popHostContainer() {
    $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$contextStackCursor);
    $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$contextFiberStackCursor);
    $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$rootInstanceStackCursor);
}
function $2b1c5193a94af2cd$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$hostTransitionProviderCursor, fiber);
    var context = $2b1c5193a94af2cd$var$contextStackCursor.current;
    var JSCompiler_inline_result = $2b1c5193a94af2cd$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$contextFiberStackCursor, fiber), $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$contextStackCursor, JSCompiler_inline_result));
}
function $2b1c5193a94af2cd$var$popHostContext(fiber) {
    $2b1c5193a94af2cd$var$contextFiberStackCursor.current === fiber && ($2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$contextStackCursor), $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$contextFiberStackCursor));
    $2b1c5193a94af2cd$var$hostTransitionProviderCursor.current === fiber && ($2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$hostTransitionProviderCursor), $2b1c5193a94af2cd$var$HostTransitionContext._currentValue = $2b1c5193a94af2cd$var$sharedNotPendingObject);
}
var $2b1c5193a94af2cd$var$prefix, $2b1c5193a94af2cd$var$suffix;
function $2b1c5193a94af2cd$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $2b1c5193a94af2cd$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $2b1c5193a94af2cd$var$prefix = match && match[1] || "";
        $2b1c5193a94af2cd$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $2b1c5193a94af2cd$var$prefix + name + $2b1c5193a94af2cd$var$suffix;
}
var $2b1c5193a94af2cd$var$reentry = !1;
function $2b1c5193a94af2cd$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $2b1c5193a94af2cd$var$reentry) return "";
    $2b1c5193a94af2cd$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $2b1c5193a94af2cd$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $2b1c5193a94af2cd$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $2b1c5193a94af2cd$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $2b1c5193a94af2cd$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $2b1c5193a94af2cd$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $2b1c5193a94af2cd$var$describeBuiltInComponentFrame("Suspense Fallback") : $2b1c5193a94af2cd$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $2b1c5193a94af2cd$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $2b1c5193a94af2cd$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $2b1c5193a94af2cd$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $2b1c5193a94af2cd$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $2b1c5193a94af2cd$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $2b1c5193a94af2cd$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $2b1c5193a94af2cd$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $2b1c5193a94af2cd$var$hasOwnProperty = Object.prototype.hasOwnProperty, $2b1c5193a94af2cd$var$scheduleCallback$3 = $5avyM.unstable_scheduleCallback, $2b1c5193a94af2cd$var$cancelCallback$1 = $5avyM.unstable_cancelCallback, $2b1c5193a94af2cd$var$shouldYield = $5avyM.unstable_shouldYield, $2b1c5193a94af2cd$var$requestPaint = $5avyM.unstable_requestPaint, $2b1c5193a94af2cd$var$now = $5avyM.unstable_now, $2b1c5193a94af2cd$var$getCurrentPriorityLevel = $5avyM.unstable_getCurrentPriorityLevel, $2b1c5193a94af2cd$var$ImmediatePriority = $5avyM.unstable_ImmediatePriority, $2b1c5193a94af2cd$var$UserBlockingPriority = $5avyM.unstable_UserBlockingPriority, $2b1c5193a94af2cd$var$NormalPriority$1 = $5avyM.unstable_NormalPriority, $2b1c5193a94af2cd$var$LowPriority = $5avyM.unstable_LowPriority, $2b1c5193a94af2cd$var$IdlePriority = $5avyM.unstable_IdlePriority, $2b1c5193a94af2cd$var$log$1 = $5avyM.log, $2b1c5193a94af2cd$var$unstable_setDisableYieldValue = $5avyM.unstable_setDisableYieldValue, $2b1c5193a94af2cd$var$rendererID = null, $2b1c5193a94af2cd$var$injectedHook = null;
function $2b1c5193a94af2cd$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $2b1c5193a94af2cd$var$log$1 && $2b1c5193a94af2cd$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($2b1c5193a94af2cd$var$injectedHook && "function" === typeof $2b1c5193a94af2cd$var$injectedHook.setStrictMode) try {
        $2b1c5193a94af2cd$var$injectedHook.setStrictMode($2b1c5193a94af2cd$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $2b1c5193a94af2cd$var$clz32 = Math.clz32 ? Math.clz32 : $2b1c5193a94af2cd$var$clz32Fallback, $2b1c5193a94af2cd$var$log = Math.log, $2b1c5193a94af2cd$var$LN2 = Math.LN2;
function $2b1c5193a94af2cd$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($2b1c5193a94af2cd$var$log(x) / $2b1c5193a94af2cd$var$LN2 | 0) | 0;
}
var $2b1c5193a94af2cd$var$nextTransitionUpdateLane = 256, $2b1c5193a94af2cd$var$nextTransitionDeferredLane = 262144, $2b1c5193a94af2cd$var$nextRetryLane = 4194304;
function $2b1c5193a94af2cd$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $2b1c5193a94af2cd$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $2b1c5193a94af2cd$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $2b1c5193a94af2cd$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2b1c5193a94af2cd$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $2b1c5193a94af2cd$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $2b1c5193a94af2cd$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $2b1c5193a94af2cd$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $2b1c5193a94af2cd$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $2b1c5193a94af2cd$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $2b1c5193a94af2cd$var$claimNextRetryLane() {
    var lane = $2b1c5193a94af2cd$var$nextRetryLane;
    $2b1c5193a94af2cd$var$nextRetryLane <<= 1;
    0 === ($2b1c5193a94af2cd$var$nextRetryLane & 62914560) && ($2b1c5193a94af2cd$var$nextRetryLane = 4194304);
    return lane;
}
function $2b1c5193a94af2cd$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $2b1c5193a94af2cd$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $2b1c5193a94af2cd$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $2b1c5193a94af2cd$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $2b1c5193a94af2cd$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $2b1c5193a94af2cd$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $2b1c5193a94af2cd$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $2b1c5193a94af2cd$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $2b1c5193a94af2cd$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $2b1c5193a94af2cd$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $2b1c5193a94af2cd$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $2b1c5193a94af2cd$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $2b1c5193a94af2cd$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $2b1c5193a94af2cd$var$resolveUpdatePriority() {
    var updatePriority = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $2b1c5193a94af2cd$var$getEventPriority(updatePriority.type);
}
function $2b1c5193a94af2cd$var$runWithPriority(priority, fn) {
    var previousPriority = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
    try {
        return $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $2b1c5193a94af2cd$var$randomKey = Math.random().toString(36).slice(2), $2b1c5193a94af2cd$var$internalInstanceKey = "__reactFiber$" + $2b1c5193a94af2cd$var$randomKey, $2b1c5193a94af2cd$var$internalPropsKey = "__reactProps$" + $2b1c5193a94af2cd$var$randomKey, $2b1c5193a94af2cd$var$internalContainerInstanceKey = "__reactContainer$" + $2b1c5193a94af2cd$var$randomKey, $2b1c5193a94af2cd$var$internalEventHandlersKey = "__reactEvents$" + $2b1c5193a94af2cd$var$randomKey, $2b1c5193a94af2cd$var$internalEventHandlerListenersKey = "__reactListeners$" + $2b1c5193a94af2cd$var$randomKey, $2b1c5193a94af2cd$var$internalEventHandlesSetKey = "__reactHandles$" + $2b1c5193a94af2cd$var$randomKey, $2b1c5193a94af2cd$var$internalRootNodeResourcesKey = "__reactResources$" + $2b1c5193a94af2cd$var$randomKey, $2b1c5193a94af2cd$var$internalHoistableMarker = "__reactMarker$" + $2b1c5193a94af2cd$var$randomKey;
function $2b1c5193a94af2cd$var$detachDeletedInstance(node) {
    delete node[$2b1c5193a94af2cd$var$internalInstanceKey];
    delete node[$2b1c5193a94af2cd$var$internalPropsKey];
    delete node[$2b1c5193a94af2cd$var$internalEventHandlersKey];
    delete node[$2b1c5193a94af2cd$var$internalEventHandlerListenersKey];
    delete node[$2b1c5193a94af2cd$var$internalEventHandlesSetKey];
}
function $2b1c5193a94af2cd$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$2b1c5193a94af2cd$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$2b1c5193a94af2cd$var$internalContainerInstanceKey] || parentNode[$2b1c5193a94af2cd$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $2b1c5193a94af2cd$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$2b1c5193a94af2cd$var$internalInstanceKey]) return parentNode;
                targetNode = $2b1c5193a94af2cd$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $2b1c5193a94af2cd$var$getInstanceFromNode(node) {
    if (node = node[$2b1c5193a94af2cd$var$internalInstanceKey] || node[$2b1c5193a94af2cd$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $2b1c5193a94af2cd$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(33));
}
function $2b1c5193a94af2cd$var$getResourcesFromRoot(root) {
    var resources = root[$2b1c5193a94af2cd$var$internalRootNodeResourcesKey];
    resources || (resources = root[$2b1c5193a94af2cd$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $2b1c5193a94af2cd$var$markNodeAsHoistable(node) {
    node[$2b1c5193a94af2cd$var$internalHoistableMarker] = !0;
}
var $2b1c5193a94af2cd$var$allNativeEvents = new Set(), $2b1c5193a94af2cd$var$registrationNameDependencies = {};
function $2b1c5193a94af2cd$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $2b1c5193a94af2cd$var$registerDirectEvent(registrationName, dependencies);
    $2b1c5193a94af2cd$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $2b1c5193a94af2cd$var$registerDirectEvent(registrationName, dependencies) {
    $2b1c5193a94af2cd$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$2b1c5193a94af2cd$var$allNativeEvents.add(dependencies[registrationName]);
}
var $2b1c5193a94af2cd$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $2b1c5193a94af2cd$var$illegalAttributeNameCache = {}, $2b1c5193a94af2cd$var$validatedAttributeNameCache = {};
function $2b1c5193a94af2cd$var$isAttributeNameSafe(attributeName) {
    if ($2b1c5193a94af2cd$var$hasOwnProperty.call($2b1c5193a94af2cd$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($2b1c5193a94af2cd$var$hasOwnProperty.call($2b1c5193a94af2cd$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($2b1c5193a94af2cd$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $2b1c5193a94af2cd$var$validatedAttributeNameCache[attributeName] = !0;
    $2b1c5193a94af2cd$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $2b1c5193a94af2cd$var$setValueForAttribute(node, name, value) {
    if ($2b1c5193a94af2cd$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $2b1c5193a94af2cd$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $2b1c5193a94af2cd$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $2b1c5193a94af2cd$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $2b1c5193a94af2cd$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $2b1c5193a94af2cd$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $2b1c5193a94af2cd$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $2b1c5193a94af2cd$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $2b1c5193a94af2cd$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $2b1c5193a94af2cd$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $2b1c5193a94af2cd$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $2b1c5193a94af2cd$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $2b1c5193a94af2cd$var$getToStringValue(value);
        } else element.value !== "" + $2b1c5193a94af2cd$var$getToStringValue(value) && (element.value = "" + $2b1c5193a94af2cd$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $2b1c5193a94af2cd$var$setDefaultValue(element, type, $2b1c5193a94af2cd$var$getToStringValue(value)) : null != defaultValue ? $2b1c5193a94af2cd$var$setDefaultValue(element, type, $2b1c5193a94af2cd$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $2b1c5193a94af2cd$var$getToStringValue(name) : element.removeAttribute("name");
}
function $2b1c5193a94af2cd$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $2b1c5193a94af2cd$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $2b1c5193a94af2cd$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $2b1c5193a94af2cd$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $2b1c5193a94af2cd$var$track(element);
}
function $2b1c5193a94af2cd$var$setDefaultValue(node, type, value) {
    "number" === type && $2b1c5193a94af2cd$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $2b1c5193a94af2cd$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $2b1c5193a94af2cd$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $2b1c5193a94af2cd$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $2b1c5193a94af2cd$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $2b1c5193a94af2cd$var$getToStringValue(defaultValue) : "";
}
function $2b1c5193a94af2cd$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(92));
            if ($2b1c5193a94af2cd$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $2b1c5193a94af2cd$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $2b1c5193a94af2cd$var$track(element);
}
function $2b1c5193a94af2cd$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $2b1c5193a94af2cd$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $2b1c5193a94af2cd$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $2b1c5193a94af2cd$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $2b1c5193a94af2cd$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $2b1c5193a94af2cd$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $2b1c5193a94af2cd$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $2b1c5193a94af2cd$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $2b1c5193a94af2cd$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $2b1c5193a94af2cd$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $2b1c5193a94af2cd$var$sanitizeURL(url) {
    return $2b1c5193a94af2cd$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $2b1c5193a94af2cd$var$noop$1() {}
var $2b1c5193a94af2cd$var$currentReplayingEvent = null;
function $2b1c5193a94af2cd$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $2b1c5193a94af2cd$var$restoreTarget = null, $2b1c5193a94af2cd$var$restoreQueue = null;
function $2b1c5193a94af2cd$var$restoreStateOfTarget(target) {
    var internalInstance = $2b1c5193a94af2cd$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$2b1c5193a94af2cd$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $2b1c5193a94af2cd$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$2b1c5193a94af2cd$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(90));
                            $2b1c5193a94af2cd$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $2b1c5193a94af2cd$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $2b1c5193a94af2cd$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $2b1c5193a94af2cd$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $2b1c5193a94af2cd$var$isInsideEventHandler = !1;
function $2b1c5193a94af2cd$var$batchedUpdates$1(fn, a, b) {
    if ($2b1c5193a94af2cd$var$isInsideEventHandler) return fn(a, b);
    $2b1c5193a94af2cd$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($2b1c5193a94af2cd$var$isInsideEventHandler = !1, null !== $2b1c5193a94af2cd$var$restoreTarget || null !== $2b1c5193a94af2cd$var$restoreQueue) {
            if ($2b1c5193a94af2cd$var$flushSyncWork$1(), $2b1c5193a94af2cd$var$restoreTarget && (a = $2b1c5193a94af2cd$var$restoreTarget, fn = $2b1c5193a94af2cd$var$restoreQueue, $2b1c5193a94af2cd$var$restoreQueue = $2b1c5193a94af2cd$var$restoreTarget = null, $2b1c5193a94af2cd$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$2b1c5193a94af2cd$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $2b1c5193a94af2cd$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$2b1c5193a94af2cd$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $2b1c5193a94af2cd$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $2b1c5193a94af2cd$var$passiveBrowserEventsSupported = !1;
if ($2b1c5193a94af2cd$var$canUseDOM) try {
    var $2b1c5193a94af2cd$var$options = {};
    Object.defineProperty($2b1c5193a94af2cd$var$options, "passive", {
        get: function() {
            $2b1c5193a94af2cd$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $2b1c5193a94af2cd$var$options, $2b1c5193a94af2cd$var$options);
    window.removeEventListener("test", $2b1c5193a94af2cd$var$options, $2b1c5193a94af2cd$var$options);
} catch (e) {
    $2b1c5193a94af2cd$var$passiveBrowserEventsSupported = !1;
}
var $2b1c5193a94af2cd$var$root = null, $2b1c5193a94af2cd$var$startText = null, $2b1c5193a94af2cd$var$fallbackText = null;
function $2b1c5193a94af2cd$var$getData() {
    if ($2b1c5193a94af2cd$var$fallbackText) return $2b1c5193a94af2cd$var$fallbackText;
    var start, startValue = $2b1c5193a94af2cd$var$startText, startLength = startValue.length, end, endValue = "value" in $2b1c5193a94af2cd$var$root ? $2b1c5193a94af2cd$var$root.value : $2b1c5193a94af2cd$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $2b1c5193a94af2cd$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $2b1c5193a94af2cd$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $2b1c5193a94af2cd$var$functionThatReturnsTrue() {
    return !0;
}
function $2b1c5193a94af2cd$var$functionThatReturnsFalse() {
    return !1;
}
function $2b1c5193a94af2cd$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $2b1c5193a94af2cd$var$functionThatReturnsTrue : $2b1c5193a94af2cd$var$functionThatReturnsFalse;
        this.isPropagationStopped = $2b1c5193a94af2cd$var$functionThatReturnsFalse;
        return this;
    }
    $2b1c5193a94af2cd$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $2b1c5193a94af2cd$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $2b1c5193a94af2cd$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $2b1c5193a94af2cd$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $2b1c5193a94af2cd$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $2b1c5193a94af2cd$var$SyntheticEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$EventInterface), $2b1c5193a94af2cd$var$UIEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$EventInterface, {
    view: 0,
    detail: 0
}), $2b1c5193a94af2cd$var$SyntheticUIEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$UIEventInterface), $2b1c5193a94af2cd$var$lastMovementX, $2b1c5193a94af2cd$var$lastMovementY, $2b1c5193a94af2cd$var$lastMouseEvent, $2b1c5193a94af2cd$var$MouseEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $2b1c5193a94af2cd$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $2b1c5193a94af2cd$var$lastMouseEvent && ($2b1c5193a94af2cd$var$lastMouseEvent && "mousemove" === event.type ? ($2b1c5193a94af2cd$var$lastMovementX = event.screenX - $2b1c5193a94af2cd$var$lastMouseEvent.screenX, $2b1c5193a94af2cd$var$lastMovementY = event.screenY - $2b1c5193a94af2cd$var$lastMouseEvent.screenY) : $2b1c5193a94af2cd$var$lastMovementY = $2b1c5193a94af2cd$var$lastMovementX = 0, $2b1c5193a94af2cd$var$lastMouseEvent = event);
        return $2b1c5193a94af2cd$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $2b1c5193a94af2cd$var$lastMovementY;
    }
}), $2b1c5193a94af2cd$var$SyntheticMouseEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$MouseEventInterface), $2b1c5193a94af2cd$var$DragEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$MouseEventInterface, {
    dataTransfer: 0
}), $2b1c5193a94af2cd$var$SyntheticDragEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$DragEventInterface), $2b1c5193a94af2cd$var$FocusEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$UIEventInterface, {
    relatedTarget: 0
}), $2b1c5193a94af2cd$var$SyntheticFocusEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$FocusEventInterface), $2b1c5193a94af2cd$var$AnimationEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2b1c5193a94af2cd$var$SyntheticAnimationEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$AnimationEventInterface), $2b1c5193a94af2cd$var$ClipboardEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $2b1c5193a94af2cd$var$SyntheticClipboardEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$ClipboardEventInterface), $2b1c5193a94af2cd$var$CompositionEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$EventInterface, {
    data: 0
}), $2b1c5193a94af2cd$var$SyntheticCompositionEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$CompositionEventInterface), $2b1c5193a94af2cd$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $2b1c5193a94af2cd$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $2b1c5193a94af2cd$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $2b1c5193a94af2cd$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $2b1c5193a94af2cd$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $2b1c5193a94af2cd$var$getEventModifierState() {
    return $2b1c5193a94af2cd$var$modifierStateGetter;
}
var $2b1c5193a94af2cd$var$KeyboardEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $2b1c5193a94af2cd$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $2b1c5193a94af2cd$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $2b1c5193a94af2cd$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $2b1c5193a94af2cd$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $2b1c5193a94af2cd$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $2b1c5193a94af2cd$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $2b1c5193a94af2cd$var$SyntheticKeyboardEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$KeyboardEventInterface), $2b1c5193a94af2cd$var$PointerEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $2b1c5193a94af2cd$var$SyntheticPointerEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$PointerEventInterface), $2b1c5193a94af2cd$var$TouchEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $2b1c5193a94af2cd$var$getEventModifierState
}), $2b1c5193a94af2cd$var$SyntheticTouchEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$TouchEventInterface), $2b1c5193a94af2cd$var$TransitionEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $2b1c5193a94af2cd$var$SyntheticTransitionEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$TransitionEventInterface), $2b1c5193a94af2cd$var$WheelEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $2b1c5193a94af2cd$var$SyntheticWheelEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$WheelEventInterface), $2b1c5193a94af2cd$var$ToggleEventInterface = $2b1c5193a94af2cd$var$assign({}, $2b1c5193a94af2cd$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $2b1c5193a94af2cd$var$SyntheticToggleEvent = $2b1c5193a94af2cd$var$createSyntheticEvent($2b1c5193a94af2cd$var$ToggleEventInterface), $2b1c5193a94af2cd$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $2b1c5193a94af2cd$var$canUseCompositionEvent = $2b1c5193a94af2cd$var$canUseDOM && "CompositionEvent" in window, $2b1c5193a94af2cd$var$documentMode = null;
$2b1c5193a94af2cd$var$canUseDOM && "documentMode" in document && ($2b1c5193a94af2cd$var$documentMode = document.documentMode);
var $2b1c5193a94af2cd$var$canUseTextInputEvent = $2b1c5193a94af2cd$var$canUseDOM && "TextEvent" in window && !$2b1c5193a94af2cd$var$documentMode, $2b1c5193a94af2cd$var$useFallbackCompositionData = $2b1c5193a94af2cd$var$canUseDOM && (!$2b1c5193a94af2cd$var$canUseCompositionEvent || $2b1c5193a94af2cd$var$documentMode && 8 < $2b1c5193a94af2cd$var$documentMode && 11 >= $2b1c5193a94af2cd$var$documentMode), $2b1c5193a94af2cd$var$SPACEBAR_CHAR = String.fromCharCode(32), $2b1c5193a94af2cd$var$hasSpaceKeypress = !1;
function $2b1c5193a94af2cd$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $2b1c5193a94af2cd$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $2b1c5193a94af2cd$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $2b1c5193a94af2cd$var$isComposing = !1;
function $2b1c5193a94af2cd$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $2b1c5193a94af2cd$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $2b1c5193a94af2cd$var$hasSpaceKeypress = !0;
            return $2b1c5193a94af2cd$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $2b1c5193a94af2cd$var$SPACEBAR_CHAR && $2b1c5193a94af2cd$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $2b1c5193a94af2cd$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($2b1c5193a94af2cd$var$isComposing) return "compositionend" === domEventName || !$2b1c5193a94af2cd$var$canUseCompositionEvent && $2b1c5193a94af2cd$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $2b1c5193a94af2cd$var$getData(), $2b1c5193a94af2cd$var$fallbackText = $2b1c5193a94af2cd$var$startText = $2b1c5193a94af2cd$var$root = null, $2b1c5193a94af2cd$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $2b1c5193a94af2cd$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $2b1c5193a94af2cd$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $2b1c5193a94af2cd$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$2b1c5193a94af2cd$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $2b1c5193a94af2cd$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $2b1c5193a94af2cd$var$restoreTarget ? $2b1c5193a94af2cd$var$restoreQueue ? $2b1c5193a94af2cd$var$restoreQueue.push(target) : $2b1c5193a94af2cd$var$restoreQueue = [
        target
    ] : $2b1c5193a94af2cd$var$restoreTarget = target;
    inst = $2b1c5193a94af2cd$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $2b1c5193a94af2cd$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $2b1c5193a94af2cd$var$activeElement$1 = null, $2b1c5193a94af2cd$var$activeElementInst$1 = null;
function $2b1c5193a94af2cd$var$runEventInBatch(dispatchQueue) {
    $2b1c5193a94af2cd$var$processDispatchQueue(dispatchQueue, 0);
}
function $2b1c5193a94af2cd$var$getInstIfValueChanged(targetInst) {
    var targetNode = $2b1c5193a94af2cd$var$getNodeFromInstance(targetInst);
    if ($2b1c5193a94af2cd$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $2b1c5193a94af2cd$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $2b1c5193a94af2cd$var$isInputEventSupported = !1;
if ($2b1c5193a94af2cd$var$canUseDOM) {
    var $2b1c5193a94af2cd$var$JSCompiler_inline_result$jscomp$286;
    if ($2b1c5193a94af2cd$var$canUseDOM) {
        var $2b1c5193a94af2cd$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$2b1c5193a94af2cd$var$isSupported$jscomp$inline_427) {
            var $2b1c5193a94af2cd$var$element$jscomp$inline_428 = document.createElement("div");
            $2b1c5193a94af2cd$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $2b1c5193a94af2cd$var$isSupported$jscomp$inline_427 = "function" === typeof $2b1c5193a94af2cd$var$element$jscomp$inline_428.oninput;
        }
        $2b1c5193a94af2cd$var$JSCompiler_inline_result$jscomp$286 = $2b1c5193a94af2cd$var$isSupported$jscomp$inline_427;
    } else $2b1c5193a94af2cd$var$JSCompiler_inline_result$jscomp$286 = !1;
    $2b1c5193a94af2cd$var$isInputEventSupported = $2b1c5193a94af2cd$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $2b1c5193a94af2cd$var$stopWatchingForValueChange() {
    $2b1c5193a94af2cd$var$activeElement$1 && ($2b1c5193a94af2cd$var$activeElement$1.detachEvent("onpropertychange", $2b1c5193a94af2cd$var$handlePropertyChange), $2b1c5193a94af2cd$var$activeElementInst$1 = $2b1c5193a94af2cd$var$activeElement$1 = null);
}
function $2b1c5193a94af2cd$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $2b1c5193a94af2cd$var$getInstIfValueChanged($2b1c5193a94af2cd$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $2b1c5193a94af2cd$var$createAndAccumulateChangeEvent(dispatchQueue, $2b1c5193a94af2cd$var$activeElementInst$1, nativeEvent, $2b1c5193a94af2cd$var$getEventTarget(nativeEvent));
        $2b1c5193a94af2cd$var$batchedUpdates$1($2b1c5193a94af2cd$var$runEventInBatch, dispatchQueue);
    }
}
function $2b1c5193a94af2cd$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($2b1c5193a94af2cd$var$stopWatchingForValueChange(), $2b1c5193a94af2cd$var$activeElement$1 = target, $2b1c5193a94af2cd$var$activeElementInst$1 = targetInst, $2b1c5193a94af2cd$var$activeElement$1.attachEvent("onpropertychange", $2b1c5193a94af2cd$var$handlePropertyChange)) : "focusout" === domEventName && $2b1c5193a94af2cd$var$stopWatchingForValueChange();
}
function $2b1c5193a94af2cd$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $2b1c5193a94af2cd$var$getInstIfValueChanged($2b1c5193a94af2cd$var$activeElementInst$1);
}
function $2b1c5193a94af2cd$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $2b1c5193a94af2cd$var$getInstIfValueChanged(targetInst);
}
function $2b1c5193a94af2cd$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $2b1c5193a94af2cd$var$getInstIfValueChanged(targetInst);
}
function $2b1c5193a94af2cd$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2b1c5193a94af2cd$var$objectIs = "function" === typeof Object.is ? Object.is : $2b1c5193a94af2cd$var$is;
function $2b1c5193a94af2cd$var$shallowEqual(objA, objB) {
    if ($2b1c5193a94af2cd$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$2b1c5193a94af2cd$var$hasOwnProperty.call(objB, currentKey) || !$2b1c5193a94af2cd$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $2b1c5193a94af2cd$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $2b1c5193a94af2cd$var$getNodeForCharacterOffset(root, offset) {
    var node = $2b1c5193a94af2cd$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $2b1c5193a94af2cd$var$getLeafNode(node);
    }
}
function $2b1c5193a94af2cd$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $2b1c5193a94af2cd$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $2b1c5193a94af2cd$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $2b1c5193a94af2cd$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $2b1c5193a94af2cd$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $2b1c5193a94af2cd$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $2b1c5193a94af2cd$var$skipSelectionChangeEvent = $2b1c5193a94af2cd$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $2b1c5193a94af2cd$var$activeElement = null, $2b1c5193a94af2cd$var$activeElementInst = null, $2b1c5193a94af2cd$var$lastSelection = null, $2b1c5193a94af2cd$var$mouseDown = !1;
function $2b1c5193a94af2cd$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $2b1c5193a94af2cd$var$mouseDown || null == $2b1c5193a94af2cd$var$activeElement || $2b1c5193a94af2cd$var$activeElement !== $2b1c5193a94af2cd$var$getActiveElement(doc) || (doc = $2b1c5193a94af2cd$var$activeElement, "selectionStart" in doc && $2b1c5193a94af2cd$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $2b1c5193a94af2cd$var$lastSelection && $2b1c5193a94af2cd$var$shallowEqual($2b1c5193a94af2cd$var$lastSelection, doc) || ($2b1c5193a94af2cd$var$lastSelection = doc, doc = $2b1c5193a94af2cd$var$accumulateTwoPhaseListeners($2b1c5193a94af2cd$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $2b1c5193a94af2cd$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $2b1c5193a94af2cd$var$activeElement)));
}
function $2b1c5193a94af2cd$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $2b1c5193a94af2cd$var$vendorPrefixes = {
    animationend: $2b1c5193a94af2cd$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $2b1c5193a94af2cd$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $2b1c5193a94af2cd$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $2b1c5193a94af2cd$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $2b1c5193a94af2cd$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $2b1c5193a94af2cd$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $2b1c5193a94af2cd$var$makePrefixMap("Transition", "TransitionEnd")
}, $2b1c5193a94af2cd$var$prefixedEventNames = {}, $2b1c5193a94af2cd$var$style = {};
$2b1c5193a94af2cd$var$canUseDOM && ($2b1c5193a94af2cd$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $2b1c5193a94af2cd$var$vendorPrefixes.animationend.animation, delete $2b1c5193a94af2cd$var$vendorPrefixes.animationiteration.animation, delete $2b1c5193a94af2cd$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $2b1c5193a94af2cd$var$vendorPrefixes.transitionend.transition);
function $2b1c5193a94af2cd$var$getVendorPrefixedEventName(eventName) {
    if ($2b1c5193a94af2cd$var$prefixedEventNames[eventName]) return $2b1c5193a94af2cd$var$prefixedEventNames[eventName];
    if (!$2b1c5193a94af2cd$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $2b1c5193a94af2cd$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $2b1c5193a94af2cd$var$style) return $2b1c5193a94af2cd$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $2b1c5193a94af2cd$var$ANIMATION_END = $2b1c5193a94af2cd$var$getVendorPrefixedEventName("animationend"), $2b1c5193a94af2cd$var$ANIMATION_ITERATION = $2b1c5193a94af2cd$var$getVendorPrefixedEventName("animationiteration"), $2b1c5193a94af2cd$var$ANIMATION_START = $2b1c5193a94af2cd$var$getVendorPrefixedEventName("animationstart"), $2b1c5193a94af2cd$var$TRANSITION_RUN = $2b1c5193a94af2cd$var$getVendorPrefixedEventName("transitionrun"), $2b1c5193a94af2cd$var$TRANSITION_START = $2b1c5193a94af2cd$var$getVendorPrefixedEventName("transitionstart"), $2b1c5193a94af2cd$var$TRANSITION_CANCEL = $2b1c5193a94af2cd$var$getVendorPrefixedEventName("transitioncancel"), $2b1c5193a94af2cd$var$TRANSITION_END = $2b1c5193a94af2cd$var$getVendorPrefixedEventName("transitionend"), $2b1c5193a94af2cd$var$topLevelEventsToReactNames = new Map(), $2b1c5193a94af2cd$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$2b1c5193a94af2cd$var$simpleEventPluginEvents.push("scrollEnd");
function $2b1c5193a94af2cd$var$registerSimpleEvent(domEventName, reactName) {
    $2b1c5193a94af2cd$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $2b1c5193a94af2cd$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $2b1c5193a94af2cd$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $2b1c5193a94af2cd$var$concurrentQueues = [], $2b1c5193a94af2cd$var$concurrentQueuesIndex = 0, $2b1c5193a94af2cd$var$concurrentlyUpdatedLanes = 0;
function $2b1c5193a94af2cd$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $2b1c5193a94af2cd$var$concurrentQueuesIndex, i = $2b1c5193a94af2cd$var$concurrentlyUpdatedLanes = $2b1c5193a94af2cd$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $2b1c5193a94af2cd$var$concurrentQueues[i];
        $2b1c5193a94af2cd$var$concurrentQueues[i++] = null;
        var queue = $2b1c5193a94af2cd$var$concurrentQueues[i];
        $2b1c5193a94af2cd$var$concurrentQueues[i++] = null;
        var update = $2b1c5193a94af2cd$var$concurrentQueues[i];
        $2b1c5193a94af2cd$var$concurrentQueues[i++] = null;
        var lane = $2b1c5193a94af2cd$var$concurrentQueues[i];
        $2b1c5193a94af2cd$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $2b1c5193a94af2cd$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $2b1c5193a94af2cd$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $2b1c5193a94af2cd$var$concurrentQueues[$2b1c5193a94af2cd$var$concurrentQueuesIndex++] = fiber;
    $2b1c5193a94af2cd$var$concurrentQueues[$2b1c5193a94af2cd$var$concurrentQueuesIndex++] = queue;
    $2b1c5193a94af2cd$var$concurrentQueues[$2b1c5193a94af2cd$var$concurrentQueuesIndex++] = update;
    $2b1c5193a94af2cd$var$concurrentQueues[$2b1c5193a94af2cd$var$concurrentQueuesIndex++] = lane;
    $2b1c5193a94af2cd$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $2b1c5193a94af2cd$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $2b1c5193a94af2cd$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $2b1c5193a94af2cd$var$getRootForUpdatedFiber(fiber);
}
function $2b1c5193a94af2cd$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $2b1c5193a94af2cd$var$enqueueUpdate$1(fiber, null, null, lane);
    return $2b1c5193a94af2cd$var$getRootForUpdatedFiber(fiber);
}
function $2b1c5193a94af2cd$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $2b1c5193a94af2cd$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $2b1c5193a94af2cd$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $2b1c5193a94af2cd$var$nestedUpdateCount) throw $2b1c5193a94af2cd$var$nestedUpdateCount = 0, $2b1c5193a94af2cd$var$rootWithNestedUpdates = null, Error($2b1c5193a94af2cd$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $2b1c5193a94af2cd$var$emptyContextObject = {};
function $2b1c5193a94af2cd$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $2b1c5193a94af2cd$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $2b1c5193a94af2cd$var$FiberNode(tag, pendingProps, key, mode);
}
function $2b1c5193a94af2cd$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $2b1c5193a94af2cd$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $2b1c5193a94af2cd$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $2b1c5193a94af2cd$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $2b1c5193a94af2cd$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $2b1c5193a94af2cd$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $2b1c5193a94af2cd$var$isHostHoistableType(type, pendingProps, $2b1c5193a94af2cd$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $2b1c5193a94af2cd$var$REACT_ACTIVITY_TYPE:
            return type = $2b1c5193a94af2cd$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $2b1c5193a94af2cd$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $2b1c5193a94af2cd$var$REACT_FRAGMENT_TYPE:
            return $2b1c5193a94af2cd$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $2b1c5193a94af2cd$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $2b1c5193a94af2cd$var$REACT_PROFILER_TYPE:
            return type = $2b1c5193a94af2cd$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $2b1c5193a94af2cd$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $2b1c5193a94af2cd$var$REACT_SUSPENSE_TYPE:
            return type = $2b1c5193a94af2cd$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $2b1c5193a94af2cd$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $2b1c5193a94af2cd$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $2b1c5193a94af2cd$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $2b1c5193a94af2cd$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $2b1c5193a94af2cd$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $2b1c5193a94af2cd$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $2b1c5193a94af2cd$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $2b1c5193a94af2cd$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $2b1c5193a94af2cd$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $2b1c5193a94af2cd$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $2b1c5193a94af2cd$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $2b1c5193a94af2cd$var$createFiberFromText(content, mode, lanes) {
    content = $2b1c5193a94af2cd$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $2b1c5193a94af2cd$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $2b1c5193a94af2cd$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $2b1c5193a94af2cd$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $2b1c5193a94af2cd$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $2b1c5193a94af2cd$var$CapturedStacks = new WeakMap();
function $2b1c5193a94af2cd$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $2b1c5193a94af2cd$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $2b1c5193a94af2cd$var$getStackByFiberInDevAndProd(source)
        };
        $2b1c5193a94af2cd$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $2b1c5193a94af2cd$var$getStackByFiberInDevAndProd(source)
    };
}
var $2b1c5193a94af2cd$var$forkStack = [], $2b1c5193a94af2cd$var$forkStackIndex = 0, $2b1c5193a94af2cd$var$treeForkProvider = null, $2b1c5193a94af2cd$var$treeForkCount = 0, $2b1c5193a94af2cd$var$idStack = [], $2b1c5193a94af2cd$var$idStackIndex = 0, $2b1c5193a94af2cd$var$treeContextProvider = null, $2b1c5193a94af2cd$var$treeContextId = 1, $2b1c5193a94af2cd$var$treeContextOverflow = "";
function $2b1c5193a94af2cd$var$pushTreeFork(workInProgress, totalChildren) {
    $2b1c5193a94af2cd$var$forkStack[$2b1c5193a94af2cd$var$forkStackIndex++] = $2b1c5193a94af2cd$var$treeForkCount;
    $2b1c5193a94af2cd$var$forkStack[$2b1c5193a94af2cd$var$forkStackIndex++] = $2b1c5193a94af2cd$var$treeForkProvider;
    $2b1c5193a94af2cd$var$treeForkProvider = workInProgress;
    $2b1c5193a94af2cd$var$treeForkCount = totalChildren;
}
function $2b1c5193a94af2cd$var$pushTreeId(workInProgress, totalChildren, index) {
    $2b1c5193a94af2cd$var$idStack[$2b1c5193a94af2cd$var$idStackIndex++] = $2b1c5193a94af2cd$var$treeContextId;
    $2b1c5193a94af2cd$var$idStack[$2b1c5193a94af2cd$var$idStackIndex++] = $2b1c5193a94af2cd$var$treeContextOverflow;
    $2b1c5193a94af2cd$var$idStack[$2b1c5193a94af2cd$var$idStackIndex++] = $2b1c5193a94af2cd$var$treeContextProvider;
    $2b1c5193a94af2cd$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $2b1c5193a94af2cd$var$treeContextId;
    workInProgress = $2b1c5193a94af2cd$var$treeContextOverflow;
    var baseLength = 32 - $2b1c5193a94af2cd$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $2b1c5193a94af2cd$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $2b1c5193a94af2cd$var$treeContextId = 1 << 32 - $2b1c5193a94af2cd$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $2b1c5193a94af2cd$var$treeContextOverflow = length + workInProgress;
    } else $2b1c5193a94af2cd$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $2b1c5193a94af2cd$var$treeContextOverflow = workInProgress;
}
function $2b1c5193a94af2cd$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($2b1c5193a94af2cd$var$pushTreeFork(workInProgress, 1), $2b1c5193a94af2cd$var$pushTreeId(workInProgress, 1, 0));
}
function $2b1c5193a94af2cd$var$popTreeContext(workInProgress) {
    for(; workInProgress === $2b1c5193a94af2cd$var$treeForkProvider;)$2b1c5193a94af2cd$var$treeForkProvider = $2b1c5193a94af2cd$var$forkStack[--$2b1c5193a94af2cd$var$forkStackIndex], $2b1c5193a94af2cd$var$forkStack[$2b1c5193a94af2cd$var$forkStackIndex] = null, $2b1c5193a94af2cd$var$treeForkCount = $2b1c5193a94af2cd$var$forkStack[--$2b1c5193a94af2cd$var$forkStackIndex], $2b1c5193a94af2cd$var$forkStack[$2b1c5193a94af2cd$var$forkStackIndex] = null;
    for(; workInProgress === $2b1c5193a94af2cd$var$treeContextProvider;)$2b1c5193a94af2cd$var$treeContextProvider = $2b1c5193a94af2cd$var$idStack[--$2b1c5193a94af2cd$var$idStackIndex], $2b1c5193a94af2cd$var$idStack[$2b1c5193a94af2cd$var$idStackIndex] = null, $2b1c5193a94af2cd$var$treeContextOverflow = $2b1c5193a94af2cd$var$idStack[--$2b1c5193a94af2cd$var$idStackIndex], $2b1c5193a94af2cd$var$idStack[$2b1c5193a94af2cd$var$idStackIndex] = null, $2b1c5193a94af2cd$var$treeContextId = $2b1c5193a94af2cd$var$idStack[--$2b1c5193a94af2cd$var$idStackIndex], $2b1c5193a94af2cd$var$idStack[$2b1c5193a94af2cd$var$idStackIndex] = null;
}
function $2b1c5193a94af2cd$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $2b1c5193a94af2cd$var$idStack[$2b1c5193a94af2cd$var$idStackIndex++] = $2b1c5193a94af2cd$var$treeContextId;
    $2b1c5193a94af2cd$var$idStack[$2b1c5193a94af2cd$var$idStackIndex++] = $2b1c5193a94af2cd$var$treeContextOverflow;
    $2b1c5193a94af2cd$var$idStack[$2b1c5193a94af2cd$var$idStackIndex++] = $2b1c5193a94af2cd$var$treeContextProvider;
    $2b1c5193a94af2cd$var$treeContextId = suspendedContext.id;
    $2b1c5193a94af2cd$var$treeContextOverflow = suspendedContext.overflow;
    $2b1c5193a94af2cd$var$treeContextProvider = workInProgress;
}
var $2b1c5193a94af2cd$var$hydrationParentFiber = null, $2b1c5193a94af2cd$var$nextHydratableInstance = null, $2b1c5193a94af2cd$var$isHydrating = !1, $2b1c5193a94af2cd$var$hydrationErrors = null, $2b1c5193a94af2cd$var$rootOrSingletonContext = !1, $2b1c5193a94af2cd$var$HydrationMismatchException = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(519));
function $2b1c5193a94af2cd$var$throwOnHydrationMismatch(fiber) {
    var error = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $2b1c5193a94af2cd$var$queueHydrationError($2b1c5193a94af2cd$var$createCapturedValueAtFiber(error, fiber));
    throw $2b1c5193a94af2cd$var$HydrationMismatchException;
}
function $2b1c5193a94af2cd$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$2b1c5193a94af2cd$var$internalInstanceKey] = fiber;
    instance[$2b1c5193a94af2cd$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("cancel", instance);
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $2b1c5193a94af2cd$var$mediaEventTypes.length; type++)$2b1c5193a94af2cd$var$listenToNonDelegatedEvent($2b1c5193a94af2cd$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("error", instance);
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("invalid", instance);
            $2b1c5193a94af2cd$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("invalid", instance), $2b1c5193a94af2cd$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $2b1c5193a94af2cd$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($2b1c5193a94af2cd$var$listenToNonDelegatedEvent("beforetoggle", instance), $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $2b1c5193a94af2cd$var$noop$1), instance = !0) : instance = !1;
    instance || $2b1c5193a94af2cd$var$throwOnHydrationMismatch(fiber, !0);
}
function $2b1c5193a94af2cd$var$popToNextHostParent(fiber) {
    for($2b1c5193a94af2cd$var$hydrationParentFiber = fiber.return; $2b1c5193a94af2cd$var$hydrationParentFiber;)switch($2b1c5193a94af2cd$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $2b1c5193a94af2cd$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $2b1c5193a94af2cd$var$rootOrSingletonContext = !0;
            return;
        default:
            $2b1c5193a94af2cd$var$hydrationParentFiber = $2b1c5193a94af2cd$var$hydrationParentFiber.return;
    }
}
function $2b1c5193a94af2cd$var$popHydrationState(fiber) {
    if (fiber !== $2b1c5193a94af2cd$var$hydrationParentFiber) return !1;
    if (!$2b1c5193a94af2cd$var$isHydrating) return $2b1c5193a94af2cd$var$popToNextHostParent(fiber), $2b1c5193a94af2cd$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $2b1c5193a94af2cd$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $2b1c5193a94af2cd$var$nextHydratableInstance && $2b1c5193a94af2cd$var$throwOnHydrationMismatch(fiber);
    $2b1c5193a94af2cd$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(317));
        $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(317));
        $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $2b1c5193a94af2cd$var$nextHydratableInstance, $2b1c5193a94af2cd$var$isSingletonScope(fiber.type) ? (fiber = $2b1c5193a94af2cd$var$previousHydratableOnEnteringScopedSingleton, $2b1c5193a94af2cd$var$previousHydratableOnEnteringScopedSingleton = null, $2b1c5193a94af2cd$var$nextHydratableInstance = fiber) : $2b1c5193a94af2cd$var$nextHydratableInstance = tag) : $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$hydrationParentFiber ? $2b1c5193a94af2cd$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $2b1c5193a94af2cd$var$resetHydrationState() {
    $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$hydrationParentFiber = null;
    $2b1c5193a94af2cd$var$isHydrating = !1;
}
function $2b1c5193a94af2cd$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $2b1c5193a94af2cd$var$hydrationErrors;
    null !== queuedErrors && (null === $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors ? $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors = queuedErrors : $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors.push.apply($2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors, queuedErrors), $2b1c5193a94af2cd$var$hydrationErrors = null);
    return queuedErrors;
}
function $2b1c5193a94af2cd$var$queueHydrationError(error) {
    null === $2b1c5193a94af2cd$var$hydrationErrors ? $2b1c5193a94af2cd$var$hydrationErrors = [
        error
    ] : $2b1c5193a94af2cd$var$hydrationErrors.push(error);
}
var $2b1c5193a94af2cd$var$valueCursor = $2b1c5193a94af2cd$var$createCursor(null), $2b1c5193a94af2cd$var$currentlyRenderingFiber$1 = null, $2b1c5193a94af2cd$var$lastContextDependency = null;
function $2b1c5193a94af2cd$var$pushProvider(providerFiber, context, nextValue) {
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $2b1c5193a94af2cd$var$popProvider(context) {
    context._currentValue = $2b1c5193a94af2cd$var$valueCursor.current;
    $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$valueCursor);
}
function $2b1c5193a94af2cd$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $2b1c5193a94af2cd$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $2b1c5193a94af2cd$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $2b1c5193a94af2cd$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $2b1c5193a94af2cd$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $2b1c5193a94af2cd$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $2b1c5193a94af2cd$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($2b1c5193a94af2cd$var$HostTransitionContext) : current = [
                $2b1c5193a94af2cd$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $2b1c5193a94af2cd$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $2b1c5193a94af2cd$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$2b1c5193a94af2cd$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $2b1c5193a94af2cd$var$prepareToReadContext(workInProgress) {
    $2b1c5193a94af2cd$var$currentlyRenderingFiber$1 = workInProgress;
    $2b1c5193a94af2cd$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $2b1c5193a94af2cd$var$readContext(context) {
    return $2b1c5193a94af2cd$var$readContextForConsumer($2b1c5193a94af2cd$var$currentlyRenderingFiber$1, context);
}
function $2b1c5193a94af2cd$var$readContextDuringReconciliation(consumer, context) {
    null === $2b1c5193a94af2cd$var$currentlyRenderingFiber$1 && $2b1c5193a94af2cd$var$prepareToReadContext(consumer);
    return $2b1c5193a94af2cd$var$readContextForConsumer(consumer, context);
}
function $2b1c5193a94af2cd$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $2b1c5193a94af2cd$var$lastContextDependency) {
        if (null === consumer) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(308));
        $2b1c5193a94af2cd$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $2b1c5193a94af2cd$var$lastContextDependency = $2b1c5193a94af2cd$var$lastContextDependency.next = context;
    return value;
}
var $2b1c5193a94af2cd$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $2b1c5193a94af2cd$var$scheduleCallback$2 = $5avyM.unstable_scheduleCallback, $2b1c5193a94af2cd$var$NormalPriority = $5avyM.unstable_NormalPriority, $2b1c5193a94af2cd$var$CacheContext = {
    $$typeof: $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $2b1c5193a94af2cd$var$createCache() {
    return {
        controller: new $2b1c5193a94af2cd$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $2b1c5193a94af2cd$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $2b1c5193a94af2cd$var$scheduleCallback$2($2b1c5193a94af2cd$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $2b1c5193a94af2cd$var$currentEntangledListeners = null, $2b1c5193a94af2cd$var$currentEntangledPendingCount = 0, $2b1c5193a94af2cd$var$currentEntangledLane = 0, $2b1c5193a94af2cd$var$currentEntangledActionThenable = null;
function $2b1c5193a94af2cd$var$entangleAsyncAction(transition, thenable) {
    if (null === $2b1c5193a94af2cd$var$currentEntangledListeners) {
        var entangledListeners = $2b1c5193a94af2cd$var$currentEntangledListeners = [];
        $2b1c5193a94af2cd$var$currentEntangledPendingCount = 0;
        $2b1c5193a94af2cd$var$currentEntangledLane = $2b1c5193a94af2cd$var$requestTransitionLane();
        $2b1c5193a94af2cd$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $2b1c5193a94af2cd$var$currentEntangledPendingCount++;
    thenable.then($2b1c5193a94af2cd$var$pingEngtangledActionScope, $2b1c5193a94af2cd$var$pingEngtangledActionScope);
    return thenable;
}
function $2b1c5193a94af2cd$var$pingEngtangledActionScope() {
    if (0 === --$2b1c5193a94af2cd$var$currentEntangledPendingCount && null !== $2b1c5193a94af2cd$var$currentEntangledListeners) {
        null !== $2b1c5193a94af2cd$var$currentEntangledActionThenable && ($2b1c5193a94af2cd$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $2b1c5193a94af2cd$var$currentEntangledListeners;
        $2b1c5193a94af2cd$var$currentEntangledListeners = null;
        $2b1c5193a94af2cd$var$currentEntangledLane = 0;
        $2b1c5193a94af2cd$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $2b1c5193a94af2cd$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $2b1c5193a94af2cd$var$prevOnStartTransitionFinish = $2b1c5193a94af2cd$var$ReactSharedInternals.S;
$2b1c5193a94af2cd$var$ReactSharedInternals.S = function(transition, returnValue) {
    $2b1c5193a94af2cd$var$globalMostRecentTransitionTime = $2b1c5193a94af2cd$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $2b1c5193a94af2cd$var$entangleAsyncAction(transition, returnValue);
    null !== $2b1c5193a94af2cd$var$prevOnStartTransitionFinish && $2b1c5193a94af2cd$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $2b1c5193a94af2cd$var$resumedCache = $2b1c5193a94af2cd$var$createCursor(null);
function $2b1c5193a94af2cd$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $2b1c5193a94af2cd$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $2b1c5193a94af2cd$var$workInProgressRoot.pooledCache;
}
function $2b1c5193a94af2cd$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$resumedCache, $2b1c5193a94af2cd$var$resumedCache.current) : $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$resumedCache, prevCachePool.pool);
}
function $2b1c5193a94af2cd$var$getSuspendedCache() {
    var cacheFromPool = $2b1c5193a94af2cd$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $2b1c5193a94af2cd$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $2b1c5193a94af2cd$var$SuspenseException = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(460)), $2b1c5193a94af2cd$var$SuspenseyCommitException = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(474)), $2b1c5193a94af2cd$var$SuspenseActionException = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(542)), $2b1c5193a94af2cd$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $2b1c5193a94af2cd$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $2b1c5193a94af2cd$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($2b1c5193a94af2cd$var$noop$1, $2b1c5193a94af2cd$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $2b1c5193a94af2cd$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($2b1c5193a94af2cd$var$noop$1, $2b1c5193a94af2cd$var$noop$1);
            else {
                thenableState = $2b1c5193a94af2cd$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $2b1c5193a94af2cd$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $2b1c5193a94af2cd$var$suspendedThenable = thenable;
            throw $2b1c5193a94af2cd$var$SuspenseException;
    }
}
function $2b1c5193a94af2cd$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $2b1c5193a94af2cd$var$suspendedThenable = x, $2b1c5193a94af2cd$var$SuspenseException;
        throw x;
    }
}
var $2b1c5193a94af2cd$var$suspendedThenable = null;
function $2b1c5193a94af2cd$var$getSuspendedThenable() {
    if (null === $2b1c5193a94af2cd$var$suspendedThenable) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(459));
    var thenable = $2b1c5193a94af2cd$var$suspendedThenable;
    $2b1c5193a94af2cd$var$suspendedThenable = null;
    return thenable;
}
function $2b1c5193a94af2cd$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $2b1c5193a94af2cd$var$SuspenseException || rejectedReason === $2b1c5193a94af2cd$var$SuspenseActionException) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(483));
}
var $2b1c5193a94af2cd$var$thenableState$1 = null, $2b1c5193a94af2cd$var$thenableIndexCounter$1 = 0;
function $2b1c5193a94af2cd$var$unwrapThenable(thenable) {
    var index = $2b1c5193a94af2cd$var$thenableIndexCounter$1;
    $2b1c5193a94af2cd$var$thenableIndexCounter$1 += 1;
    null === $2b1c5193a94af2cd$var$thenableState$1 && ($2b1c5193a94af2cd$var$thenableState$1 = []);
    return $2b1c5193a94af2cd$var$trackUsedThenable($2b1c5193a94af2cd$var$thenableState$1, thenable, index);
}
function $2b1c5193a94af2cd$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $2b1c5193a94af2cd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $2b1c5193a94af2cd$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $2b1c5193a94af2cd$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $2b1c5193a94af2cd$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $2b1c5193a94af2cd$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $2b1c5193a94af2cd$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $2b1c5193a94af2cd$var$REACT_LAZY_TYPE && $2b1c5193a94af2cd$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $2b1c5193a94af2cd$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $2b1c5193a94af2cd$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $2b1c5193a94af2cd$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $2b1c5193a94af2cd$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $2b1c5193a94af2cd$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $2b1c5193a94af2cd$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2b1c5193a94af2cd$var$REACT_ELEMENT_TYPE:
                    return lanes = $2b1c5193a94af2cd$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2b1c5193a94af2cd$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $2b1c5193a94af2cd$var$REACT_PORTAL_TYPE:
                    return newChild = $2b1c5193a94af2cd$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $2b1c5193a94af2cd$var$REACT_LAZY_TYPE:
                    return newChild = $2b1c5193a94af2cd$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($2b1c5193a94af2cd$var$isArrayImpl(newChild) || $2b1c5193a94af2cd$var$getIteratorFn(newChild)) return newChild = $2b1c5193a94af2cd$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $2b1c5193a94af2cd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $2b1c5193a94af2cd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2b1c5193a94af2cd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2b1c5193a94af2cd$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $2b1c5193a94af2cd$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $2b1c5193a94af2cd$var$REACT_LAZY_TYPE:
                    return newChild = $2b1c5193a94af2cd$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($2b1c5193a94af2cd$var$isArrayImpl(newChild) || $2b1c5193a94af2cd$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $2b1c5193a94af2cd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $2b1c5193a94af2cd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2b1c5193a94af2cd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2b1c5193a94af2cd$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $2b1c5193a94af2cd$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $2b1c5193a94af2cd$var$REACT_LAZY_TYPE:
                    return newChild = $2b1c5193a94af2cd$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($2b1c5193a94af2cd$var$isArrayImpl(newChild) || $2b1c5193a94af2cd$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $2b1c5193a94af2cd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $2b1c5193a94af2cd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2b1c5193a94af2cd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $2b1c5193a94af2cd$var$isHydrating && $2b1c5193a94af2cd$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $2b1c5193a94af2cd$var$isHydrating && $2b1c5193a94af2cd$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2b1c5193a94af2cd$var$isHydrating && $2b1c5193a94af2cd$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $2b1c5193a94af2cd$var$isHydrating && $2b1c5193a94af2cd$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $2b1c5193a94af2cd$var$isHydrating && $2b1c5193a94af2cd$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $2b1c5193a94af2cd$var$isHydrating && $2b1c5193a94af2cd$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $2b1c5193a94af2cd$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $2b1c5193a94af2cd$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $2b1c5193a94af2cd$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $2b1c5193a94af2cd$var$REACT_LAZY_TYPE && $2b1c5193a94af2cd$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $2b1c5193a94af2cd$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $2b1c5193a94af2cd$var$REACT_FRAGMENT_TYPE ? (lanes = $2b1c5193a94af2cd$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $2b1c5193a94af2cd$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $2b1c5193a94af2cd$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $2b1c5193a94af2cd$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $2b1c5193a94af2cd$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $2b1c5193a94af2cd$var$REACT_LAZY_TYPE:
                    return newChild = $2b1c5193a94af2cd$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($2b1c5193a94af2cd$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($2b1c5193a94af2cd$var$getIteratorFn(newChild)) {
                key = $2b1c5193a94af2cd$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2b1c5193a94af2cd$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $2b1c5193a94af2cd$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $2b1c5193a94af2cd$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $2b1c5193a94af2cd$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $2b1c5193a94af2cd$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $2b1c5193a94af2cd$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $2b1c5193a94af2cd$var$SuspenseException || x === $2b1c5193a94af2cd$var$SuspenseActionException) throw x;
            var fiber = $2b1c5193a94af2cd$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $2b1c5193a94af2cd$var$reconcileChildFibers = $2b1c5193a94af2cd$var$createChildReconciler(!0), $2b1c5193a94af2cd$var$mountChildFibers = $2b1c5193a94af2cd$var$createChildReconciler(!1), $2b1c5193a94af2cd$var$hasForceUpdate = !1;
function $2b1c5193a94af2cd$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $2b1c5193a94af2cd$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $2b1c5193a94af2cd$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $2b1c5193a94af2cd$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($2b1c5193a94af2cd$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $2b1c5193a94af2cd$var$getRootForUpdatedFiber(fiber);
        $2b1c5193a94af2cd$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $2b1c5193a94af2cd$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $2b1c5193a94af2cd$var$getRootForUpdatedFiber(fiber);
}
function $2b1c5193a94af2cd$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $2b1c5193a94af2cd$var$markRootEntangled(root, lane);
    }
}
function $2b1c5193a94af2cd$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $2b1c5193a94af2cd$var$didReadFromEntangledAsyncAction = !1;
function $2b1c5193a94af2cd$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($2b1c5193a94af2cd$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $2b1c5193a94af2cd$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $2b1c5193a94af2cd$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $2b1c5193a94af2cd$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $2b1c5193a94af2cd$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $2b1c5193a94af2cd$var$currentEntangledLane && ($2b1c5193a94af2cd$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $2b1c5193a94af2cd$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $2b1c5193a94af2cd$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $2b1c5193a94af2cd$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $2b1c5193a94af2cd$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $2b1c5193a94af2cd$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$2b1c5193a94af2cd$var$callCallback(callbacks[updateQueue], context);
}
var $2b1c5193a94af2cd$var$currentTreeHiddenStackCursor = $2b1c5193a94af2cd$var$createCursor(null), $2b1c5193a94af2cd$var$prevEntangledRenderLanesCursor = $2b1c5193a94af2cd$var$createCursor(0);
function $2b1c5193a94af2cd$var$pushHiddenContext(fiber, context) {
    fiber = $2b1c5193a94af2cd$var$entangledRenderLanes;
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$prevEntangledRenderLanesCursor, fiber);
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$currentTreeHiddenStackCursor, context);
    $2b1c5193a94af2cd$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $2b1c5193a94af2cd$var$reuseHiddenContextOnStack() {
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$prevEntangledRenderLanesCursor, $2b1c5193a94af2cd$var$entangledRenderLanes);
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$currentTreeHiddenStackCursor, $2b1c5193a94af2cd$var$currentTreeHiddenStackCursor.current);
}
function $2b1c5193a94af2cd$var$popHiddenContext() {
    $2b1c5193a94af2cd$var$entangledRenderLanes = $2b1c5193a94af2cd$var$prevEntangledRenderLanesCursor.current;
    $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$currentTreeHiddenStackCursor);
    $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$prevEntangledRenderLanesCursor);
}
var $2b1c5193a94af2cd$var$suspenseHandlerStackCursor = $2b1c5193a94af2cd$var$createCursor(null), $2b1c5193a94af2cd$var$shellBoundary = null;
function $2b1c5193a94af2cd$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseStackCursor, $2b1c5193a94af2cd$var$suspenseStackCursor.current & 1);
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseHandlerStackCursor, handler);
    null === $2b1c5193a94af2cd$var$shellBoundary && (null === current || null !== $2b1c5193a94af2cd$var$currentTreeHiddenStackCursor.current ? $2b1c5193a94af2cd$var$shellBoundary = handler : null !== current.memoizedState && ($2b1c5193a94af2cd$var$shellBoundary = handler));
}
function $2b1c5193a94af2cd$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseStackCursor, $2b1c5193a94af2cd$var$suspenseStackCursor.current);
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseHandlerStackCursor, fiber);
    null === $2b1c5193a94af2cd$var$shellBoundary && ($2b1c5193a94af2cd$var$shellBoundary = fiber);
}
function $2b1c5193a94af2cd$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseStackCursor, $2b1c5193a94af2cd$var$suspenseStackCursor.current), $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseHandlerStackCursor, fiber), null === $2b1c5193a94af2cd$var$shellBoundary && ($2b1c5193a94af2cd$var$shellBoundary = fiber)) : $2b1c5193a94af2cd$var$reuseSuspenseHandlerOnStack(fiber);
}
function $2b1c5193a94af2cd$var$reuseSuspenseHandlerOnStack() {
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseStackCursor, $2b1c5193a94af2cd$var$suspenseStackCursor.current);
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseHandlerStackCursor, $2b1c5193a94af2cd$var$suspenseHandlerStackCursor.current);
}
function $2b1c5193a94af2cd$var$popSuspenseHandler(fiber) {
    $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$suspenseHandlerStackCursor);
    $2b1c5193a94af2cd$var$shellBoundary === fiber && ($2b1c5193a94af2cd$var$shellBoundary = null);
    $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$suspenseStackCursor);
}
var $2b1c5193a94af2cd$var$suspenseStackCursor = $2b1c5193a94af2cd$var$createCursor(0);
function $2b1c5193a94af2cd$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $2b1c5193a94af2cd$var$isSuspenseInstancePending(state) || $2b1c5193a94af2cd$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $2b1c5193a94af2cd$var$renderLanes = 0, $2b1c5193a94af2cd$var$currentlyRenderingFiber = null, $2b1c5193a94af2cd$var$currentHook = null, $2b1c5193a94af2cd$var$workInProgressHook = null, $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdate = !1, $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $2b1c5193a94af2cd$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $2b1c5193a94af2cd$var$localIdCounter = 0, $2b1c5193a94af2cd$var$thenableIndexCounter = 0, $2b1c5193a94af2cd$var$thenableState = null, $2b1c5193a94af2cd$var$globalClientIdCounter = 0;
function $2b1c5193a94af2cd$var$throwInvalidHookError() {
    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(321));
}
function $2b1c5193a94af2cd$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$2b1c5193a94af2cd$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $2b1c5193a94af2cd$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $2b1c5193a94af2cd$var$renderLanes = nextRenderLanes;
    $2b1c5193a94af2cd$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $2b1c5193a94af2cd$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $2b1c5193a94af2cd$var$HooksDispatcherOnMount : $2b1c5193a94af2cd$var$HooksDispatcherOnUpdate;
    $2b1c5193a94af2cd$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $2b1c5193a94af2cd$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $2b1c5193a94af2cd$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $2b1c5193a94af2cd$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $2b1c5193a94af2cd$var$finishRenderingHooks(current) {
    $2b1c5193a94af2cd$var$ReactSharedInternals.H = $2b1c5193a94af2cd$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $2b1c5193a94af2cd$var$currentHook && null !== $2b1c5193a94af2cd$var$currentHook.next;
    $2b1c5193a94af2cd$var$renderLanes = 0;
    $2b1c5193a94af2cd$var$workInProgressHook = $2b1c5193a94af2cd$var$currentHook = $2b1c5193a94af2cd$var$currentlyRenderingFiber = null;
    $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdate = !1;
    $2b1c5193a94af2cd$var$thenableIndexCounter = 0;
    $2b1c5193a94af2cd$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(300));
    null === current || $2b1c5193a94af2cd$var$didReceiveUpdate || (current = current.dependencies, null !== current && $2b1c5193a94af2cd$var$checkIfContextChanged(current) && ($2b1c5193a94af2cd$var$didReceiveUpdate = !0));
}
function $2b1c5193a94af2cd$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $2b1c5193a94af2cd$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdateDuringThisPass && ($2b1c5193a94af2cd$var$thenableState = null);
        $2b1c5193a94af2cd$var$thenableIndexCounter = 0;
        $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $2b1c5193a94af2cd$var$workInProgressHook = $2b1c5193a94af2cd$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $2b1c5193a94af2cd$var$ReactSharedInternals.H = $2b1c5193a94af2cd$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $2b1c5193a94af2cd$var$TransitionAwareHostComponent() {
    var dispatcher = $2b1c5193a94af2cd$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $2b1c5193a94af2cd$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $2b1c5193a94af2cd$var$currentHook ? $2b1c5193a94af2cd$var$currentHook.memoizedState : null) !== dispatcher && ($2b1c5193a94af2cd$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $2b1c5193a94af2cd$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $2b1c5193a94af2cd$var$localIdCounter;
    $2b1c5193a94af2cd$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $2b1c5193a94af2cd$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $2b1c5193a94af2cd$var$resetHooksOnUnwind(workInProgress) {
    if ($2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdate = !1;
    }
    $2b1c5193a94af2cd$var$renderLanes = 0;
    $2b1c5193a94af2cd$var$workInProgressHook = $2b1c5193a94af2cd$var$currentHook = $2b1c5193a94af2cd$var$currentlyRenderingFiber = null;
    $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $2b1c5193a94af2cd$var$thenableIndexCounter = $2b1c5193a94af2cd$var$localIdCounter = 0;
    $2b1c5193a94af2cd$var$thenableState = null;
}
function $2b1c5193a94af2cd$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $2b1c5193a94af2cd$var$workInProgressHook ? $2b1c5193a94af2cd$var$currentlyRenderingFiber.memoizedState = $2b1c5193a94af2cd$var$workInProgressHook = hook : $2b1c5193a94af2cd$var$workInProgressHook = $2b1c5193a94af2cd$var$workInProgressHook.next = hook;
    return $2b1c5193a94af2cd$var$workInProgressHook;
}
function $2b1c5193a94af2cd$var$updateWorkInProgressHook() {
    if (null === $2b1c5193a94af2cd$var$currentHook) {
        var nextCurrentHook = $2b1c5193a94af2cd$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $2b1c5193a94af2cd$var$currentHook.next;
    var nextWorkInProgressHook = null === $2b1c5193a94af2cd$var$workInProgressHook ? $2b1c5193a94af2cd$var$currentlyRenderingFiber.memoizedState : $2b1c5193a94af2cd$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $2b1c5193a94af2cd$var$workInProgressHook = nextWorkInProgressHook, $2b1c5193a94af2cd$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $2b1c5193a94af2cd$var$currentlyRenderingFiber.alternate) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(467));
            throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(310));
        }
        $2b1c5193a94af2cd$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $2b1c5193a94af2cd$var$currentHook.memoizedState,
            baseState: $2b1c5193a94af2cd$var$currentHook.baseState,
            baseQueue: $2b1c5193a94af2cd$var$currentHook.baseQueue,
            queue: $2b1c5193a94af2cd$var$currentHook.queue,
            next: null
        };
        null === $2b1c5193a94af2cd$var$workInProgressHook ? $2b1c5193a94af2cd$var$currentlyRenderingFiber.memoizedState = $2b1c5193a94af2cd$var$workInProgressHook = nextCurrentHook : $2b1c5193a94af2cd$var$workInProgressHook = $2b1c5193a94af2cd$var$workInProgressHook.next = nextCurrentHook;
    }
    return $2b1c5193a94af2cd$var$workInProgressHook;
}
function $2b1c5193a94af2cd$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $2b1c5193a94af2cd$var$useThenable(thenable) {
    var index = $2b1c5193a94af2cd$var$thenableIndexCounter;
    $2b1c5193a94af2cd$var$thenableIndexCounter += 1;
    null === $2b1c5193a94af2cd$var$thenableState && ($2b1c5193a94af2cd$var$thenableState = []);
    thenable = $2b1c5193a94af2cd$var$trackUsedThenable($2b1c5193a94af2cd$var$thenableState, thenable, index);
    index = $2b1c5193a94af2cd$var$currentlyRenderingFiber;
    null === (null === $2b1c5193a94af2cd$var$workInProgressHook ? index.memoizedState : $2b1c5193a94af2cd$var$workInProgressHook.next) && (index = index.alternate, $2b1c5193a94af2cd$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $2b1c5193a94af2cd$var$HooksDispatcherOnMount : $2b1c5193a94af2cd$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $2b1c5193a94af2cd$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $2b1c5193a94af2cd$var$useThenable(usable);
        if (usable.$$typeof === $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE) return $2b1c5193a94af2cd$var$readContext(usable);
    }
    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(438, String(usable)));
}
function $2b1c5193a94af2cd$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $2b1c5193a94af2cd$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $2b1c5193a94af2cd$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $2b1c5193a94af2cd$var$createFunctionComponentUpdateQueue(), $2b1c5193a94af2cd$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $2b1c5193a94af2cd$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $2b1c5193a94af2cd$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $2b1c5193a94af2cd$var$updateReducer(reducer) {
    var hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
    return $2b1c5193a94af2cd$var$updateReducerImpl(hook, $2b1c5193a94af2cd$var$currentHook, reducer);
}
function $2b1c5193a94af2cd$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($2b1c5193a94af2cd$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $2b1c5193a94af2cd$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($2b1c5193a94af2cd$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $2b1c5193a94af2cd$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $2b1c5193a94af2cd$var$currentlyRenderingFiber.lanes |= revertLane, $2b1c5193a94af2cd$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $2b1c5193a94af2cd$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $2b1c5193a94af2cd$var$currentlyRenderingFiber.lanes |= updateLane, $2b1c5193a94af2cd$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$2b1c5193a94af2cd$var$objectIs(pendingQueue, hook.memoizedState) && ($2b1c5193a94af2cd$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $2b1c5193a94af2cd$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $2b1c5193a94af2cd$var$rerenderReducer(reducer) {
    var hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $2b1c5193a94af2cd$var$objectIs(newState, hook.memoizedState) || ($2b1c5193a94af2cd$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $2b1c5193a94af2cd$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $2b1c5193a94af2cd$var$currentlyRenderingFiber, hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $2b1c5193a94af2cd$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$2b1c5193a94af2cd$var$objectIs(($2b1c5193a94af2cd$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $2b1c5193a94af2cd$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $2b1c5193a94af2cd$var$updateEffect($2b1c5193a94af2cd$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $2b1c5193a94af2cd$var$workInProgressHook && $2b1c5193a94af2cd$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $2b1c5193a94af2cd$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $2b1c5193a94af2cd$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $2b1c5193a94af2cd$var$workInProgressRoot) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($2b1c5193a94af2cd$var$renderLanes & 127) || $2b1c5193a94af2cd$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $2b1c5193a94af2cd$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $2b1c5193a94af2cd$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $2b1c5193a94af2cd$var$createFunctionComponentUpdateQueue(), $2b1c5193a94af2cd$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $2b1c5193a94af2cd$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $2b1c5193a94af2cd$var$checkIfSnapshotChanged(inst) && $2b1c5193a94af2cd$var$forceStoreRerender(fiber);
}
function $2b1c5193a94af2cd$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $2b1c5193a94af2cd$var$checkIfSnapshotChanged(inst) && $2b1c5193a94af2cd$var$forceStoreRerender(fiber);
    });
}
function $2b1c5193a94af2cd$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2b1c5193a94af2cd$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2b1c5193a94af2cd$var$forceStoreRerender(fiber) {
    var root = $2b1c5193a94af2cd$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $2b1c5193a94af2cd$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $2b1c5193a94af2cd$var$mountStateImpl(initialState) {
    var hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($2b1c5193a94af2cd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2b1c5193a94af2cd$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $2b1c5193a94af2cd$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2b1c5193a94af2cd$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $2b1c5193a94af2cd$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $2b1c5193a94af2cd$var$updateReducerImpl(hook, $2b1c5193a94af2cd$var$currentHook, "function" === typeof reducer ? reducer : $2b1c5193a94af2cd$var$basicStateReducer);
}
function $2b1c5193a94af2cd$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($2b1c5193a94af2cd$var$isRenderPhaseUpdate(fiber)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $2b1c5193a94af2cd$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $2b1c5193a94af2cd$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $2b1c5193a94af2cd$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $2b1c5193a94af2cd$var$ReactSharedInternals.T, currentTransition = {};
        $2b1c5193a94af2cd$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $2b1c5193a94af2cd$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $2b1c5193a94af2cd$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $2b1c5193a94af2cd$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2b1c5193a94af2cd$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $2b1c5193a94af2cd$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $2b1c5193a94af2cd$var$onActionError(actionQueue, node, error$66);
    }
}
function $2b1c5193a94af2cd$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $2b1c5193a94af2cd$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $2b1c5193a94af2cd$var$onActionError(actionQueue, node, error);
    }) : $2b1c5193a94af2cd$var$onActionSuccess(actionQueue, node, returnValue);
}
function $2b1c5193a94af2cd$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $2b1c5193a94af2cd$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $2b1c5193a94af2cd$var$runActionStateAction(actionQueue, nextState)));
}
function $2b1c5193a94af2cd$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $2b1c5193a94af2cd$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $2b1c5193a94af2cd$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $2b1c5193a94af2cd$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $2b1c5193a94af2cd$var$mountActionState(action, initialStateProp) {
    if ($2b1c5193a94af2cd$var$isHydrating) {
        var ssrFormState = $2b1c5193a94af2cd$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $2b1c5193a94af2cd$var$currentlyRenderingFiber;
                if ($2b1c5193a94af2cd$var$isHydrating) {
                    if ($2b1c5193a94af2cd$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $2b1c5193a94af2cd$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $2b1c5193a94af2cd$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $2b1c5193a94af2cd$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $2b1c5193a94af2cd$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $2b1c5193a94af2cd$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $2b1c5193a94af2cd$var$dispatchSetState.bind(null, $2b1c5193a94af2cd$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $2b1c5193a94af2cd$var$mountStateImpl(!1);
    inRootOrSingleton = $2b1c5193a94af2cd$var$dispatchOptimisticSetState.bind(null, $2b1c5193a94af2cd$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $2b1c5193a94af2cd$var$dispatchActionState.bind(null, $2b1c5193a94af2cd$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $2b1c5193a94af2cd$var$updateActionState(action) {
    var stateHook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
    return $2b1c5193a94af2cd$var$updateActionStateImpl(stateHook, $2b1c5193a94af2cd$var$currentHook, action);
}
function $2b1c5193a94af2cd$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $2b1c5193a94af2cd$var$updateReducerImpl(stateHook, currentStateHook, $2b1c5193a94af2cd$var$actionStateReducer)[0];
    stateHook = $2b1c5193a94af2cd$var$updateReducer($2b1c5193a94af2cd$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $2b1c5193a94af2cd$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $2b1c5193a94af2cd$var$SuspenseException) throw $2b1c5193a94af2cd$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($2b1c5193a94af2cd$var$currentlyRenderingFiber.flags |= 2048, $2b1c5193a94af2cd$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $2b1c5193a94af2cd$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $2b1c5193a94af2cd$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $2b1c5193a94af2cd$var$rerenderActionState(action) {
    var stateHook = $2b1c5193a94af2cd$var$updateWorkInProgressHook(), currentStateHook = $2b1c5193a94af2cd$var$currentHook;
    if (null !== currentStateHook) return $2b1c5193a94af2cd$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $2b1c5193a94af2cd$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $2b1c5193a94af2cd$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $2b1c5193a94af2cd$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $2b1c5193a94af2cd$var$createFunctionComponentUpdateQueue(), $2b1c5193a94af2cd$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $2b1c5193a94af2cd$var$updateRef() {
    return $2b1c5193a94af2cd$var$updateWorkInProgressHook().memoizedState;
}
function $2b1c5193a94af2cd$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
    $2b1c5193a94af2cd$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $2b1c5193a94af2cd$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $2b1c5193a94af2cd$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $2b1c5193a94af2cd$var$currentHook && null !== deps && $2b1c5193a94af2cd$var$areHookInputsEqual(deps, $2b1c5193a94af2cd$var$currentHook.memoizedState.deps) ? hook.memoizedState = $2b1c5193a94af2cd$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($2b1c5193a94af2cd$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $2b1c5193a94af2cd$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $2b1c5193a94af2cd$var$mountEffect(create, deps) {
    $2b1c5193a94af2cd$var$mountEffectImpl(8390656, 8, create, deps);
}
function $2b1c5193a94af2cd$var$updateEffect(create, deps) {
    $2b1c5193a94af2cd$var$updateEffectImpl(2048, 8, create, deps);
}
function $2b1c5193a94af2cd$var$useEffectEventImpl(payload) {
    $2b1c5193a94af2cd$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $2b1c5193a94af2cd$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $2b1c5193a94af2cd$var$createFunctionComponentUpdateQueue(), $2b1c5193a94af2cd$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $2b1c5193a94af2cd$var$updateEvent(callback) {
    var ref = $2b1c5193a94af2cd$var$updateWorkInProgressHook().memoizedState;
    $2b1c5193a94af2cd$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($2b1c5193a94af2cd$var$executionContext & 2)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $2b1c5193a94af2cd$var$updateInsertionEffect(create, deps) {
    return $2b1c5193a94af2cd$var$updateEffectImpl(4, 2, create, deps);
}
function $2b1c5193a94af2cd$var$updateLayoutEffect(create, deps) {
    return $2b1c5193a94af2cd$var$updateEffectImpl(4, 4, create, deps);
}
function $2b1c5193a94af2cd$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $2b1c5193a94af2cd$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $2b1c5193a94af2cd$var$updateEffectImpl(4, 4, $2b1c5193a94af2cd$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $2b1c5193a94af2cd$var$mountDebugValue() {}
function $2b1c5193a94af2cd$var$updateCallback(callback, deps) {
    var hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2b1c5193a94af2cd$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $2b1c5193a94af2cd$var$updateMemo(nextCreate, deps) {
    var hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $2b1c5193a94af2cd$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($2b1c5193a94af2cd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $2b1c5193a94af2cd$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $2b1c5193a94af2cd$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $2b1c5193a94af2cd$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($2b1c5193a94af2cd$var$renderLanes & 1073741824) && 0 === ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $2b1c5193a94af2cd$var$requestDeferredLane();
    $2b1c5193a94af2cd$var$currentlyRenderingFiber.lanes |= hook;
    $2b1c5193a94af2cd$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $2b1c5193a94af2cd$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($2b1c5193a94af2cd$var$objectIs(value, prevValue)) return value;
    if (null !== $2b1c5193a94af2cd$var$currentTreeHiddenStackCursor.current) return hook = $2b1c5193a94af2cd$var$mountDeferredValueImpl(hook, value, initialValue), $2b1c5193a94af2cd$var$objectIs(hook, prevValue) || ($2b1c5193a94af2cd$var$didReceiveUpdate = !0), hook;
    if (0 === ($2b1c5193a94af2cd$var$renderLanes & 42) || 0 !== ($2b1c5193a94af2cd$var$renderLanes & 1073741824) && 0 === ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 261930)) return $2b1c5193a94af2cd$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $2b1c5193a94af2cd$var$requestDeferredLane();
    $2b1c5193a94af2cd$var$currentlyRenderingFiber.lanes |= hook;
    $2b1c5193a94af2cd$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $2b1c5193a94af2cd$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
    $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $2b1c5193a94af2cd$var$ReactSharedInternals.T, currentTransition = {};
    $2b1c5193a94af2cd$var$ReactSharedInternals.T = currentTransition;
    $2b1c5193a94af2cd$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $2b1c5193a94af2cd$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $2b1c5193a94af2cd$var$chainThenableValue(returnValue, finishedState);
            $2b1c5193a94af2cd$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $2b1c5193a94af2cd$var$requestUpdateLane(fiber));
        } else $2b1c5193a94af2cd$var$dispatchSetStateInternal(fiber, queue, finishedState, $2b1c5193a94af2cd$var$requestUpdateLane(fiber));
    } catch (error) {
        $2b1c5193a94af2cd$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $2b1c5193a94af2cd$var$requestUpdateLane());
    } finally{
        $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $2b1c5193a94af2cd$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2b1c5193a94af2cd$var$noop() {}
function $2b1c5193a94af2cd$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(476));
    var queue = $2b1c5193a94af2cd$var$ensureFormComponentIsStateful(formFiber).queue;
    $2b1c5193a94af2cd$var$startTransition(formFiber, queue, pendingState, $2b1c5193a94af2cd$var$sharedNotPendingObject, null === action ? $2b1c5193a94af2cd$var$noop : function() {
        $2b1c5193a94af2cd$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $2b1c5193a94af2cd$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $2b1c5193a94af2cd$var$sharedNotPendingObject,
        baseState: $2b1c5193a94af2cd$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2b1c5193a94af2cd$var$basicStateReducer,
            lastRenderedState: $2b1c5193a94af2cd$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $2b1c5193a94af2cd$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $2b1c5193a94af2cd$var$requestFormReset$1(formFiber) {
    var stateHook = $2b1c5193a94af2cd$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $2b1c5193a94af2cd$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $2b1c5193a94af2cd$var$requestUpdateLane());
}
function $2b1c5193a94af2cd$var$useHostTransitionStatus() {
    return $2b1c5193a94af2cd$var$readContext($2b1c5193a94af2cd$var$HostTransitionContext);
}
function $2b1c5193a94af2cd$var$updateId() {
    return $2b1c5193a94af2cd$var$updateWorkInProgressHook().memoizedState;
}
function $2b1c5193a94af2cd$var$updateRefresh() {
    return $2b1c5193a94af2cd$var$updateWorkInProgressHook().memoizedState;
}
function $2b1c5193a94af2cd$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $2b1c5193a94af2cd$var$requestUpdateLane();
                fiber = $2b1c5193a94af2cd$var$createUpdate(lane);
                var root$69 = $2b1c5193a94af2cd$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($2b1c5193a94af2cd$var$scheduleUpdateOnFiber(root$69, provider, lane), $2b1c5193a94af2cd$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $2b1c5193a94af2cd$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $2b1c5193a94af2cd$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $2b1c5193a94af2cd$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $2b1c5193a94af2cd$var$isRenderPhaseUpdate(fiber) ? $2b1c5193a94af2cd$var$enqueueRenderPhaseUpdate(queue, action) : (action = $2b1c5193a94af2cd$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($2b1c5193a94af2cd$var$scheduleUpdateOnFiber(action, fiber, lane), $2b1c5193a94af2cd$var$entangleTransitionUpdate(action, queue, lane)));
}
function $2b1c5193a94af2cd$var$dispatchSetState(fiber, queue, action) {
    var lane = $2b1c5193a94af2cd$var$requestUpdateLane();
    $2b1c5193a94af2cd$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $2b1c5193a94af2cd$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2b1c5193a94af2cd$var$isRenderPhaseUpdate(fiber)) $2b1c5193a94af2cd$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($2b1c5193a94af2cd$var$objectIs(eagerState, currentState)) return $2b1c5193a94af2cd$var$enqueueUpdate$1(fiber, queue, update, 0), null === $2b1c5193a94af2cd$var$workInProgressRoot && $2b1c5193a94af2cd$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $2b1c5193a94af2cd$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $2b1c5193a94af2cd$var$scheduleUpdateOnFiber(action, fiber, lane), $2b1c5193a94af2cd$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $2b1c5193a94af2cd$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $2b1c5193a94af2cd$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($2b1c5193a94af2cd$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $2b1c5193a94af2cd$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $2b1c5193a94af2cd$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $2b1c5193a94af2cd$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $2b1c5193a94af2cd$var$currentlyRenderingFiber || null !== alternate && alternate === $2b1c5193a94af2cd$var$currentlyRenderingFiber;
}
function $2b1c5193a94af2cd$var$enqueueRenderPhaseUpdate(queue, update) {
    $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdateDuringThisPass = $2b1c5193a94af2cd$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $2b1c5193a94af2cd$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $2b1c5193a94af2cd$var$markRootEntangled(root, lane);
    }
}
var $2b1c5193a94af2cd$var$ContextOnlyDispatcher = {
    readContext: $2b1c5193a94af2cd$var$readContext,
    use: $2b1c5193a94af2cd$var$use,
    useCallback: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useContext: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useEffect: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useImperativeHandle: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useLayoutEffect: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useInsertionEffect: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useMemo: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useReducer: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useRef: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useState: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useDebugValue: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useDeferredValue: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useTransition: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useSyncExternalStore: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useId: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useHostTransitionStatus: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useFormState: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useActionState: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useOptimistic: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useMemoCache: $2b1c5193a94af2cd$var$throwInvalidHookError,
    useCacheRefresh: $2b1c5193a94af2cd$var$throwInvalidHookError
};
$2b1c5193a94af2cd$var$ContextOnlyDispatcher.useEffectEvent = $2b1c5193a94af2cd$var$throwInvalidHookError;
var $2b1c5193a94af2cd$var$HooksDispatcherOnMount = {
    readContext: $2b1c5193a94af2cd$var$readContext,
    use: $2b1c5193a94af2cd$var$use,
    useCallback: function(callback, deps) {
        $2b1c5193a94af2cd$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $2b1c5193a94af2cd$var$readContext,
    useEffect: $2b1c5193a94af2cd$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $2b1c5193a94af2cd$var$mountEffectImpl(4194308, 4, $2b1c5193a94af2cd$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $2b1c5193a94af2cd$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $2b1c5193a94af2cd$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($2b1c5193a94af2cd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $2b1c5193a94af2cd$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $2b1c5193a94af2cd$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($2b1c5193a94af2cd$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $2b1c5193a94af2cd$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $2b1c5193a94af2cd$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $2b1c5193a94af2cd$var$dispatchReducerAction.bind(null, $2b1c5193a94af2cd$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $2b1c5193a94af2cd$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $2b1c5193a94af2cd$var$dispatchSetState.bind(null, $2b1c5193a94af2cd$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $2b1c5193a94af2cd$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
        return $2b1c5193a94af2cd$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $2b1c5193a94af2cd$var$mountStateImpl(!1);
        stateHook = $2b1c5193a94af2cd$var$startTransition.bind(null, $2b1c5193a94af2cd$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $2b1c5193a94af2cd$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $2b1c5193a94af2cd$var$currentlyRenderingFiber, hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
        if ($2b1c5193a94af2cd$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $2b1c5193a94af2cd$var$workInProgressRoot) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(349));
            0 !== ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 127) || $2b1c5193a94af2cd$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $2b1c5193a94af2cd$var$mountEffect($2b1c5193a94af2cd$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $2b1c5193a94af2cd$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $2b1c5193a94af2cd$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook(), identifierPrefix = $2b1c5193a94af2cd$var$workInProgressRoot.identifierPrefix;
        if ($2b1c5193a94af2cd$var$isHydrating) {
            var JSCompiler_inline_result = $2b1c5193a94af2cd$var$treeContextOverflow;
            var idWithLeadingBit = $2b1c5193a94af2cd$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $2b1c5193a94af2cd$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $2b1c5193a94af2cd$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $2b1c5193a94af2cd$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $2b1c5193a94af2cd$var$useHostTransitionStatus,
    useFormState: $2b1c5193a94af2cd$var$mountActionState,
    useActionState: $2b1c5193a94af2cd$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $2b1c5193a94af2cd$var$dispatchOptimisticSetState.bind(null, $2b1c5193a94af2cd$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $2b1c5193a94af2cd$var$useMemoCache,
    useCacheRefresh: function() {
        return $2b1c5193a94af2cd$var$mountWorkInProgressHook().memoizedState = $2b1c5193a94af2cd$var$refreshCache.bind(null, $2b1c5193a94af2cd$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $2b1c5193a94af2cd$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($2b1c5193a94af2cd$var$executionContext & 2)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $2b1c5193a94af2cd$var$HooksDispatcherOnUpdate = {
    readContext: $2b1c5193a94af2cd$var$readContext,
    use: $2b1c5193a94af2cd$var$use,
    useCallback: $2b1c5193a94af2cd$var$updateCallback,
    useContext: $2b1c5193a94af2cd$var$readContext,
    useEffect: $2b1c5193a94af2cd$var$updateEffect,
    useImperativeHandle: $2b1c5193a94af2cd$var$updateImperativeHandle,
    useInsertionEffect: $2b1c5193a94af2cd$var$updateInsertionEffect,
    useLayoutEffect: $2b1c5193a94af2cd$var$updateLayoutEffect,
    useMemo: $2b1c5193a94af2cd$var$updateMemo,
    useReducer: $2b1c5193a94af2cd$var$updateReducer,
    useRef: $2b1c5193a94af2cd$var$updateRef,
    useState: function() {
        return $2b1c5193a94af2cd$var$updateReducer($2b1c5193a94af2cd$var$basicStateReducer);
    },
    useDebugValue: $2b1c5193a94af2cd$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
        return $2b1c5193a94af2cd$var$updateDeferredValueImpl(hook, $2b1c5193a94af2cd$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $2b1c5193a94af2cd$var$updateReducer($2b1c5193a94af2cd$var$basicStateReducer)[0], start = $2b1c5193a94af2cd$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2b1c5193a94af2cd$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2b1c5193a94af2cd$var$updateSyncExternalStore,
    useId: $2b1c5193a94af2cd$var$updateId,
    useHostTransitionStatus: $2b1c5193a94af2cd$var$useHostTransitionStatus,
    useFormState: $2b1c5193a94af2cd$var$updateActionState,
    useActionState: $2b1c5193a94af2cd$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
        return $2b1c5193a94af2cd$var$updateOptimisticImpl(hook, $2b1c5193a94af2cd$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $2b1c5193a94af2cd$var$useMemoCache,
    useCacheRefresh: $2b1c5193a94af2cd$var$updateRefresh
};
$2b1c5193a94af2cd$var$HooksDispatcherOnUpdate.useEffectEvent = $2b1c5193a94af2cd$var$updateEvent;
var $2b1c5193a94af2cd$var$HooksDispatcherOnRerender = {
    readContext: $2b1c5193a94af2cd$var$readContext,
    use: $2b1c5193a94af2cd$var$use,
    useCallback: $2b1c5193a94af2cd$var$updateCallback,
    useContext: $2b1c5193a94af2cd$var$readContext,
    useEffect: $2b1c5193a94af2cd$var$updateEffect,
    useImperativeHandle: $2b1c5193a94af2cd$var$updateImperativeHandle,
    useInsertionEffect: $2b1c5193a94af2cd$var$updateInsertionEffect,
    useLayoutEffect: $2b1c5193a94af2cd$var$updateLayoutEffect,
    useMemo: $2b1c5193a94af2cd$var$updateMemo,
    useReducer: $2b1c5193a94af2cd$var$rerenderReducer,
    useRef: $2b1c5193a94af2cd$var$updateRef,
    useState: function() {
        return $2b1c5193a94af2cd$var$rerenderReducer($2b1c5193a94af2cd$var$basicStateReducer);
    },
    useDebugValue: $2b1c5193a94af2cd$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
        return null === $2b1c5193a94af2cd$var$currentHook ? $2b1c5193a94af2cd$var$mountDeferredValueImpl(hook, value, initialValue) : $2b1c5193a94af2cd$var$updateDeferredValueImpl(hook, $2b1c5193a94af2cd$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $2b1c5193a94af2cd$var$rerenderReducer($2b1c5193a94af2cd$var$basicStateReducer)[0], start = $2b1c5193a94af2cd$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $2b1c5193a94af2cd$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $2b1c5193a94af2cd$var$updateSyncExternalStore,
    useId: $2b1c5193a94af2cd$var$updateId,
    useHostTransitionStatus: $2b1c5193a94af2cd$var$useHostTransitionStatus,
    useFormState: $2b1c5193a94af2cd$var$rerenderActionState,
    useActionState: $2b1c5193a94af2cd$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $2b1c5193a94af2cd$var$updateWorkInProgressHook();
        if (null !== $2b1c5193a94af2cd$var$currentHook) return $2b1c5193a94af2cd$var$updateOptimisticImpl(hook, $2b1c5193a94af2cd$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $2b1c5193a94af2cd$var$useMemoCache,
    useCacheRefresh: $2b1c5193a94af2cd$var$updateRefresh
};
$2b1c5193a94af2cd$var$HooksDispatcherOnRerender.useEffectEvent = $2b1c5193a94af2cd$var$updateEvent;
function $2b1c5193a94af2cd$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $2b1c5193a94af2cd$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $2b1c5193a94af2cd$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2b1c5193a94af2cd$var$requestUpdateLane(), update = $2b1c5193a94af2cd$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2b1c5193a94af2cd$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2b1c5193a94af2cd$var$scheduleUpdateOnFiber(payload, inst, lane), $2b1c5193a94af2cd$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $2b1c5193a94af2cd$var$requestUpdateLane(), update = $2b1c5193a94af2cd$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $2b1c5193a94af2cd$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($2b1c5193a94af2cd$var$scheduleUpdateOnFiber(payload, inst, lane), $2b1c5193a94af2cd$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $2b1c5193a94af2cd$var$requestUpdateLane(), update = $2b1c5193a94af2cd$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $2b1c5193a94af2cd$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($2b1c5193a94af2cd$var$scheduleUpdateOnFiber(callback, inst, lane), $2b1c5193a94af2cd$var$entangleTransitions(callback, inst, lane));
    }
};
function $2b1c5193a94af2cd$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$2b1c5193a94af2cd$var$shallowEqual(oldProps, newProps) || !$2b1c5193a94af2cd$var$shallowEqual(oldState, newState) : !0;
}
function $2b1c5193a94af2cd$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $2b1c5193a94af2cd$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $2b1c5193a94af2cd$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $2b1c5193a94af2cd$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $2b1c5193a94af2cd$var$defaultOnUncaughtError(error) {
    $2b1c5193a94af2cd$var$reportGlobalError(error);
}
function $2b1c5193a94af2cd$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $2b1c5193a94af2cd$var$defaultOnRecoverableError(error) {
    $2b1c5193a94af2cd$var$reportGlobalError(error);
}
function $2b1c5193a94af2cd$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $2b1c5193a94af2cd$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $2b1c5193a94af2cd$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $2b1c5193a94af2cd$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $2b1c5193a94af2cd$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $2b1c5193a94af2cd$var$createClassErrorUpdate(lane) {
    lane = $2b1c5193a94af2cd$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $2b1c5193a94af2cd$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $2b1c5193a94af2cd$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $2b1c5193a94af2cd$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $2b1c5193a94af2cd$var$legacyErrorBoundariesThatAlreadyFailed ? $2b1c5193a94af2cd$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $2b1c5193a94af2cd$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $2b1c5193a94af2cd$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $2b1c5193a94af2cd$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $2b1c5193a94af2cd$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $2b1c5193a94af2cd$var$shellBoundary ? $2b1c5193a94af2cd$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $2b1c5193a94af2cd$var$workInProgressRootExitStatus && ($2b1c5193a94af2cd$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $2b1c5193a94af2cd$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $2b1c5193a94af2cd$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $2b1c5193a94af2cd$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $2b1c5193a94af2cd$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $2b1c5193a94af2cd$var$attachPingListener(root, value, rootRenderLanes);
        $2b1c5193a94af2cd$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($2b1c5193a94af2cd$var$isHydrating) return returnFiber = $2b1c5193a94af2cd$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $2b1c5193a94af2cd$var$HydrationMismatchException && (root = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(422), {
        cause: value
    }), $2b1c5193a94af2cd$var$queueHydrationError($2b1c5193a94af2cd$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $2b1c5193a94af2cd$var$HydrationMismatchException && (returnFiber = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(423), {
        cause: value
    }), $2b1c5193a94af2cd$var$queueHydrationError($2b1c5193a94af2cd$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $2b1c5193a94af2cd$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $2b1c5193a94af2cd$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $2b1c5193a94af2cd$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $2b1c5193a94af2cd$var$workInProgressRootExitStatus && ($2b1c5193a94af2cd$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $2b1c5193a94af2cd$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $2b1c5193a94af2cd$var$workInProgressRootConcurrentErrors ? $2b1c5193a94af2cd$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $2b1c5193a94af2cd$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $2b1c5193a94af2cd$var$workInProgressRootExitStatus && ($2b1c5193a94af2cd$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $2b1c5193a94af2cd$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $2b1c5193a94af2cd$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $2b1c5193a94af2cd$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $2b1c5193a94af2cd$var$legacyErrorBoundariesThatAlreadyFailed || !$2b1c5193a94af2cd$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $2b1c5193a94af2cd$var$createClassErrorUpdate(rootRenderLanes), $2b1c5193a94af2cd$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $2b1c5193a94af2cd$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $2b1c5193a94af2cd$var$SelectiveHydrationException = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(461)), $2b1c5193a94af2cd$var$didReceiveUpdate = !1;
function $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $2b1c5193a94af2cd$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $2b1c5193a94af2cd$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $2b1c5193a94af2cd$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $2b1c5193a94af2cd$var$prepareToReadContext(workInProgress);
    nextProps = $2b1c5193a94af2cd$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $2b1c5193a94af2cd$var$checkDidRenderIdHook();
    if (null !== current && !$2b1c5193a94af2cd$var$didReceiveUpdate) return $2b1c5193a94af2cd$var$bailoutHooks(current, workInProgress, renderLanes), $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2b1c5193a94af2cd$var$isHydrating && key && $2b1c5193a94af2cd$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2b1c5193a94af2cd$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$2b1c5193a94af2cd$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $2b1c5193a94af2cd$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $2b1c5193a94af2cd$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$2b1c5193a94af2cd$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $2b1c5193a94af2cd$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $2b1c5193a94af2cd$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $2b1c5193a94af2cd$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($2b1c5193a94af2cd$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($2b1c5193a94af2cd$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $2b1c5193a94af2cd$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($2b1c5193a94af2cd$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $2b1c5193a94af2cd$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $2b1c5193a94af2cd$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $2b1c5193a94af2cd$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $2b1c5193a94af2cd$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $2b1c5193a94af2cd$var$pushHiddenContext(workInProgress, prevState) : $2b1c5193a94af2cd$var$reuseHiddenContextOnStack(), $2b1c5193a94af2cd$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $2b1c5193a94af2cd$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($2b1c5193a94af2cd$var$pushTransition(workInProgress, prevState.cachePool), $2b1c5193a94af2cd$var$pushHiddenContext(workInProgress, prevState), $2b1c5193a94af2cd$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $2b1c5193a94af2cd$var$pushTransition(workInProgress, null), $2b1c5193a94af2cd$var$reuseHiddenContextOnStack(), $2b1c5193a94af2cd$var$reuseSuspenseHandlerOnStack(workInProgress));
    $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $2b1c5193a94af2cd$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $2b1c5193a94af2cd$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $2b1c5193a94af2cd$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $2b1c5193a94af2cd$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $2b1c5193a94af2cd$var$pushTransition(workInProgress, null);
    $2b1c5193a94af2cd$var$reuseHiddenContextOnStack();
    $2b1c5193a94af2cd$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $2b1c5193a94af2cd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $2b1c5193a94af2cd$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $2b1c5193a94af2cd$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $2b1c5193a94af2cd$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $2b1c5193a94af2cd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $2b1c5193a94af2cd$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $2b1c5193a94af2cd$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($2b1c5193a94af2cd$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $2b1c5193a94af2cd$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $2b1c5193a94af2cd$var$bailoutOffscreenComponent(null, current);
            $2b1c5193a94af2cd$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $2b1c5193a94af2cd$var$nextHydratableInstance) ? (current = $2b1c5193a94af2cd$var$canHydrateHydrationBoundary(current, $2b1c5193a94af2cd$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $2b1c5193a94af2cd$var$treeContextProvider ? {
                    id: $2b1c5193a94af2cd$var$treeContextId,
                    overflow: $2b1c5193a94af2cd$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $2b1c5193a94af2cd$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $2b1c5193a94af2cd$var$hydrationParentFiber = workInProgress, $2b1c5193a94af2cd$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $2b1c5193a94af2cd$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $2b1c5193a94af2cd$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $2b1c5193a94af2cd$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $2b1c5193a94af2cd$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(558));
        } else if ($2b1c5193a94af2cd$var$didReceiveUpdate || $2b1c5193a94af2cd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $2b1c5193a94af2cd$var$didReceiveUpdate || didSuspend) {
            nextProps = $2b1c5193a94af2cd$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $2b1c5193a94af2cd$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $2b1c5193a94af2cd$var$enqueueConcurrentRenderForLane(current, dehydrated), $2b1c5193a94af2cd$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $2b1c5193a94af2cd$var$SelectiveHydrationException;
            $2b1c5193a94af2cd$var$renderDidSuspendDelayIfPossible();
            workInProgress = $2b1c5193a94af2cd$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$getNextHydratable(dehydrated.nextSibling), $2b1c5193a94af2cd$var$hydrationParentFiber = workInProgress, $2b1c5193a94af2cd$var$isHydrating = !0, $2b1c5193a94af2cd$var$hydrationErrors = null, $2b1c5193a94af2cd$var$rootOrSingletonContext = !1, null !== current && $2b1c5193a94af2cd$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $2b1c5193a94af2cd$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $2b1c5193a94af2cd$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $2b1c5193a94af2cd$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $2b1c5193a94af2cd$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2b1c5193a94af2cd$var$prepareToReadContext(workInProgress);
    Component = $2b1c5193a94af2cd$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $2b1c5193a94af2cd$var$checkDidRenderIdHook();
    if (null !== current && !$2b1c5193a94af2cd$var$didReceiveUpdate) return $2b1c5193a94af2cd$var$bailoutHooks(current, workInProgress, renderLanes), $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2b1c5193a94af2cd$var$isHydrating && nextProps && $2b1c5193a94af2cd$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $2b1c5193a94af2cd$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $2b1c5193a94af2cd$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $2b1c5193a94af2cd$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $2b1c5193a94af2cd$var$finishRenderingHooks(current);
    Component = $2b1c5193a94af2cd$var$checkDidRenderIdHook();
    if (null !== current && !$2b1c5193a94af2cd$var$didReceiveUpdate) return $2b1c5193a94af2cd$var$bailoutHooks(current, workInProgress, renderLanes), $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $2b1c5193a94af2cd$var$isHydrating && Component && $2b1c5193a94af2cd$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $2b1c5193a94af2cd$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $2b1c5193a94af2cd$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $2b1c5193a94af2cd$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $2b1c5193a94af2cd$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $2b1c5193a94af2cd$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $2b1c5193a94af2cd$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $2b1c5193a94af2cd$var$readContext(contextType) : $2b1c5193a94af2cd$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($2b1c5193a94af2cd$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $2b1c5193a94af2cd$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $2b1c5193a94af2cd$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $2b1c5193a94af2cd$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $2b1c5193a94af2cd$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $2b1c5193a94af2cd$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $2b1c5193a94af2cd$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $2b1c5193a94af2cd$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $2b1c5193a94af2cd$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2b1c5193a94af2cd$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2b1c5193a94af2cd$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $2b1c5193a94af2cd$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($2b1c5193a94af2cd$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $2b1c5193a94af2cd$var$hasForceUpdate || $2b1c5193a94af2cd$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $2b1c5193a94af2cd$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $2b1c5193a94af2cd$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $2b1c5193a94af2cd$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $2b1c5193a94af2cd$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $2b1c5193a94af2cd$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $2b1c5193a94af2cd$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $2b1c5193a94af2cd$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $2b1c5193a94af2cd$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $2b1c5193a94af2cd$var$hasForceUpdate || null !== current && null !== current.dependencies && $2b1c5193a94af2cd$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($2b1c5193a94af2cd$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $2b1c5193a94af2cd$var$hasForceUpdate || $2b1c5193a94af2cd$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $2b1c5193a94af2cd$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $2b1c5193a94af2cd$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $2b1c5193a94af2cd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $2b1c5193a94af2cd$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $2b1c5193a94af2cd$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $2b1c5193a94af2cd$var$resetHydrationState();
    workInProgress.flags |= 256;
    $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $2b1c5193a94af2cd$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $2b1c5193a94af2cd$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $2b1c5193a94af2cd$var$getSuspendedCache()
    };
}
function $2b1c5193a94af2cd$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $2b1c5193a94af2cd$var$workInProgressDeferredLane);
    return current;
}
function $2b1c5193a94af2cd$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($2b1c5193a94af2cd$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($2b1c5193a94af2cd$var$isHydrating) {
            showFallback ? $2b1c5193a94af2cd$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $2b1c5193a94af2cd$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $2b1c5193a94af2cd$var$nextHydratableInstance) ? (current = $2b1c5193a94af2cd$var$canHydrateHydrationBoundary(current, $2b1c5193a94af2cd$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $2b1c5193a94af2cd$var$treeContextProvider ? {
                    id: $2b1c5193a94af2cd$var$treeContextId,
                    overflow: $2b1c5193a94af2cd$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $2b1c5193a94af2cd$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $2b1c5193a94af2cd$var$hydrationParentFiber = workInProgress, $2b1c5193a94af2cd$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $2b1c5193a94af2cd$var$throwOnHydrationMismatch(workInProgress);
            $2b1c5193a94af2cd$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $2b1c5193a94af2cd$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $2b1c5193a94af2cd$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $2b1c5193a94af2cd$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $2b1c5193a94af2cd$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $2b1c5193a94af2cd$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2b1c5193a94af2cd$var$SUSPENDED_MARKER, $2b1c5193a94af2cd$var$bailoutOffscreenComponent(null, nextProps);
        $2b1c5193a94af2cd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $2b1c5193a94af2cd$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($2b1c5193a94af2cd$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $2b1c5193a94af2cd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($2b1c5193a94af2cd$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($2b1c5193a94af2cd$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $2b1c5193a94af2cd$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $2b1c5193a94af2cd$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $2b1c5193a94af2cd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $2b1c5193a94af2cd$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $2b1c5193a94af2cd$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2b1c5193a94af2cd$var$SUSPENDED_MARKER, workInProgress = $2b1c5193a94af2cd$var$bailoutOffscreenComponent(null, nextProps));
        else if ($2b1c5193a94af2cd$var$pushPrimaryTreeSuspenseHandler(workInProgress), $2b1c5193a94af2cd$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($2b1c5193a94af2cd$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $2b1c5193a94af2cd$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $2b1c5193a94af2cd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($2b1c5193a94af2cd$var$didReceiveUpdate || $2b1c5193a94af2cd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $2b1c5193a94af2cd$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $2b1c5193a94af2cd$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $2b1c5193a94af2cd$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $2b1c5193a94af2cd$var$enqueueConcurrentRenderForLane(current, nextProps), $2b1c5193a94af2cd$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $2b1c5193a94af2cd$var$SelectiveHydrationException;
            $2b1c5193a94af2cd$var$isSuspenseInstancePending(nextPrimaryChildren) || $2b1c5193a94af2cd$var$renderDidSuspendDelayIfPossible();
            workInProgress = $2b1c5193a94af2cd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $2b1c5193a94af2cd$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$getNextHydratable(nextPrimaryChildren.nextSibling), $2b1c5193a94af2cd$var$hydrationParentFiber = workInProgress, $2b1c5193a94af2cd$var$isHydrating = !0, $2b1c5193a94af2cd$var$hydrationErrors = null, $2b1c5193a94af2cd$var$rootOrSingletonContext = !1, null !== current && $2b1c5193a94af2cd$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $2b1c5193a94af2cd$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $2b1c5193a94af2cd$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $2b1c5193a94af2cd$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $2b1c5193a94af2cd$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $2b1c5193a94af2cd$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $2b1c5193a94af2cd$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $2b1c5193a94af2cd$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $2b1c5193a94af2cd$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $2b1c5193a94af2cd$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $2b1c5193a94af2cd$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $2b1c5193a94af2cd$var$SUSPENDED_MARKER, $2b1c5193a94af2cd$var$bailoutOffscreenComponent(current.child, nextProps);
    $2b1c5193a94af2cd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $2b1c5193a94af2cd$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $2b1c5193a94af2cd$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $2b1c5193a94af2cd$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $2b1c5193a94af2cd$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $2b1c5193a94af2cd$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $2b1c5193a94af2cd$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $2b1c5193a94af2cd$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $2b1c5193a94af2cd$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $2b1c5193a94af2cd$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $2b1c5193a94af2cd$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $2b1c5193a94af2cd$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $2b1c5193a94af2cd$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $2b1c5193a94af2cd$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseStackCursor, suspenseContext);
    $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $2b1c5193a94af2cd$var$isHydrating ? $2b1c5193a94af2cd$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $2b1c5193a94af2cd$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $2b1c5193a94af2cd$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $2b1c5193a94af2cd$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $2b1c5193a94af2cd$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $2b1c5193a94af2cd$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $2b1c5193a94af2cd$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $2b1c5193a94af2cd$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $2b1c5193a94af2cd$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($2b1c5193a94af2cd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $2b1c5193a94af2cd$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $2b1c5193a94af2cd$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $2b1c5193a94af2cd$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $2b1c5193a94af2cd$var$checkIfContextChanged(current) ? !0 : !1;
}
function $2b1c5193a94af2cd$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $2b1c5193a94af2cd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $2b1c5193a94af2cd$var$pushProvider(workInProgress, $2b1c5193a94af2cd$var$CacheContext, current.memoizedState.cache);
            $2b1c5193a94af2cd$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $2b1c5193a94af2cd$var$pushHostContext(workInProgress);
            break;
        case 4:
            $2b1c5193a94af2cd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $2b1c5193a94af2cd$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $2b1c5193a94af2cd$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $2b1c5193a94af2cd$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $2b1c5193a94af2cd$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $2b1c5193a94af2cd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $2b1c5193a94af2cd$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($2b1c5193a94af2cd$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $2b1c5193a94af2cd$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseStackCursor, $2b1c5193a94af2cd$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $2b1c5193a94af2cd$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $2b1c5193a94af2cd$var$pushProvider(workInProgress, $2b1c5193a94af2cd$var$CacheContext, current.memoizedState.cache);
    }
    return $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $2b1c5193a94af2cd$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $2b1c5193a94af2cd$var$didReceiveUpdate = !0;
        else {
            if (!$2b1c5193a94af2cd$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $2b1c5193a94af2cd$var$didReceiveUpdate = !1, $2b1c5193a94af2cd$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $2b1c5193a94af2cd$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $2b1c5193a94af2cd$var$didReceiveUpdate = !1, $2b1c5193a94af2cd$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $2b1c5193a94af2cd$var$pushTreeId(workInProgress, $2b1c5193a94af2cd$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $2b1c5193a94af2cd$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $2b1c5193a94af2cd$var$shouldConstruct(current) ? (props = $2b1c5193a94af2cd$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $2b1c5193a94af2cd$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $2b1c5193a94af2cd$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $2b1c5193a94af2cd$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $2b1c5193a94af2cd$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $2b1c5193a94af2cd$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $2b1c5193a94af2cd$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $2b1c5193a94af2cd$var$getComponentNameFromType(current) || current;
                    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $2b1c5193a94af2cd$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $2b1c5193a94af2cd$var$resolveClassComponentProps(props, workInProgress.pendingProps), $2b1c5193a94af2cd$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $2b1c5193a94af2cd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $2b1c5193a94af2cd$var$cloneUpdateQueue(current, workInProgress);
                $2b1c5193a94af2cd$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $2b1c5193a94af2cd$var$pushProvider(workInProgress, $2b1c5193a94af2cd$var$CacheContext, props);
                props !== prevState.cache && $2b1c5193a94af2cd$var$propagateContextChanges(workInProgress, [
                    $2b1c5193a94af2cd$var$CacheContext
                ], renderLanes, !0);
                $2b1c5193a94af2cd$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $2b1c5193a94af2cd$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $2b1c5193a94af2cd$var$createCapturedValueAtFiber(Error($2b1c5193a94af2cd$var$formatProdErrorMessage(424)), workInProgress);
                        $2b1c5193a94af2cd$var$queueHydrationError($$typeof);
                        workInProgress = $2b1c5193a94af2cd$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$getNextHydratable(current.firstChild);
                        $2b1c5193a94af2cd$var$hydrationParentFiber = workInProgress;
                        $2b1c5193a94af2cd$var$isHydrating = !0;
                        $2b1c5193a94af2cd$var$hydrationErrors = null;
                        $2b1c5193a94af2cd$var$rootOrSingletonContext = !0;
                        renderLanes = $2b1c5193a94af2cd$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $2b1c5193a94af2cd$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $2b1c5193a94af2cd$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $2b1c5193a94af2cd$var$markRef(current, workInProgress), null === current ? (renderLanes = $2b1c5193a94af2cd$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $2b1c5193a94af2cd$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $2b1c5193a94af2cd$var$getOwnerDocumentFromRootContainer($2b1c5193a94af2cd$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$2b1c5193a94af2cd$var$internalInstanceKey] = workInProgress, props[$2b1c5193a94af2cd$var$internalPropsKey] = current, $2b1c5193a94af2cd$var$setInitialProperties(props, renderLanes, current), $2b1c5193a94af2cd$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $2b1c5193a94af2cd$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $2b1c5193a94af2cd$var$pushHostContext(workInProgress), null === current && $2b1c5193a94af2cd$var$isHydrating && (props = workInProgress.stateNode = $2b1c5193a94af2cd$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $2b1c5193a94af2cd$var$rootInstanceStackCursor.current), $2b1c5193a94af2cd$var$hydrationParentFiber = workInProgress, $2b1c5193a94af2cd$var$rootOrSingletonContext = !0, $$typeof = $2b1c5193a94af2cd$var$nextHydratableInstance, $2b1c5193a94af2cd$var$isSingletonScope(workInProgress.type) ? ($2b1c5193a94af2cd$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$getNextHydratable(props.firstChild)) : $2b1c5193a94af2cd$var$nextHydratableInstance = $$typeof), $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $2b1c5193a94af2cd$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $2b1c5193a94af2cd$var$isHydrating) {
                if ($$typeof = props = $2b1c5193a94af2cd$var$nextHydratableInstance) props = $2b1c5193a94af2cd$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $2b1c5193a94af2cd$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $2b1c5193a94af2cd$var$hydrationParentFiber = workInProgress, $2b1c5193a94af2cd$var$nextHydratableInstance = $2b1c5193a94af2cd$var$getNextHydratable(props.firstChild), $2b1c5193a94af2cd$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $2b1c5193a94af2cd$var$throwOnHydrationMismatch(workInProgress);
            }
            $2b1c5193a94af2cd$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $2b1c5193a94af2cd$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $2b1c5193a94af2cd$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $2b1c5193a94af2cd$var$renderWithHooks(current, workInProgress, $2b1c5193a94af2cd$var$TransitionAwareHostComponent, null, null, renderLanes), $2b1c5193a94af2cd$var$HostTransitionContext._currentValue = $$typeof);
            $2b1c5193a94af2cd$var$markRef(current, workInProgress);
            $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $2b1c5193a94af2cd$var$isHydrating) {
                if (current = renderLanes = $2b1c5193a94af2cd$var$nextHydratableInstance) renderLanes = $2b1c5193a94af2cd$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $2b1c5193a94af2cd$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $2b1c5193a94af2cd$var$hydrationParentFiber = workInProgress, $2b1c5193a94af2cd$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $2b1c5193a94af2cd$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $2b1c5193a94af2cd$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $2b1c5193a94af2cd$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $2b1c5193a94af2cd$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $2b1c5193a94af2cd$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $2b1c5193a94af2cd$var$pushProvider(workInProgress, workInProgress.type, props.value), $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $2b1c5193a94af2cd$var$prepareToReadContext(workInProgress), $$typeof = $2b1c5193a94af2cd$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $2b1c5193a94af2cd$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $2b1c5193a94af2cd$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $2b1c5193a94af2cd$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $2b1c5193a94af2cd$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $2b1c5193a94af2cd$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $2b1c5193a94af2cd$var$prepareToReadContext(workInProgress), props = $2b1c5193a94af2cd$var$readContext($2b1c5193a94af2cd$var$CacheContext), null === current ? ($$typeof = $2b1c5193a94af2cd$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $2b1c5193a94af2cd$var$workInProgressRoot, prevState = $2b1c5193a94af2cd$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $2b1c5193a94af2cd$var$initializeUpdateQueue(workInProgress), $2b1c5193a94af2cd$var$pushProvider(workInProgress, $2b1c5193a94af2cd$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($2b1c5193a94af2cd$var$cloneUpdateQueue(current, workInProgress), $2b1c5193a94af2cd$var$processUpdateQueue(workInProgress, null, null, renderLanes), $2b1c5193a94af2cd$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $2b1c5193a94af2cd$var$pushProvider(workInProgress, $2b1c5193a94af2cd$var$CacheContext, props)) : (props = prevState.cache, $2b1c5193a94af2cd$var$pushProvider(workInProgress, $2b1c5193a94af2cd$var$CacheContext, props), props !== $$typeof.cache && $2b1c5193a94af2cd$var$propagateContextChanges(workInProgress, [
                $2b1c5193a94af2cd$var$CacheContext
            ], renderLanes, !0))), $2b1c5193a94af2cd$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2b1c5193a94af2cd$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $2b1c5193a94af2cd$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($2b1c5193a94af2cd$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $2b1c5193a94af2cd$var$suspendedThenable = $2b1c5193a94af2cd$var$noopSuspenseyCommitThenable, $2b1c5193a94af2cd$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $2b1c5193a94af2cd$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$2b1c5193a94af2cd$var$preloadResource(resource)) {
        if ($2b1c5193a94af2cd$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $2b1c5193a94af2cd$var$suspendedThenable = $2b1c5193a94af2cd$var$noopSuspenseyCommitThenable, $2b1c5193a94af2cd$var$SuspenseyCommitException;
    }
}
function $2b1c5193a94af2cd$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $2b1c5193a94af2cd$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $2b1c5193a94af2cd$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $2b1c5193a94af2cd$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$2b1c5193a94af2cd$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $2b1c5193a94af2cd$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $2b1c5193a94af2cd$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $2b1c5193a94af2cd$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), null;
        case 1:
            return $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $2b1c5193a94af2cd$var$popProvider($2b1c5193a94af2cd$var$CacheContext);
            $2b1c5193a94af2cd$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $2b1c5193a94af2cd$var$popHydrationState(workInProgress) ? $2b1c5193a94af2cd$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $2b1c5193a94af2cd$var$upgradeHydrationErrorsToRecoverable());
            $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($2b1c5193a94af2cd$var$markUpdate(workInProgress), null !== nextResource ? ($2b1c5193a94af2cd$var$bubbleProperties(workInProgress), $2b1c5193a94af2cd$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($2b1c5193a94af2cd$var$bubbleProperties(workInProgress), $2b1c5193a94af2cd$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($2b1c5193a94af2cd$var$markUpdate(workInProgress), $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), $2b1c5193a94af2cd$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($2b1c5193a94af2cd$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $2b1c5193a94af2cd$var$markUpdate(workInProgress), $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), $2b1c5193a94af2cd$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $2b1c5193a94af2cd$var$popHostContext(workInProgress);
            renderLanes = $2b1c5193a94af2cd$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2b1c5193a94af2cd$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(166));
                    $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $2b1c5193a94af2cd$var$contextStackCursor.current;
                $2b1c5193a94af2cd$var$popHydrationState(workInProgress) ? $2b1c5193a94af2cd$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $2b1c5193a94af2cd$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $2b1c5193a94af2cd$var$markUpdate(workInProgress));
            }
            $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $2b1c5193a94af2cd$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2b1c5193a94af2cd$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(166));
                    $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $2b1c5193a94af2cd$var$contextStackCursor.current;
                if ($2b1c5193a94af2cd$var$popHydrationState(workInProgress)) $2b1c5193a94af2cd$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $2b1c5193a94af2cd$var$getOwnerDocumentFromRootContainer($2b1c5193a94af2cd$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$2b1c5193a94af2cd$var$internalInstanceKey] = workInProgress;
                    nextResource[$2b1c5193a94af2cd$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($2b1c5193a94af2cd$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $2b1c5193a94af2cd$var$markUpdate(workInProgress);
                }
            }
            $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
            $2b1c5193a94af2cd$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $2b1c5193a94af2cd$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(166));
                current = $2b1c5193a94af2cd$var$rootInstanceStackCursor.current;
                if ($2b1c5193a94af2cd$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $2b1c5193a94af2cd$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$2b1c5193a94af2cd$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $2b1c5193a94af2cd$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $2b1c5193a94af2cd$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $2b1c5193a94af2cd$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$2b1c5193a94af2cd$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $2b1c5193a94af2cd$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(557));
                        current[$2b1c5193a94af2cd$var$internalInstanceKey] = workInProgress;
                    } else $2b1c5193a94af2cd$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $2b1c5193a94af2cd$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress), workInProgress;
                    $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(558));
            }
            $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $2b1c5193a94af2cd$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(317));
                        type[$2b1c5193a94af2cd$var$internalInstanceKey] = workInProgress;
                    } else $2b1c5193a94af2cd$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $2b1c5193a94af2cd$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress), workInProgress;
                    $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $2b1c5193a94af2cd$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $2b1c5193a94af2cd$var$popHostContainer(), null === current && $2b1c5193a94af2cd$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), null;
        case 10:
            return $2b1c5193a94af2cd$var$popProvider(workInProgress.type), $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), null;
        case 19:
            $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $2b1c5193a94af2cd$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $2b1c5193a94af2cd$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $2b1c5193a94af2cd$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $2b1c5193a94af2cd$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $2b1c5193a94af2cd$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$2b1c5193a94af2cd$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseStackCursor, $2b1c5193a94af2cd$var$suspenseStackCursor.current & 1 | 2);
                            $2b1c5193a94af2cd$var$isHydrating && $2b1c5193a94af2cd$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $2b1c5193a94af2cd$var$now() > $2b1c5193a94af2cd$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $2b1c5193a94af2cd$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $2b1c5193a94af2cd$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $2b1c5193a94af2cd$var$scheduleRetryEffect(workInProgress, current), $2b1c5193a94af2cd$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$2b1c5193a94af2cd$var$isHydrating) return $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), null;
                    } else 2 * $2b1c5193a94af2cd$var$now() - newProps.renderingStartTime > $2b1c5193a94af2cd$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $2b1c5193a94af2cd$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $2b1c5193a94af2cd$var$now(), current.sibling = null, renderLanes = $2b1c5193a94af2cd$var$suspenseStackCursor.current, $2b1c5193a94af2cd$var$push($2b1c5193a94af2cd$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $2b1c5193a94af2cd$var$isHydrating && $2b1c5193a94af2cd$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $2b1c5193a94af2cd$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress), $2b1c5193a94af2cd$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($2b1c5193a94af2cd$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $2b1c5193a94af2cd$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $2b1c5193a94af2cd$var$popProvider($2b1c5193a94af2cd$var$CacheContext), $2b1c5193a94af2cd$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $2b1c5193a94af2cd$var$unwindWork(current, workInProgress) {
    $2b1c5193a94af2cd$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $2b1c5193a94af2cd$var$popProvider($2b1c5193a94af2cd$var$CacheContext), $2b1c5193a94af2cd$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $2b1c5193a94af2cd$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(340));
                $2b1c5193a94af2cd$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(340));
                $2b1c5193a94af2cd$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$suspenseStackCursor), null;
        case 4:
            return $2b1c5193a94af2cd$var$popHostContainer(), null;
        case 10:
            return $2b1c5193a94af2cd$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $2b1c5193a94af2cd$var$popSuspenseHandler(workInProgress), $2b1c5193a94af2cd$var$popHiddenContext(), null !== current && $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $2b1c5193a94af2cd$var$popProvider($2b1c5193a94af2cd$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $2b1c5193a94af2cd$var$unwindInterruptedWork(current, interruptedWork) {
    $2b1c5193a94af2cd$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $2b1c5193a94af2cd$var$popProvider($2b1c5193a94af2cd$var$CacheContext);
            $2b1c5193a94af2cd$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $2b1c5193a94af2cd$var$popHostContext(interruptedWork);
            break;
        case 4:
            $2b1c5193a94af2cd$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $2b1c5193a94af2cd$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $2b1c5193a94af2cd$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$suspenseStackCursor);
            break;
        case 10:
            $2b1c5193a94af2cd$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $2b1c5193a94af2cd$var$popSuspenseHandler(interruptedWork);
            $2b1c5193a94af2cd$var$popHiddenContext();
            null !== current && $2b1c5193a94af2cd$var$pop($2b1c5193a94af2cd$var$resumedCache);
            break;
        case 24:
            $2b1c5193a94af2cd$var$popProvider($2b1c5193a94af2cd$var$CacheContext);
    }
}
function $2b1c5193a94af2cd$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2b1c5193a94af2cd$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $2b1c5193a94af2cd$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2b1c5193a94af2cd$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $2b1c5193a94af2cd$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $2b1c5193a94af2cd$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $2b1c5193a94af2cd$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $2b1c5193a94af2cd$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2b1c5193a94af2cd$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $2b1c5193a94af2cd$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $2b1c5193a94af2cd$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $2b1c5193a94af2cd$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $2b1c5193a94af2cd$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $2b1c5193a94af2cd$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2b1c5193a94af2cd$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $2b1c5193a94af2cd$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$2b1c5193a94af2cd$var$internalPropsKey] = newProps;
    } catch (error) {
        $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2b1c5193a94af2cd$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $2b1c5193a94af2cd$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $2b1c5193a94af2cd$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $2b1c5193a94af2cd$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $2b1c5193a94af2cd$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $2b1c5193a94af2cd$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $2b1c5193a94af2cd$var$noop$1));
    else if (4 !== tag && (27 === tag && $2b1c5193a94af2cd$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($2b1c5193a94af2cd$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$2b1c5193a94af2cd$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $2b1c5193a94af2cd$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $2b1c5193a94af2cd$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($2b1c5193a94af2cd$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$2b1c5193a94af2cd$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $2b1c5193a94af2cd$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $2b1c5193a94af2cd$var$setInitialProperties(singleton, type, props);
        singleton[$2b1c5193a94af2cd$var$internalInstanceKey] = finishedWork;
        singleton[$2b1c5193a94af2cd$var$internalPropsKey] = props;
    } catch (error) {
        $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden = !1, $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden = !1, $2b1c5193a94af2cd$var$needsFormReset = !1, $2b1c5193a94af2cd$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $2b1c5193a94af2cd$var$nextEffect = null;
function $2b1c5193a94af2cd$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $2b1c5193a94af2cd$var$eventsEnabled = $2b1c5193a94af2cd$var$_enabled;
    root = $2b1c5193a94af2cd$var$getActiveElementDeep(root);
    if ($2b1c5193a94af2cd$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $2b1c5193a94af2cd$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $2b1c5193a94af2cd$var$_enabled = !1;
    for($2b1c5193a94af2cd$var$nextEffect = firstChild; null !== $2b1c5193a94af2cd$var$nextEffect;)if (firstChild = $2b1c5193a94af2cd$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $2b1c5193a94af2cd$var$nextEffect = root;
    else for(; null !== $2b1c5193a94af2cd$var$nextEffect;){
        firstChild = $2b1c5193a94af2cd$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $2b1c5193a94af2cd$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $2b1c5193a94af2cd$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $2b1c5193a94af2cd$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $2b1c5193a94af2cd$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $2b1c5193a94af2cd$var$nextEffect = root;
            break;
        }
        $2b1c5193a94af2cd$var$nextEffect = firstChild.return;
    }
}
function $2b1c5193a94af2cd$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2b1c5193a94af2cd$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $2b1c5193a94af2cd$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $2b1c5193a94af2cd$var$commitClassCallbacks(finishedWork);
            flags & 512 && $2b1c5193a94af2cd$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $2b1c5193a94af2cd$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $2b1c5193a94af2cd$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $2b1c5193a94af2cd$var$commitHostMount(finishedWork);
            flags & 512 && $2b1c5193a94af2cd$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2b1c5193a94af2cd$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $2b1c5193a94af2cd$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $2b1c5193a94af2cd$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $2b1c5193a94af2cd$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden;
                prevProps = $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden;
                $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden = flags;
                ($2b1c5193a94af2cd$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden = prevProps;
                $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $2b1c5193a94af2cd$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $2b1c5193a94af2cd$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $2b1c5193a94af2cd$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $2b1c5193a94af2cd$var$hostParent = null, $2b1c5193a94af2cd$var$hostParentIsContainer = !1;
function $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$2b1c5193a94af2cd$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $2b1c5193a94af2cd$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($2b1c5193a94af2cd$var$injectedHook && "function" === typeof $2b1c5193a94af2cd$var$injectedHook.onCommitFiberUnmount) try {
        $2b1c5193a94af2cd$var$injectedHook.onCommitFiberUnmount($2b1c5193a94af2cd$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || $2b1c5193a94af2cd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || $2b1c5193a94af2cd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $2b1c5193a94af2cd$var$hostParent, prevHostParentIsContainer = $2b1c5193a94af2cd$var$hostParentIsContainer;
            $2b1c5193a94af2cd$var$isSingletonScope(deletedFiber.type) && ($2b1c5193a94af2cd$var$hostParent = deletedFiber.stateNode, $2b1c5193a94af2cd$var$hostParentIsContainer = !1);
            $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2b1c5193a94af2cd$var$releaseSingletonInstance(deletedFiber.stateNode);
            $2b1c5193a94af2cd$var$hostParent = prevHostParent;
            $2b1c5193a94af2cd$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || $2b1c5193a94af2cd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $2b1c5193a94af2cd$var$hostParent;
            prevHostParentIsContainer = $2b1c5193a94af2cd$var$hostParentIsContainer;
            $2b1c5193a94af2cd$var$hostParent = null;
            $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2b1c5193a94af2cd$var$hostParent = prevHostParent;
            $2b1c5193a94af2cd$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $2b1c5193a94af2cd$var$hostParent) {
                if ($2b1c5193a94af2cd$var$hostParentIsContainer) try {
                    (9 === $2b1c5193a94af2cd$var$hostParent.nodeType ? $2b1c5193a94af2cd$var$hostParent.body : "HTML" === $2b1c5193a94af2cd$var$hostParent.nodeName ? $2b1c5193a94af2cd$var$hostParent.ownerDocument.body : $2b1c5193a94af2cd$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2b1c5193a94af2cd$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $2b1c5193a94af2cd$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $2b1c5193a94af2cd$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $2b1c5193a94af2cd$var$hostParent && ($2b1c5193a94af2cd$var$hostParentIsContainer ? (finishedRoot = $2b1c5193a94af2cd$var$hostParent, $2b1c5193a94af2cd$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $2b1c5193a94af2cd$var$retryIfBlockedOn(finishedRoot)) : $2b1c5193a94af2cd$var$clearHydrationBoundary($2b1c5193a94af2cd$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $2b1c5193a94af2cd$var$hostParent;
            prevHostParentIsContainer = $2b1c5193a94af2cd$var$hostParentIsContainer;
            $2b1c5193a94af2cd$var$hostParent = deletedFiber.stateNode.containerInfo;
            $2b1c5193a94af2cd$var$hostParentIsContainer = !0;
            $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2b1c5193a94af2cd$var$hostParent = prevHostParent;
            $2b1c5193a94af2cd$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $2b1c5193a94af2cd$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || $2b1c5193a94af2cd$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || ($2b1c5193a94af2cd$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $2b1c5193a94af2cd$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden = (prevHostParent = $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $2b1c5193a94af2cd$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $2b1c5193a94af2cd$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $2b1c5193a94af2cd$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $2b1c5193a94af2cd$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $2b1c5193a94af2cd$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $2b1c5193a94af2cd$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $2b1c5193a94af2cd$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $2b1c5193a94af2cd$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $2b1c5193a94af2cd$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $2b1c5193a94af2cd$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $2b1c5193a94af2cd$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($2b1c5193a94af2cd$var$isSingletonScope(parent.type)) {
                        $2b1c5193a94af2cd$var$hostParent = parent.stateNode;
                        $2b1c5193a94af2cd$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $2b1c5193a94af2cd$var$hostParent = parent.stateNode;
                    $2b1c5193a94af2cd$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $2b1c5193a94af2cd$var$hostParent = parent.stateNode.containerInfo;
                    $2b1c5193a94af2cd$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $2b1c5193a94af2cd$var$hostParent) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(160));
        $2b1c5193a94af2cd$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $2b1c5193a94af2cd$var$hostParent = null;
        $2b1c5193a94af2cd$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$2b1c5193a94af2cd$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $2b1c5193a94af2cd$var$currentHoistableRoot = null;
function $2b1c5193a94af2cd$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($2b1c5193a94af2cd$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $2b1c5193a94af2cd$var$commitHookEffectListMount(3, finishedWork), $2b1c5193a94af2cd$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || null === current || $2b1c5193a94af2cd$var$safelyDetachRef(current, current.return));
            flags & 64 && $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $2b1c5193a94af2cd$var$currentHoistableRoot;
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || null === current || $2b1c5193a94af2cd$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$2b1c5193a94af2cd$var$internalHoistableMarker] || currentResource[$2b1c5193a94af2cd$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $2b1c5193a94af2cd$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$2b1c5193a94af2cd$var$internalInstanceKey] = finishedWork;
                                        $2b1c5193a94af2cd$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $2b1c5193a94af2cd$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2b1c5193a94af2cd$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $2b1c5193a94af2cd$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $2b1c5193a94af2cd$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$2b1c5193a94af2cd$var$internalInstanceKey] = finishedWork;
                                $2b1c5193a94af2cd$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $2b1c5193a94af2cd$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $2b1c5193a94af2cd$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $2b1c5193a94af2cd$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $2b1c5193a94af2cd$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $2b1c5193a94af2cd$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || null === current || $2b1c5193a94af2cd$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $2b1c5193a94af2cd$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || null === current || $2b1c5193a94af2cd$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $2b1c5193a94af2cd$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $2b1c5193a94af2cd$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($2b1c5193a94af2cd$var$needsFormReset = !0);
            break;
        case 6:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $2b1c5193a94af2cd$var$tagCaches = null;
            hoistableRoot = $2b1c5193a94af2cd$var$currentHoistableRoot;
            $2b1c5193a94af2cd$var$currentHoistableRoot = $2b1c5193a94af2cd$var$getHoistableRoot(root.containerInfo);
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$currentHoistableRoot = hoistableRoot;
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $2b1c5193a94af2cd$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $2b1c5193a94af2cd$var$needsFormReset && ($2b1c5193a94af2cd$var$needsFormReset = !1, $2b1c5193a94af2cd$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $2b1c5193a94af2cd$var$currentHoistableRoot;
            $2b1c5193a94af2cd$var$currentHoistableRoot = $2b1c5193a94af2cd$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            $2b1c5193a94af2cd$var$currentHoistableRoot = flags;
            break;
        case 12:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2b1c5193a94af2cd$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($2b1c5193a94af2cd$var$globalMostRecentFallbackTime = $2b1c5193a94af2cd$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2b1c5193a94af2cd$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden;
            $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $2b1c5193a94af2cd$var$offscreenSubtreeIsHidden || $2b1c5193a94af2cd$var$offscreenSubtreeWasHidden || $2b1c5193a94af2cd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $2b1c5193a94af2cd$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $2b1c5193a94af2cd$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $2b1c5193a94af2cd$var$hideOrUnhideDehydratedBoundary(instance, !0) : $2b1c5193a94af2cd$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $2b1c5193a94af2cd$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $2b1c5193a94af2cd$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $2b1c5193a94af2cd$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $2b1c5193a94af2cd$var$recursivelyTraverseMutationEffects(root, finishedWork), $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork);
    }
}
function $2b1c5193a94af2cd$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($2b1c5193a94af2cd$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $2b1c5193a94af2cd$var$getHostSibling(finishedWork);
                    $2b1c5193a94af2cd$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($2b1c5193a94af2cd$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $2b1c5193a94af2cd$var$getHostSibling(finishedWork);
                    $2b1c5193a94af2cd$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $2b1c5193a94af2cd$var$getHostSibling(finishedWork);
                    $2b1c5193a94af2cd$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $2b1c5193a94af2cd$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $2b1c5193a94af2cd$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $2b1c5193a94af2cd$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$2b1c5193a94af2cd$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $2b1c5193a94af2cd$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $2b1c5193a94af2cd$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $2b1c5193a94af2cd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $2b1c5193a94af2cd$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $2b1c5193a94af2cd$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $2b1c5193a94af2cd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $2b1c5193a94af2cd$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $2b1c5193a94af2cd$var$safelyDetachRef(finishedWork, finishedWork.return);
                $2b1c5193a94af2cd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2b1c5193a94af2cd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $2b1c5193a94af2cd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $2b1c5193a94af2cd$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2b1c5193a94af2cd$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $2b1c5193a94af2cd$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$2b1c5193a94af2cd$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $2b1c5193a94af2cd$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $2b1c5193a94af2cd$var$commitClassCallbacks(finishedWork);
                $2b1c5193a94af2cd$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $2b1c5193a94af2cd$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $2b1c5193a94af2cd$var$commitHostMount(finishedWork);
                $2b1c5193a94af2cd$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $2b1c5193a94af2cd$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $2b1c5193a94af2cd$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $2b1c5193a94af2cd$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $2b1c5193a94af2cd$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2b1c5193a94af2cd$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $2b1c5193a94af2cd$var$releaseCache(previousCache));
}
function $2b1c5193a94af2cd$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $2b1c5193a94af2cd$var$releaseCache(current));
}
function $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2b1c5193a94af2cd$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $2b1c5193a94af2cd$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2b1c5193a94af2cd$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $2b1c5193a94af2cd$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $2b1c5193a94af2cd$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $2b1c5193a94af2cd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $2b1c5193a94af2cd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $2b1c5193a94af2cd$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $2b1c5193a94af2cd$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $2b1c5193a94af2cd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $2b1c5193a94af2cd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $2b1c5193a94af2cd$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $2b1c5193a94af2cd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $2b1c5193a94af2cd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $2b1c5193a94af2cd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $2b1c5193a94af2cd$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2b1c5193a94af2cd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $2b1c5193a94af2cd$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2b1c5193a94af2cd$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2b1c5193a94af2cd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $2b1c5193a94af2cd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2b1c5193a94af2cd$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $2b1c5193a94af2cd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $2b1c5193a94af2cd$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $2b1c5193a94af2cd$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $2b1c5193a94af2cd$var$suspenseyCommitFlag = 8192;
function $2b1c5193a94af2cd$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $2b1c5193a94af2cd$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$2b1c5193a94af2cd$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $2b1c5193a94af2cd$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $2b1c5193a94af2cd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $2b1c5193a94af2cd$var$suspenseyCommitFlag && null !== fiber.memoizedState && $2b1c5193a94af2cd$var$suspendResource(suspendedState, $2b1c5193a94af2cd$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $2b1c5193a94af2cd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $2b1c5193a94af2cd$var$currentHoistableRoot;
            $2b1c5193a94af2cd$var$currentHoistableRoot = $2b1c5193a94af2cd$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $2b1c5193a94af2cd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $2b1c5193a94af2cd$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $2b1c5193a94af2cd$var$suspenseyCommitFlag, $2b1c5193a94af2cd$var$suspenseyCommitFlag = 16777216, $2b1c5193a94af2cd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $2b1c5193a94af2cd$var$suspenseyCommitFlag = previousHoistableRoot) : $2b1c5193a94af2cd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $2b1c5193a94af2cd$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $2b1c5193a94af2cd$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $2b1c5193a94af2cd$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2b1c5193a94af2cd$var$nextEffect = childToDelete;
            $2b1c5193a94af2cd$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2b1c5193a94af2cd$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$2b1c5193a94af2cd$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $2b1c5193a94af2cd$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $2b1c5193a94af2cd$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $2b1c5193a94af2cd$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $2b1c5193a94af2cd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $2b1c5193a94af2cd$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $2b1c5193a94af2cd$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $2b1c5193a94af2cd$var$nextEffect = childToDelete;
            $2b1c5193a94af2cd$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $2b1c5193a94af2cd$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $2b1c5193a94af2cd$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $2b1c5193a94af2cd$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $2b1c5193a94af2cd$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $2b1c5193a94af2cd$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $2b1c5193a94af2cd$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $2b1c5193a94af2cd$var$nextEffect;){
        var fiber = $2b1c5193a94af2cd$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $2b1c5193a94af2cd$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $2b1c5193a94af2cd$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $2b1c5193a94af2cd$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $2b1c5193a94af2cd$var$nextEffect;){
            cache = $2b1c5193a94af2cd$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $2b1c5193a94af2cd$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $2b1c5193a94af2cd$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $2b1c5193a94af2cd$var$nextEffect = sibling;
                break a;
            }
            $2b1c5193a94af2cd$var$nextEffect = returnFiber;
        }
    }
}
var $2b1c5193a94af2cd$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $2b1c5193a94af2cd$var$readContext($2b1c5193a94af2cd$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $2b1c5193a94af2cd$var$readContext($2b1c5193a94af2cd$var$CacheContext).controller.signal;
    }
}, $2b1c5193a94af2cd$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $2b1c5193a94af2cd$var$executionContext = 0, $2b1c5193a94af2cd$var$workInProgressRoot = null, $2b1c5193a94af2cd$var$workInProgress = null, $2b1c5193a94af2cd$var$workInProgressRootRenderLanes = 0, $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0, $2b1c5193a94af2cd$var$workInProgressThrownValue = null, $2b1c5193a94af2cd$var$workInProgressRootDidSkipSuspendedSiblings = !1, $2b1c5193a94af2cd$var$workInProgressRootIsPrerendering = !1, $2b1c5193a94af2cd$var$workInProgressRootDidAttachPingListener = !1, $2b1c5193a94af2cd$var$entangledRenderLanes = 0, $2b1c5193a94af2cd$var$workInProgressRootExitStatus = 0, $2b1c5193a94af2cd$var$workInProgressRootSkippedLanes = 0, $2b1c5193a94af2cd$var$workInProgressRootInterleavedUpdatedLanes = 0, $2b1c5193a94af2cd$var$workInProgressRootPingedLanes = 0, $2b1c5193a94af2cd$var$workInProgressDeferredLane = 0, $2b1c5193a94af2cd$var$workInProgressSuspendedRetryLanes = 0, $2b1c5193a94af2cd$var$workInProgressRootConcurrentErrors = null, $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors = null, $2b1c5193a94af2cd$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $2b1c5193a94af2cd$var$globalMostRecentFallbackTime = 0, $2b1c5193a94af2cd$var$globalMostRecentTransitionTime = 0, $2b1c5193a94af2cd$var$workInProgressRootRenderTargetTime = Infinity, $2b1c5193a94af2cd$var$workInProgressTransitions = null, $2b1c5193a94af2cd$var$legacyErrorBoundariesThatAlreadyFailed = null, $2b1c5193a94af2cd$var$pendingEffectsStatus = 0, $2b1c5193a94af2cd$var$pendingEffectsRoot = null, $2b1c5193a94af2cd$var$pendingFinishedWork = null, $2b1c5193a94af2cd$var$pendingEffectsLanes = 0, $2b1c5193a94af2cd$var$pendingEffectsRemainingLanes = 0, $2b1c5193a94af2cd$var$pendingPassiveTransitions = null, $2b1c5193a94af2cd$var$pendingRecoverableErrors = null, $2b1c5193a94af2cd$var$nestedUpdateCount = 0, $2b1c5193a94af2cd$var$rootWithNestedUpdates = null;
function $2b1c5193a94af2cd$var$requestUpdateLane() {
    return 0 !== ($2b1c5193a94af2cd$var$executionContext & 2) && 0 !== $2b1c5193a94af2cd$var$workInProgressRootRenderLanes ? $2b1c5193a94af2cd$var$workInProgressRootRenderLanes & -$2b1c5193a94af2cd$var$workInProgressRootRenderLanes : null !== $2b1c5193a94af2cd$var$ReactSharedInternals.T ? $2b1c5193a94af2cd$var$requestTransitionLane() : $2b1c5193a94af2cd$var$resolveUpdatePriority();
}
function $2b1c5193a94af2cd$var$requestDeferredLane() {
    if (0 === $2b1c5193a94af2cd$var$workInProgressDeferredLane) {
        if (0 === ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 536870912) || $2b1c5193a94af2cd$var$isHydrating) {
            var lane = $2b1c5193a94af2cd$var$nextTransitionDeferredLane;
            $2b1c5193a94af2cd$var$nextTransitionDeferredLane <<= 1;
            0 === ($2b1c5193a94af2cd$var$nextTransitionDeferredLane & 3932160) && ($2b1c5193a94af2cd$var$nextTransitionDeferredLane = 262144);
            $2b1c5193a94af2cd$var$workInProgressDeferredLane = lane;
        } else $2b1c5193a94af2cd$var$workInProgressDeferredLane = 536870912;
    }
    lane = $2b1c5193a94af2cd$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $2b1c5193a94af2cd$var$workInProgressDeferredLane;
}
function $2b1c5193a94af2cd$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $2b1c5193a94af2cd$var$workInProgressRoot && (2 === $2b1c5193a94af2cd$var$workInProgressSuspendedReason || 9 === $2b1c5193a94af2cd$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $2b1c5193a94af2cd$var$prepareFreshStack(root, 0), $2b1c5193a94af2cd$var$markRootSuspended(root, $2b1c5193a94af2cd$var$workInProgressRootRenderLanes, $2b1c5193a94af2cd$var$workInProgressDeferredLane, !1);
    $2b1c5193a94af2cd$var$markRootUpdated$1(root, lane);
    if (0 === ($2b1c5193a94af2cd$var$executionContext & 2) || root !== $2b1c5193a94af2cd$var$workInProgressRoot) root === $2b1c5193a94af2cd$var$workInProgressRoot && (0 === ($2b1c5193a94af2cd$var$executionContext & 2) && ($2b1c5193a94af2cd$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $2b1c5193a94af2cd$var$workInProgressRootExitStatus && $2b1c5193a94af2cd$var$markRootSuspended(root, $2b1c5193a94af2cd$var$workInProgressRootRenderLanes, $2b1c5193a94af2cd$var$workInProgressDeferredLane, !1)), $2b1c5193a94af2cd$var$ensureRootIsScheduled(root);
}
function $2b1c5193a94af2cd$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($2b1c5193a94af2cd$var$executionContext & 6)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $2b1c5193a94af2cd$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $2b1c5193a94af2cd$var$renderRootConcurrent(root$jscomp$0, lanes) : $2b1c5193a94af2cd$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $2b1c5193a94af2cd$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $2b1c5193a94af2cd$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$2b1c5193a94af2cd$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $2b1c5193a94af2cd$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $2b1c5193a94af2cd$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($2b1c5193a94af2cd$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $2b1c5193a94af2cd$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($2b1c5193a94af2cd$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $2b1c5193a94af2cd$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors;
                            $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors ? $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors.push.apply($2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $2b1c5193a94af2cd$var$prepareFreshStack(root$jscomp$0, 0);
                $2b1c5193a94af2cd$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $2b1c5193a94af2cd$var$markRootSuspended(shouldTimeSlice, lanes, $2b1c5193a94af2cd$var$workInProgressDeferredLane, !$2b1c5193a94af2cd$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $2b1c5193a94af2cd$var$globalMostRecentFallbackTime + 300 - $2b1c5193a94af2cd$var$now(), 10 < exitStatus)) {
                    $2b1c5193a94af2cd$var$markRootSuspended(shouldTimeSlice, lanes, $2b1c5193a94af2cd$var$workInProgressDeferredLane, !$2b1c5193a94af2cd$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $2b1c5193a94af2cd$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $2b1c5193a94af2cd$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $2b1c5193a94af2cd$var$scheduleTimeout($2b1c5193a94af2cd$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors, $2b1c5193a94af2cd$var$workInProgressTransitions, $2b1c5193a94af2cd$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2b1c5193a94af2cd$var$workInProgressDeferredLane, $2b1c5193a94af2cd$var$workInProgressRootInterleavedUpdatedLanes, $2b1c5193a94af2cd$var$workInProgressSuspendedRetryLanes, $2b1c5193a94af2cd$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $2b1c5193a94af2cd$var$commitRootWhenReady(shouldTimeSlice, forceSync, $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors, $2b1c5193a94af2cd$var$workInProgressTransitions, $2b1c5193a94af2cd$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $2b1c5193a94af2cd$var$workInProgressDeferredLane, $2b1c5193a94af2cd$var$workInProgressRootInterleavedUpdatedLanes, $2b1c5193a94af2cd$var$workInProgressSuspendedRetryLanes, $2b1c5193a94af2cd$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $2b1c5193a94af2cd$var$ensureRootIsScheduled(root$jscomp$0);
}
function $2b1c5193a94af2cd$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $2b1c5193a94af2cd$var$noop$1
        };
        $2b1c5193a94af2cd$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $2b1c5193a94af2cd$var$globalMostRecentFallbackTime - $2b1c5193a94af2cd$var$now() : (lanes & 4194048) === lanes ? $2b1c5193a94af2cd$var$globalMostRecentTransitionTime - $2b1c5193a94af2cd$var$now() : 0;
        timeoutOffset = $2b1c5193a94af2cd$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $2b1c5193a94af2cd$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($2b1c5193a94af2cd$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $2b1c5193a94af2cd$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $2b1c5193a94af2cd$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $2b1c5193a94af2cd$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$2b1c5193a94af2cd$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $2b1c5193a94af2cd$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$2b1c5193a94af2cd$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$2b1c5193a94af2cd$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $2b1c5193a94af2cd$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $2b1c5193a94af2cd$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $2b1c5193a94af2cd$var$flushSyncWork$1() {
    return 0 === ($2b1c5193a94af2cd$var$executionContext & 6) ? ($2b1c5193a94af2cd$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $2b1c5193a94af2cd$var$resetWorkInProgressStack() {
    if (null !== $2b1c5193a94af2cd$var$workInProgress) {
        if (0 === $2b1c5193a94af2cd$var$workInProgressSuspendedReason) var interruptedWork = $2b1c5193a94af2cd$var$workInProgress.return;
        else interruptedWork = $2b1c5193a94af2cd$var$workInProgress, $2b1c5193a94af2cd$var$lastContextDependency = $2b1c5193a94af2cd$var$currentlyRenderingFiber$1 = null, $2b1c5193a94af2cd$var$resetHooksOnUnwind(interruptedWork), $2b1c5193a94af2cd$var$thenableState$1 = null, $2b1c5193a94af2cd$var$thenableIndexCounter$1 = 0, interruptedWork = $2b1c5193a94af2cd$var$workInProgress;
        for(; null !== interruptedWork;)$2b1c5193a94af2cd$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $2b1c5193a94af2cd$var$workInProgress = null;
    }
}
function $2b1c5193a94af2cd$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $2b1c5193a94af2cd$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $2b1c5193a94af2cd$var$pendingEffectsLanes = 0;
    $2b1c5193a94af2cd$var$resetWorkInProgressStack();
    $2b1c5193a94af2cd$var$workInProgressRoot = root;
    $2b1c5193a94af2cd$var$workInProgress = timeoutHandle = $2b1c5193a94af2cd$var$createWorkInProgress(root.current, null);
    $2b1c5193a94af2cd$var$workInProgressRootRenderLanes = lanes;
    $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0;
    $2b1c5193a94af2cd$var$workInProgressThrownValue = null;
    $2b1c5193a94af2cd$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $2b1c5193a94af2cd$var$workInProgressRootIsPrerendering = $2b1c5193a94af2cd$var$checkIfRootIsPrerendering(root, lanes);
    $2b1c5193a94af2cd$var$workInProgressRootDidAttachPingListener = !1;
    $2b1c5193a94af2cd$var$workInProgressSuspendedRetryLanes = $2b1c5193a94af2cd$var$workInProgressDeferredLane = $2b1c5193a94af2cd$var$workInProgressRootPingedLanes = $2b1c5193a94af2cd$var$workInProgressRootInterleavedUpdatedLanes = $2b1c5193a94af2cd$var$workInProgressRootSkippedLanes = $2b1c5193a94af2cd$var$workInProgressRootExitStatus = 0;
    $2b1c5193a94af2cd$var$workInProgressRootRecoverableErrors = $2b1c5193a94af2cd$var$workInProgressRootConcurrentErrors = null;
    $2b1c5193a94af2cd$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $2b1c5193a94af2cd$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $2b1c5193a94af2cd$var$entangledRenderLanes = lanes;
    $2b1c5193a94af2cd$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $2b1c5193a94af2cd$var$handleThrow(root, thrownValue) {
    $2b1c5193a94af2cd$var$currentlyRenderingFiber = null;
    $2b1c5193a94af2cd$var$ReactSharedInternals.H = $2b1c5193a94af2cd$var$ContextOnlyDispatcher;
    thrownValue === $2b1c5193a94af2cd$var$SuspenseException || thrownValue === $2b1c5193a94af2cd$var$SuspenseActionException ? (thrownValue = $2b1c5193a94af2cd$var$getSuspendedThenable(), $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 3) : thrownValue === $2b1c5193a94af2cd$var$SuspenseyCommitException ? (thrownValue = $2b1c5193a94af2cd$var$getSuspendedThenable(), $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 4) : $2b1c5193a94af2cd$var$workInProgressSuspendedReason = thrownValue === $2b1c5193a94af2cd$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $2b1c5193a94af2cd$var$workInProgressThrownValue = thrownValue;
    null === $2b1c5193a94af2cd$var$workInProgress && ($2b1c5193a94af2cd$var$workInProgressRootExitStatus = 1, $2b1c5193a94af2cd$var$logUncaughtError(root, $2b1c5193a94af2cd$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $2b1c5193a94af2cd$var$shouldRemainOnPreviousScreen() {
    var handler = $2b1c5193a94af2cd$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 4194048) === $2b1c5193a94af2cd$var$workInProgressRootRenderLanes ? null === $2b1c5193a94af2cd$var$shellBoundary ? !0 : !1 : ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 62914560) === $2b1c5193a94af2cd$var$workInProgressRootRenderLanes || 0 !== ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 536870912) ? handler === $2b1c5193a94af2cd$var$shellBoundary : !1;
}
function $2b1c5193a94af2cd$var$pushDispatcher() {
    var prevDispatcher = $2b1c5193a94af2cd$var$ReactSharedInternals.H;
    $2b1c5193a94af2cd$var$ReactSharedInternals.H = $2b1c5193a94af2cd$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $2b1c5193a94af2cd$var$ContextOnlyDispatcher : prevDispatcher;
}
function $2b1c5193a94af2cd$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $2b1c5193a94af2cd$var$ReactSharedInternals.A;
    $2b1c5193a94af2cd$var$ReactSharedInternals.A = $2b1c5193a94af2cd$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $2b1c5193a94af2cd$var$renderDidSuspendDelayIfPossible() {
    $2b1c5193a94af2cd$var$workInProgressRootExitStatus = 4;
    $2b1c5193a94af2cd$var$workInProgressRootDidSkipSuspendedSiblings || ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 4194048) !== $2b1c5193a94af2cd$var$workInProgressRootRenderLanes && null !== $2b1c5193a94af2cd$var$suspenseHandlerStackCursor.current || ($2b1c5193a94af2cd$var$workInProgressRootIsPrerendering = !0);
    0 === ($2b1c5193a94af2cd$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($2b1c5193a94af2cd$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $2b1c5193a94af2cd$var$workInProgressRoot || $2b1c5193a94af2cd$var$markRootSuspended($2b1c5193a94af2cd$var$workInProgressRoot, $2b1c5193a94af2cd$var$workInProgressRootRenderLanes, $2b1c5193a94af2cd$var$workInProgressDeferredLane, !1);
}
function $2b1c5193a94af2cd$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $2b1c5193a94af2cd$var$executionContext;
    $2b1c5193a94af2cd$var$executionContext |= 2;
    var prevDispatcher = $2b1c5193a94af2cd$var$pushDispatcher(), prevAsyncDispatcher = $2b1c5193a94af2cd$var$pushAsyncDispatcher();
    if ($2b1c5193a94af2cd$var$workInProgressRoot !== root || $2b1c5193a94af2cd$var$workInProgressRootRenderLanes !== lanes) $2b1c5193a94af2cd$var$workInProgressTransitions = null, $2b1c5193a94af2cd$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $2b1c5193a94af2cd$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $2b1c5193a94af2cd$var$workInProgressSuspendedReason && null !== $2b1c5193a94af2cd$var$workInProgress) {
            var unitOfWork = $2b1c5193a94af2cd$var$workInProgress, thrownValue = $2b1c5193a94af2cd$var$workInProgressThrownValue;
            switch($2b1c5193a94af2cd$var$workInProgressSuspendedReason){
                case 8:
                    $2b1c5193a94af2cd$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $2b1c5193a94af2cd$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $2b1c5193a94af2cd$var$workInProgressSuspendedReason;
                    $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0;
                    $2b1c5193a94af2cd$var$workInProgressThrownValue = null;
                    $2b1c5193a94af2cd$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $2b1c5193a94af2cd$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $2b1c5193a94af2cd$var$workInProgressSuspendedReason, $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0, $2b1c5193a94af2cd$var$workInProgressThrownValue = null, $2b1c5193a94af2cd$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $2b1c5193a94af2cd$var$workLoopSync();
        exitStatus = $2b1c5193a94af2cd$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $2b1c5193a94af2cd$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $2b1c5193a94af2cd$var$lastContextDependency = $2b1c5193a94af2cd$var$currentlyRenderingFiber$1 = null;
    $2b1c5193a94af2cd$var$executionContext = prevExecutionContext;
    $2b1c5193a94af2cd$var$ReactSharedInternals.H = prevDispatcher;
    $2b1c5193a94af2cd$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $2b1c5193a94af2cd$var$workInProgress && ($2b1c5193a94af2cd$var$workInProgressRoot = null, $2b1c5193a94af2cd$var$workInProgressRootRenderLanes = 0, $2b1c5193a94af2cd$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $2b1c5193a94af2cd$var$workLoopSync() {
    for(; null !== $2b1c5193a94af2cd$var$workInProgress;)$2b1c5193a94af2cd$var$performUnitOfWork($2b1c5193a94af2cd$var$workInProgress);
}
function $2b1c5193a94af2cd$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $2b1c5193a94af2cd$var$executionContext;
    $2b1c5193a94af2cd$var$executionContext |= 2;
    var prevDispatcher = $2b1c5193a94af2cd$var$pushDispatcher(), prevAsyncDispatcher = $2b1c5193a94af2cd$var$pushAsyncDispatcher();
    $2b1c5193a94af2cd$var$workInProgressRoot !== root || $2b1c5193a94af2cd$var$workInProgressRootRenderLanes !== lanes ? ($2b1c5193a94af2cd$var$workInProgressTransitions = null, $2b1c5193a94af2cd$var$workInProgressRootRenderTargetTime = $2b1c5193a94af2cd$var$now() + 500, $2b1c5193a94af2cd$var$prepareFreshStack(root, lanes)) : $2b1c5193a94af2cd$var$workInProgressRootIsPrerendering = $2b1c5193a94af2cd$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $2b1c5193a94af2cd$var$workInProgressSuspendedReason && null !== $2b1c5193a94af2cd$var$workInProgress) {
            lanes = $2b1c5193a94af2cd$var$workInProgress;
            var thrownValue = $2b1c5193a94af2cd$var$workInProgressThrownValue;
            b: switch($2b1c5193a94af2cd$var$workInProgressSuspendedReason){
                case 1:
                    $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0;
                    $2b1c5193a94af2cd$var$workInProgressThrownValue = null;
                    $2b1c5193a94af2cd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($2b1c5193a94af2cd$var$isThenableResolved(thrownValue)) {
                        $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0;
                        $2b1c5193a94af2cd$var$workInProgressThrownValue = null;
                        $2b1c5193a94af2cd$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $2b1c5193a94af2cd$var$workInProgressSuspendedReason && 9 !== $2b1c5193a94af2cd$var$workInProgressSuspendedReason || $2b1c5193a94af2cd$var$workInProgressRoot !== root || ($2b1c5193a94af2cd$var$workInProgressSuspendedReason = 7);
                        $2b1c5193a94af2cd$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $2b1c5193a94af2cd$var$isThenableResolved(thrownValue) ? ($2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0, $2b1c5193a94af2cd$var$workInProgressThrownValue = null, $2b1c5193a94af2cd$var$replaySuspendedUnitOfWork(lanes)) : ($2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0, $2b1c5193a94af2cd$var$workInProgressThrownValue = null, $2b1c5193a94af2cd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($2b1c5193a94af2cd$var$workInProgress.tag){
                        case 26:
                            resource = $2b1c5193a94af2cd$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $2b1c5193a94af2cd$var$workInProgress;
                            if (resource ? $2b1c5193a94af2cd$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0;
                                $2b1c5193a94af2cd$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $2b1c5193a94af2cd$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($2b1c5193a94af2cd$var$workInProgress = returnFiber, $2b1c5193a94af2cd$var$completeUnitOfWork(returnFiber)) : $2b1c5193a94af2cd$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0;
                    $2b1c5193a94af2cd$var$workInProgressThrownValue = null;
                    $2b1c5193a94af2cd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $2b1c5193a94af2cd$var$workInProgressSuspendedReason = 0;
                    $2b1c5193a94af2cd$var$workInProgressThrownValue = null;
                    $2b1c5193a94af2cd$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $2b1c5193a94af2cd$var$resetWorkInProgressStack();
                    $2b1c5193a94af2cd$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(462));
            }
        }
        $2b1c5193a94af2cd$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $2b1c5193a94af2cd$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $2b1c5193a94af2cd$var$lastContextDependency = $2b1c5193a94af2cd$var$currentlyRenderingFiber$1 = null;
    $2b1c5193a94af2cd$var$ReactSharedInternals.H = prevDispatcher;
    $2b1c5193a94af2cd$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $2b1c5193a94af2cd$var$executionContext = prevExecutionContext;
    if (null !== $2b1c5193a94af2cd$var$workInProgress) return 0;
    $2b1c5193a94af2cd$var$workInProgressRoot = null;
    $2b1c5193a94af2cd$var$workInProgressRootRenderLanes = 0;
    $2b1c5193a94af2cd$var$finishQueueingConcurrentUpdates();
    return $2b1c5193a94af2cd$var$workInProgressRootExitStatus;
}
function $2b1c5193a94af2cd$var$workLoopConcurrentByScheduler() {
    for(; null !== $2b1c5193a94af2cd$var$workInProgress && !$2b1c5193a94af2cd$var$shouldYield();)$2b1c5193a94af2cd$var$performUnitOfWork($2b1c5193a94af2cd$var$workInProgress);
}
function $2b1c5193a94af2cd$var$performUnitOfWork(unitOfWork) {
    var next = $2b1c5193a94af2cd$var$beginWork(unitOfWork.alternate, unitOfWork, $2b1c5193a94af2cd$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2b1c5193a94af2cd$var$completeUnitOfWork(unitOfWork) : $2b1c5193a94af2cd$var$workInProgress = next;
}
function $2b1c5193a94af2cd$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $2b1c5193a94af2cd$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $2b1c5193a94af2cd$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $2b1c5193a94af2cd$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $2b1c5193a94af2cd$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $2b1c5193a94af2cd$var$resetHooksOnUnwind(next);
        default:
            $2b1c5193a94af2cd$var$unwindInterruptedWork(current, next), next = $2b1c5193a94af2cd$var$workInProgress = $2b1c5193a94af2cd$var$resetWorkInProgress(next, $2b1c5193a94af2cd$var$entangledRenderLanes), next = $2b1c5193a94af2cd$var$beginWork(current, next, $2b1c5193a94af2cd$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $2b1c5193a94af2cd$var$completeUnitOfWork(unitOfWork) : $2b1c5193a94af2cd$var$workInProgress = next;
}
function $2b1c5193a94af2cd$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $2b1c5193a94af2cd$var$lastContextDependency = $2b1c5193a94af2cd$var$currentlyRenderingFiber$1 = null;
    $2b1c5193a94af2cd$var$resetHooksOnUnwind(unitOfWork);
    $2b1c5193a94af2cd$var$thenableState$1 = null;
    $2b1c5193a94af2cd$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($2b1c5193a94af2cd$var$throwException(root, returnFiber, unitOfWork, thrownValue, $2b1c5193a94af2cd$var$workInProgressRootRenderLanes)) {
            $2b1c5193a94af2cd$var$workInProgressRootExitStatus = 1;
            $2b1c5193a94af2cd$var$logUncaughtError(root, $2b1c5193a94af2cd$var$createCapturedValueAtFiber(thrownValue, root.current));
            $2b1c5193a94af2cd$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $2b1c5193a94af2cd$var$workInProgress = returnFiber, error;
        $2b1c5193a94af2cd$var$workInProgressRootExitStatus = 1;
        $2b1c5193a94af2cd$var$logUncaughtError(root, $2b1c5193a94af2cd$var$createCapturedValueAtFiber(thrownValue, root.current));
        $2b1c5193a94af2cd$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($2b1c5193a94af2cd$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($2b1c5193a94af2cd$var$workInProgressRootIsPrerendering || 0 !== ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($2b1c5193a94af2cd$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $2b1c5193a94af2cd$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $2b1c5193a94af2cd$var$unwindUnitOfWork(unitOfWork, root);
    } else $2b1c5193a94af2cd$var$completeUnitOfWork(unitOfWork);
}
function $2b1c5193a94af2cd$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $2b1c5193a94af2cd$var$unwindUnitOfWork(completedWork, $2b1c5193a94af2cd$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $2b1c5193a94af2cd$var$completeWork(completedWork.alternate, completedWork, $2b1c5193a94af2cd$var$entangledRenderLanes);
        if (null !== next) {
            $2b1c5193a94af2cd$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $2b1c5193a94af2cd$var$workInProgress = completedWork;
            return;
        }
        $2b1c5193a94af2cd$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $2b1c5193a94af2cd$var$workInProgressRootExitStatus && ($2b1c5193a94af2cd$var$workInProgressRootExitStatus = 5);
}
function $2b1c5193a94af2cd$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $2b1c5193a94af2cd$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $2b1c5193a94af2cd$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $2b1c5193a94af2cd$var$workInProgress = unitOfWork;
            return;
        }
        $2b1c5193a94af2cd$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $2b1c5193a94af2cd$var$workInProgressRootExitStatus = 6;
    $2b1c5193a94af2cd$var$workInProgress = null;
}
function $2b1c5193a94af2cd$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $2b1c5193a94af2cd$var$flushPendingEffects();
    while (0 !== $2b1c5193a94af2cd$var$pendingEffectsStatus);
    if (0 !== ($2b1c5193a94af2cd$var$executionContext & 6)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $2b1c5193a94af2cd$var$concurrentlyUpdatedLanes;
        $2b1c5193a94af2cd$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $2b1c5193a94af2cd$var$workInProgressRoot && ($2b1c5193a94af2cd$var$workInProgress = $2b1c5193a94af2cd$var$workInProgressRoot = null, $2b1c5193a94af2cd$var$workInProgressRootRenderLanes = 0);
        $2b1c5193a94af2cd$var$pendingFinishedWork = finishedWork;
        $2b1c5193a94af2cd$var$pendingEffectsRoot = root;
        $2b1c5193a94af2cd$var$pendingEffectsLanes = lanes;
        $2b1c5193a94af2cd$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $2b1c5193a94af2cd$var$pendingPassiveTransitions = transitions;
        $2b1c5193a94af2cd$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $2b1c5193a94af2cd$var$scheduleCallback$1($2b1c5193a94af2cd$var$NormalPriority$1, function() {
            $2b1c5193a94af2cd$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $2b1c5193a94af2cd$var$ReactSharedInternals.T;
            $2b1c5193a94af2cd$var$ReactSharedInternals.T = null;
            transitions = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
            $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $2b1c5193a94af2cd$var$executionContext;
            $2b1c5193a94af2cd$var$executionContext |= 4;
            try {
                $2b1c5193a94af2cd$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $2b1c5193a94af2cd$var$executionContext = spawnedLane, $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = transitions, $2b1c5193a94af2cd$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $2b1c5193a94af2cd$var$pendingEffectsStatus = 1;
        $2b1c5193a94af2cd$var$flushMutationEffects();
        $2b1c5193a94af2cd$var$flushLayoutEffects();
        $2b1c5193a94af2cd$var$flushSpawnedWork();
    }
}
function $2b1c5193a94af2cd$var$flushMutationEffects() {
    if (1 === $2b1c5193a94af2cd$var$pendingEffectsStatus) {
        $2b1c5193a94af2cd$var$pendingEffectsStatus = 0;
        var root = $2b1c5193a94af2cd$var$pendingEffectsRoot, finishedWork = $2b1c5193a94af2cd$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $2b1c5193a94af2cd$var$ReactSharedInternals.T;
            $2b1c5193a94af2cd$var$ReactSharedInternals.T = null;
            var previousPriority = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
            $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2b1c5193a94af2cd$var$executionContext;
            $2b1c5193a94af2cd$var$executionContext |= 4;
            try {
                $2b1c5193a94af2cd$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $2b1c5193a94af2cd$var$selectionInformation, curFocusedElem = $2b1c5193a94af2cd$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $2b1c5193a94af2cd$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $2b1c5193a94af2cd$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $2b1c5193a94af2cd$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $2b1c5193a94af2cd$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $2b1c5193a94af2cd$var$_enabled = !!$2b1c5193a94af2cd$var$eventsEnabled;
                $2b1c5193a94af2cd$var$selectionInformation = $2b1c5193a94af2cd$var$eventsEnabled = null;
            } finally{
                $2b1c5193a94af2cd$var$executionContext = prevExecutionContext, $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = previousPriority, $2b1c5193a94af2cd$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $2b1c5193a94af2cd$var$pendingEffectsStatus = 2;
    }
}
function $2b1c5193a94af2cd$var$flushLayoutEffects() {
    if (2 === $2b1c5193a94af2cd$var$pendingEffectsStatus) {
        $2b1c5193a94af2cd$var$pendingEffectsStatus = 0;
        var root = $2b1c5193a94af2cd$var$pendingEffectsRoot, finishedWork = $2b1c5193a94af2cd$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $2b1c5193a94af2cd$var$ReactSharedInternals.T;
            $2b1c5193a94af2cd$var$ReactSharedInternals.T = null;
            var previousPriority = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
            $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $2b1c5193a94af2cd$var$executionContext;
            $2b1c5193a94af2cd$var$executionContext |= 4;
            try {
                $2b1c5193a94af2cd$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $2b1c5193a94af2cd$var$executionContext = prevExecutionContext, $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = previousPriority, $2b1c5193a94af2cd$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $2b1c5193a94af2cd$var$pendingEffectsStatus = 3;
    }
}
function $2b1c5193a94af2cd$var$flushSpawnedWork() {
    if (4 === $2b1c5193a94af2cd$var$pendingEffectsStatus || 3 === $2b1c5193a94af2cd$var$pendingEffectsStatus) {
        $2b1c5193a94af2cd$var$pendingEffectsStatus = 0;
        $2b1c5193a94af2cd$var$requestPaint();
        var root = $2b1c5193a94af2cd$var$pendingEffectsRoot, finishedWork = $2b1c5193a94af2cd$var$pendingFinishedWork, lanes = $2b1c5193a94af2cd$var$pendingEffectsLanes, recoverableErrors = $2b1c5193a94af2cd$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $2b1c5193a94af2cd$var$pendingEffectsStatus = 5 : ($2b1c5193a94af2cd$var$pendingEffectsStatus = 0, $2b1c5193a94af2cd$var$pendingFinishedWork = $2b1c5193a94af2cd$var$pendingEffectsRoot = null, $2b1c5193a94af2cd$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($2b1c5193a94af2cd$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $2b1c5193a94af2cd$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($2b1c5193a94af2cd$var$injectedHook && "function" === typeof $2b1c5193a94af2cd$var$injectedHook.onCommitFiberRoot) try {
            $2b1c5193a94af2cd$var$injectedHook.onCommitFiberRoot($2b1c5193a94af2cd$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $2b1c5193a94af2cd$var$ReactSharedInternals.T;
            remainingLanes = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
            $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = 2;
            $2b1c5193a94af2cd$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $2b1c5193a94af2cd$var$ReactSharedInternals.T = finishedWork, $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($2b1c5193a94af2cd$var$pendingEffectsLanes & 3) && $2b1c5193a94af2cd$var$flushPendingEffects();
        $2b1c5193a94af2cd$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $2b1c5193a94af2cd$var$rootWithNestedUpdates ? $2b1c5193a94af2cd$var$nestedUpdateCount++ : ($2b1c5193a94af2cd$var$nestedUpdateCount = 0, $2b1c5193a94af2cd$var$rootWithNestedUpdates = root) : $2b1c5193a94af2cd$var$nestedUpdateCount = 0;
        $2b1c5193a94af2cd$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $2b1c5193a94af2cd$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $2b1c5193a94af2cd$var$releaseCache(remainingLanes)));
}
function $2b1c5193a94af2cd$var$flushPendingEffects() {
    $2b1c5193a94af2cd$var$flushMutationEffects();
    $2b1c5193a94af2cd$var$flushLayoutEffects();
    $2b1c5193a94af2cd$var$flushSpawnedWork();
    return $2b1c5193a94af2cd$var$flushPassiveEffects();
}
function $2b1c5193a94af2cd$var$flushPassiveEffects() {
    if (5 !== $2b1c5193a94af2cd$var$pendingEffectsStatus) return !1;
    var root = $2b1c5193a94af2cd$var$pendingEffectsRoot, remainingLanes = $2b1c5193a94af2cd$var$pendingEffectsRemainingLanes;
    $2b1c5193a94af2cd$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $2b1c5193a94af2cd$var$lanesToEventPriority($2b1c5193a94af2cd$var$pendingEffectsLanes), prevTransition = $2b1c5193a94af2cd$var$ReactSharedInternals.T, previousPriority = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
    try {
        $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $2b1c5193a94af2cd$var$ReactSharedInternals.T = null;
        renderPriority = $2b1c5193a94af2cd$var$pendingPassiveTransitions;
        $2b1c5193a94af2cd$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $2b1c5193a94af2cd$var$pendingEffectsRoot, lanes = $2b1c5193a94af2cd$var$pendingEffectsLanes;
        $2b1c5193a94af2cd$var$pendingEffectsStatus = 0;
        $2b1c5193a94af2cd$var$pendingFinishedWork = $2b1c5193a94af2cd$var$pendingEffectsRoot = null;
        $2b1c5193a94af2cd$var$pendingEffectsLanes = 0;
        if (0 !== ($2b1c5193a94af2cd$var$executionContext & 6)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(331));
        var prevExecutionContext = $2b1c5193a94af2cd$var$executionContext;
        $2b1c5193a94af2cd$var$executionContext |= 4;
        $2b1c5193a94af2cd$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $2b1c5193a94af2cd$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $2b1c5193a94af2cd$var$executionContext = prevExecutionContext;
        $2b1c5193a94af2cd$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($2b1c5193a94af2cd$var$injectedHook && "function" === typeof $2b1c5193a94af2cd$var$injectedHook.onPostCommitFiberRoot) try {
            $2b1c5193a94af2cd$var$injectedHook.onPostCommitFiberRoot($2b1c5193a94af2cd$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = previousPriority, $2b1c5193a94af2cd$var$ReactSharedInternals.T = prevTransition, $2b1c5193a94af2cd$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $2b1c5193a94af2cd$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $2b1c5193a94af2cd$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $2b1c5193a94af2cd$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $2b1c5193a94af2cd$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($2b1c5193a94af2cd$var$markRootUpdated$1(rootFiber, 2), $2b1c5193a94af2cd$var$ensureRootIsScheduled(rootFiber));
}
function $2b1c5193a94af2cd$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $2b1c5193a94af2cd$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $2b1c5193a94af2cd$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $2b1c5193a94af2cd$var$legacyErrorBoundariesThatAlreadyFailed || !$2b1c5193a94af2cd$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $2b1c5193a94af2cd$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $2b1c5193a94af2cd$var$createClassErrorUpdate(2);
                instance = $2b1c5193a94af2cd$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($2b1c5193a94af2cd$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $2b1c5193a94af2cd$var$markRootUpdated$1(instance, 2), $2b1c5193a94af2cd$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $2b1c5193a94af2cd$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $2b1c5193a94af2cd$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($2b1c5193a94af2cd$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $2b1c5193a94af2cd$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $2b1c5193a94af2cd$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $2b1c5193a94af2cd$var$workInProgressRoot === root && ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $2b1c5193a94af2cd$var$workInProgressRootExitStatus || 3 === $2b1c5193a94af2cd$var$workInProgressRootExitStatus && ($2b1c5193a94af2cd$var$workInProgressRootRenderLanes & 62914560) === $2b1c5193a94af2cd$var$workInProgressRootRenderLanes && 300 > $2b1c5193a94af2cd$var$now() - $2b1c5193a94af2cd$var$globalMostRecentFallbackTime ? 0 === ($2b1c5193a94af2cd$var$executionContext & 2) && $2b1c5193a94af2cd$var$prepareFreshStack(root, 0) : $2b1c5193a94af2cd$var$workInProgressRootPingedLanes |= pingedLanes, $2b1c5193a94af2cd$var$workInProgressSuspendedRetryLanes === $2b1c5193a94af2cd$var$workInProgressRootRenderLanes && ($2b1c5193a94af2cd$var$workInProgressSuspendedRetryLanes = 0));
    $2b1c5193a94af2cd$var$ensureRootIsScheduled(root);
}
function $2b1c5193a94af2cd$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $2b1c5193a94af2cd$var$claimNextRetryLane());
    boundaryFiber = $2b1c5193a94af2cd$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($2b1c5193a94af2cd$var$markRootUpdated$1(boundaryFiber, retryLane), $2b1c5193a94af2cd$var$ensureRootIsScheduled(boundaryFiber));
}
function $2b1c5193a94af2cd$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $2b1c5193a94af2cd$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2b1c5193a94af2cd$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $2b1c5193a94af2cd$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $2b1c5193a94af2cd$var$scheduleCallback$1(priorityLevel, callback) {
    return $2b1c5193a94af2cd$var$scheduleCallback$3(priorityLevel, callback);
}
var $2b1c5193a94af2cd$var$firstScheduledRoot = null, $2b1c5193a94af2cd$var$lastScheduledRoot = null, $2b1c5193a94af2cd$var$didScheduleMicrotask = !1, $2b1c5193a94af2cd$var$mightHavePendingSyncWork = !1, $2b1c5193a94af2cd$var$isFlushingWork = !1, $2b1c5193a94af2cd$var$currentEventTransitionLane = 0;
function $2b1c5193a94af2cd$var$ensureRootIsScheduled(root) {
    root !== $2b1c5193a94af2cd$var$lastScheduledRoot && null === root.next && (null === $2b1c5193a94af2cd$var$lastScheduledRoot ? $2b1c5193a94af2cd$var$firstScheduledRoot = $2b1c5193a94af2cd$var$lastScheduledRoot = root : $2b1c5193a94af2cd$var$lastScheduledRoot = $2b1c5193a94af2cd$var$lastScheduledRoot.next = root);
    $2b1c5193a94af2cd$var$mightHavePendingSyncWork = !0;
    $2b1c5193a94af2cd$var$didScheduleMicrotask || ($2b1c5193a94af2cd$var$didScheduleMicrotask = !0, $2b1c5193a94af2cd$var$scheduleImmediateRootScheduleTask());
}
function $2b1c5193a94af2cd$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$2b1c5193a94af2cd$var$isFlushingWork && $2b1c5193a94af2cd$var$mightHavePendingSyncWork) {
        $2b1c5193a94af2cd$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $2b1c5193a94af2cd$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $2b1c5193a94af2cd$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $2b1c5193a94af2cd$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $2b1c5193a94af2cd$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $2b1c5193a94af2cd$var$getNextLanes(root$170, root$170 === $2b1c5193a94af2cd$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $2b1c5193a94af2cd$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $2b1c5193a94af2cd$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $2b1c5193a94af2cd$var$isFlushingWork = !1;
    }
}
function $2b1c5193a94af2cd$var$processRootScheduleInImmediateTask() {
    $2b1c5193a94af2cd$var$processRootScheduleInMicrotask();
}
function $2b1c5193a94af2cd$var$processRootScheduleInMicrotask() {
    $2b1c5193a94af2cd$var$mightHavePendingSyncWork = $2b1c5193a94af2cd$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $2b1c5193a94af2cd$var$currentEventTransitionLane && $2b1c5193a94af2cd$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $2b1c5193a94af2cd$var$currentEventTransitionLane);
    for(var currentTime = $2b1c5193a94af2cd$var$now(), prev = null, root = $2b1c5193a94af2cd$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $2b1c5193a94af2cd$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $2b1c5193a94af2cd$var$firstScheduledRoot = next : prev.next = next, null === next && ($2b1c5193a94af2cd$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $2b1c5193a94af2cd$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $2b1c5193a94af2cd$var$pendingEffectsStatus && 5 !== $2b1c5193a94af2cd$var$pendingEffectsStatus || $2b1c5193a94af2cd$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $2b1c5193a94af2cd$var$currentEventTransitionLane && ($2b1c5193a94af2cd$var$currentEventTransitionLane = 0);
}
function $2b1c5193a94af2cd$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $2b1c5193a94af2cd$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $2b1c5193a94af2cd$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $2b1c5193a94af2cd$var$workInProgressRoot;
    suspendedLanes = $2b1c5193a94af2cd$var$workInProgressRootRenderLanes;
    suspendedLanes = $2b1c5193a94af2cd$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $2b1c5193a94af2cd$var$workInProgressSuspendedReason || 9 === $2b1c5193a94af2cd$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $2b1c5193a94af2cd$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $2b1c5193a94af2cd$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $2b1c5193a94af2cd$var$cancelCallback$1(pingedLanes);
        switch($2b1c5193a94af2cd$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $2b1c5193a94af2cd$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $2b1c5193a94af2cd$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $2b1c5193a94af2cd$var$IdlePriority;
                break;
            default:
                suspendedLanes = $2b1c5193a94af2cd$var$NormalPriority$1;
        }
        pingedLanes = $2b1c5193a94af2cd$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $2b1c5193a94af2cd$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $2b1c5193a94af2cd$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $2b1c5193a94af2cd$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $2b1c5193a94af2cd$var$pendingEffectsStatus && 5 !== $2b1c5193a94af2cd$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($2b1c5193a94af2cd$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $2b1c5193a94af2cd$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $2b1c5193a94af2cd$var$getNextLanes(root, root === $2b1c5193a94af2cd$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $2b1c5193a94af2cd$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $2b1c5193a94af2cd$var$scheduleTaskForRootDuringMicrotask(root, $2b1c5193a94af2cd$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $2b1c5193a94af2cd$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $2b1c5193a94af2cd$var$performSyncWorkOnRoot(root, lanes) {
    if ($2b1c5193a94af2cd$var$flushPendingEffects()) return null;
    $2b1c5193a94af2cd$var$performWorkOnRoot(root, lanes, !0);
}
function $2b1c5193a94af2cd$var$scheduleImmediateRootScheduleTask() {
    $2b1c5193a94af2cd$var$scheduleMicrotask(function() {
        0 !== ($2b1c5193a94af2cd$var$executionContext & 6) ? $2b1c5193a94af2cd$var$scheduleCallback$3($2b1c5193a94af2cd$var$ImmediatePriority, $2b1c5193a94af2cd$var$processRootScheduleInImmediateTask) : $2b1c5193a94af2cd$var$processRootScheduleInMicrotask();
    });
}
function $2b1c5193a94af2cd$var$requestTransitionLane() {
    if (0 === $2b1c5193a94af2cd$var$currentEventTransitionLane) {
        var actionScopeLane = $2b1c5193a94af2cd$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $2b1c5193a94af2cd$var$nextTransitionUpdateLane, $2b1c5193a94af2cd$var$nextTransitionUpdateLane <<= 1, 0 === ($2b1c5193a94af2cd$var$nextTransitionUpdateLane & 261888) && ($2b1c5193a94af2cd$var$nextTransitionUpdateLane = 256));
        $2b1c5193a94af2cd$var$currentEventTransitionLane = actionScopeLane;
    }
    return $2b1c5193a94af2cd$var$currentEventTransitionLane;
}
function $2b1c5193a94af2cd$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $2b1c5193a94af2cd$var$sanitizeURL("" + actionProp);
}
function $2b1c5193a94af2cd$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $2b1c5193a94af2cd$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $2b1c5193a94af2cd$var$coerceFormActionProp((nativeEventTarget[$2b1c5193a94af2cd$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$2b1c5193a94af2cd$var$internalPropsKey] || null) ? $2b1c5193a94af2cd$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $2b1c5193a94af2cd$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $2b1c5193a94af2cd$var$currentEventTransitionLane) {
                                var formData = submitter ? $2b1c5193a94af2cd$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $2b1c5193a94af2cd$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $2b1c5193a94af2cd$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $2b1c5193a94af2cd$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $2b1c5193a94af2cd$var$i$jscomp$inline_1577 = 0; $2b1c5193a94af2cd$var$i$jscomp$inline_1577 < $2b1c5193a94af2cd$var$simpleEventPluginEvents.length; $2b1c5193a94af2cd$var$i$jscomp$inline_1577++){
    var $2b1c5193a94af2cd$var$eventName$jscomp$inline_1578 = $2b1c5193a94af2cd$var$simpleEventPluginEvents[$2b1c5193a94af2cd$var$i$jscomp$inline_1577], $2b1c5193a94af2cd$var$domEventName$jscomp$inline_1579 = $2b1c5193a94af2cd$var$eventName$jscomp$inline_1578.toLowerCase(), $2b1c5193a94af2cd$var$capitalizedEvent$jscomp$inline_1580 = $2b1c5193a94af2cd$var$eventName$jscomp$inline_1578[0].toUpperCase() + $2b1c5193a94af2cd$var$eventName$jscomp$inline_1578.slice(1);
    $2b1c5193a94af2cd$var$registerSimpleEvent($2b1c5193a94af2cd$var$domEventName$jscomp$inline_1579, "on" + $2b1c5193a94af2cd$var$capitalizedEvent$jscomp$inline_1580);
}
$2b1c5193a94af2cd$var$registerSimpleEvent($2b1c5193a94af2cd$var$ANIMATION_END, "onAnimationEnd");
$2b1c5193a94af2cd$var$registerSimpleEvent($2b1c5193a94af2cd$var$ANIMATION_ITERATION, "onAnimationIteration");
$2b1c5193a94af2cd$var$registerSimpleEvent($2b1c5193a94af2cd$var$ANIMATION_START, "onAnimationStart");
$2b1c5193a94af2cd$var$registerSimpleEvent("dblclick", "onDoubleClick");
$2b1c5193a94af2cd$var$registerSimpleEvent("focusin", "onFocus");
$2b1c5193a94af2cd$var$registerSimpleEvent("focusout", "onBlur");
$2b1c5193a94af2cd$var$registerSimpleEvent($2b1c5193a94af2cd$var$TRANSITION_RUN, "onTransitionRun");
$2b1c5193a94af2cd$var$registerSimpleEvent($2b1c5193a94af2cd$var$TRANSITION_START, "onTransitionStart");
$2b1c5193a94af2cd$var$registerSimpleEvent($2b1c5193a94af2cd$var$TRANSITION_CANCEL, "onTransitionCancel");
$2b1c5193a94af2cd$var$registerSimpleEvent($2b1c5193a94af2cd$var$TRANSITION_END, "onTransitionEnd");
$2b1c5193a94af2cd$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$2b1c5193a94af2cd$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$2b1c5193a94af2cd$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$2b1c5193a94af2cd$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$2b1c5193a94af2cd$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$2b1c5193a94af2cd$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$2b1c5193a94af2cd$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$2b1c5193a94af2cd$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$2b1c5193a94af2cd$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$2b1c5193a94af2cd$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $2b1c5193a94af2cd$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $2b1c5193a94af2cd$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($2b1c5193a94af2cd$var$mediaEventTypes));
function $2b1c5193a94af2cd$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2b1c5193a94af2cd$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $2b1c5193a94af2cd$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $2b1c5193a94af2cd$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$2b1c5193a94af2cd$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$2b1c5193a94af2cd$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($2b1c5193a94af2cd$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $2b1c5193a94af2cd$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $2b1c5193a94af2cd$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $2b1c5193a94af2cd$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $2b1c5193a94af2cd$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$2b1c5193a94af2cd$var$listeningMarker]) {
        rootContainerElement[$2b1c5193a94af2cd$var$listeningMarker] = !0;
        $2b1c5193a94af2cd$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($2b1c5193a94af2cd$var$nonDelegatedEvents.has(domEventName) || $2b1c5193a94af2cd$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $2b1c5193a94af2cd$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$2b1c5193a94af2cd$var$listeningMarker] || (ownerDocument[$2b1c5193a94af2cd$var$listeningMarker] = !0, $2b1c5193a94af2cd$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $2b1c5193a94af2cd$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($2b1c5193a94af2cd$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $2b1c5193a94af2cd$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $2b1c5193a94af2cd$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $2b1c5193a94af2cd$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$2b1c5193a94af2cd$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $2b1c5193a94af2cd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $2b1c5193a94af2cd$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $2b1c5193a94af2cd$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $2b1c5193a94af2cd$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $2b1c5193a94af2cd$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $2b1c5193a94af2cd$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticTouchEvent;
                        break;
                    case $2b1c5193a94af2cd$var$ANIMATION_END:
                    case $2b1c5193a94af2cd$var$ANIMATION_ITERATION:
                    case $2b1c5193a94af2cd$var$ANIMATION_START:
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticAnimationEvent;
                        break;
                    case $2b1c5193a94af2cd$var$TRANSITION_END:
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $2b1c5193a94af2cd$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $2b1c5193a94af2cd$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($2b1c5193a94af2cd$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $2b1c5193a94af2cd$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($2b1c5193a94af2cd$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$2b1c5193a94af2cd$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $2b1c5193a94af2cd$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $2b1c5193a94af2cd$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $2b1c5193a94af2cd$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $2b1c5193a94af2cd$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $2b1c5193a94af2cd$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $2b1c5193a94af2cd$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $2b1c5193a94af2cd$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $2b1c5193a94af2cd$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $2b1c5193a94af2cd$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $2b1c5193a94af2cd$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $2b1c5193a94af2cd$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $2b1c5193a94af2cd$var$getTargetInstForChangeEvent;
                else if ($2b1c5193a94af2cd$var$isTextInputElement(reactName)) {
                    if ($2b1c5193a94af2cd$var$isInputEventSupported) getTargetInstFunc = $2b1c5193a94af2cd$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $2b1c5193a94af2cd$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $2b1c5193a94af2cd$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $2b1c5193a94af2cd$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $2b1c5193a94af2cd$var$getTargetInstForChangeEvent) : getTargetInstFunc = $2b1c5193a94af2cd$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $2b1c5193a94af2cd$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $2b1c5193a94af2cd$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $2b1c5193a94af2cd$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($2b1c5193a94af2cd$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $2b1c5193a94af2cd$var$activeElement = handleEventFunc, $2b1c5193a94af2cd$var$activeElementInst = targetInst, $2b1c5193a94af2cd$var$lastSelection = null;
                    break;
                case "focusout":
                    $2b1c5193a94af2cd$var$lastSelection = $2b1c5193a94af2cd$var$activeElementInst = $2b1c5193a94af2cd$var$activeElement = null;
                    break;
                case "mousedown":
                    $2b1c5193a94af2cd$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $2b1c5193a94af2cd$var$mouseDown = !1;
                    $2b1c5193a94af2cd$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($2b1c5193a94af2cd$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $2b1c5193a94af2cd$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($2b1c5193a94af2cd$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $2b1c5193a94af2cd$var$isComposing ? $2b1c5193a94af2cd$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($2b1c5193a94af2cd$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($2b1c5193a94af2cd$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $2b1c5193a94af2cd$var$isComposing && (fallbackData = $2b1c5193a94af2cd$var$getData()) : ($2b1c5193a94af2cd$var$root = nativeEventTarget, $2b1c5193a94af2cd$var$startText = "value" in $2b1c5193a94af2cd$var$root ? $2b1c5193a94af2cd$var$root.value : $2b1c5193a94af2cd$var$root.textContent, $2b1c5193a94af2cd$var$isComposing = !0)), handleEventFunc = $2b1c5193a94af2cd$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $2b1c5193a94af2cd$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $2b1c5193a94af2cd$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $2b1c5193a94af2cd$var$canUseTextInputEvent ? $2b1c5193a94af2cd$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $2b1c5193a94af2cd$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $2b1c5193a94af2cd$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $2b1c5193a94af2cd$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $2b1c5193a94af2cd$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $2b1c5193a94af2cd$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $2b1c5193a94af2cd$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $2b1c5193a94af2cd$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $2b1c5193a94af2cd$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($2b1c5193a94af2cd$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $2b1c5193a94af2cd$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($2b1c5193a94af2cd$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $2b1c5193a94af2cd$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $2b1c5193a94af2cd$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $2b1c5193a94af2cd$var$getListener(target, registrationName), null != stateNode && listeners.unshift($2b1c5193a94af2cd$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $2b1c5193a94af2cd$var$getListener(target, registrationName), null != stateNode && listeners.push($2b1c5193a94af2cd$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $2b1c5193a94af2cd$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $2b1c5193a94af2cd$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $2b1c5193a94af2cd$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($2b1c5193a94af2cd$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($2b1c5193a94af2cd$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $2b1c5193a94af2cd$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $2b1c5193a94af2cd$var$normalizeMarkupForTextOrAttribute(clientText);
    return $2b1c5193a94af2cd$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $2b1c5193a94af2cd$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $2b1c5193a94af2cd$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $2b1c5193a94af2cd$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $2b1c5193a94af2cd$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $2b1c5193a94af2cd$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $2b1c5193a94af2cd$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $2b1c5193a94af2cd$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $2b1c5193a94af2cd$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2b1c5193a94af2cd$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $2b1c5193a94af2cd$var$setProp(domElement, tag, "name", props.name, props, null), $2b1c5193a94af2cd$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $2b1c5193a94af2cd$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $2b1c5193a94af2cd$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($2b1c5193a94af2cd$var$setProp(domElement, tag, "encType", props.encType, props, null), $2b1c5193a94af2cd$var$setProp(domElement, tag, "method", props.method, props, null), $2b1c5193a94af2cd$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $2b1c5193a94af2cd$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2b1c5193a94af2cd$var$noop$1);
            break;
        case "onScroll":
            null != value && $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $2b1c5193a94af2cd$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("toggle", domElement);
            $2b1c5193a94af2cd$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $2b1c5193a94af2cd$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $2b1c5193a94af2cd$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $2b1c5193a94af2cd$var$aliases.get(key) || key, $2b1c5193a94af2cd$var$setValueForAttribute(domElement, key, value);
    }
}
function $2b1c5193a94af2cd$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $2b1c5193a94af2cd$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $2b1c5193a94af2cd$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $2b1c5193a94af2cd$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $2b1c5193a94af2cd$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$2b1c5193a94af2cd$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$2b1c5193a94af2cd$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $2b1c5193a94af2cd$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $2b1c5193a94af2cd$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("error", domElement);
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(137, tag));
                    default:
                        $2b1c5193a94af2cd$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $2b1c5193a94af2cd$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $2b1c5193a94af2cd$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $2b1c5193a94af2cd$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $2b1c5193a94af2cd$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $2b1c5193a94af2cd$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $2b1c5193a94af2cd$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $2b1c5193a94af2cd$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(91));
                    break;
                default:
                    $2b1c5193a94af2cd$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $2b1c5193a94af2cd$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $2b1c5193a94af2cd$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("toggle", domElement);
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("cancel", domElement);
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $2b1c5193a94af2cd$var$mediaEventTypes.length; hasSrc++)$2b1c5193a94af2cd$var$listenToNonDelegatedEvent($2b1c5193a94af2cd$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("error", domElement);
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("error", domElement), $2b1c5193a94af2cd$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(137, tag));
                default:
                    $2b1c5193a94af2cd$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($2b1c5193a94af2cd$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $2b1c5193a94af2cd$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $2b1c5193a94af2cd$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $2b1c5193a94af2cd$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $2b1c5193a94af2cd$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $2b1c5193a94af2cd$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $2b1c5193a94af2cd$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $2b1c5193a94af2cd$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $2b1c5193a94af2cd$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $2b1c5193a94af2cd$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $2b1c5193a94af2cd$var$updateOptions(domElement, !!lastProps, tag, !0) : $2b1c5193a94af2cd$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $2b1c5193a94af2cd$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $2b1c5193a94af2cd$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $2b1c5193a94af2cd$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $2b1c5193a94af2cd$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $2b1c5193a94af2cd$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $2b1c5193a94af2cd$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $2b1c5193a94af2cd$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($2b1c5193a94af2cd$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $2b1c5193a94af2cd$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $2b1c5193a94af2cd$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $2b1c5193a94af2cd$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $2b1c5193a94af2cd$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $2b1c5193a94af2cd$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $2b1c5193a94af2cd$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $2b1c5193a94af2cd$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $2b1c5193a94af2cd$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $2b1c5193a94af2cd$var$eventsEnabled = null, $2b1c5193a94af2cd$var$selectionInformation = null;
function $2b1c5193a94af2cd$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $2b1c5193a94af2cd$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $2b1c5193a94af2cd$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $2b1c5193a94af2cd$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $2b1c5193a94af2cd$var$currentPopstateTransitionEvent = null;
function $2b1c5193a94af2cd$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $2b1c5193a94af2cd$var$currentPopstateTransitionEvent) return !1;
        $2b1c5193a94af2cd$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $2b1c5193a94af2cd$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $2b1c5193a94af2cd$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $2b1c5193a94af2cd$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $2b1c5193a94af2cd$var$localPromise = "function" === typeof Promise ? Promise : void 0, $2b1c5193a94af2cd$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $2b1c5193a94af2cd$var$localPromise ? function(callback) {
    return $2b1c5193a94af2cd$var$localPromise.resolve(null).then(callback).catch($2b1c5193a94af2cd$var$handleErrorInNextTick);
} : $2b1c5193a94af2cd$var$scheduleTimeout;
function $2b1c5193a94af2cd$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $2b1c5193a94af2cd$var$isSingletonScope(type) {
    return "head" === type;
}
function $2b1c5193a94af2cd$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $2b1c5193a94af2cd$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $2b1c5193a94af2cd$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $2b1c5193a94af2cd$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$2b1c5193a94af2cd$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $2b1c5193a94af2cd$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $2b1c5193a94af2cd$var$retryIfBlockedOn(hydrationInstance);
}
function $2b1c5193a94af2cd$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $2b1c5193a94af2cd$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $2b1c5193a94af2cd$var$clearContainerSparingly(node);
                $2b1c5193a94af2cd$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $2b1c5193a94af2cd$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$2b1c5193a94af2cd$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $2b1c5193a94af2cd$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $2b1c5193a94af2cd$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $2b1c5193a94af2cd$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $2b1c5193a94af2cd$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $2b1c5193a94af2cd$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $2b1c5193a94af2cd$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $2b1c5193a94af2cd$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $2b1c5193a94af2cd$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $2b1c5193a94af2cd$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $2b1c5193a94af2cd$var$previousHydratableOnEnteringScopedSingleton = null;
function $2b1c5193a94af2cd$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $2b1c5193a94af2cd$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $2b1c5193a94af2cd$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $2b1c5193a94af2cd$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $2b1c5193a94af2cd$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(451));
    }
}
function $2b1c5193a94af2cd$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $2b1c5193a94af2cd$var$detachDeletedInstance(instance);
}
var $2b1c5193a94af2cd$var$preloadPropsMap = new Map(), $2b1c5193a94af2cd$var$preconnectsSet = new Set();
function $2b1c5193a94af2cd$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $2b1c5193a94af2cd$var$previousDispatcher = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.d;
$2b1c5193a94af2cd$var$ReactDOMSharedInternals.d = {
    f: $2b1c5193a94af2cd$var$flushSyncWork,
    r: $2b1c5193a94af2cd$var$requestFormReset,
    D: $2b1c5193a94af2cd$var$prefetchDNS,
    C: $2b1c5193a94af2cd$var$preconnect,
    L: $2b1c5193a94af2cd$var$preload,
    m: $2b1c5193a94af2cd$var$preloadModule,
    X: $2b1c5193a94af2cd$var$preinitScript,
    S: $2b1c5193a94af2cd$var$preinitStyle,
    M: $2b1c5193a94af2cd$var$preinitModuleScript
};
function $2b1c5193a94af2cd$var$flushSyncWork() {
    var previousWasRendering = $2b1c5193a94af2cd$var$previousDispatcher.f(), wasRendering = $2b1c5193a94af2cd$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $2b1c5193a94af2cd$var$requestFormReset(form) {
    var formInst = $2b1c5193a94af2cd$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $2b1c5193a94af2cd$var$requestFormReset$1(formInst) : $2b1c5193a94af2cd$var$previousDispatcher.r(form);
}
var $2b1c5193a94af2cd$var$globalDocument = "undefined" === typeof document ? null : document;
function $2b1c5193a94af2cd$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $2b1c5193a94af2cd$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $2b1c5193a94af2cd$var$preconnectsSet.has(limitedEscapedHref) || ($2b1c5193a94af2cd$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $2b1c5193a94af2cd$var$setInitialProperties(href, "link", rel), $2b1c5193a94af2cd$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $2b1c5193a94af2cd$var$prefetchDNS(href) {
    $2b1c5193a94af2cd$var$previousDispatcher.D(href);
    $2b1c5193a94af2cd$var$preconnectAs("dns-prefetch", href, null);
}
function $2b1c5193a94af2cd$var$preconnect(href, crossOrigin) {
    $2b1c5193a94af2cd$var$previousDispatcher.C(href, crossOrigin);
    $2b1c5193a94af2cd$var$preconnectAs("preconnect", href, crossOrigin);
}
function $2b1c5193a94af2cd$var$preload(href, as, options) {
    $2b1c5193a94af2cd$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $2b1c5193a94af2cd$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $2b1c5193a94af2cd$var$getStyleKey(href);
                break;
            case "script":
                key = $2b1c5193a94af2cd$var$getScriptKey(href);
        }
        $2b1c5193a94af2cd$var$preloadPropsMap.has(key) || (href = $2b1c5193a94af2cd$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $2b1c5193a94af2cd$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($2b1c5193a94af2cd$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($2b1c5193a94af2cd$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $2b1c5193a94af2cd$var$setInitialProperties(as, "link", href), $2b1c5193a94af2cd$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $2b1c5193a94af2cd$var$preloadModule(href, options) {
    $2b1c5193a94af2cd$var$previousDispatcher.m(href, options);
    var ownerDocument = $2b1c5193a94af2cd$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $2b1c5193a94af2cd$var$getScriptKey(href);
        }
        if (!$2b1c5193a94af2cd$var$preloadPropsMap.has(key) && (href = $2b1c5193a94af2cd$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $2b1c5193a94af2cd$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($2b1c5193a94af2cd$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $2b1c5193a94af2cd$var$setInitialProperties(as, "link", href);
            $2b1c5193a94af2cd$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $2b1c5193a94af2cd$var$preinitStyle(href, precedence, options) {
    $2b1c5193a94af2cd$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $2b1c5193a94af2cd$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $2b1c5193a94af2cd$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $2b1c5193a94af2cd$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($2b1c5193a94af2cd$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $2b1c5193a94af2cd$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $2b1c5193a94af2cd$var$preloadPropsMap.get(key)) && $2b1c5193a94af2cd$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $2b1c5193a94af2cd$var$markNodeAsHoistable(link);
                $2b1c5193a94af2cd$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $2b1c5193a94af2cd$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $2b1c5193a94af2cd$var$preinitScript(src, options) {
    $2b1c5193a94af2cd$var$previousDispatcher.X(src, options);
    var ownerDocument = $2b1c5193a94af2cd$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2b1c5193a94af2cd$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2b1c5193a94af2cd$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2b1c5193a94af2cd$var$getScriptSelectorFromKey(key)), resource || (src = $2b1c5193a94af2cd$var$assign({
            src: src,
            async: !0
        }, options), (options = $2b1c5193a94af2cd$var$preloadPropsMap.get(key)) && $2b1c5193a94af2cd$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2b1c5193a94af2cd$var$markNodeAsHoistable(resource), $2b1c5193a94af2cd$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2b1c5193a94af2cd$var$preinitModuleScript(src, options) {
    $2b1c5193a94af2cd$var$previousDispatcher.M(src, options);
    var ownerDocument = $2b1c5193a94af2cd$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $2b1c5193a94af2cd$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $2b1c5193a94af2cd$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($2b1c5193a94af2cd$var$getScriptSelectorFromKey(key)), resource || (src = $2b1c5193a94af2cd$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $2b1c5193a94af2cd$var$preloadPropsMap.get(key)) && $2b1c5193a94af2cd$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $2b1c5193a94af2cd$var$markNodeAsHoistable(resource), $2b1c5193a94af2cd$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $2b1c5193a94af2cd$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $2b1c5193a94af2cd$var$rootInstanceStackCursor.current) ? $2b1c5193a94af2cd$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $2b1c5193a94af2cd$var$getStyleKey(pendingProps.href), pendingProps = $2b1c5193a94af2cd$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $2b1c5193a94af2cd$var$getStyleKey(pendingProps.href);
                var styles$243 = $2b1c5193a94af2cd$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($2b1c5193a94af2cd$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $2b1c5193a94af2cd$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $2b1c5193a94af2cd$var$preloadPropsMap.set(type, pendingProps), styles$243 || $2b1c5193a94af2cd$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $2b1c5193a94af2cd$var$getScriptKey(pendingProps), pendingProps = $2b1c5193a94af2cd$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(444, type));
    }
}
function $2b1c5193a94af2cd$var$getStyleKey(href) {
    return 'href="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $2b1c5193a94af2cd$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $2b1c5193a94af2cd$var$stylesheetPropsFromRawProps(rawProps) {
    return $2b1c5193a94af2cd$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $2b1c5193a94af2cd$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $2b1c5193a94af2cd$var$setInitialProperties(key, "link", preloadProps), $2b1c5193a94af2cd$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $2b1c5193a94af2cd$var$getScriptKey(src) {
    return '[src="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $2b1c5193a94af2cd$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $2b1c5193a94af2cd$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $2b1c5193a94af2cd$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $2b1c5193a94af2cd$var$markNodeAsHoistable(instance), instance;
            var styleProps = $2b1c5193a94af2cd$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $2b1c5193a94af2cd$var$markNodeAsHoistable(instance);
            $2b1c5193a94af2cd$var$setInitialProperties(instance, "style", styleProps);
            $2b1c5193a94af2cd$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $2b1c5193a94af2cd$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($2b1c5193a94af2cd$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $2b1c5193a94af2cd$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $2b1c5193a94af2cd$var$stylesheetPropsFromRawProps(props);
            (styleProps = $2b1c5193a94af2cd$var$preloadPropsMap.get(styleProps)) && $2b1c5193a94af2cd$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $2b1c5193a94af2cd$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2b1c5193a94af2cd$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $2b1c5193a94af2cd$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $2b1c5193a94af2cd$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($2b1c5193a94af2cd$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $2b1c5193a94af2cd$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $2b1c5193a94af2cd$var$preloadPropsMap.get(instance$249)) instance = $2b1c5193a94af2cd$var$assign({}, props), $2b1c5193a94af2cd$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $2b1c5193a94af2cd$var$markNodeAsHoistable(styleProps);
            $2b1c5193a94af2cd$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $2b1c5193a94af2cd$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $2b1c5193a94af2cd$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $2b1c5193a94af2cd$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $2b1c5193a94af2cd$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $2b1c5193a94af2cd$var$tagCaches = null;
function $2b1c5193a94af2cd$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $2b1c5193a94af2cd$var$tagCaches) {
        var cache = new Map();
        var caches = $2b1c5193a94af2cd$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $2b1c5193a94af2cd$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$2b1c5193a94af2cd$var$internalHoistableMarker] || node[$2b1c5193a94af2cd$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $2b1c5193a94af2cd$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $2b1c5193a94af2cd$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $2b1c5193a94af2cd$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $2b1c5193a94af2cd$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $2b1c5193a94af2cd$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($2b1c5193a94af2cd$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $2b1c5193a94af2cd$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $2b1c5193a94af2cd$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $2b1c5193a94af2cd$var$stylesheetPropsFromRawProps(props);
            (key = $2b1c5193a94af2cd$var$preloadPropsMap.get(key)) && $2b1c5193a94af2cd$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $2b1c5193a94af2cd$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $2b1c5193a94af2cd$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $2b1c5193a94af2cd$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $2b1c5193a94af2cd$var$estimatedBytesWithinLimit = 0;
function $2b1c5193a94af2cd$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $2b1c5193a94af2cd$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $2b1c5193a94af2cd$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $2b1c5193a94af2cd$var$estimatedBytesWithinLimit && ($2b1c5193a94af2cd$var$estimatedBytesWithinLimit = 62500 * $2b1c5193a94af2cd$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $2b1c5193a94af2cd$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $2b1c5193a94af2cd$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $2b1c5193a94af2cd$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $2b1c5193a94af2cd$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $2b1c5193a94af2cd$var$precedencesByRoot = null;
function $2b1c5193a94af2cd$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $2b1c5193a94af2cd$var$precedencesByRoot = new Map(), resources.forEach($2b1c5193a94af2cd$var$insertStylesheetIntoRoot, state), $2b1c5193a94af2cd$var$precedencesByRoot = null, $2b1c5193a94af2cd$var$onUnsuspend.call(state));
}
function $2b1c5193a94af2cd$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $2b1c5193a94af2cd$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $2b1c5193a94af2cd$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $2b1c5193a94af2cd$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $2b1c5193a94af2cd$var$HostTransitionContext = {
    $$typeof: $2b1c5193a94af2cd$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $2b1c5193a94af2cd$var$sharedNotPendingObject,
    _currentValue2: $2b1c5193a94af2cd$var$sharedNotPendingObject,
    _threadCount: 0
};
function $2b1c5193a94af2cd$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $2b1c5193a94af2cd$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $2b1c5193a94af2cd$var$createLaneMap(0);
    this.hiddenUpdates = $2b1c5193a94af2cd$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $2b1c5193a94af2cd$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $2b1c5193a94af2cd$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $2b1c5193a94af2cd$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $2b1c5193a94af2cd$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $2b1c5193a94af2cd$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $2b1c5193a94af2cd$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $2b1c5193a94af2cd$var$emptyContextObject;
    parentComponent = $2b1c5193a94af2cd$var$emptyContextObject;
    return parentComponent;
}
function $2b1c5193a94af2cd$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $2b1c5193a94af2cd$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $2b1c5193a94af2cd$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $2b1c5193a94af2cd$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($2b1c5193a94af2cd$var$scheduleUpdateOnFiber(element, rootFiber, lane), $2b1c5193a94af2cd$var$entangleTransitions(element, rootFiber, lane));
}
function $2b1c5193a94af2cd$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $2b1c5193a94af2cd$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $2b1c5193a94af2cd$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $2b1c5193a94af2cd$var$markRetryLaneImpl(fiber, retryLane);
}
function $2b1c5193a94af2cd$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $2b1c5193a94af2cd$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $2b1c5193a94af2cd$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $2b1c5193a94af2cd$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $2b1c5193a94af2cd$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $2b1c5193a94af2cd$var$requestUpdateLane();
        lane = $2b1c5193a94af2cd$var$getBumpedLaneForHydrationByLane(lane);
        var root = $2b1c5193a94af2cd$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $2b1c5193a94af2cd$var$scheduleUpdateOnFiber(root, fiber, lane);
        $2b1c5193a94af2cd$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $2b1c5193a94af2cd$var$_enabled = !0;
function $2b1c5193a94af2cd$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2b1c5193a94af2cd$var$ReactSharedInternals.T;
    $2b1c5193a94af2cd$var$ReactSharedInternals.T = null;
    var previousPriority = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
    try {
        $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = 2, $2b1c5193a94af2cd$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = previousPriority, $2b1c5193a94af2cd$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2b1c5193a94af2cd$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $2b1c5193a94af2cd$var$ReactSharedInternals.T;
    $2b1c5193a94af2cd$var$ReactSharedInternals.T = null;
    var previousPriority = $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p;
    try {
        $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = 8, $2b1c5193a94af2cd$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $2b1c5193a94af2cd$var$ReactDOMSharedInternals.p = previousPriority, $2b1c5193a94af2cd$var$ReactSharedInternals.T = prevTransition;
    }
}
function $2b1c5193a94af2cd$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($2b1c5193a94af2cd$var$_enabled) {
        var blockedOn = $2b1c5193a94af2cd$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $2b1c5193a94af2cd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2b1c5193a94af2cd$var$return_targetInst, targetContainer), $2b1c5193a94af2cd$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($2b1c5193a94af2cd$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($2b1c5193a94af2cd$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $2b1c5193a94af2cd$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $2b1c5193a94af2cd$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $2b1c5193a94af2cd$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $2b1c5193a94af2cd$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $2b1c5193a94af2cd$var$ensureRootIsScheduled(fiber);
                                0 === ($2b1c5193a94af2cd$var$executionContext & 6) && ($2b1c5193a94af2cd$var$workInProgressRootRenderTargetTime = $2b1c5193a94af2cd$var$now() + 500, $2b1c5193a94af2cd$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $2b1c5193a94af2cd$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $2b1c5193a94af2cd$var$scheduleUpdateOnFiber(root, fiber, 2), $2b1c5193a94af2cd$var$flushSyncWork$1(), $2b1c5193a94af2cd$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $2b1c5193a94af2cd$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $2b1c5193a94af2cd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $2b1c5193a94af2cd$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $2b1c5193a94af2cd$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $2b1c5193a94af2cd$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $2b1c5193a94af2cd$var$getEventTarget(nativeEvent);
    return $2b1c5193a94af2cd$var$findInstanceBlockingTarget(nativeEvent);
}
var $2b1c5193a94af2cd$var$return_targetInst = null;
function $2b1c5193a94af2cd$var$findInstanceBlockingTarget(targetNode) {
    $2b1c5193a94af2cd$var$return_targetInst = null;
    targetNode = $2b1c5193a94af2cd$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $2b1c5193a94af2cd$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $2b1c5193a94af2cd$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $2b1c5193a94af2cd$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $2b1c5193a94af2cd$var$return_targetInst = targetNode;
    return null;
}
function $2b1c5193a94af2cd$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($2b1c5193a94af2cd$var$getCurrentPriorityLevel()){
                case $2b1c5193a94af2cd$var$ImmediatePriority:
                    return 2;
                case $2b1c5193a94af2cd$var$UserBlockingPriority:
                    return 8;
                case $2b1c5193a94af2cd$var$NormalPriority$1:
                case $2b1c5193a94af2cd$var$LowPriority:
                    return 32;
                case $2b1c5193a94af2cd$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $2b1c5193a94af2cd$var$hasScheduledReplayAttempt = !1, $2b1c5193a94af2cd$var$queuedFocus = null, $2b1c5193a94af2cd$var$queuedDrag = null, $2b1c5193a94af2cd$var$queuedMouse = null, $2b1c5193a94af2cd$var$queuedPointers = new Map(), $2b1c5193a94af2cd$var$queuedPointerCaptures = new Map(), $2b1c5193a94af2cd$var$queuedExplicitHydrationTargets = [], $2b1c5193a94af2cd$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $2b1c5193a94af2cd$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $2b1c5193a94af2cd$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $2b1c5193a94af2cd$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $2b1c5193a94af2cd$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $2b1c5193a94af2cd$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $2b1c5193a94af2cd$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $2b1c5193a94af2cd$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $2b1c5193a94af2cd$var$getInstanceFromNode(blockedOn), null !== blockedOn && $2b1c5193a94af2cd$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $2b1c5193a94af2cd$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $2b1c5193a94af2cd$var$queuedFocus = $2b1c5193a94af2cd$var$accumulateOrCreateContinuousQueuedReplayableEvent($2b1c5193a94af2cd$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $2b1c5193a94af2cd$var$queuedDrag = $2b1c5193a94af2cd$var$accumulateOrCreateContinuousQueuedReplayableEvent($2b1c5193a94af2cd$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $2b1c5193a94af2cd$var$queuedMouse = $2b1c5193a94af2cd$var$accumulateOrCreateContinuousQueuedReplayableEvent($2b1c5193a94af2cd$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $2b1c5193a94af2cd$var$queuedPointers.set(pointerId, $2b1c5193a94af2cd$var$accumulateOrCreateContinuousQueuedReplayableEvent($2b1c5193a94af2cd$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $2b1c5193a94af2cd$var$queuedPointerCaptures.set(pointerId, $2b1c5193a94af2cd$var$accumulateOrCreateContinuousQueuedReplayableEvent($2b1c5193a94af2cd$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $2b1c5193a94af2cd$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $2b1c5193a94af2cd$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $2b1c5193a94af2cd$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $2b1c5193a94af2cd$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $2b1c5193a94af2cd$var$runWithPriority(queuedTarget.priority, function() {
                        $2b1c5193a94af2cd$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $2b1c5193a94af2cd$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $2b1c5193a94af2cd$var$runWithPriority(queuedTarget.priority, function() {
                        $2b1c5193a94af2cd$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $2b1c5193a94af2cd$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $2b1c5193a94af2cd$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $2b1c5193a94af2cd$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $2b1c5193a94af2cd$var$currentReplayingEvent = null;
        } else return targetContainers = $2b1c5193a94af2cd$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $2b1c5193a94af2cd$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $2b1c5193a94af2cd$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $2b1c5193a94af2cd$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $2b1c5193a94af2cd$var$replayUnblockedEvents() {
    $2b1c5193a94af2cd$var$hasScheduledReplayAttempt = !1;
    null !== $2b1c5193a94af2cd$var$queuedFocus && $2b1c5193a94af2cd$var$attemptReplayContinuousQueuedEvent($2b1c5193a94af2cd$var$queuedFocus) && ($2b1c5193a94af2cd$var$queuedFocus = null);
    null !== $2b1c5193a94af2cd$var$queuedDrag && $2b1c5193a94af2cd$var$attemptReplayContinuousQueuedEvent($2b1c5193a94af2cd$var$queuedDrag) && ($2b1c5193a94af2cd$var$queuedDrag = null);
    null !== $2b1c5193a94af2cd$var$queuedMouse && $2b1c5193a94af2cd$var$attemptReplayContinuousQueuedEvent($2b1c5193a94af2cd$var$queuedMouse) && ($2b1c5193a94af2cd$var$queuedMouse = null);
    $2b1c5193a94af2cd$var$queuedPointers.forEach($2b1c5193a94af2cd$var$attemptReplayContinuousQueuedEventInMap);
    $2b1c5193a94af2cd$var$queuedPointerCaptures.forEach($2b1c5193a94af2cd$var$attemptReplayContinuousQueuedEventInMap);
}
function $2b1c5193a94af2cd$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $2b1c5193a94af2cd$var$hasScheduledReplayAttempt || ($2b1c5193a94af2cd$var$hasScheduledReplayAttempt = !0, $5avyM.unstable_scheduleCallback($5avyM.unstable_NormalPriority, $2b1c5193a94af2cd$var$replayUnblockedEvents)));
}
var $2b1c5193a94af2cd$var$lastScheduledReplayQueue = null;
function $2b1c5193a94af2cd$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $2b1c5193a94af2cd$var$lastScheduledReplayQueue !== formReplayingQueue && ($2b1c5193a94af2cd$var$lastScheduledReplayQueue = formReplayingQueue, $5avyM.unstable_scheduleCallback($5avyM.unstable_NormalPriority, function() {
        $2b1c5193a94af2cd$var$lastScheduledReplayQueue === formReplayingQueue && ($2b1c5193a94af2cd$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $2b1c5193a94af2cd$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $2b1c5193a94af2cd$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $2b1c5193a94af2cd$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $2b1c5193a94af2cd$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $2b1c5193a94af2cd$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $2b1c5193a94af2cd$var$queuedFocus && $2b1c5193a94af2cd$var$scheduleCallbackIfUnblocked($2b1c5193a94af2cd$var$queuedFocus, unblocked);
    null !== $2b1c5193a94af2cd$var$queuedDrag && $2b1c5193a94af2cd$var$scheduleCallbackIfUnblocked($2b1c5193a94af2cd$var$queuedDrag, unblocked);
    null !== $2b1c5193a94af2cd$var$queuedMouse && $2b1c5193a94af2cd$var$scheduleCallbackIfUnblocked($2b1c5193a94af2cd$var$queuedMouse, unblocked);
    $2b1c5193a94af2cd$var$queuedPointers.forEach(unblock);
    $2b1c5193a94af2cd$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $2b1c5193a94af2cd$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $2b1c5193a94af2cd$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $2b1c5193a94af2cd$var$queuedExplicitHydrationTargets.length && (i = $2b1c5193a94af2cd$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$2b1c5193a94af2cd$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $2b1c5193a94af2cd$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$2b1c5193a94af2cd$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $2b1c5193a94af2cd$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$2b1c5193a94af2cd$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $2b1c5193a94af2cd$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $2b1c5193a94af2cd$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $2b1c5193a94af2cd$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $2b1c5193a94af2cd$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2b1c5193a94af2cd$var$ReactDOMHydrationRoot.prototype.render = $2b1c5193a94af2cd$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(409));
    var current = root.current, lane = $2b1c5193a94af2cd$var$requestUpdateLane();
    $2b1c5193a94af2cd$var$updateContainerImpl(current, lane, children, root, null, null);
};
$2b1c5193a94af2cd$var$ReactDOMHydrationRoot.prototype.unmount = $2b1c5193a94af2cd$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $2b1c5193a94af2cd$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $2b1c5193a94af2cd$var$flushSyncWork$1();
        container[$2b1c5193a94af2cd$var$internalContainerInstanceKey] = null;
    }
};
function $2b1c5193a94af2cd$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$2b1c5193a94af2cd$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $2b1c5193a94af2cd$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $2b1c5193a94af2cd$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $2b1c5193a94af2cd$var$queuedExplicitHydrationTargets[i].priority; i++);
        $2b1c5193a94af2cd$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $2b1c5193a94af2cd$var$attemptExplicitHydrationTarget(target);
    }
};
var $2b1c5193a94af2cd$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $kYCgE.version;
if ("19.2.7" !== $2b1c5193a94af2cd$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(527, $2b1c5193a94af2cd$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.7"));
$2b1c5193a94af2cd$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $2b1c5193a94af2cd$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $2b1c5193a94af2cd$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $2b1c5193a94af2cd$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $2b1c5193a94af2cd$var$ReactSharedInternals,
    reconcilerVersion: "19.2.7"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $2b1c5193a94af2cd$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$2b1c5193a94af2cd$var$hook$jscomp$inline_2348.isDisabled && $2b1c5193a94af2cd$var$hook$jscomp$inline_2348.supportsFiber) try {
        $2b1c5193a94af2cd$var$rendererID = $2b1c5193a94af2cd$var$hook$jscomp$inline_2348.inject($2b1c5193a94af2cd$var$internals$jscomp$inline_2347), $2b1c5193a94af2cd$var$injectedHook = $2b1c5193a94af2cd$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$2b1c5193a94af2cd$export$882461b6382ed46c = function(container, options) {
    if (!$2b1c5193a94af2cd$var$isValidContainer(container)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2b1c5193a94af2cd$var$defaultOnUncaughtError, onCaughtError = $2b1c5193a94af2cd$var$defaultOnCaughtError, onRecoverableError = $2b1c5193a94af2cd$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $2b1c5193a94af2cd$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $2b1c5193a94af2cd$var$defaultOnDefaultTransitionIndicator);
    container[$2b1c5193a94af2cd$var$internalContainerInstanceKey] = options.current;
    $2b1c5193a94af2cd$var$listenToAllSupportedEvents(container);
    return new $2b1c5193a94af2cd$var$ReactDOMRoot(options);
};
$2b1c5193a94af2cd$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$2b1c5193a94af2cd$var$isValidContainer(container)) throw Error($2b1c5193a94af2cd$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $2b1c5193a94af2cd$var$defaultOnUncaughtError, onCaughtError = $2b1c5193a94af2cd$var$defaultOnCaughtError, onRecoverableError = $2b1c5193a94af2cd$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $2b1c5193a94af2cd$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $2b1c5193a94af2cd$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $2b1c5193a94af2cd$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $2b1c5193a94af2cd$var$requestUpdateLane();
    isStrictMode = $2b1c5193a94af2cd$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $2b1c5193a94af2cd$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $2b1c5193a94af2cd$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $2b1c5193a94af2cd$var$markRootUpdated$1(initialChildren, options);
    $2b1c5193a94af2cd$var$ensureRootIsScheduled(initialChildren);
    container[$2b1c5193a94af2cd$var$internalContainerInstanceKey] = initialChildren.current;
    $2b1c5193a94af2cd$var$listenToAllSupportedEvents(container);
    return new $2b1c5193a94af2cd$var$ReactDOMHydrationRoot(initialChildren);
};
$2b1c5193a94af2cd$export$83d89fbfd8236492 = "19.2.7";

});
parcelRegister("5avyM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cSB2o"));

});
parcelRegister("cSB2o", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $96074219c4300688$export$c4744153514ff05d; }, function (v) { return $96074219c4300688$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $96074219c4300688$export$3e506c1ccc9cc1a7; }, function (v) { return $96074219c4300688$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $96074219c4300688$export$e26fe2ed2fa76875; }, function (v) { return $96074219c4300688$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $96074219c4300688$export$502329bbf4b505b1; }, function (v) { return $96074219c4300688$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $96074219c4300688$export$6e3807111c4874c4; }, function (v) { return $96074219c4300688$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $96074219c4300688$export$c27134553091fb3a; }, function (v) { return $96074219c4300688$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $96074219c4300688$export$33ee1acdc04fd2a2; }, function (v) { return $96074219c4300688$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $96074219c4300688$export$b00a404bbd5edef2; }, function (v) { return $96074219c4300688$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $96074219c4300688$export$d66a1c1c77bd778b; }, function (v) { return $96074219c4300688$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $96074219c4300688$export$d3dfb8e4810cb555; }, function (v) { return $96074219c4300688$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $96074219c4300688$export$72fdf0e06517287b; }, function (v) { return $96074219c4300688$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $96074219c4300688$export$816d2913ae6b83b1; }, function (v) { return $96074219c4300688$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $96074219c4300688$export$61bcfe829111a1d0; }, function (v) { return $96074219c4300688$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $96074219c4300688$export$7ee8c9beb337bc3f; }, function (v) { return $96074219c4300688$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $96074219c4300688$export$b5836b71941fa3ed; }, function (v) { return $96074219c4300688$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $96074219c4300688$export$cf845f2c119da08a; }, function (v) { return $96074219c4300688$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $96074219c4300688$export$c4744153514ff05d;
var $96074219c4300688$export$3e506c1ccc9cc1a7;
var $96074219c4300688$export$e26fe2ed2fa76875;
var $96074219c4300688$export$502329bbf4b505b1;
var $96074219c4300688$export$6e3807111c4874c4;
var $96074219c4300688$export$c27134553091fb3a;
var $96074219c4300688$export$33ee1acdc04fd2a2;
var $96074219c4300688$export$b00a404bbd5edef2;
var $96074219c4300688$export$d66a1c1c77bd778b;
var $96074219c4300688$export$d3dfb8e4810cb555;
var $96074219c4300688$export$72fdf0e06517287b;
var $96074219c4300688$export$816d2913ae6b83b1;
var $96074219c4300688$export$61bcfe829111a1d0;
var $96074219c4300688$export$7ee8c9beb337bc3f;
var $96074219c4300688$export$b5836b71941fa3ed;
var $96074219c4300688$export$cf845f2c119da08a;
"use strict";
function $96074219c4300688$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $96074219c4300688$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $96074219c4300688$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $96074219c4300688$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $96074219c4300688$var$compare(left, last)) rightIndex < length && 0 > $96074219c4300688$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $96074219c4300688$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $96074219c4300688$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$96074219c4300688$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $96074219c4300688$var$localPerformance = performance;
    $96074219c4300688$export$c4744153514ff05d = function() {
        return $96074219c4300688$var$localPerformance.now();
    };
} else {
    var $96074219c4300688$var$localDate = Date, $96074219c4300688$var$initialTime = $96074219c4300688$var$localDate.now();
    $96074219c4300688$export$c4744153514ff05d = function() {
        return $96074219c4300688$var$localDate.now() - $96074219c4300688$var$initialTime;
    };
}
var $96074219c4300688$var$taskQueue = [], $96074219c4300688$var$timerQueue = [], $96074219c4300688$var$taskIdCounter = 1, $96074219c4300688$var$currentTask = null, $96074219c4300688$var$currentPriorityLevel = 3, $96074219c4300688$var$isPerformingWork = !1, $96074219c4300688$var$isHostCallbackScheduled = !1, $96074219c4300688$var$isHostTimeoutScheduled = !1, $96074219c4300688$var$needsPaint = !1, $96074219c4300688$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $96074219c4300688$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $96074219c4300688$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $96074219c4300688$var$advanceTimers(currentTime) {
    for(var timer = $96074219c4300688$var$peek($96074219c4300688$var$timerQueue); null !== timer;){
        if (null === timer.callback) $96074219c4300688$var$pop($96074219c4300688$var$timerQueue);
        else if (timer.startTime <= currentTime) $96074219c4300688$var$pop($96074219c4300688$var$timerQueue), timer.sortIndex = timer.expirationTime, $96074219c4300688$var$push($96074219c4300688$var$taskQueue, timer);
        else break;
        timer = $96074219c4300688$var$peek($96074219c4300688$var$timerQueue);
    }
}
function $96074219c4300688$var$handleTimeout(currentTime) {
    $96074219c4300688$var$isHostTimeoutScheduled = !1;
    $96074219c4300688$var$advanceTimers(currentTime);
    if (!$96074219c4300688$var$isHostCallbackScheduled) {
        if (null !== $96074219c4300688$var$peek($96074219c4300688$var$taskQueue)) $96074219c4300688$var$isHostCallbackScheduled = !0, $96074219c4300688$var$isMessageLoopRunning || ($96074219c4300688$var$isMessageLoopRunning = !0, $96074219c4300688$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $96074219c4300688$var$peek($96074219c4300688$var$timerQueue);
            null !== firstTimer && $96074219c4300688$var$requestHostTimeout($96074219c4300688$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $96074219c4300688$var$isMessageLoopRunning = !1, $96074219c4300688$var$taskTimeoutID = -1, $96074219c4300688$var$frameInterval = 5, $96074219c4300688$var$startTime = -1;
function $96074219c4300688$var$shouldYieldToHost() {
    return $96074219c4300688$var$needsPaint ? !0 : $96074219c4300688$export$c4744153514ff05d() - $96074219c4300688$var$startTime < $96074219c4300688$var$frameInterval ? !1 : !0;
}
function $96074219c4300688$var$performWorkUntilDeadline() {
    $96074219c4300688$var$needsPaint = !1;
    if ($96074219c4300688$var$isMessageLoopRunning) {
        var currentTime = $96074219c4300688$export$c4744153514ff05d();
        $96074219c4300688$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $96074219c4300688$var$isHostCallbackScheduled = !1;
                $96074219c4300688$var$isHostTimeoutScheduled && ($96074219c4300688$var$isHostTimeoutScheduled = !1, $96074219c4300688$var$localClearTimeout($96074219c4300688$var$taskTimeoutID), $96074219c4300688$var$taskTimeoutID = -1);
                $96074219c4300688$var$isPerformingWork = !0;
                var previousPriorityLevel = $96074219c4300688$var$currentPriorityLevel;
                try {
                    b: {
                        $96074219c4300688$var$advanceTimers(currentTime);
                        for($96074219c4300688$var$currentTask = $96074219c4300688$var$peek($96074219c4300688$var$taskQueue); null !== $96074219c4300688$var$currentTask && !($96074219c4300688$var$currentTask.expirationTime > currentTime && $96074219c4300688$var$shouldYieldToHost());){
                            var callback = $96074219c4300688$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $96074219c4300688$var$currentTask.callback = null;
                                $96074219c4300688$var$currentPriorityLevel = $96074219c4300688$var$currentTask.priorityLevel;
                                var continuationCallback = callback($96074219c4300688$var$currentTask.expirationTime <= currentTime);
                                currentTime = $96074219c4300688$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $96074219c4300688$var$currentTask.callback = continuationCallback;
                                    $96074219c4300688$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $96074219c4300688$var$currentTask === $96074219c4300688$var$peek($96074219c4300688$var$taskQueue) && $96074219c4300688$var$pop($96074219c4300688$var$taskQueue);
                                $96074219c4300688$var$advanceTimers(currentTime);
                            } else $96074219c4300688$var$pop($96074219c4300688$var$taskQueue);
                            $96074219c4300688$var$currentTask = $96074219c4300688$var$peek($96074219c4300688$var$taskQueue);
                        }
                        if (null !== $96074219c4300688$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $96074219c4300688$var$peek($96074219c4300688$var$timerQueue);
                            null !== firstTimer && $96074219c4300688$var$requestHostTimeout($96074219c4300688$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $96074219c4300688$var$currentTask = null, $96074219c4300688$var$currentPriorityLevel = previousPriorityLevel, $96074219c4300688$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $96074219c4300688$var$schedulePerformWorkUntilDeadline() : $96074219c4300688$var$isMessageLoopRunning = !1;
        }
    }
}
var $96074219c4300688$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $96074219c4300688$var$localSetImmediate) $96074219c4300688$var$schedulePerformWorkUntilDeadline = function() {
    $96074219c4300688$var$localSetImmediate($96074219c4300688$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $96074219c4300688$var$channel = new MessageChannel(), $96074219c4300688$var$port = $96074219c4300688$var$channel.port2;
    $96074219c4300688$var$channel.port1.onmessage = $96074219c4300688$var$performWorkUntilDeadline;
    $96074219c4300688$var$schedulePerformWorkUntilDeadline = function() {
        $96074219c4300688$var$port.postMessage(null);
    };
} else $96074219c4300688$var$schedulePerformWorkUntilDeadline = function() {
    $96074219c4300688$var$localSetTimeout($96074219c4300688$var$performWorkUntilDeadline, 0);
};
function $96074219c4300688$var$requestHostTimeout(callback, ms) {
    $96074219c4300688$var$taskTimeoutID = $96074219c4300688$var$localSetTimeout(function() {
        callback($96074219c4300688$export$c4744153514ff05d());
    }, ms);
}
$96074219c4300688$export$3e506c1ccc9cc1a7 = 5;
$96074219c4300688$export$e26fe2ed2fa76875 = 1;
$96074219c4300688$export$502329bbf4b505b1 = 4;
$96074219c4300688$export$6e3807111c4874c4 = 3;
$96074219c4300688$export$c27134553091fb3a = null;
$96074219c4300688$export$33ee1acdc04fd2a2 = 2;
$96074219c4300688$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$96074219c4300688$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $96074219c4300688$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$96074219c4300688$export$d3dfb8e4810cb555 = function() {
    return $96074219c4300688$var$currentPriorityLevel;
};
$96074219c4300688$export$72fdf0e06517287b = function(eventHandler) {
    switch($96074219c4300688$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $96074219c4300688$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $96074219c4300688$var$currentPriorityLevel;
    $96074219c4300688$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $96074219c4300688$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$96074219c4300688$export$816d2913ae6b83b1 = function() {
    $96074219c4300688$var$needsPaint = !0;
};
$96074219c4300688$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $96074219c4300688$var$currentPriorityLevel;
    $96074219c4300688$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $96074219c4300688$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$96074219c4300688$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $96074219c4300688$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $96074219c4300688$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $96074219c4300688$var$push($96074219c4300688$var$timerQueue, priorityLevel), null === $96074219c4300688$var$peek($96074219c4300688$var$taskQueue) && priorityLevel === $96074219c4300688$var$peek($96074219c4300688$var$timerQueue) && ($96074219c4300688$var$isHostTimeoutScheduled ? ($96074219c4300688$var$localClearTimeout($96074219c4300688$var$taskTimeoutID), $96074219c4300688$var$taskTimeoutID = -1) : $96074219c4300688$var$isHostTimeoutScheduled = !0, $96074219c4300688$var$requestHostTimeout($96074219c4300688$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $96074219c4300688$var$push($96074219c4300688$var$taskQueue, priorityLevel), $96074219c4300688$var$isHostCallbackScheduled || $96074219c4300688$var$isPerformingWork || ($96074219c4300688$var$isHostCallbackScheduled = !0, $96074219c4300688$var$isMessageLoopRunning || ($96074219c4300688$var$isMessageLoopRunning = !0, $96074219c4300688$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$96074219c4300688$export$b5836b71941fa3ed = $96074219c4300688$var$shouldYieldToHost;
$96074219c4300688$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $96074219c4300688$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $96074219c4300688$var$currentPriorityLevel;
        $96074219c4300688$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $96074219c4300688$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("kYCgE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8bG4B"));

});

parcelRegister("kt8M1", function(module, exports) {
'use strict';
function $ee6d524dd1519f90$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ee6d524dd1519f90$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ee6d524dd1519f90$var$checkDCE();

module.exports = (parcelRequire("73V1G"));

});
parcelRegister("73V1G", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $52450c6ccb0c82d6$export$69ce8ef3fe5cead0; }, function (v) { return $52450c6ccb0c82d6$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $52450c6ccb0c82d6$export$d39a5bbd09211389; }, function (v) { return $52450c6ccb0c82d6$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $52450c6ccb0c82d6$export$cd75ccfd720a3cd4; }, function (v) { return $52450c6ccb0c82d6$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $52450c6ccb0c82d6$export$a0816fa17a9e79be; }, function (v) { return $52450c6ccb0c82d6$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $52450c6ccb0c82d6$export$7292efcadded39f3; }, function (v) { return $52450c6ccb0c82d6$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $52450c6ccb0c82d6$export$da407abadb9b8f86; }, function (v) { return $52450c6ccb0c82d6$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $52450c6ccb0c82d6$export$314cfea32580671c; }, function (v) { return $52450c6ccb0c82d6$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $52450c6ccb0c82d6$export$513ccb98c53b8039; }, function (v) { return $52450c6ccb0c82d6$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $52450c6ccb0c82d6$export$dbca993bc2d264a; }, function (v) { return $52450c6ccb0c82d6$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $52450c6ccb0c82d6$export$4797a8006f0655d0; }, function (v) { return $52450c6ccb0c82d6$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $52450c6ccb0c82d6$export$c78a37762a8d58e1; }, function (v) { return $52450c6ccb0c82d6$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $52450c6ccb0c82d6$export$606f11b2eb45ecc6; }, function (v) { return $52450c6ccb0c82d6$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $52450c6ccb0c82d6$export$f7e8a0bf92324b1e; }, function (v) { return $52450c6ccb0c82d6$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $52450c6ccb0c82d6$export$83d89fbfd8236492; }, function (v) { return $52450c6ccb0c82d6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $52450c6ccb0c82d6$export$69ce8ef3fe5cead0;
var $52450c6ccb0c82d6$export$d39a5bbd09211389;
var $52450c6ccb0c82d6$export$cd75ccfd720a3cd4;
var $52450c6ccb0c82d6$export$a0816fa17a9e79be;
var $52450c6ccb0c82d6$export$7292efcadded39f3;
var $52450c6ccb0c82d6$export$da407abadb9b8f86;
var $52450c6ccb0c82d6$export$314cfea32580671c;
var $52450c6ccb0c82d6$export$513ccb98c53b8039;
var $52450c6ccb0c82d6$export$dbca993bc2d264a;
var $52450c6ccb0c82d6$export$4797a8006f0655d0;
var $52450c6ccb0c82d6$export$c78a37762a8d58e1;
var $52450c6ccb0c82d6$export$606f11b2eb45ecc6;
var $52450c6ccb0c82d6$export$f7e8a0bf92324b1e;
var $52450c6ccb0c82d6$export$83d89fbfd8236492;
"use strict";

var $kYCgE = parcelRequire("kYCgE");
function $52450c6ccb0c82d6$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $52450c6ccb0c82d6$var$noop() {}
var $52450c6ccb0c82d6$var$Internals = {
    d: {
        f: $52450c6ccb0c82d6$var$noop,
        r: function() {
            throw Error($52450c6ccb0c82d6$var$formatProdErrorMessage(522));
        },
        D: $52450c6ccb0c82d6$var$noop,
        C: $52450c6ccb0c82d6$var$noop,
        L: $52450c6ccb0c82d6$var$noop,
        m: $52450c6ccb0c82d6$var$noop,
        X: $52450c6ccb0c82d6$var$noop,
        S: $52450c6ccb0c82d6$var$noop,
        M: $52450c6ccb0c82d6$var$noop
    },
    p: 0,
    findDOMNode: null
}, $52450c6ccb0c82d6$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $52450c6ccb0c82d6$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $52450c6ccb0c82d6$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $52450c6ccb0c82d6$var$ReactSharedInternals = $kYCgE.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $52450c6ccb0c82d6$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$52450c6ccb0c82d6$export$69ce8ef3fe5cead0 = $52450c6ccb0c82d6$var$Internals;
$52450c6ccb0c82d6$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($52450c6ccb0c82d6$var$formatProdErrorMessage(299));
    return $52450c6ccb0c82d6$var$createPortal$1(children, container, null, key);
};
$52450c6ccb0c82d6$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $52450c6ccb0c82d6$var$ReactSharedInternals.T, previousUpdatePriority = $52450c6ccb0c82d6$var$Internals.p;
    try {
        if ($52450c6ccb0c82d6$var$ReactSharedInternals.T = null, $52450c6ccb0c82d6$var$Internals.p = 2, fn) return fn();
    } finally{
        $52450c6ccb0c82d6$var$ReactSharedInternals.T = previousTransition, $52450c6ccb0c82d6$var$Internals.p = previousUpdatePriority, $52450c6ccb0c82d6$var$Internals.d.f();
    }
};
$52450c6ccb0c82d6$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $52450c6ccb0c82d6$var$Internals.d.C(href, options));
};
$52450c6ccb0c82d6$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $52450c6ccb0c82d6$var$Internals.d.D(href);
};
$52450c6ccb0c82d6$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $52450c6ccb0c82d6$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $52450c6ccb0c82d6$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $52450c6ccb0c82d6$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$52450c6ccb0c82d6$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $52450c6ccb0c82d6$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $52450c6ccb0c82d6$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $52450c6ccb0c82d6$var$Internals.d.M(href);
    }
};
$52450c6ccb0c82d6$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $52450c6ccb0c82d6$var$getCrossOriginStringAs(as, options.crossOrigin);
        $52450c6ccb0c82d6$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$52450c6ccb0c82d6$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $52450c6ccb0c82d6$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $52450c6ccb0c82d6$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $52450c6ccb0c82d6$var$Internals.d.m(href);
    }
};
$52450c6ccb0c82d6$export$4797a8006f0655d0 = function(form) {
    $52450c6ccb0c82d6$var$Internals.d.r(form);
};
$52450c6ccb0c82d6$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$52450c6ccb0c82d6$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $52450c6ccb0c82d6$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$52450c6ccb0c82d6$export$f7e8a0bf92324b1e = function() {
    return $52450c6ccb0c82d6$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$52450c6ccb0c82d6$export$83d89fbfd8236492 = "19.2.7";

});



parcelRegister("fwKGi", function(module, exports) {
"use strict";
var $b4de0e1259c5cfc7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4de0e1259c5cfc7$var$StyleToObject;

const $b4de0e1259c5cfc7$var$inline_style_parser_1 = $b4de0e1259c5cfc7$var$__importDefault((parcelRequire("3WVey")));
/**
 * Parses inline style to object.
 *
 * @param style - Inline style.
 * @param iterator - Iterator.
 * @returns - Style object or null.
 *
 * @example Parsing inline style to object:
 *
 * ```js
 * import parse from 'style-to-object';
 * parse('line-height: 42;'); // { 'line-height': '42' }
 * ```
 */ function $b4de0e1259c5cfc7$var$StyleToObject(style, iterator) {
    let styleObject = null;
    if (!style || typeof style !== 'string') return styleObject;
    const declarations = (0, $b4de0e1259c5cfc7$var$inline_style_parser_1.default)(style);
    const hasIterator = typeof iterator === 'function';
    declarations.forEach((declaration)=>{
        if (declaration.type !== 'declaration') return;
        const { property: property, value: value } = declaration;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            styleObject = styleObject || {};
            styleObject[property] = value;
        }
    });
    return styleObject;
}

});
parcelRegister("3WVey", function(module, exports) {
'use strict';
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $2e032f5466115b06$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $2e032f5466115b06$var$NEWLINE_REGEX = /\n/g;
var $2e032f5466115b06$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $2e032f5466115b06$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $2e032f5466115b06$var$COLON_REGEX = /^:\s*/;
var $2e032f5466115b06$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $2e032f5466115b06$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $2e032f5466115b06$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $2e032f5466115b06$var$NEWLINE = '\n';
var $2e032f5466115b06$var$FORWARD_SLASH = '/';
var $2e032f5466115b06$var$ASTERISK = '*';
var $2e032f5466115b06$var$EMPTY_STRING = '';
// types
var $2e032f5466115b06$var$TYPE_COMMENT = 'comment';
var $2e032f5466115b06$var$TYPE_DECLARATION = 'declaration';
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ function $2e032f5466115b06$var$index(style, options) {
    if (typeof style !== 'string') throw new TypeError('First argument must be a string');
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($2e032f5466115b06$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($2e032f5466115b06$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ':' + lineno + ':' + column + ': ' + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) ;
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($2e032f5466115b06$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($2e032f5466115b06$var$FORWARD_SLASH != style.charAt(0) || $2e032f5466115b06$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($2e032f5466115b06$var$EMPTY_STRING != style.charAt(i) && ($2e032f5466115b06$var$ASTERISK != style.charAt(i) || $2e032f5466115b06$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($2e032f5466115b06$var$EMPTY_STRING === style.charAt(i - 1)) return error('End of comment missing');
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $2e032f5466115b06$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($2e032f5466115b06$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($2e032f5466115b06$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($2e032f5466115b06$var$VALUE_REGEX);
        var ret = pos({
            type: $2e032f5466115b06$var$TYPE_DECLARATION,
            property: $2e032f5466115b06$var$trim(prop[0].replace($2e032f5466115b06$var$COMMENT_REGEX, $2e032f5466115b06$var$EMPTY_STRING)),
            value: val ? $2e032f5466115b06$var$trim(val[0].replace($2e032f5466115b06$var$COMMENT_REGEX, $2e032f5466115b06$var$EMPTY_STRING)) : $2e032f5466115b06$var$EMPTY_STRING
        });
        // ;
        match($2e032f5466115b06$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
}
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $2e032f5466115b06$var$trim(str) {
    return str ? str.replace($2e032f5466115b06$var$TRIM_REGEX, $2e032f5466115b06$var$EMPTY_STRING) : $2e032f5466115b06$var$EMPTY_STRING;
}
module.exports = $2e032f5466115b06$var$index;

});


var $bff2c38a23c12238$exports = {};
'use strict';

$bff2c38a23c12238$exports = (parcelRequire("19JKY"));


parcelRequire("kYCgE");
/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $733fac03dee448e0$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $733fac03dee448e0$export$825a82322d91916e = /^[\\/]{2}/;
function $733fac03dee448e0$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $0055add69b9e7367$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $0055add69b9e7367$var$PopStateEventType = "popstate";
function $0055add69b9e7367$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $0055add69b9e7367$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $0055add69b9e7367$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $0055add69b9e7367$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $0055add69b9e7367$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $0055add69b9e7367$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $0055add69b9e7367$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $0055add69b9e7367$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $0055add69b9e7367$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $0055add69b9e7367$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $0055add69b9e7367$export$fe53371bee54353d(to);
    }
    return $0055add69b9e7367$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $0055add69b9e7367$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $0055add69b9e7367$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $0055add69b9e7367$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $0055add69b9e7367$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $0055add69b9e7367$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $0055add69b9e7367$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $0055add69b9e7367$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $0055add69b9e7367$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $0055add69b9e7367$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $0055add69b9e7367$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $0055add69b9e7367$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $0055add69b9e7367$export$8ccf933b0513f8d0(to) : to,
        state: state,
        key: to && to.key || key || $0055add69b9e7367$var$createKey(),
        mask: mask
    };
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @category Utils
*/ function $0055add69b9e7367$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @category Utils
*/ function $0055add69b9e7367$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $0055add69b9e7367$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $0055add69b9e7367$var$isLocation(to) ? to : $0055add69b9e7367$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $0055add69b9e7367$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $0055add69b9e7367$var$isLocation(to) ? to : $0055add69b9e7367$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $0055add69b9e7367$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $0055add69b9e7367$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($0055add69b9e7367$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($0055add69b9e7367$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $0055add69b9e7367$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $0055add69b9e7367$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $0055add69b9e7367$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $733fac03dee448e0$export$825a82322d91916e).test(href)) href = base + href;
    return new URL(href, base);
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $kYCgE = parcelRequire("kYCgE");
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $3a8c0daece04f6ae$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $3a8c0daece04f6ae$export$b8d3e69d4b3eff04 = class {
    #map = /* @__PURE__ */ new Map();
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if (this.#map.has(context)) return this.#map.get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        this.#map.set(context, value);
    }
};
const $3a8c0daece04f6ae$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $3a8c0daece04f6ae$export$3e22299e33adeed1(key) {
    return $3a8c0daece04f6ae$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $3a8c0daece04f6ae$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $3a8c0daece04f6ae$export$a89d811eaa209e85(key) {
    return $3a8c0daece04f6ae$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $3a8c0daece04f6ae$var$isIndexRoute(route) {
    return route.index === true;
}
function $3a8c0daece04f6ae$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $kYCgE.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $kYCgE.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $kYCgE.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $3a8c0daece04f6ae$export$87cb1a9238dc3fba(routes, mapRouteProperties = $3a8c0daece04f6ae$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $0055add69b9e7367$export$f5708dca728d7177)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $0055add69b9e7367$export$f5708dca728d7177)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($3a8c0daece04f6ae$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $3a8c0daece04f6ae$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $3a8c0daece04f6ae$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $3a8c0daece04f6ae$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $3a8c0daece04f6ae$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $3a8c0daece04f6ae$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $3a8c0daece04f6ae$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $3a8c0daece04f6ae$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $3a8c0daece04f6ae$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $3a8c0daece04f6ae$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $3a8c0daece04f6ae$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $3a8c0daece04f6ae$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $3a8c0daece04f6ae$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $3a8c0daece04f6ae$export$e486c0390e42ccf6(routes) {
    let branches = $3a8c0daece04f6ae$var$flattenRoutes(routes);
    $3a8c0daece04f6ae$var$rankRouteBranches(branches);
    return branches;
}
function $3a8c0daece04f6ae$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $0055add69b9e7367$export$f5708dca728d7177)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $3a8c0daece04f6ae$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $0055add69b9e7367$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $3a8c0daece04f6ae$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $3a8c0daece04f6ae$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $3a8c0daece04f6ae$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $3a8c0daece04f6ae$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $3a8c0daece04f6ae$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $3a8c0daece04f6ae$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $3a8c0daece04f6ae$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $3a8c0daece04f6ae$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $3a8c0daece04f6ae$var$paramRe = /^:[\w-]+$/;
const $3a8c0daece04f6ae$var$dynamicSegmentValue = 3;
const $3a8c0daece04f6ae$var$indexRouteValue = 2;
const $3a8c0daece04f6ae$var$emptySegmentValue = 1;
const $3a8c0daece04f6ae$var$staticSegmentValue = 10;
const $3a8c0daece04f6ae$var$splatPenalty = -2;
const $3a8c0daece04f6ae$var$isSplat = (s)=>s === "*";
function $3a8c0daece04f6ae$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($3a8c0daece04f6ae$var$isSplat)) initialScore += $3a8c0daece04f6ae$var$splatPenalty;
    if (index) initialScore += $3a8c0daece04f6ae$var$indexRouteValue;
    return segments.filter((s)=>!$3a8c0daece04f6ae$var$isSplat(s)).reduce((score, segment)=>score + ($3a8c0daece04f6ae$var$paramRe.test(segment) ? $3a8c0daece04f6ae$var$dynamicSegmentValue : segment === "" ? $3a8c0daece04f6ae$var$emptySegmentValue : $3a8c0daece04f6ae$var$staticSegmentValue), initialScore);
}
function $3a8c0daece04f6ae$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $3a8c0daece04f6ae$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $3a8c0daece04f6ae$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $3a8c0daece04f6ae$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $3a8c0daece04f6ae$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $3a8c0daece04f6ae$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $3a8c0daece04f6ae$var$normalizePathname($3a8c0daece04f6ae$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $3a8c0daece04f6ae$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Returns a path with params interpolated.
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $3a8c0daece04f6ae$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $0055add69b9e7367$export$491112666e282270)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $0055add69b9e7367$export$f5708dca728d7177)(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $3a8c0daece04f6ae$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $3a8c0daece04f6ae$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $3a8c0daece04f6ae$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $3a8c0daece04f6ae$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $3a8c0daece04f6ae$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $0055add69b9e7367$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $3a8c0daece04f6ae$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $0055add69b9e7367$export$491112666e282270)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $3a8c0daece04f6ae$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $3a8c0daece04f6ae$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $3a8c0daece04f6ae$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $3a8c0daece04f6ae$export$a1cbf2de32a9fd1 = (url)=>(0, $733fac03dee448e0$export$6c52c2011d568bd0).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $3a8c0daece04f6ae$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $3a8c0daece04f6ae$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/")) pathname = $3a8c0daece04f6ae$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $3a8c0daece04f6ae$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $3a8c0daece04f6ae$var$normalizeSearch(search),
        hash: $3a8c0daece04f6ae$var$normalizeHash(hash)
    };
}
function $3a8c0daece04f6ae$var$resolvePathname(relativePath, fromPathname) {
    let segments = $3a8c0daece04f6ae$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $3a8c0daece04f6ae$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $3a8c0daece04f6ae$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $3a8c0daece04f6ae$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $3a8c0daece04f6ae$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $3a8c0daece04f6ae$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(toArg);
    else {
        to = {
            ...toArg
        };
        (0, $0055add69b9e7367$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("?"), $3a8c0daece04f6ae$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $0055add69b9e7367$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("#"), $3a8c0daece04f6ae$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $0055add69b9e7367$export$f5708dca728d7177)(!to.search || !to.search.includes("#"), $3a8c0daece04f6ae$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $3a8c0daece04f6ae$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $3a8c0daece04f6ae$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $3a8c0daece04f6ae$export$86d9a7913e44197e = (paths)=>$3a8c0daece04f6ae$export$f857a07c5bd323b8(paths.join("/"));
const $3a8c0daece04f6ae$export$b6d465111d914331 = (path)=>path.replace(/\/+$/, "");
const $3a8c0daece04f6ae$var$normalizePathname = (pathname)=>$3a8c0daece04f6ae$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $3a8c0daece04f6ae$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $3a8c0daece04f6ae$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $3a8c0daece04f6ae$var$DataWithResponseInit = class {
    type = "DataWithResponseInit";
    data;
    init;
    constructor(data, init){
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $3a8c0daece04f6ae$export$4051a07651545597(data, init) {
    return new $3a8c0daece04f6ae$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $3a8c0daece04f6ae$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $3a8c0daece04f6ae$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $3a8c0daece04f6ae$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $3a8c0daece04f6ae$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $3a8c0daece04f6ae$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $3a8c0daece04f6ae$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $3a8c0daece04f6ae$export$f2680fa305b734ca = class {
    status;
    statusText;
    data;
    error;
    internal;
    constructor(status, statusText, data, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $3a8c0daece04f6ae$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $3a8c0daece04f6ae$export$d738435097971c09(matches) {
    return $3a8c0daece04f6ae$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
const $3a8c0daece04f6ae$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $3a8c0daece04f6ae$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $733fac03dee448e0$export$6c52c2011d568bd0).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($3a8c0daece04f6ae$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $733fac03dee448e0$export$825a82322d91916e).test(to) ? new URL((0, $733fac03dee448e0$export$977999b735cd4f26)(to, currentUrl.protocol)) : new URL(to);
        let path = $3a8c0daece04f6ae$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        (0, $0055add69b9e7367$export$491112666e282270)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/instrumentation.ts
const $12cd0aa20ed3d63f$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $12cd0aa20ed3d63f$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $12cd0aa20ed3d63f$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $12cd0aa20ed3d63f$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$12cd0aa20ed3d63f$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $12cd0aa20ed3d63f$var$wrapImpl(aggregated[key], original, (...args)=>$12cd0aa20ed3d63f$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$12cd0aa20ed3d63f$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$12cd0aa20ed3d63f$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $12cd0aa20ed3d63f$var$wrapImpl(aggregated.middleware, original, (...args)=>$12cd0aa20ed3d63f$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$12cd0aa20ed3d63f$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $12cd0aa20ed3d63f$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$12cd0aa20ed3d63f$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $12cd0aa20ed3d63f$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $0055add69b9e7367$export$fe53371bee54353d)(to) : ".",
                ...$12cd0aa20ed3d63f$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$12cd0aa20ed3d63f$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch = router.fetch[$12cd0aa20ed3d63f$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $12cd0aa20ed3d63f$var$wrapImpl(aggregated.fetch, fetch, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$12cd0aa20ed3d63f$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$12cd0aa20ed3d63f$var$UninstrumentedSymbol] = fetch;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $12cd0aa20ed3d63f$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $12cd0aa20ed3d63f$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $12cd0aa20ed3d63f$var$getReadonlyRequest(request),
            context: context != null ? $12cd0aa20ed3d63f$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $12cd0aa20ed3d63f$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $12cd0aa20ed3d63f$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $12cd0aa20ed3d63f$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        result = {
            type: "success",
            value: await handler()
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $12cd0aa20ed3d63f$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            (0, $0055add69b9e7367$export$f5708dca728d7177)(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
}
function $12cd0aa20ed3d63f$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $12cd0aa20ed3d63f$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $12cd0aa20ed3d63f$var$getReadonlyContext(context)
    };
}
function $12cd0aa20ed3d63f$var$getRouterInfo(router, opts) {
    return {
        currentUrl: (0, $0055add69b9e7367$export$fe53371bee54353d)(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $12cd0aa20ed3d63f$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $12cd0aa20ed3d63f$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}


//#region lib/router/router.ts
const $288f5ae2386e6584$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $288f5ae2386e6584$var$validMutationMethods = new Set($288f5ae2386e6584$var$validMutationMethodsArr);
const $288f5ae2386e6584$var$validRequestMethodsArr = [
    "GET",
    ...$288f5ae2386e6584$var$validMutationMethodsArr
];
const $288f5ae2386e6584$var$validRequestMethods = new Set($288f5ae2386e6584$var$validRequestMethodsArr);
const $288f5ae2386e6584$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $288f5ae2386e6584$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $288f5ae2386e6584$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $288f5ae2386e6584$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $288f5ae2386e6584$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $288f5ae2386e6584$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $288f5ae2386e6584$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $288f5ae2386e6584$var$DataRoutes = class {
    #routes;
    #branches;
    #hmrRoutes;
    #hmrBranches;
    constructor(routes){
        this.#routes = routes;
        this.#branches = (0, $3a8c0daece04f6ae$export$e486c0390e42ccf6)(routes);
    }
    /** The stable route tree */ get stableRoutes() {
        return this.#routes;
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return this.#hmrRoutes ?? this.#routes;
    }
    /** Pre-computed branches */ get branches() {
        return this.#hmrBranches ?? this.#branches;
    }
    get hasHMRRoutes() {
        return this.#hmrRoutes != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        this.#routes = routes;
        this.#branches = (0, $3a8c0daece04f6ae$export$e486c0390e42ccf6)(routes);
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        this.#hmrRoutes = routes;
        this.#hmrBranches = (0, $3a8c0daece04f6ae$export$e486c0390e42ccf6)(routes);
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if (this.#hmrRoutes) {
            this.#routes = this.#hmrRoutes;
            this.#branches = this.#hmrBranches;
            this.#hmrRoutes = void 0;
            this.#hmrBranches = void 0;
        }
    }
};
/**
* Create a router and listen to history POP navigations
*/ function $288f5ae2386e6584$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $0055add69b9e7367$export$f5708dca728d7177)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $12cd0aa20ed3d63f$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $288f5ae2386e6584$var$DataRoutes((0, $3a8c0daece04f6ae$export$87cb1a9238dc3fba)(init.routes, mapRouteProperties, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $288f5ae2386e6584$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $288f5ae2386e6584$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $288f5ae2386e6584$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$288f5ae2386e6584$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $288f5ae2386e6584$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $288f5ae2386e6584$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $0055add69b9e7367$export$491112666e282270)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $288f5ae2386e6584$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $288f5ae2386e6584$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$288f5ae2386e6584$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $288f5ae2386e6584$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $288f5ae2386e6584$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $288f5ae2386e6584$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $288f5ae2386e6584$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP") {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $288f5ae2386e6584$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $288f5ae2386e6584$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let { path: path, submission: submission, error: error } = $288f5ae2386e6584$var$normalizeNavigateOptions(false, $288f5ae2386e6584$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative), opts);
        let maskPath;
        if (opts?.mask) maskPath = {
            pathname: "",
            search: "",
            hash: "",
            ...typeof opts.mask === "string" ? (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            }
        };
        let currentLocation = state.location;
        let nextLocation = (0, $0055add69b9e7367$export$90c043f1c57770b8)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $288f5ae2386e6584$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $288f5ae2386e6584$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $288f5ae2386e6584$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $288f5ae2386e6584$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $288f5ae2386e6584$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $288f5ae2386e6584$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new (0, $3a8c0daece04f6ae$export$b8d3e69d4b3eff04)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $288f5ae2386e6584$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $288f5ae2386e6584$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($288f5ae2386e6584$var$isErrorResult(result) && (0, $3a8c0daece04f6ae$export$972111febbeef05b)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $288f5ae2386e6584$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $288f5ae2386e6584$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$288f5ae2386e6584$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        updateState({
            navigation: $288f5ae2386e6584$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $288f5ae2386e6584$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $288f5ae2386e6584$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $288f5ae2386e6584$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $288f5ae2386e6584$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $288f5ae2386e6584$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($288f5ae2386e6584$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $288f5ae2386e6584$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($288f5ae2386e6584$var$isErrorResult(result)) {
            let boundaryMatch = $288f5ae2386e6584$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $288f5ae2386e6584$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $288f5ae2386e6584$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $288f5ae2386e6584$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $288f5ae2386e6584$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $288f5ae2386e6584$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $288f5ae2386e6584$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$288f5ae2386e6584$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects ? {
                    fetchers: workingFetchers
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect = $288f5ae2386e6584$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $288f5ae2386e6584$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $288f5ae2386e6584$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$288f5ae2386e6584$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $288f5ae2386e6584$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $288f5ae2386e6584$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $288f5ae2386e6584$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $288f5ae2386e6584$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $3a8c0daece04f6ae$export$b8d3e69d4b3eff04)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $288f5ae2386e6584$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        updateFetcherState(key, $288f5ae2386e6584$var$getSubmittingFetcher(submission, state.fetchers.get(key)), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $288f5ae2386e6584$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $288f5ae2386e6584$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $288f5ae2386e6584$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $288f5ae2386e6584$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $288f5ae2386e6584$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($288f5ae2386e6584$var$isRedirectResult(actionResult) || $288f5ae2386e6584$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $288f5ae2386e6584$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($288f5ae2386e6584$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $288f5ae2386e6584$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $288f5ae2386e6584$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($288f5ae2386e6584$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $288f5ae2386e6584$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        (0, $0055add69b9e7367$export$f5708dca728d7177)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $288f5ae2386e6584$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $288f5ae2386e6584$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $288f5ae2386e6584$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $288f5ae2386e6584$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers
            };
        };
        let redirect = $288f5ae2386e6584$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $288f5ae2386e6584$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $288f5ae2386e6584$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $288f5ae2386e6584$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $0055add69b9e7367$export$f5708dca728d7177)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $288f5ae2386e6584$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $288f5ae2386e6584$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $288f5ae2386e6584$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $288f5ae2386e6584$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $288f5ae2386e6584$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $288f5ae2386e6584$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $288f5ae2386e6584$var$getDoneFetcher(void 0));
            return;
        }
        if ($288f5ae2386e6584$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $288f5ae2386e6584$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($288f5ae2386e6584$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $288f5ae2386e6584$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $0055add69b9e7367$export$f5708dca728d7177)(location, "Expected a Location header on the redirect Response");
        location = $288f5ae2386e6584$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = (0, $0055add69b9e7367$export$90c043f1c57770b8)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $3a8c0daece04f6ae$export$a1cbf2de32a9fd1)(location)) {
                const url = (0, $0055add69b9e7367$export$e2450fce17852bf2)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $288f5ae2386e6584$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($288f5ae2386e6584$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $288f5ae2386e6584$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $288f5ae2386e6584$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $288f5ae2386e6584$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$288f5ae2386e6584$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($288f5ae2386e6584$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $288f5ae2386e6584$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $288f5ae2386e6584$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $288f5ae2386e6584$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $288f5ae2386e6584$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $288f5ae2386e6584$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $288f5ae2386e6584$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $0055add69b9e7367$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $288f5ae2386e6584$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $0055add69b9e7367$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $0055add69b9e7367$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $288f5ae2386e6584$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $288f5ae2386e6584$export$386d57f03f0b2883;
        (0, $0055add69b9e7367$export$f5708dca728d7177)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $0055add69b9e7367$export$491112666e282270)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $288f5ae2386e6584$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $288f5ae2386e6584$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $288f5ae2386e6584$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $3a8c0daece04f6ae$export$fcf533780bf49ee2)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) return {
                active: true,
                matches: (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(routesToUse, pathname, basename, true, activeBranches) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(routesToUse, pathname, basename, true, activeBranches)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $288f5ae2386e6584$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $3a8c0daece04f6ae$export$87cb1a9238dc3fba)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $288f5ae2386e6584$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $12cd0aa20ed3d63f$export$ac4df491f31cbbfc)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $288f5ae2386e6584$export$3336b097a6fbc59a(routes, opts) {
    (0, $0055add69b9e7367$export$f5708dca728d7177)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    ({
        ...opts?.future
    });
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $12cd0aa20ed3d63f$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = (0, $3a8c0daece04f6ae$export$87cb1a9238dc3fba)(routes, mapRouteProperties, void 0, manifest);
    let routeBranches = (0, $3a8c0daece04f6ae$export$e486c0390e42ccf6)(dataRoutes);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $288f5ae2386e6584$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $0055add69b9e7367$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new (0, $3a8c0daece04f6ae$export$b8d3e69d4b3eff04)();
        if (!$288f5ae2386e6584$var$isValidMethod(method) && method !== "HEAD") {
            let error = $288f5ae2386e6584$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $288f5ae2386e6584$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $288f5ae2386e6584$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $288f5ae2386e6584$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $0055add69b9e7367$export$f5708dca728d7177)(requestContext instanceof (0, $3a8c0daece04f6ae$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $288f5ae2386e6584$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $288f5ae2386e6584$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $288f5ae2386e6584$var$createDataFunctionUrl(request, location),
                    pattern: (0, $3a8c0daece04f6ae$export$d738435097971c09)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? opts.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($288f5ae2386e6584$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result
                        };
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($288f5ae2386e6584$export$6e80290866a84dd4(error)) return error;
                    if ($288f5ae2386e6584$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(error.status, error.statusText, await $288f5ae2386e6584$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($288f5ae2386e6584$export$e0163cfdf7bc9cfa(error)) error = $288f5ae2386e6584$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $288f5ae2386e6584$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $288f5ae2386e6584$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $288f5ae2386e6584$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id]: error
                            },
                            statusCode: (0, $3a8c0daece04f6ae$export$972111febbeef05b)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $0055add69b9e7367$export$f5708dca728d7177)($288f5ae2386e6584$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($288f5ae2386e6584$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($288f5ae2386e6584$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $288f5ae2386e6584$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $0055add69b9e7367$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new (0, $3a8c0daece04f6ae$export$b8d3e69d4b3eff04)();
        if (!$288f5ae2386e6584$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $288f5ae2386e6584$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $288f5ae2386e6584$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $288f5ae2386e6584$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $288f5ae2386e6584$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $288f5ae2386e6584$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $0055add69b9e7367$export$f5708dca728d7177)(requestContext instanceof (0, $3a8c0daece04f6ae$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $288f5ae2386e6584$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $288f5ae2386e6584$var$runServerMiddlewarePipeline({
                request: request,
                url: $288f5ae2386e6584$var$createDataFunctionUrl(request, location),
                pattern: (0, $3a8c0daece04f6ae$export$d738435097971c09)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $288f5ae2386e6584$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($288f5ae2386e6584$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($288f5ae2386e6584$var$dataWithResponseInitToResponse(error));
                if ($288f5ae2386e6584$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($288f5ae2386e6584$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $0055add69b9e7367$export$f5708dca728d7177)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($288f5ae2386e6584$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $288f5ae2386e6584$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $288f5ae2386e6584$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($288f5ae2386e6584$var$isDataStrategyResult(e) && $288f5ae2386e6584$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($288f5ae2386e6584$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $288f5ae2386e6584$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $288f5ae2386e6584$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $288f5ae2386e6584$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($288f5ae2386e6584$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($288f5ae2386e6584$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($288f5ae2386e6584$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $288f5ae2386e6584$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $3a8c0daece04f6ae$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($288f5ae2386e6584$var$isErrorResult(result)) return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                (skipLoaderErrorBubbling ? actionMatch : $288f5ae2386e6584$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                result
            ]),
            statusCode: (0, $3a8c0daece04f6ae$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: {
                ...result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {}
            }
        };
        return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad),
            actionData: {
                [actionMatch.route.id]: result.data
            },
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $288f5ae2386e6584$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $288f5ae2386e6584$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $288f5ae2386e6584$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $3a8c0daece04f6ae$export$d738435097971c09)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $288f5ae2386e6584$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $288f5ae2386e6584$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $288f5ae2386e6584$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $288f5ae2386e6584$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return {
            ...$288f5ae2386e6584$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling),
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $288f5ae2386e6584$var$callDataStrategyImpl(dataStrategy || $288f5ae2386e6584$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($288f5ae2386e6584$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $288f5ae2386e6584$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($288f5ae2386e6584$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($288f5ae2386e6584$export$e0163cfdf7bc9cfa(result.result)) throw $288f5ae2386e6584$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $288f5ae2386e6584$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $288f5ae2386e6584$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: (0, $3a8c0daece04f6ae$export$972111febbeef05b)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $288f5ae2386e6584$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $288f5ae2386e6584$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $288f5ae2386e6584$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $288f5ae2386e6584$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $3a8c0daece04f6ae$export$cae722b0cc860f13)(to ? to : ".", (0, $3a8c0daece04f6ae$export$fe6dbc5de95f53ab)(contextualMatches), (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $288f5ae2386e6584$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $3a8c0daece04f6ae$export$e9a5bfadbc179142)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $0055add69b9e7367$export$fe53371bee54353d)(path);
}
function $288f5ae2386e6584$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$288f5ae2386e6584$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$288f5ae2386e6584$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $288f5ae2386e6584$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $288f5ae2386e6584$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $288f5ae2386e6584$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$288f5ae2386e6584$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$288f5ae2386e6584$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    (0, $0055add69b9e7367$export$f5708dca728d7177)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $288f5ae2386e6584$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $288f5ae2386e6584$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $288f5ae2386e6584$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $288f5ae2386e6584$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($288f5ae2386e6584$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(path);
    if (isFetcher && parsedPath.search && $288f5ae2386e6584$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $0055add69b9e7367$export$fe53371bee54353d)(parsedPath),
        submission: submission
    };
}
function $288f5ae2386e6584$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $288f5ae2386e6584$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $288f5ae2386e6584$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = (0, $3a8c0daece04f6ae$export$d738435097971c09)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$288f5ae2386e6584$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $288f5ae2386e6584$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($288f5ae2386e6584$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $288f5ae2386e6584$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($288f5ae2386e6584$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        return $288f5ae2386e6584$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $288f5ae2386e6584$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $288f5ae2386e6584$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $288f5ae2386e6584$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $288f5ae2386e6584$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $288f5ae2386e6584$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($288f5ae2386e6584$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $288f5ae2386e6584$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $288f5ae2386e6584$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $288f5ae2386e6584$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$288f5ae2386e6584$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $288f5ae2386e6584$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $288f5ae2386e6584$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $288f5ae2386e6584$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $288f5ae2386e6584$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $0055add69b9e7367$export$f5708dca728d7177)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$288f5ae2386e6584$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $3a8c0daece04f6ae$export$87cb1a9238dc3fba)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $3a8c0daece04f6ae$export$87cb1a9238dc3fba)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $288f5ae2386e6584$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$288f5ae2386e6584$var$isSameRoute(aChild, bChild))) ?? false;
}
const $288f5ae2386e6584$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $288f5ae2386e6584$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $0055add69b9e7367$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $288f5ae2386e6584$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $288f5ae2386e6584$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $3a8c0daece04f6ae$export$3e22299e33adeed1)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $0055add69b9e7367$export$491112666e282270)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $0055add69b9e7367$export$491112666e282270)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
const $288f5ae2386e6584$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $288f5ae2386e6584$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $0055add69b9e7367$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $288f5ae2386e6584$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $0055add69b9e7367$export$f5708dca728d7177)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $3a8c0daece04f6ae$export$a89d811eaa209e85)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $0055add69b9e7367$export$491112666e282270)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $0055add69b9e7367$export$491112666e282270)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                ...mapRouteProperties(routeToUpdate),
                lazy: void 0
            });
        })();
        $288f5ae2386e6584$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $288f5ae2386e6584$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $288f5ae2386e6584$var$isNonNullable(value) {
    return value !== void 0;
}
function $288f5ae2386e6584$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $288f5ae2386e6584$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($288f5ae2386e6584$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $288f5ae2386e6584$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $288f5ae2386e6584$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $288f5ae2386e6584$var$defaultDataStrategy(args);
    return $288f5ae2386e6584$var$runClientMiddlewarePipeline(args, ()=>$288f5ae2386e6584$var$defaultDataStrategy(args));
}
function $288f5ae2386e6584$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $288f5ae2386e6584$var$runMiddlewarePipeline(args, handler, processResult, $288f5ae2386e6584$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $288f5ae2386e6584$export$e0163cfdf7bc9cfa(result) ? $288f5ae2386e6584$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $288f5ae2386e6584$var$runClientMiddlewarePipeline(args, handler) {
    return $288f5ae2386e6584$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($288f5ae2386e6584$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $288f5ae2386e6584$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                await match._lazyPromises?.route;
            } catch  {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$288f5ae2386e6584$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $288f5ae2386e6584$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    return await $288f5ae2386e6584$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $288f5ae2386e6584$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $288f5ae2386e6584$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $288f5ae2386e6584$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $288f5ae2386e6584$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $288f5ae2386e6584$var$loadLazyRoute(match.route, $288f5ae2386e6584$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $288f5ae2386e6584$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $288f5ae2386e6584$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $288f5ae2386e6584$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $288f5ae2386e6584$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $288f5ae2386e6584$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$288f5ae2386e6584$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($288f5ae2386e6584$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $288f5ae2386e6584$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    };
}
function $288f5ae2386e6584$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $288f5ae2386e6584$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $288f5ae2386e6584$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $3a8c0daece04f6ae$export$d738435097971c09)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $288f5ae2386e6584$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $288f5ae2386e6584$var$createDataFunctionUrl(request, path),
        pattern: (0, $3a8c0daece04f6ae$export$d738435097971c09)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $288f5ae2386e6584$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $288f5ae2386e6584$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $288f5ae2386e6584$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $288f5ae2386e6584$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $288f5ae2386e6584$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data",
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $288f5ae2386e6584$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $288f5ae2386e6584$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $288f5ae2386e6584$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($288f5ae2386e6584$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $288f5ae2386e6584$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($288f5ae2386e6584$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $288f5ae2386e6584$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $3a8c0daece04f6ae$export$972111febbeef05b)(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $3a8c0daece04f6ae$export$972111febbeef05b)(result) ? result.status : void 0
        };
    }
    if ($288f5ae2386e6584$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $288f5ae2386e6584$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $0055add69b9e7367$export$f5708dca728d7177)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $3a8c0daece04f6ae$export$a1cbf2de32a9fd1)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $288f5ae2386e6584$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $288f5ae2386e6584$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $288f5ae2386e6584$export$961a3ef7a4da3a39(location) {
    try {
        return $288f5ae2386e6584$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $288f5ae2386e6584$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $3a8c0daece04f6ae$export$a1cbf2de32a9fd1)(location)) {
        let normalizedLocation = location;
        let url = (0, $733fac03dee448e0$export$825a82322d91916e).test(normalizedLocation) ? new URL((0, $733fac03dee448e0$export$977999b735cd4f26)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($288f5ae2386e6584$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $3a8c0daece04f6ae$export$f857a07c5bd323b8)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($288f5ae2386e6584$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $288f5ae2386e6584$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($288f5ae2386e6584$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $288f5ae2386e6584$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $288f5ae2386e6584$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $288f5ae2386e6584$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $288f5ae2386e6584$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $288f5ae2386e6584$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $288f5ae2386e6584$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $288f5ae2386e6584$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $0055add69b9e7367$export$f5708dca728d7177)(!$288f5ae2386e6584$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($288f5ae2386e6584$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $288f5ae2386e6584$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $288f5ae2386e6584$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $3a8c0daece04f6ae$export$972111febbeef05b)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $288f5ae2386e6584$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $288f5ae2386e6584$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $0055add69b9e7367$export$f5708dca728d7177)(result, "Did not find corresponding fetcher result");
        if ($288f5ae2386e6584$var$isErrorResult(result)) {
            let boundaryMatch = $288f5ae2386e6584$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($288f5ae2386e6584$var$isRedirectResult(result)) (0, $0055add69b9e7367$export$f5708dca728d7177)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $288f5ae2386e6584$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $288f5ae2386e6584$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $288f5ae2386e6584$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $288f5ae2386e6584$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $288f5ae2386e6584$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $288f5ae2386e6584$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $288f5ae2386e6584$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $288f5ae2386e6584$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(status || 500, statusText, new Error(errorMessage), true);
}
function $288f5ae2386e6584$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($288f5ae2386e6584$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $288f5ae2386e6584$var$stripHashFromPath(path) {
    return (0, $0055add69b9e7367$export$fe53371bee54353d)({
        ...typeof path === "string" ? (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(path) : path,
        hash: ""
    });
}
function $288f5ae2386e6584$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $288f5ae2386e6584$var$dataWithResponseInitToResponse(data) {
    return Response.json(data.data, data.init ?? void 0);
}
function $288f5ae2386e6584$var$dataWithResponseInitToErrorResponse(data) {
    return new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(data.init?.status ?? 500, data.init?.statusText ?? "Internal Server Error", data.data);
}
function $288f5ae2386e6584$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $288f5ae2386e6584$var$isDataStrategyResult(value));
}
function $288f5ae2386e6584$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $288f5ae2386e6584$var$isRedirectDataStrategyResult(result) {
    return $288f5ae2386e6584$export$3f1eb41d9a6a6a27(result.result) && $288f5ae2386e6584$var$redirectStatusCodes.has(result.result.status);
}
function $288f5ae2386e6584$var$isErrorResult(result) {
    return result.type === "error";
}
function $288f5ae2386e6584$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $288f5ae2386e6584$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $288f5ae2386e6584$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $288f5ae2386e6584$export$794b2760043cf8cd(statusCode) {
    return $288f5ae2386e6584$var$redirectStatusCodes.has(statusCode);
}
function $288f5ae2386e6584$export$6e80290866a84dd4(result) {
    return $288f5ae2386e6584$export$3f1eb41d9a6a6a27(result) && $288f5ae2386e6584$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $288f5ae2386e6584$var$isValidMethod(method) {
    return $288f5ae2386e6584$var$validRequestMethods.has(method.toUpperCase());
}
function $288f5ae2386e6584$export$cbae47800eb95bc3(method) {
    return $288f5ae2386e6584$var$validMutationMethods.has(method.toUpperCase());
}
function $288f5ae2386e6584$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $288f5ae2386e6584$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $288f5ae2386e6584$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $3a8c0daece04f6ae$export$b234c29a3bb68fc8)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $288f5ae2386e6584$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $288f5ae2386e6584$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $288f5ae2386e6584$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $288f5ae2386e6584$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $288f5ae2386e6584$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $288f5ae2386e6584$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $288f5ae2386e6584$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($288f5ae2386e6584$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $288f5ae2386e6584$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($288f5ae2386e6584$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $0055add69b9e7367$export$491112666e282270)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $288f5ae2386e6584$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $kYCgE = parcelRequire("kYCgE");
//#region lib/context.ts
const $2ee0dbe4389e78ae$export$2eeee58951ff3c1c = $kYCgE.createContext(null);
$2ee0dbe4389e78ae$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $2ee0dbe4389e78ae$export$315e3ffb01f217 = $kYCgE.createContext(null);
$2ee0dbe4389e78ae$export$315e3ffb01f217.displayName = "DataRouterState";
const $2ee0dbe4389e78ae$export$717f757c655223f1 = $kYCgE.createContext(false);
function $2ee0dbe4389e78ae$export$6e1eeb090b3ec35b() {
    return $kYCgE.useContext($2ee0dbe4389e78ae$export$717f757c655223f1);
}
const $2ee0dbe4389e78ae$export$3681f408decb40d1 = $kYCgE.createContext({
    isTransitioning: false
});
$2ee0dbe4389e78ae$export$3681f408decb40d1.displayName = "ViewTransition";
const $2ee0dbe4389e78ae$export$cb3f1df1bef00a39 = $kYCgE.createContext(/* @__PURE__ */ new Map());
$2ee0dbe4389e78ae$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $2ee0dbe4389e78ae$export$804c460aade54ac8 = $kYCgE.createContext(null);
$2ee0dbe4389e78ae$export$804c460aade54ac8.displayName = "Await";
const $2ee0dbe4389e78ae$export$2666c20e15407622 = (props)=>$kYCgE.createElement($2ee0dbe4389e78ae$export$804c460aade54ac8.Provider, props);
const $2ee0dbe4389e78ae$export$3044ab7fdabeaee6 = $kYCgE.createContext(null);
$2ee0dbe4389e78ae$export$3044ab7fdabeaee6.displayName = "Navigation";
const $2ee0dbe4389e78ae$export$e6a44b110a0c44d3 = $kYCgE.createContext(null);
$2ee0dbe4389e78ae$export$e6a44b110a0c44d3.displayName = "Location";
const $2ee0dbe4389e78ae$export$aac280ed165a4397 = $kYCgE.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$2ee0dbe4389e78ae$export$aac280ed165a4397.displayName = "Route";
const $2ee0dbe4389e78ae$export$af8bd2647fea9c11 = $kYCgE.createContext(null);
$2ee0dbe4389e78ae$export$af8bd2647fea9c11.displayName = "RouteError";


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/errors.ts
const $c3ef13444bb59b12$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $c3ef13444bb59b12$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $c3ef13444bb59b12$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $c3ef13444bb59b12$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$c3ef13444bb59b12$var$ERROR_DIGEST_BASE}:${$c3ef13444bb59b12$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $c3ef13444bb59b12$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$c3ef13444bb59b12$var$ERROR_DIGEST_BASE}:${$c3ef13444bb59b12$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}



var $kYCgE = parcelRequire("kYCgE");
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $1d4d79585a8afe02$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $0055add69b9e7367$export$f5708dca728d7177)($1d4d79585a8afe02$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let { hash: hash, pathname: pathname, search: search } = $1d4d79585a8afe02$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $3a8c0daece04f6ae$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $1d4d79585a8afe02$export$9c954a9d03d32f4a() {
    return $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$e6a44b110a0c44d3)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $1d4d79585a8afe02$export$45d76561a5302f2b() {
    (0, $0055add69b9e7367$export$f5708dca728d7177)($1d4d79585a8afe02$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$e6a44b110a0c44d3)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $1d4d79585a8afe02$export$1b3f31771c5d07c() {
    return $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$e6a44b110a0c44d3)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $1d4d79585a8afe02$export$6c330e8992e8a295(pattern) {
    (0, $0055add69b9e7367$export$f5708dca728d7177)($1d4d79585a8afe02$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $1d4d79585a8afe02$export$45d76561a5302f2b();
    return $kYCgE.useMemo(()=>(0, $3a8c0daece04f6ae$export$81336c211d5ff295)(pattern, (0, $3a8c0daece04f6ae$export$cd27bea214d030c2)(pathname)), [
        pathname,
        pattern
    ]);
}
const $1d4d79585a8afe02$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: Enable [`document.startViewTransition`](https://developer.mozilla.org/en-US/docs/Web/API/Document/startViewTransition) for this navigation
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate({
*   pathname: "/some/route",
*   search: "?search=param",
*   hash: "#hash",
*   state: { some: "state" },
* });
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* <br/>
* <br/>
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $1d4d79585a8afe02$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397));
    return isDataRoute ? $1d4d79585a8afe02$var$useNavigateStable() : $1d4d79585a8afe02$var$useNavigateUnstable();
}
function $1d4d79585a8afe02$var$useNavigateUnstable() {
    (0, $0055add69b9e7367$export$f5708dca728d7177)($1d4d79585a8afe02$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$2eeee58951ff3c1c));
    let { basename: basename, navigator: navigator } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let { matches: matches } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397));
    let { pathname: locationPathname } = $1d4d79585a8afe02$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $3a8c0daece04f6ae$export$fe6dbc5de95f53ab)(matches));
    let activeRef = $kYCgE.useRef(false);
    $kYCgE.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $kYCgE.useCallback((to, options = {})=>{
        (0, $0055add69b9e7367$export$491112666e282270)(activeRef.current, $1d4d79585a8afe02$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $3a8c0daece04f6ae$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $3a8c0daece04f6ae$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $1d4d79585a8afe02$var$OutletContext = $kYCgE.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $1d4d79585a8afe02$export$4138103a3ae699cc() {
    return $kYCgE.useContext($1d4d79585a8afe02$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $1d4d79585a8afe02$export$a3be3530d8e40d0b(context) {
    let outlet = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397)).outlet;
    return $kYCgE.useMemo(()=>outlet && /* @__PURE__ */ $kYCgE.createElement($1d4d79585a8afe02$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $1d4d79585a8afe02$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397));
    return matches[matches.length - 1]?.params ?? {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $1d4d79585a8afe02$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397));
    let { pathname: locationPathname } = $1d4d79585a8afe02$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $3a8c0daece04f6ae$export$fe6dbc5de95f53ab)(matches));
    return $kYCgE.useMemo(()=>(0, $3a8c0daece04f6ae$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $1d4d79585a8afe02$export$5d3fca4a98652595(routes, locationArg) {
    return $1d4d79585a8afe02$export$f7ce0646a48561fb(routes, locationArg);
}
function $1d4d79585a8afe02$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $0055add69b9e7367$export$f5708dca728d7177)($1d4d79585a8afe02$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let { matches: parentMatches } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $1d4d79585a8afe02$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        (0, $0055add69b9e7367$export$f5708dca728d7177)(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : (0, $3a8c0daece04f6ae$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $1d4d79585a8afe02$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $3a8c0daece04f6ae$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $3a8c0daece04f6ae$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$e6a44b110a0c44d3).Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $1d4d79585a8afe02$var$DefaultErrorComponent() {
    let error = $1d4d79585a8afe02$export$ed527bf60f6e05f2();
    let message = (0, $3a8c0daece04f6ae$export$972111febbeef05b)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, /* @__PURE__ */ $kYCgE.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $kYCgE.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $kYCgE.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $1d4d79585a8afe02$var$defaultErrorElement = /* @__PURE__ */ $kYCgE.createElement($1d4d79585a8afe02$var$DefaultErrorComponent, null);
var $1d4d79585a8afe02$var$RenderErrorBoundary = class extends $kYCgE.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static contextType = (0, $2ee0dbe4389e78ae$export$717f757c655223f1);
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $c3ef13444bb59b12$export$2b5950305b3e7eaf)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$aac280ed165a4397).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$af8bd2647fea9c11).Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $kYCgE.createElement($1d4d79585a8afe02$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
const $1d4d79585a8afe02$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $1d4d79585a8afe02$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $c3ef13444bb59b12$export$30db792b333fd2ee)(error.digest);
        if (redirect) {
            let existingRedirect = $1d4d79585a8afe02$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $3a8c0daece04f6ae$export$ac5aeb949e84fd96)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            if ((0, $288f5ae2386e6584$export$961a3ef7a4da3a39)(target)) throw new Error("Invalid redirect location");
            if ((0, $3a8c0daece04f6ae$export$4e09c449d6c407f7) && !$1d4d79585a8afe02$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $1d4d79585a8afe02$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $kYCgE.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $1d4d79585a8afe02$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$2eeee58951ff3c1c));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$aac280ed165a4397).Provider, {
        value: routeContext
    }, children);
}
function $1d4d79585a8afe02$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        (0, $0055add69b9e7367$export$f5708dca728d7177)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: (0, $3a8c0daece04f6ae$export$d738435097971c09)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $1d4d79585a8afe02$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $1d4d79585a8afe02$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $kYCgE.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $kYCgE.createElement($1d4d79585a8afe02$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $kYCgE.createElement($1d4d79585a8afe02$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $1d4d79585a8afe02$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $1d4d79585a8afe02$var$useDataRouterContext(hookName) {
    let ctx = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$2eeee58951ff3c1c));
    (0, $0055add69b9e7367$export$f5708dca728d7177)(ctx, $1d4d79585a8afe02$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $1d4d79585a8afe02$var$useDataRouterState(hookName) {
    let state = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$315e3ffb01f217));
    (0, $0055add69b9e7367$export$f5708dca728d7177)(state, $1d4d79585a8afe02$var$getDataRouterConsoleError(hookName));
    return state;
}
function $1d4d79585a8afe02$var$useRouteContext(hookName) {
    let route = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397));
    (0, $0055add69b9e7367$export$f5708dca728d7177)(route, $1d4d79585a8afe02$var$getDataRouterConsoleError(hookName));
    return route;
}
function $1d4d79585a8afe02$var$useCurrentRouteId(hookName) {
    let route = $1d4d79585a8afe02$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    (0, $0055add69b9e7367$export$f5708dca728d7177)(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
/**
* Returns the ID for the nearest contextual route
*
* @category Hooks
* @returns The ID of the nearest contextual route
*/ function $1d4d79585a8afe02$export$4200b254756b08af() {
    return $1d4d79585a8afe02$var$useCurrentRouteId("useRouteId");
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $1d4d79585a8afe02$export$d0fd4b7106de2769() {
    let state = $1d4d79585a8afe02$var$useDataRouterState("useNavigation");
    return $kYCgE.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $1d4d79585a8afe02$export$600dc272ed516c15() {
    let dataRouterContext = $1d4d79585a8afe02$var$useDataRouterContext("useRevalidator");
    let state = $1d4d79585a8afe02$var$useDataRouterState("useRevalidator");
    let revalidate = $kYCgE.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $kYCgE.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $1d4d79585a8afe02$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $1d4d79585a8afe02$var$useDataRouterState("useMatches");
    return $kYCgE.useMemo(()=>matches.map((m)=>(0, $3a8c0daece04f6ae$export$fcf533780bf49ee2)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $1d4d79585a8afe02$export$1448a5050d252c4d() {
    let state = $1d4d79585a8afe02$var$useDataRouterState("useLoaderData");
    let routeId = $1d4d79585a8afe02$var$useCurrentRouteId("useLoaderData");
    return state.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $1d4d79585a8afe02$export$fd5d37484eab868d(routeId) {
    return $1d4d79585a8afe02$var$useDataRouterState("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $1d4d79585a8afe02$export$fdc00f3f26066d5e() {
    let state = $1d4d79585a8afe02$var$useDataRouterState("useActionData");
    let routeId = $1d4d79585a8afe02$var$useCurrentRouteId("useLoaderData");
    return state.actionData ? state.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $1d4d79585a8afe02$export$ed527bf60f6e05f2() {
    let error = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$af8bd2647fea9c11));
    let state = $1d4d79585a8afe02$var$useDataRouterState("useRouteError");
    let routeId = $1d4d79585a8afe02$var$useCurrentRouteId("useRouteError");
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $1d4d79585a8afe02$export$78a72ddb39bdd145() {
    return $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$804c460aade54ac8))?._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $1d4d79585a8afe02$export$17f53340677d5831() {
    return $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$804c460aade54ac8))?._error;
}
let $1d4d79585a8afe02$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $1d4d79585a8afe02$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $1d4d79585a8afe02$var$useDataRouterContext("useBlocker");
    let state = $1d4d79585a8afe02$var$useDataRouterState("useBlocker");
    let [blockerKey, setBlockerKey] = $kYCgE.useState("");
    let blockerFunction = $kYCgE.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $kYCgE.useEffect(()=>{
        let key = String(++$1d4d79585a8afe02$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $kYCgE.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $288f5ae2386e6584$export$386d57f03f0b2883);
}
function $1d4d79585a8afe02$var$useNavigateStable() {
    let { router: router } = $1d4d79585a8afe02$var$useDataRouterContext("useNavigate");
    let id = $1d4d79585a8afe02$var$useCurrentRouteId("useNavigate");
    let activeRef = $kYCgE.useRef(false);
    $kYCgE.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $kYCgE.useCallback(async (to, options = {})=>{
        (0, $0055add69b9e7367$export$491112666e282270)(activeRef.current, $1d4d79585a8afe02$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
}
const $1d4d79585a8afe02$var$alreadyWarned = {};
function $1d4d79585a8afe02$var$warningOnce(key, cond, message) {
    if (!cond && !$1d4d79585a8afe02$var$alreadyWarned[key]) {
        $1d4d79585a8afe02$var$alreadyWarned[key] = true;
        (0, $0055add69b9e7367$export$491112666e282270)(false, message);
    }
}
function $1d4d79585a8afe02$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $1d4d79585a8afe02$var$useCurrentRouteId("useRoute");
    const id = args[0] ?? currentRouteId;
    const state = $1d4d79585a8afe02$var$useDataRouterState("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $1d4d79585a8afe02$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = unstable_useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $1d4d79585a8afe02$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $1d4d79585a8afe02$var$useDataRouterState("unstable_useRouterState");
    let active = $kYCgE.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$1d4d79585a8afe02$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $kYCgE.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$1d4d79585a8afe02$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $kYCgE.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $02973bd024c1f301$var$alreadyWarned = {};
function $02973bd024c1f301$export$5b28268982f175ba(condition, message) {
    if (!condition && !$02973bd024c1f301$var$alreadyWarned[message]) {
        $02973bd024c1f301$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}



var $kYCgE = parcelRequire("kYCgE");
//#region lib/components.tsx
const $102f7a9a4f39f387$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $102f7a9a4f39f387$export$f30f7e456d254e83(routes, opts) {
    return (0, $288f5ae2386e6584$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $0055add69b9e7367$export$2b76ad033c6e6d08)({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $3a8c0daece04f6ae$export$6bc17138063be773),
        hydrationRouteProperties: $102f7a9a4f39f387$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $102f7a9a4f39f387$var$Deferred = class {
    status = "pending";
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $102f7a9a4f39f387$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $2ee0dbe4389e78ae$export$6e1eeb090b3ec35b)() || useTransitions;
    let [_state, setStateImpl] = $kYCgE.useState(router.state);
    let [state, setOptimisticState] = (0, $kYCgE.useOptimistic)(_state);
    let [pendingState, setPendingState] = $kYCgE.useState();
    let [vtContext, setVtContext] = $kYCgE.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $kYCgE.useState();
    let [transition, setTransition] = $kYCgE.useState();
    let [interruption, setInterruption] = $kYCgE.useState();
    let fetcherData = $kYCgE.useRef(/* @__PURE__ */ new Map());
    let setState = $kYCgE.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: (0, $3a8c0daece04f6ae$export$d738435097971c09)(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $02973bd024c1f301$export$5b28268982f175ba)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $02973bd024c1f301$export$5b28268982f175ba)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $kYCgE.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$102f7a9a4f39f387$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $kYCgE.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $kYCgE.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $102f7a9a4f39f387$var$Deferred());
    }, [
        vtContext
    ]);
    $kYCgE.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $kYCgE.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$102f7a9a4f39f387$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $kYCgE.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $kYCgE.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $kYCgE.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $kYCgE.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$2eeee58951ff3c1c).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$315e3ffb01f217).Provider, {
        value: state
    }, /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$cb3f1df1bef00a39).Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$3681f408decb40d1).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $kYCgE.createElement($102f7a9a4f39f387$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $kYCgE.createElement($102f7a9a4f39f387$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $102f7a9a4f39f387$var$getOptimisticRouterState(currentState, newState) {
    return {
        ...currentState,
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
const $102f7a9a4f39f387$var$MemoizedDataRoutes = $kYCgE.memo($102f7a9a4f39f387$export$699f06c8afb533c9);
function $102f7a9a4f39f387$export$699f06c8afb533c9({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return (0, $1d4d79585a8afe02$export$f7ce0646a48561fb)(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $102f7a9a4f39f387$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $kYCgE.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $0055add69b9e7367$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kYCgE.useState({
        action: history.action,
        location: history.location
    });
    let setState = $kYCgE.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $kYCgE.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $kYCgE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $kYCgE.createElement($102f7a9a4f39f387$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $102f7a9a4f39f387$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $0055add69b9e7367$export$f5708dca728d7177)((0, $1d4d79585a8afe02$export$9c954a9d03d32f4a)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    (0, $0055add69b9e7367$export$491112666e282270)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397));
    let { pathname: locationPathname } = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let navigate = (0, $1d4d79585a8afe02$export$9770f232ac06a008)();
    let path = (0, $3a8c0daece04f6ae$export$cae722b0cc860f13)(to, (0, $3a8c0daece04f6ae$export$fe6dbc5de95f53ab)(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $kYCgE.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $102f7a9a4f39f387$export$910ae8079b2c2852(props) {
    return (0, $1d4d79585a8afe02$export$a3be3530d8e40d0b)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $102f7a9a4f39f387$export$e7b0ac011bb776c6(props) {
    (0, $0055add69b9e7367$export$f5708dca728d7177)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $102f7a9a4f39f387$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $0055add69b9e7367$export$f5708dca728d7177)(!(0, $1d4d79585a8afe02$export$9c954a9d03d32f4a)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $kYCgE.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $0055add69b9e7367$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $kYCgE.useMemo(()=>{
        let trailingPathname = (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $0055add69b9e7367$export$491112666e282270)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$e6a44b110a0c44d3).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $102f7a9a4f39f387$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $1d4d79585a8afe02$export$5d3fca4a98652595)($102f7a9a4f39f387$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @returns React element for the rendered awaited value
*/ function $102f7a9a4f39f387$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$2eeee58951ff3c1c));
    let dataRouterStateContext = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$315e3ffb01f217));
    let onError = $kYCgE.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: (0, $3a8c0daece04f6ae$export$d738435097971c09)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $kYCgE.createElement($102f7a9a4f39f387$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $kYCgE.createElement($102f7a9a4f39f387$var$ResolveAwait, null, children));
}
var $102f7a9a4f39f387$var$AwaitErrorBoundary = class extends $kYCgE.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$804c460aade54ac8).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $kYCgE.createElement((0, $2ee0dbe4389e78ae$export$804c460aade54ac8).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $102f7a9a4f39f387$var$ResolveAwait({ children: children }) {
    let data = (0, $1d4d79585a8afe02$export$78a72ddb39bdd145)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $102f7a9a4f39f387$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $kYCgE.Children.forEach(children, (element, index)=>{
        if (!$kYCgE.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $kYCgE.Fragment) {
            routes.push.apply(routes, $102f7a9a4f39f387$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $0055add69b9e7367$export$f5708dca728d7177)(element.type === $102f7a9a4f39f387$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $0055add69b9e7367$export$f5708dca728d7177)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $102f7a9a4f39f387$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $102f7a9a4f39f387$export$9b5b6d122dea0c88 = $102f7a9a4f39f387$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $102f7a9a4f39f387$export$daf73786167a7f72(matches) {
    return (0, $1d4d79585a8afe02$export$569816e95a012c39)(matches);
}
function $102f7a9a4f39f387$var$useRouteComponentProps() {
    return {
        params: (0, $1d4d79585a8afe02$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $1d4d79585a8afe02$export$1448a5050d252c4d)(),
        actionData: (0, $1d4d79585a8afe02$export$fdc00f3f26066d5e)(),
        matches: (0, $1d4d79585a8afe02$export$2378eb7f5ff86053)()
    };
}
function $102f7a9a4f39f387$export$6c4f3826290c37af({ children: children }) {
    const props = $102f7a9a4f39f387$var$useRouteComponentProps();
    return $kYCgE.cloneElement(children, props);
}
function $102f7a9a4f39f387$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $102f7a9a4f39f387$var$useRouteComponentProps();
        return $kYCgE.createElement(Component, props);
    };
}
function $102f7a9a4f39f387$var$useHydrateFallbackProps() {
    return {
        params: (0, $1d4d79585a8afe02$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $1d4d79585a8afe02$export$1448a5050d252c4d)(),
        actionData: (0, $1d4d79585a8afe02$export$fdc00f3f26066d5e)()
    };
}
function $102f7a9a4f39f387$export$f8cff34f39c1932a({ children: children }) {
    const props = $102f7a9a4f39f387$var$useHydrateFallbackProps();
    return $kYCgE.cloneElement(children, props);
}
function $102f7a9a4f39f387$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $102f7a9a4f39f387$var$useHydrateFallbackProps();
        return $kYCgE.createElement(HydrateFallback, props);
    };
}
function $102f7a9a4f39f387$var$useErrorBoundaryProps() {
    return {
        params: (0, $1d4d79585a8afe02$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $1d4d79585a8afe02$export$1448a5050d252c4d)(),
        actionData: (0, $1d4d79585a8afe02$export$fdc00f3f26066d5e)(),
        error: (0, $1d4d79585a8afe02$export$ed527bf60f6e05f2)()
    };
}
function $102f7a9a4f39f387$export$e5afde5c4b6d747b({ children: children }) {
    const props = $102f7a9a4f39f387$var$useErrorBoundaryProps();
    return $kYCgE.cloneElement(children, props);
}
function $102f7a9a4f39f387$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $102f7a9a4f39f387$var$useErrorBoundaryProps();
        return $kYCgE.createElement(ErrorBoundary, props);
    };
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

const $249f1cbf1ac17a9a$var$defaultEncType = "application/x-www-form-urlencoded";
function $249f1cbf1ac17a9a$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $249f1cbf1ac17a9a$var$isButtonElement(object) {
    return $249f1cbf1ac17a9a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $249f1cbf1ac17a9a$var$isFormElement(object) {
    return $249f1cbf1ac17a9a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $249f1cbf1ac17a9a$var$isInputElement(object) {
    return $249f1cbf1ac17a9a$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $249f1cbf1ac17a9a$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $249f1cbf1ac17a9a$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$249f1cbf1ac17a9a$var$isModifiedEvent(event);
}
/**
Creates a URLSearchParams object using the given initializer.

This is identical to `new URLSearchParams(init)` except it also
supports arrays as values in the object form of the initializer
instead of just strings. This is convenient when you need multiple
values for a given key, but don't want to use an array initializer.

For example, instead of:

```tsx
let searchParams = new URLSearchParams([
['sort', 'name'],
['sort', 'price']
]);
```
you can do:

```
let searchParams = createSearchParams({
sort: ['name', 'price']
});
```

@category Utils
*/ function $249f1cbf1ac17a9a$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $249f1cbf1ac17a9a$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $249f1cbf1ac17a9a$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $249f1cbf1ac17a9a$var$_formDataSupportsSubmitter = null;
function $249f1cbf1ac17a9a$var$isFormDataSubmitterSupported() {
    if ($249f1cbf1ac17a9a$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $249f1cbf1ac17a9a$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $249f1cbf1ac17a9a$var$_formDataSupportsSubmitter = true;
    }
    return $249f1cbf1ac17a9a$var$_formDataSupportsSubmitter;
}
const $249f1cbf1ac17a9a$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $249f1cbf1ac17a9a$var$getFormEncType(encType) {
    if (encType != null && !$249f1cbf1ac17a9a$var$supportedFormEncTypes.has(encType)) {
        (0, $0055add69b9e7367$export$491112666e282270)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$249f1cbf1ac17a9a$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $249f1cbf1ac17a9a$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($249f1cbf1ac17a9a$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $249f1cbf1ac17a9a$var$getFormEncType(target.getAttribute("enctype")) || $249f1cbf1ac17a9a$var$defaultEncType;
        formData = new FormData(target);
    } else if ($249f1cbf1ac17a9a$var$isButtonElement(target) || $249f1cbf1ac17a9a$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $249f1cbf1ac17a9a$var$getFormEncType(target.getAttribute("formenctype")) || $249f1cbf1ac17a9a$var$getFormEncType(form.getAttribute("enctype")) || $249f1cbf1ac17a9a$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$249f1cbf1ac17a9a$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($249f1cbf1ac17a9a$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $249f1cbf1ac17a9a$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $e2b8d8dd76a7158f$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $e2b8d8dd76a7158f$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $e2b8d8dd76a7158f$export$4cf11838cdc2a8a8(html) {
    return html.replace($e2b8d8dd76a7158f$var$ESCAPE_REGEX, (match)=>$e2b8d8dd76a7158f$var$ESCAPE_LOOKUP[match]);
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $c39b49159123aba6$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $f52cb3be8ca668c2$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $f52cb3be8ca668c2$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $f52cb3be8ca668c2$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}


//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $2af7a77e1e1e7b23$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $2af7a77e1e1e7b23$var$dedupeLinkDescriptors(matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2), $2af7a77e1e1e7b23$export$442b9e023f41af00(matches, manifest));
}
function $2af7a77e1e1e7b23$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $2af7a77e1e1e7b23$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $2af7a77e1e1e7b23$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($2af7a77e1e1e7b23$var$prefetchStyleLink));
}
async function $2af7a77e1e1e7b23$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$2af7a77e1e1e7b23$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$2af7a77e1e1e7b23$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$2af7a77e1e1e7b23$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($2af7a77e1e1e7b23$var$prefetchStyleLink));
}
async function $2af7a77e1e1e7b23$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $2af7a77e1e1e7b23$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $2af7a77e1e1e7b23$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $2af7a77e1e1e7b23$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $2af7a77e1e1e7b23$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $f52cb3be8ca668c2$export$d9c4a4e8105733a6)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($2af7a77e1e1e7b23$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $2af7a77e1e1e7b23$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return currentMatches[index].pathname !== match.pathname || currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $2af7a77e1e1e7b23$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $2af7a77e1e1e7b23$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $2af7a77e1e1e7b23$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $2af7a77e1e1e7b23$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $2af7a77e1e1e7b23$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$2af7a77e1e1e7b23$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($2af7a77e1e1e7b23$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $2af7a77e1e1e7b23$var$_isPreloadSupported;
function $2af7a77e1e1e7b23$var$isPreloadSupported() {
    if ($2af7a77e1e1e7b23$var$_isPreloadSupported !== void 0) return $2af7a77e1e1e7b23$var$_isPreloadSupported;
    let el = document.createElement("link");
    $2af7a77e1e1e7b23$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $2af7a77e1e1e7b23$var$_isPreloadSupported;
}



/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts
var $42fe165906f06bae$export$85f6557964517f1a = class {
    promise;
    resolve;
    reject;
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $42fe165906f06bae$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $66e40a49413046c4$var$TIME_LIMIT_MS = 1;
const $66e40a49413046c4$var$getNow = ()=>Date.now();
const $66e40a49413046c4$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $66e40a49413046c4$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $66e40a49413046c4$var$stringify.call(this, stack);
    return index;
}
async function $66e40a49413046c4$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $66e40a49413046c4$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $66e40a49413046c4$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $66e40a49413046c4$var$TIME_LIMIT_MS) {
            await $66e40a49413046c4$var$yieldToMain();
            lastYieldTime = $66e40a49413046c4$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($66e40a49413046c4$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $66e40a49413046c4$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $66e40a49413046c4$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $66e40a49413046c4$var$objectProtoNames;
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region vendor/turbo-stream-v2/unflatten.ts
const $61921de78f642125$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $61921de78f642125$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $61921de78f642125$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $61921de78f642125$var$hydrate.call(this, startIndex);
}
function $61921de78f642125$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $42fe165906f06bae$export$85f6557964517f1a)();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $61921de78f642125$var$globalObj && (0, $3a8c0daece04f6ae$export$1a235bd2b33434e5).includes(errorType) && errorType in $61921de78f642125$var$globalObj && typeof $61921de78f642125$var$globalObj[errorType] === "function" ? new $61921de78f642125$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}


//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $99d980d9aebf6c0a$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new (0, $42fe165906f06bae$export$85f6557964517f1a)();
    const reader = readable.pipeThrough((0, $42fe165906f06bae$export$4786a9f20844482d)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $99d980d9aebf6c0a$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $99d980d9aebf6c0a$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $99d980d9aebf6c0a$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $61921de78f642125$export$4315a2af848d75d7).call(this, line)
    };
}
async function $99d980d9aebf6c0a$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = (0, $61921de78f642125$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = (0, $61921de78f642125$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $99d980d9aebf6c0a$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $66e40a49413046c4$export$bffa455ba8c619a6).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $66e40a49413046c4$export$bffa455ba8c619a6).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $66e40a49413046c4$export$bffa455ba8c619a6).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $3c47fe7664de8b77$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}



var $kYCgE = parcelRequire("kYCgE");
//#region lib/dom/ssr/single-fetch.tsx
const $d356e85dc11754ac$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $d356e85dc11754ac$var$SingleFetchNoResultError = class extends Error {
};
const $d356e85dc11754ac$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $d356e85dc11754ac$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $kYCgE.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $e2b8d8dd76a7158f$export$4cf11838cdc2a8a8)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, scriptTag, /* @__PURE__ */ $kYCgE.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, scriptTag, /* @__PURE__ */ $kYCgE.createElement($kYCgE.Suspense, null, /* @__PURE__ */ $kYCgE.createElement($d356e85dc11754ac$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $d356e85dc11754ac$export$77d7799427e365da(getRouter, manifest, routeModules, ssr) {
    let dataStrategy = $d356e85dc11754ac$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $c39b49159123aba6$export$2e2bcd8739ae039)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $d356e85dc11754ac$var$fetchAndDecodeViaTurboStream, ssr);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $d356e85dc11754ac$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $d356e85dc11754ac$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $d356e85dc11754ac$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $d356e85dc11754ac$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $d356e85dc11754ac$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut);
    };
}
async function $d356e85dc11754ac$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $d356e85dc11754ac$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $288f5ae2386e6584$export$3f1eb41d9a6a6a27)(result.result) || (0, $3a8c0daece04f6ae$export$972111febbeef05b)(result.result) || (0, $288f5ae2386e6584$export$e0163cfdf7bc9cfa)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $3a8c0daece04f6ae$export$4051a07651545597)(result.result, actionStatus)
        }
    };
}
async function $d356e85dc11754ac$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data } = await fetchAndDecode(args, [
                        routeId
                    ]);
                    return $d356e85dc11754ac$var$unwrapSingleFetchResult(data, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $d356e85dc11754ac$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$d356e85dc11754ac$var$createDeferred());
    let singleFetchDfd = $d356e85dc11754ac$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute ||= m.shouldRevalidateArgs != null && hasLoader;
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $d356e85dc11754ac$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $d356e85dc11754ac$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $d356e85dc11754ac$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $d356e85dc11754ac$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $d356e85dc11754ac$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $d356e85dc11754ac$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $d356e85dc11754ac$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $d356e85dc11754ac$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $d356e85dc11754ac$export$7b977381851b2c(reqUrl, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
async function $d356e85dc11754ac$var$fetchAndDecodeViaTurboStream(args, targetRoutes) {
    let { request: request } = args;
    let url = $d356e85dc11754ac$export$7b977381851b2c(request.url, "data");
    if (request.method === "GET") {
        url = $d356e85dc11754ac$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await (0, $3c47fe7664de8b77$export$a30aa2a0fce6c468)(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: 202,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($d356e85dc11754ac$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(res.body, "No response body to decode");
    try {
        let decoded = await $d356e85dc11754ac$export$4023ad4ecd4126a2(res.body, window);
        let data;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($d356e85dc11754ac$export$60644022b8b46aaa in typed) data = {
                redirect: typed[$d356e85dc11754ac$export$60644022b8b46aaa]
            };
            else data = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            (0, $c39b49159123aba6$export$2e2bcd8739ae039)(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data = {
                redirect: typed
            };
            else data = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $d356e85dc11754ac$export$4023ad4ecd4126a2(body, global) {
    return (0, $99d980d9aebf6c0a$export$2f872c0f2117be69)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $3a8c0daece04f6ae$export$1a235bd2b33434e5).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$d356e85dc11754ac$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $d356e85dc11754ac$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $3a8c0daece04f6ae$export$89e12c5b50f7529d)(location, {
            status: status,
            headers: {
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $d356e85dc11754ac$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $d356e85dc11754ac$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $kYCgE = parcelRequire("kYCgE");
//#region lib/dom/ssr/errorBoundaries.tsx
var $b3ffb6b56e521fe4$export$32e57f52df4b6e34 = class extends $kYCgE.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $kYCgE.createElement($b3ffb6b56e521fe4$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $b3ffb6b56e521fe4$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $041a7678c1a14adb$export$17134ff624fc6bc2)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $kYCgE.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $3a8c0daece04f6ae$export$972111febbeef05b)(error)) return /* @__PURE__ */ $kYCgE.createElement($b3ffb6b56e521fe4$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $kYCgE.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $kYCgE.createElement($b3ffb6b56e521fe4$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $kYCgE.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $kYCgE.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $b3ffb6b56e521fe4$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = (0, $041a7678c1a14adb$export$17134ff624fc6bc2)();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $kYCgE.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $kYCgE.createElement("head", null, /* @__PURE__ */ $kYCgE.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $kYCgE.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $kYCgE.createElement("title", null, title)), /* @__PURE__ */ $kYCgE.createElement("body", null, /* @__PURE__ */ $kYCgE.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $kYCgE.createElement((0, $041a7678c1a14adb$export$ff0bf87698939488), null) : null)));
}


/**
 * react-router v8.0.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $kYCgE = parcelRequire("kYCgE");
//#region lib/dom/ssr/fallback.tsx
function $659e5a33fbef023d$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $041a7678c1a14adb$export$17134ff624fc6bc2)();
    return /* @__PURE__ */ $kYCgE.createElement((0, $b3ffb6b56e521fe4$export$cf8626ebc6a4ba63), {
        title: "Loading...",
        renderScripts: true
    }, null);
}



var $kYCgE = parcelRequire("kYCgE");
//#region lib/dom/ssr/routes.tsx
function $956158eac0a739b7$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $956158eac0a739b7$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $956158eac0a739b7$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $659e5a33fbef023d$export$7e8143a7b6df36d9) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $kYCgE.createElement((0, $b3ffb6b56e521fe4$export$20b33acd14692c9), {
            error: (0, $1d4d79585a8afe02$export$ed527bf60f6e05f2)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component ? {
            element: /* @__PURE__ */ $kYCgE.createElement(routeModule.Layout, null, /* @__PURE__ */ $kYCgE.createElement(Component, null))
        } : {
            Component: Component
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $kYCgE.createElement(routeModule.Layout, null, /* @__PURE__ */ $kYCgE.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $kYCgE.createElement(routeModule.Layout, null, /* @__PURE__ */ $kYCgE.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $956158eac0a739b7$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $956158eac0a739b7$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $c39b49159123aba6$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$956158eac0a739b7$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $956158eac0a739b7$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $956158eac0a739b7$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $956158eac0a739b7$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $956158eac0a739b7$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $956158eac0a739b7$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
function $956158eac0a739b7$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(405, "Method Not Allowed", new Error(msg), true);
}
function $956158eac0a739b7$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $956158eac0a739b7$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $c39b49159123aba6$export$2e2bcd8739ae039)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $956158eac0a739b7$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $2af7a77e1e1e7b23$export$26f28bc6dfd6cfc6)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$956158eac0a739b7$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $956158eac0a739b7$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $956158eac0a739b7$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $956158eac0a739b7$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $956158eac0a739b7$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $956158eac0a739b7$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $956158eac0a739b7$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $956158eac0a739b7$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $956158eac0a739b7$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $956158eac0a739b7$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $956158eac0a739b7$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $956158eac0a739b7$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $956158eac0a739b7$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $956158eac0a739b7$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $3a8c0daece04f6ae$export$d726f29eb2425705)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $956158eac0a739b7$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $956158eac0a739b7$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $f52cb3be8ca668c2$export$d9c4a4e8105733a6)(route, routeModules);
    let prefetchRouteCssPromise = (0, $2af7a77e1e1e7b23$export$2ee8f5601ba37b41)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $2af7a77e1e1e7b23$export$26f28bc6dfd6cfc6)(route, routeModule)
    ]);
    return {
        Component: $956158eac0a739b7$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $956158eac0a739b7$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $956158eac0a739b7$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}



var $kYCgE = parcelRequire("kYCgE");
//#region lib/dom/ssr/fog-of-war.ts
const $8baf06887bdd9c60$var$nextPaths = /* @__PURE__ */ new Set();
const $8baf06887bdd9c60$var$discoveredPathsMaxSize = 1e3;
const $8baf06887bdd9c60$var$discoveredPaths = /* @__PURE__ */ new Set();
const $8baf06887bdd9c60$export$b5915cf27fa06b9f = 7680;
function $8baf06887bdd9c60$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $8baf06887bdd9c60$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $8baf06887bdd9c60$export$ae5150779dbcc11a({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = (0, $3a8c0daece04f6ae$export$5c7b09132f833c25)(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $8baf06887bdd9c60$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$8baf06887bdd9c60$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($8baf06887bdd9c60$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $8baf06887bdd9c60$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $0055add69b9e7367$export$fe53371bee54353d)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $8baf06887bdd9c60$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $kYCgE.useEffect(()=>{
        if (!$8baf06887bdd9c60$export$741d98b28dbfd(routeDiscovery, ssr) || window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$8baf06887bdd9c60$var$discoveredPaths.has(pathname)) $8baf06887bdd9c60$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($8baf06887bdd9c60$var$nextPaths.keys()).filter((path)=>{
                if ($8baf06887bdd9c60$var$discoveredPaths.has(path)) {
                    $8baf06887bdd9c60$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $8baf06887bdd9c60$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $8baf06887bdd9c60$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $8baf06887bdd9c60$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $3a8c0daece04f6ae$export$86d9a7913e44197e)([
        basename,
        manifestPath
    ]);
}
const $8baf06887bdd9c60$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $8baf06887bdd9c60$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $8baf06887bdd9c60$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($8baf06887bdd9c60$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $8baf06887bdd9c60$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($8baf06887bdd9c60$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($8baf06887bdd9c60$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($8baf06887bdd9c60$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$8baf06887bdd9c60$var$addToFifoQueue(p, $8baf06887bdd9c60$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $956158eac0a739b7$export$af76e85f27ba0229)(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $8baf06887bdd9c60$var$addToFifoQueue(path, queue) {
    if (queue.size >= $8baf06887bdd9c60$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $8baf06887bdd9c60$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}



var $kYCgE = parcelRequire("kYCgE");
//#region lib/dom/ssr/components.tsx
function $041a7678c1a14adb$var$useDataRouterContext() {
    let context = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$2eeee58951ff3c1c));
    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $041a7678c1a14adb$var$useDataRouterStateContext() {
    let context = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$315e3ffb01f217));
    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
const $041a7678c1a14adb$export$208d6a3bc3aa62bd = $kYCgE.createContext(void 0);
$041a7678c1a14adb$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $041a7678c1a14adb$export$17134ff624fc6bc2() {
    let context = $kYCgE.useContext($041a7678c1a14adb$export$208d6a3bc3aa62bd);
    (0, $c39b49159123aba6$export$2e2bcd8739ae039)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $041a7678c1a14adb$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $kYCgE.useContext($041a7678c1a14adb$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $kYCgE.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $kYCgE.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $kYCgE.useRef(null);
    $kYCgE.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $kYCgE.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $041a7678c1a14adb$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $041a7678c1a14adb$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $041a7678c1a14adb$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $041a7678c1a14adb$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $041a7678c1a14adb$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $041a7678c1a14adb$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $041a7678c1a14adb$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$041a7678c1a14adb$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $041a7678c1a14adb$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $041a7678c1a14adb$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $041a7678c1a14adb$export$17134ff624fc6bc2();
    let { errors: errors, matches: routerMatches } = $041a7678c1a14adb$var$useDataRouterStateContext();
    let matches = $041a7678c1a14adb$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $kYCgE.useMemo(()=>(0, $2af7a77e1e1e7b23$export$c43eb07eab2c950a)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $kYCgE.createElement("style", {
        [$041a7678c1a14adb$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $kYCgE.createElement("link", {
        [$041a7678c1a14adb$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>(0, $2af7a77e1e1e7b23$export$aea1aca0de10baae)(link) ? /* @__PURE__ */ $kYCgE.createElement($041a7678c1a14adb$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $kYCgE.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $041a7678c1a14adb$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = (0, $2ee0dbe4389e78ae$export$6e1eeb090b3ec35b)();
    let { nonce: contextNonce } = $041a7678c1a14adb$export$17134ff624fc6bc2();
    let { router: router } = $041a7678c1a14adb$var$useDataRouterContext();
    let matches = $kYCgE.useMemo(()=>(0, $3a8c0daece04f6ae$export$2708184779ceb39d)(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $kYCgE.createElement($041a7678c1a14adb$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $kYCgE.createElement($041a7678c1a14adb$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $041a7678c1a14adb$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $041a7678c1a14adb$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $kYCgE.useState([]);
    $kYCgE.useEffect(()=>{
        let interrupted = false;
        (0, $2af7a77e1e1e7b23$export$98f31d7a23772264)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $041a7678c1a14adb$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let dataHrefs = $kYCgE.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $d356e85dc11754ac$export$7b977381851b2c)(page, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $kYCgE.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $041a7678c1a14adb$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let { manifest: manifest, routeModules: routeModules } = $041a7678c1a14adb$export$17134ff624fc6bc2();
    let { loaderData: loaderData, matches: matches } = $041a7678c1a14adb$var$useDataRouterStateContext();
    let newMatchesForData = $kYCgE.useMemo(()=>(0, $2af7a77e1e1e7b23$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $kYCgE.useMemo(()=>(0, $2af7a77e1e1e7b23$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $kYCgE.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $d356e85dc11754ac$export$7b977381851b2c)(page, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $kYCgE.useMemo(()=>(0, $2af7a77e1e1e7b23$export$442b9e023f41af00)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $041a7678c1a14adb$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $kYCgE.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $kYCgE.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>/* @__PURE__ */ $kYCgE.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $041a7678c1a14adb$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $041a7678c1a14adb$export$17134ff624fc6bc2();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $041a7678c1a14adb$var$useDataRouterStateContext();
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let _matches = $041a7678c1a14adb$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$041a7678c1a14adb$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $kYCgE.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $kYCgE.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ??= metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $kYCgE.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $kYCgE.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $e2b8d8dd76a7158f$export$4cf11838cdc2a8a8)(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $kYCgE.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $041a7678c1a14adb$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $041a7678c1a14adb$var$isHydrated = false;
function $041a7678c1a14adb$export$3be068dde909e563() {
    $041a7678c1a14adb$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $041a7678c1a14adb$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $041a7678c1a14adb$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = $041a7678c1a14adb$var$useDataRouterContext();
    let { matches: routerMatches } = $041a7678c1a14adb$var$useDataRouterStateContext();
    let isRSCRouterContext = (0, $2ee0dbe4389e78ae$export$6e1eeb090b3ec35b)();
    let enableFogOfWar = (0, $8baf06887bdd9c60$export$741d98b28dbfd)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $041a7678c1a14adb$var$getActiveMatches(routerMatches, null, isSpaMode);
    $kYCgE.useEffect(()=>{
        $041a7678c1a14adb$export$3be068dde909e563();
    }, []);
    let initialScripts = $kYCgE.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $c39b49159123aba6$export$2e2bcd8739ae039)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $8baf06887bdd9c60$export$ae5150779dbcc11a)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, /* @__PURE__ */ $kYCgE.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $kYCgE.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $041a7678c1a14adb$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $2af7a77e1e1e7b23$export$442b9e023f41af00)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $02973bd024c1f301$export$5b28268982f175ba)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $041a7678c1a14adb$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $kYCgE.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $kYCgE.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $kYCgE.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $kYCgE.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $041a7678c1a14adb$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}



var $kYCgE = parcelRequire("kYCgE");
//#region lib/dom/lib.tsx
const $083e616e9396c747$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($083e616e9396c747$var$isBrowser) window.__reactRouterVersion = "8.0.1";
} catch (e) {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $083e616e9396c747$export$1f3f55432a00e06d(routes, opts) {
    return (0, $288f5ae2386e6584$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $0055add69b9e7367$export$719fc203c4e16dee)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $083e616e9396c747$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3a8c0daece04f6ae$export$6bc17138063be773),
        hydrationRouteProperties: $102f7a9a4f39f387$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $083e616e9396c747$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $288f5ae2386e6584$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $0055add69b9e7367$export$b71fdd3798280242)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $083e616e9396c747$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $3a8c0daece04f6ae$export$6bc17138063be773),
        hydrationRouteProperties: $102f7a9a4f39f387$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $083e616e9396c747$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $083e616e9396c747$var$deserializeErrors(state.errors)
    };
    return state;
}
function $083e616e9396c747$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $3a8c0daece04f6ae$export$f2680fa305b734ca)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $3a8c0daece04f6ae$export$1a235bd2b33434e5).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch (e) {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $083e616e9396c747$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $kYCgE.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $0055add69b9e7367$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kYCgE.useState({
        action: history.action,
        location: history.location
    });
    let setState = $kYCgE.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $kYCgE.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $kYCgE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $kYCgE.createElement((0, $102f7a9a4f39f387$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $083e616e9396c747$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $kYCgE.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $0055add69b9e7367$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kYCgE.useState({
        action: history.action,
        location: history.location
    });
    let setState = $kYCgE.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $kYCgE.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $kYCgE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $kYCgE.createElement((0, $102f7a9a4f39f387$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $083e616e9396c747$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $kYCgE.useState({
        action: history.action,
        location: history.location
    });
    let setState = $kYCgE.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $kYCgE.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $kYCgE.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $kYCgE.createElement((0, $102f7a9a4f39f387$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$083e616e9396c747$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $083e616e9396c747$export$a6c7ac8248d6e38a = $kYCgE.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let isAbsolute = typeof to === "string" && (0, $733fac03dee448e0$export$6c52c2011d568bd0).test(to);
    let parsed = (0, $3a8c0daece04f6ae$export$ac5aeb949e84fd96)(to, basename);
    to = parsed.to;
    let href = (0, $1d4d79585a8afe02$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $3a8c0daece04f6ae$export$cae722b0cc860f13)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $3a8c0daece04f6ae$export$86d9a7913e44197e)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $041a7678c1a14adb$export$6eb91431f5da407c)(prefetch, rest);
    let internalOnClick = $083e616e9396c747$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $kYCgE.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $041a7678c1a14adb$export$c9058316764c140e)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $kYCgE.createElement($kYCgE.Fragment, null, link, /* @__PURE__ */ $kYCgE.createElement((0, $041a7678c1a14adb$export$60dcec93e67386bd), {
        page: href
    })) : link;
});
$083e616e9396c747$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $083e616e9396c747$export$b0d92dbee9b5b60d = $kYCgE.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = (0, $1d4d79585a8afe02$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let routerState = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$315e3ffb01f217));
    let { navigator: navigator, basename: basename } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let isTransitioning = routerState != null && $083e616e9396c747$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $kYCgE.createElement($083e616e9396c747$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$083e616e9396c747$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $083e616e9396c747$export$a7fed597f4b8afd8 = $kYCgE.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let submit = $083e616e9396c747$export$47c85c6e3a081d3();
    let formAction = $083e616e9396c747$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $733fac03dee448e0$export$6c52c2011d568bd0).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $kYCgE.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $kYCgE.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$083e616e9396c747$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $083e616e9396c747$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $kYCgE.useContext((0, $041a7678c1a14adb$export$208d6a3bc3aa62bd));
    let { basename: basename } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let matches = (0, $1d4d79585a8afe02$export$2378eb7f5ff86053)();
    $083e616e9396c747$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $kYCgE.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $083e616e9396c747$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $kYCgE.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $e2b8d8dd76a7158f$export$4cf11838cdc2a8a8)(JSON.stringify(storageKey || $083e616e9396c747$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $e2b8d8dd76a7158f$export$4cf11838cdc2a8a8)(JSON.stringify(ssrKey))})`
        }
    });
}
$083e616e9396c747$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $083e616e9396c747$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $083e616e9396c747$var$useDataRouterContext(hookName) {
    let ctx = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$2eeee58951ff3c1c));
    (0, $0055add69b9e7367$export$f5708dca728d7177)(ctx, $083e616e9396c747$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $083e616e9396c747$var$useDataRouterState(hookName) {
    let state = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$315e3ffb01f217));
    (0, $0055add69b9e7367$export$f5708dca728d7177)(state, $083e616e9396c747$var$getDataRouterConsoleError(hookName));
    return state;
}
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition Enables a [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* for this navigation. To apply specific styles during the transition, see
* {@link useViewTransitionState}. Defaults to `false`.
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. Defaults to `true`.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $083e616e9396c747$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $1d4d79585a8afe02$export$9770f232ac06a008)();
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let path = (0, $1d4d79585a8afe02$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $kYCgE.useCallback((event)=>{
        if ((0, $249f1cbf1ac17a9a$export$4c2d35dce1b682e)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $0055add69b9e7367$export$fe53371bee54353d)(location) === (0, $0055add69b9e7367$export$fe53371bee54353d)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $kYCgE.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $083e616e9396c747$export$f1a78c17382fe22a(defaultInit) {
    (0, $0055add69b9e7367$export$491112666e282270)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $kYCgE.useRef((0, $249f1cbf1ac17a9a$export$a2e4e2dcc7b1f22f)(defaultInit));
    let hasSetSearchParamsRef = $kYCgE.useRef(false);
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let searchParams = $kYCgE.useMemo(()=>(0, $249f1cbf1ac17a9a$export$4370c962fe3096e6)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $1d4d79585a8afe02$export$9770f232ac06a008)();
    return [
        searchParams,
        $kYCgE.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $249f1cbf1ac17a9a$export$a2e4e2dcc7b1f22f)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $083e616e9396c747$var$fetcherId = 0;
let $083e616e9396c747$var$getUniqueFetcherId = ()=>`__${String(++$083e616e9396c747$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $083e616e9396c747$export$47c85c6e3a081d3() {
    let { router: router } = $083e616e9396c747$var$useDataRouterContext("useSubmit");
    let { basename: basename } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let currentRouteId = (0, $1d4d79585a8afe02$export$4200b254756b08af)();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $kYCgE.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $249f1cbf1ac17a9a$export$80917616746b9ab4)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $083e616e9396c747$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $083e616e9396c747$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let routeContext = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397));
    (0, $0055add69b9e7367$export$f5708dca728d7177)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...(0, $1d4d79585a8afe02$export$e75d2a2d1b3c245b)(action ? action : ".", {
            relative: relative
        })
    };
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $3a8c0daece04f6ae$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $0055add69b9e7367$export$fe53371bee54353d)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $083e616e9396c747$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $083e616e9396c747$var$useDataRouterContext("useFetcher");
    let state = $083e616e9396c747$var$useDataRouterState("useFetcher");
    let fetcherData = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$cb3f1df1bef00a39));
    let route = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$aac280ed165a4397));
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    (0, $0055add69b9e7367$export$f5708dca728d7177)(fetcherData, `useFetcher must be used inside a FetchersContext`);
    (0, $0055add69b9e7367$export$f5708dca728d7177)(route, `useFetcher must be used inside a RouteContext`);
    (0, $0055add69b9e7367$export$f5708dca728d7177)(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $kYCgE.useId();
    let [fetcherKey, setFetcherKey] = $kYCgE.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $kYCgE.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $kYCgE.useCallback(async (href, opts)=>{
        (0, $0055add69b9e7367$export$f5708dca728d7177)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $083e616e9396c747$export$47c85c6e3a081d3();
    let submit = $kYCgE.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $kYCgE.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $kYCgE.useMemo(()=>{
        let FetcherForm = $kYCgE.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $kYCgE.createElement($083e616e9396c747$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || (0, $288f5ae2386e6584$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    return $kYCgE.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $083e616e9396c747$export$fa996778a3a31087() {
    let state = $083e616e9396c747$var$useDataRouterState("useFetchers");
    return $kYCgE.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
const $083e616e9396c747$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $083e616e9396c747$var$savedScrollPositions = {};
function $083e616e9396c747$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $083e616e9396c747$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $083e616e9396c747$var$useDataRouterContext("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $083e616e9396c747$var$useDataRouterState("useScrollRestoration");
    let { basename: basename } = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3044ab7fdabeaee6));
    let location = (0, $1d4d79585a8afe02$export$45d76561a5302f2b)();
    let matches = (0, $1d4d79585a8afe02$export$2378eb7f5ff86053)();
    let navigation = (0, $1d4d79585a8afe02$export$d0fd4b7106de2769)();
    $kYCgE.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $083e616e9396c747$var$usePageHide($kYCgE.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $083e616e9396c747$var$getScrollRestorationKey(location, matches, basename, getKey);
            $083e616e9396c747$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $083e616e9396c747$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($083e616e9396c747$var$savedScrollPositions));
        } catch (error) {
            (0, $0055add69b9e7367$export$491112666e282270)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $kYCgE.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $083e616e9396c747$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $083e616e9396c747$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $kYCgE.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($083e616e9396c747$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$083e616e9396c747$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $kYCgE.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                (0, $0055add69b9e7367$export$491112666e282270)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $083e616e9396c747$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $kYCgE.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $083e616e9396c747$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $kYCgE.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $083e616e9396c747$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $1d4d79585a8afe02$export$b273b3273281a049)(when);
    $kYCgE.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $kYCgE.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*/ function $083e616e9396c747$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $kYCgE.useContext((0, $2ee0dbe4389e78ae$export$3681f408decb40d1));
    (0, $0055add69b9e7367$export$f5708dca728d7177)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $083e616e9396c747$var$useDataRouterContext("useViewTransitionState");
    let path = (0, $1d4d79585a8afe02$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $3a8c0daece04f6ae$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $3a8c0daece04f6ae$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $3a8c0daece04f6ae$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


var $b72177ec5dfe0822$exports = {};
'use strict';
function $b72177ec5dfe0822$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b72177ec5dfe0822$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b72177ec5dfe0822$var$checkDCE();

$b72177ec5dfe0822$exports = (parcelRequire("3HtyS"));




parcelRequire("kYCgE");


parcelRequire("kYCgE");
var $813139c09616f284$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsxs)((0, $bff2c38a23c12238$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("header", {
                className: "masthead",
                children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                        className: "grid",
                        children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                            className: "row",
                            children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                                className: "col-lg-7 header-column my-5",
                                children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsxs)("div", {
                                    className: "header-content my-5 p-3",
                                    children: [
                                        /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("h2", {
                                            className: "mb-5",
                                            children: "CarveWizard is an experimental GPU G-code planner that takes 3D geometry and outputs milling tool paths."
                                        }),
                                        /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsxs)("p", {
                                            children: [
                                                "GPUs used for AI come with substantial amounts of video RAM, which enables us to operate on the part ",
                                                /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("i", {
                                                    children: " volume "
                                                }),
                                                "rather than the",
                                                /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("i", {
                                                    children: " surface "
                                                }),
                                                " as a B-REP kernel would."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("p", {
                                            children: "This enables large parallelization speedups and also produces paths which have been 100% collision checked and shortcut in a volume-aware way so that every segment is cutting."
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("section", {
                className: "py-5 video-section",
                children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                    className: "video-section-content",
                    children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                            className: "row justify-content-center",
                            children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                                className: "col-lg-10",
                                children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                                    className: "video-embed",
                                    children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
                                        className: "ratio ratio-16x9",
                                        children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("iframe", {
                                            src: "https://www.youtube.com/embed/efMCUcesigo",
                                            title: "CarveWizard: CAM For Robots",
                                            allowFullScreen: true,
                                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });




var $kYCgE = parcelRequire("kYCgE");
/**
 * @import {Element, Nodes, Parents, Root} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {ComponentType, JSX, ReactElement, ReactNode} from 'react'
 * @import {Options as RemarkRehypeOptions} from 'remark-rehype'
 * @import {BuildVisitor} from 'unist-util-visit'
 * @import {PluggableList, Processor} from 'unified'
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 */ /**
 * @typedef ExtraProps
 *   Extra fields we pass.
 * @property {Element | undefined} [node]
 *   passed when `passNode` is on.
 */ /**
 * @typedef {{
 *   [Key in keyof JSX.IntrinsicElements]?: ComponentType<JSX.IntrinsicElements[Key] & ExtraProps> | keyof JSX.IntrinsicElements
 * }} Components
 *   Map tag names to components.
 */ /**
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 */ /**
 * @typedef HooksOptionsOnly
 *   Configuration specifically for {@linkcode MarkdownHooks}.
 * @property {ReactNode | null | undefined} [fallback]
 *   Content to render while the processor processing the markdown (optional).
 */ /**
 * @typedef {Options & HooksOptionsOnly} HooksOptions
 *   Configuration for {@linkcode MarkdownHooks};
 *   extends the regular {@linkcode Options} with a `fallback` prop.
 */ /**
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ function $86de8631a137d21f$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $86de8631a137d21f$export$411ce8e5a71e3069() {}
function $86de8631a137d21f$export$dcb8b3f0e2de7e49() {}
function $86de8631a137d21f$export$565e9d9bd6b6e0d4() {}


/**
 * @import {Identifier, Literal, MemberExpression} from 'estree'
 * @import {Jsx, JsxDev, Options, Props} from 'hast-util-to-jsx-runtime'
 * @import {Element, Nodes, Parents, Root, Text} from 'hast'
 * @import {MdxFlowExpressionHast, MdxTextExpressionHast} from 'mdast-util-mdx-expression'
 * @import {MdxJsxFlowElementHast, MdxJsxTextElementHast} from 'mdast-util-mdx-jsx'
 * @import {MdxjsEsmHast} from 'mdast-util-mdxjs-esm'
 * @import {Position} from 'unist'
 * @import {Child, Create, Field, JsxElement, State, Style} from './types.js'
 */ /**
 * @typedef Options
 *   Configuration for `stringify`.
 * @property {boolean} [padLeft=true]
 *   Whether to pad a space before a token.
 * @property {boolean} [padRight=false]
 *   Whether to pad a space after a token.
 */ /**
 * @typedef {Options} StringifyOptions
 *   Please use `StringifyOptions` instead.
 */ /**
 * Parse comma-separated tokens to an array.
 *
 * @param {string} value
 *   Comma-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $6d5a88e09f30d747$export$98e6a39c04603d36(value) {
    /** @type {Array<string>} */ const tokens = [];
    const input = String(value || '');
    let index = input.indexOf(',');
    let start = 0;
    /** @type {boolean} */ let end = false;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        const token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(',', start);
    }
    return tokens;
}
function $6d5a88e09f30d747$export$fac44ee5b035f737(values, options) {
    const settings = options || {};
    // Ensure the last empty entry is seen.
    const input = values[values.length - 1] === '' ? [
        ...values,
        ''
    ] : values;
    return input.join((settings.padRight ? ' ' : '') + ',' + (settings.padLeft === false ? '' : ' ')).trim();
}



/**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ const $9cb8597a102b01f9$var$startRe = /[$_\p{ID_Start}]/u;
const $9cb8597a102b01f9$var$contRe = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $9cb8597a102b01f9$var$contReJsx = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u;
const $9cb8597a102b01f9$var$nameRe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
const $9cb8597a102b01f9$var$nameReJsx = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u;
/** @type {Options} */ const $9cb8597a102b01f9$var$emptyOptions = {};
function $9cb8597a102b01f9$export$b3571188c770cc5a(code) {
    return code ? $9cb8597a102b01f9$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $9cb8597a102b01f9$export$10eb6dc47bf009dc(code, options) {
    const settings = options || $9cb8597a102b01f9$var$emptyOptions;
    const re = settings.jsx ? $9cb8597a102b01f9$var$contReJsx : $9cb8597a102b01f9$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $9cb8597a102b01f9$export$a8ff84c12d48cfa6(name, options) {
    const settings = options || $9cb8597a102b01f9$var$emptyOptions;
    const re = settings.jsx ? $9cb8597a102b01f9$var$nameReJsx : $9cb8597a102b01f9$var$nameRe;
    return re.test(name);
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $88c2fb7c1c9376fd$var$re = /[ \t\n\f\r]/g;
function $88c2fb7c1c9376fd$export$7af1228ff777d175(thing) {
    return typeof thing === 'object' ? thing.type === 'text' ? $88c2fb7c1c9376fd$var$empty(thing.value) : false : $88c2fb7c1c9376fd$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $88c2fb7c1c9376fd$var$empty(value) {
    return value.replace($88c2fb7c1c9376fd$var$re, '') === '';
}


/**
 * @import {Schema} from 'property-information'
 */ /**
 * @import {Space} from 'property-information'
 */ /**
 * @import {Info as InfoType} from 'property-information'
 */ /** @type {InfoType} */ class $6edcf62935c3ef23$export$c4868e4a24d48fad {
    /**
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @returns
   *   Info.
   */ constructor(property, attribute){
        this.attribute = attribute;
        this.property = property;
    }
}
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.attribute = '';
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.booleanish = false;
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.boolean = false;
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.defined = false;
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.number = false;
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.property = '';
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$6edcf62935c3ef23$export$c4868e4a24d48fad.prototype.space = undefined;


var $349c9fb388419550$exports = {};

$parcel$export($349c9fb388419550$exports, "boolean", function () { return $349c9fb388419550$export$4a21f16c33752377; });
$parcel$export($349c9fb388419550$exports, "booleanish", function () { return $349c9fb388419550$export$55e9e1fbc638dc8f; });
$parcel$export($349c9fb388419550$exports, "overloadedBoolean", function () { return $349c9fb388419550$export$242ac3d3042558aa; });
$parcel$export($349c9fb388419550$exports, "number", function () { return $349c9fb388419550$export$98e628dec113755e; });
$parcel$export($349c9fb388419550$exports, "spaceSeparated", function () { return $349c9fb388419550$export$ab8645c862eb5a3e; });
$parcel$export($349c9fb388419550$exports, "commaSeparated", function () { return $349c9fb388419550$export$9c8d678629b3d3; });
$parcel$export($349c9fb388419550$exports, "commaOrSpaceSeparated", function () { return $349c9fb388419550$export$2ad25cfebf36cacd; });
let $349c9fb388419550$var$powers = 0;
const $349c9fb388419550$export$4a21f16c33752377 = $349c9fb388419550$var$increment();
const $349c9fb388419550$export$55e9e1fbc638dc8f = $349c9fb388419550$var$increment();
const $349c9fb388419550$export$242ac3d3042558aa = $349c9fb388419550$var$increment();
const $349c9fb388419550$export$98e628dec113755e = $349c9fb388419550$var$increment();
const $349c9fb388419550$export$ab8645c862eb5a3e = $349c9fb388419550$var$increment();
const $349c9fb388419550$export$9c8d678629b3d3 = $349c9fb388419550$var$increment();
const $349c9fb388419550$export$2ad25cfebf36cacd = $349c9fb388419550$var$increment();
function $349c9fb388419550$var$increment() {
    return 2 ** ++$349c9fb388419550$var$powers;
}


const $e69aafc1b9dc18e2$var$checks = /** @type {ReadonlyArray<keyof typeof types>} */ Object.keys($349c9fb388419550$exports);
class $e69aafc1b9dc18e2$export$ea6b9f0064e88c9b extends (0, $6edcf62935c3ef23$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   *   Property.
   * @param {string} attribute
   *   Attribute.
   * @param {number | null | undefined} [mask]
   *   Mask.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Info.
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $e69aafc1b9dc18e2$var$mark(this, 'space', space);
        if (typeof mask === 'number') while(++index < $e69aafc1b9dc18e2$var$checks.length){
            const check = $e69aafc1b9dc18e2$var$checks[index];
            $e69aafc1b9dc18e2$var$mark(this, $e69aafc1b9dc18e2$var$checks[index], (mask & $349c9fb388419550$exports[check]) === $349c9fb388419550$exports[check]);
        }
    }
}
$e69aafc1b9dc18e2$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @template {keyof DefinedInfo} Key
 *   Key type.
 * @param {DefinedInfo} values
 *   Info.
 * @param {Key} key
 *   Key.
 * @param {DefinedInfo[Key]} value
 *   Value.
 * @returns {undefined}
 *   Nothing.
 */ function $e69aafc1b9dc18e2$var$mark(values, key, value) {
    if (value) values[key] = value;
}



/**
 * Get the cleaned case insensitive form of an attribute or property.
 *
 * @param {string} value
 *   An attribute-like or property-like name.
 * @returns {string}
 *   Value that can be used to look up the properly cased property on a
 *   `Schema`.
 */ function $488878f1a00eebf3$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


const $6e85ae16d7a4f080$var$cap = /[A-Z]/g;
const $6e85ae16d7a4f080$var$dash = /-[a-z]/g;
const $6e85ae16d7a4f080$var$valid = /^data[-\w.:]+$/i;
function $6e85ae16d7a4f080$export$71aa6c912b956294(schema, value) {
    const normal = (0, $488878f1a00eebf3$export$a3295358bff77e)(value);
    let property = value;
    let Type = (0, $6edcf62935c3ef23$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === 'data' && $6e85ae16d7a4f080$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === '-') {
            // Turn it into a property.
            const rest = value.slice(5).replace($6e85ae16d7a4f080$var$dash, $6e85ae16d7a4f080$var$camelcase);
            property = 'data' + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$6e85ae16d7a4f080$var$dash.test(rest)) {
                let dashes = rest.replace($6e85ae16d7a4f080$var$cap, $6e85ae16d7a4f080$var$kebab);
                if (dashes.charAt(0) !== '-') dashes = '-' + dashes;
                value = 'data' + dashes;
            }
        }
        Type = (0, $e69aafc1b9dc18e2$export$ea6b9f0064e88c9b);
    }
    return new Type(property, value);
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Kebab.
 */ function $6e85ae16d7a4f080$var$kebab($0) {
    return '-' + $0.toLowerCase();
}
/**
 * @param {string} $0
 *   Value.
 * @returns {string}
 *   Camel.
 */ function $6e85ae16d7a4f080$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * Special cases for React (`Record<string, string>`).
 *
 * `hast` is close to `React` but differs in a couple of cases.
 * To get a React property from a hast property,
 * check if it is in `hastToReact`.
 * If it is, use the corresponding value;
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $f1a9921af0eb0bc3$export$d8abd7e5fb6871f9 = {
    classId: 'classID',
    dataType: 'datatype',
    itemId: 'itemID',
    strokeDashArray: 'strokeDasharray',
    strokeDashOffset: 'strokeDashoffset',
    strokeLineCap: 'strokeLinecap',
    strokeLineJoin: 'strokeLinejoin',
    strokeMiterLimit: 'strokeMiterlimit',
    typeOf: 'typeof',
    xLinkActuate: 'xlinkActuate',
    xLinkArcRole: 'xlinkArcrole',
    xLinkHref: 'xlinkHref',
    xLinkRole: 'xlinkRole',
    xLinkShow: 'xlinkShow',
    xLinkTitle: 'xlinkTitle',
    xLinkType: 'xlinkType',
    xmlnsXLink: 'xmlnsXlink'
};

// Note: types exposed from `index.d.ts`.
/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @import {Schema as SchemaType, Space} from 'property-information'
 */ /** @type {SchemaType} */ class $325208c6840c9bc6$export$19342e026b58ebb7 {
    /**
   * @param {SchemaType['property']} property
   *   Property.
   * @param {SchemaType['normal']} normal
   *   Normal.
   * @param {Space | undefined} [space]
   *   Space.
   * @returns
   *   Schema.
   */ constructor(property, normal, space){
        this.normal = normal;
        this.property = property;
        if (space) this.space = space;
    }
}
$325208c6840c9bc6$export$19342e026b58ebb7.prototype.normal = {};
$325208c6840c9bc6$export$19342e026b58ebb7.prototype.property = {};
$325208c6840c9bc6$export$19342e026b58ebb7.prototype.space = undefined;


function $488631ebec1f60b8$export$4950aa0f605343fb(definitions, space) {
    /** @type {Record<string, Info>} */ const property = {};
    /** @type {Record<string, string>} */ const normal = {};
    for (const definition of definitions){
        Object.assign(property, definition.property);
        Object.assign(normal, definition.normal);
    }
    return new (0, $325208c6840c9bc6$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @import {Info, Space} from 'property-information'
 */ /**
 * @typedef Definition
 *   Definition of a schema.
 * @property {Record<string, string> | undefined} [attributes]
 *   Normalzed names to special attribute case.
 * @property {ReadonlyArray<string> | undefined} [mustUseProperty]
 *   Normalized names that must be set as properties.
 * @property {Record<string, number | null>} properties
 *   Property names to their types.
 * @property {Space | undefined} [space]
 *   Space.
 * @property {Transform} transform
 *   Transform a property name.
 */ /**
 * @callback Transform
 *   Transform.
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} property
 *   Property.
 * @returns {string}
 *   Attribute.
 */ 


function $daa89ff492231150$export$185802fd694ee1f5(definition) {
    /** @type {Record<string, Info>} */ const properties = {};
    /** @type {Record<string, string>} */ const normals = {};
    for (const [property, value] of Object.entries(definition.properties)){
        const info = new (0, $e69aafc1b9dc18e2$export$ea6b9f0064e88c9b)(property, definition.transform(definition.attributes || {}, property), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(property)) info.mustUseProperty = true;
        properties[property] = info;
        normals[(0, $488878f1a00eebf3$export$a3295358bff77e)(property)] = property;
        normals[(0, $488878f1a00eebf3$export$a3295358bff77e)(info.attribute)] = property;
    }
    return new (0, $325208c6840c9bc6$export$19342e026b58ebb7)(properties, normals, definition.space);
}



const $c5b18158769213d4$export$4d2d26490572750a = (0, $daa89ff492231150$export$185802fd694ee1f5)({
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaColIndex: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaColSpan: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaControls: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        ariaLevel: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaPressed: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaRowIndex: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaRowSpan: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaSelected: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaValueMin: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaValueNow: (0, $349c9fb388419550$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    },
    transform (_, property) {
        return property === 'role' ? property : 'aria-' + property.slice(4).toLowerCase();
    }
});


/**
 * @param {Record<string, string>} attributes
 *   Attributes.
 * @param {string} attribute
 *   Attribute.
 * @returns {string}
 *   Transformed attribute.
 */ function $9e791619eb9056d4$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $4cb8e4d3866567f6$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $9e791619eb9056d4$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}




const $22ae6f0dc9a21236$export$c0bb0b647f701bb5 = (0, $daa89ff492231150$export$185802fd694ee1f5)({
    attributes: {
        acceptcharset: 'accept-charset',
        classname: 'class',
        htmlfor: 'for',
        httpequiv: 'http-equiv'
    },
    mustUseProperty: [
        'checked',
        'multiple',
        'muted',
        'selected'
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $349c9fb388419550$export$9c8d678629b3d3),
        acceptCharset: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        accessKey: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $349c9fb388419550$export$4a21f16c33752377),
        allowPaymentRequest: (0, $349c9fb388419550$export$4a21f16c33752377),
        allowUserMedia: (0, $349c9fb388419550$export$4a21f16c33752377),
        alpha: (0, $349c9fb388419550$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $349c9fb388419550$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        autoFocus: (0, $349c9fb388419550$export$4a21f16c33752377),
        autoPlay: (0, $349c9fb388419550$export$4a21f16c33752377),
        blocking: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        capture: null,
        charSet: null,
        checked: (0, $349c9fb388419550$export$4a21f16c33752377),
        cite: null,
        className: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        closedBy: null,
        colorSpace: null,
        cols: (0, $349c9fb388419550$export$98e628dec113755e),
        colSpan: (0, $349c9fb388419550$export$98e628dec113755e),
        command: null,
        commandFor: null,
        content: null,
        contentEditable: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        controls: (0, $349c9fb388419550$export$4a21f16c33752377),
        controlsList: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        coords: (0, $349c9fb388419550$export$98e628dec113755e) | (0, $349c9fb388419550$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $349c9fb388419550$export$4a21f16c33752377),
        defer: (0, $349c9fb388419550$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $349c9fb388419550$export$4a21f16c33752377),
        download: (0, $349c9fb388419550$export$242ac3d3042558aa),
        draggable: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        fetchPriority: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $349c9fb388419550$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        height: (0, $349c9fb388419550$export$98e628dec113755e),
        hidden: (0, $349c9fb388419550$export$242ac3d3042558aa),
        high: (0, $349c9fb388419550$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        httpEquiv: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inert: (0, $349c9fb388419550$export$4a21f16c33752377),
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $349c9fb388419550$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        itemRef: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        itemScope: (0, $349c9fb388419550$export$4a21f16c33752377),
        itemType: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $349c9fb388419550$export$4a21f16c33752377),
        low: (0, $349c9fb388419550$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $349c9fb388419550$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $349c9fb388419550$export$98e628dec113755e),
        multiple: (0, $349c9fb388419550$export$4a21f16c33752377),
        muted: (0, $349c9fb388419550$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $349c9fb388419550$export$4a21f16c33752377),
        noValidate: (0, $349c9fb388419550$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeToggle: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $349c9fb388419550$export$4a21f16c33752377),
        optimum: (0, $349c9fb388419550$export$98e628dec113755e),
        pattern: null,
        ping: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $349c9fb388419550$export$4a21f16c33752377),
        popover: null,
        popoverTarget: null,
        popoverTargetAction: null,
        poster: null,
        preload: null,
        readOnly: (0, $349c9fb388419550$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        required: (0, $349c9fb388419550$export$4a21f16c33752377),
        reversed: (0, $349c9fb388419550$export$4a21f16c33752377),
        rows: (0, $349c9fb388419550$export$98e628dec113755e),
        rowSpan: (0, $349c9fb388419550$export$98e628dec113755e),
        sandbox: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $349c9fb388419550$export$4a21f16c33752377),
        seamless: (0, $349c9fb388419550$export$4a21f16c33752377),
        selected: (0, $349c9fb388419550$export$4a21f16c33752377),
        shadowRootClonable: (0, $349c9fb388419550$export$4a21f16c33752377),
        shadowRootCustomElementRegistry: (0, $349c9fb388419550$export$4a21f16c33752377),
        shadowRootDelegatesFocus: (0, $349c9fb388419550$export$4a21f16c33752377),
        shadowRootMode: null,
        shadowRootSerializable: (0, $349c9fb388419550$export$4a21f16c33752377),
        shape: null,
        size: (0, $349c9fb388419550$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $349c9fb388419550$export$98e628dec113755e),
        spellCheck: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $349c9fb388419550$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $349c9fb388419550$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $349c9fb388419550$export$4a21f16c33752377),
        useMap: null,
        value: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        width: (0, $349c9fb388419550$export$98e628dec113755e),
        wrap: null,
        writingSuggestions: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $349c9fb388419550$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $349c9fb388419550$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $349c9fb388419550$export$4a21f16c33752377),
        declare: (0, $349c9fb388419550$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $349c9fb388419550$export$98e628dec113755e),
        leftMargin: (0, $349c9fb388419550$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $349c9fb388419550$export$98e628dec113755e),
        marginWidth: (0, $349c9fb388419550$export$98e628dec113755e),
        noResize: (0, $349c9fb388419550$export$4a21f16c33752377),
        noHref: (0, $349c9fb388419550$export$4a21f16c33752377),
        noShade: (0, $349c9fb388419550$export$4a21f16c33752377),
        noWrap: (0, $349c9fb388419550$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $349c9fb388419550$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $349c9fb388419550$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $349c9fb388419550$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $349c9fb388419550$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        credentialless: (0, $349c9fb388419550$export$4a21f16c33752377),
        disablePictureInPicture: (0, $349c9fb388419550$export$4a21f16c33752377),
        disableRemotePlayback: (0, $349c9fb388419550$export$4a21f16c33752377),
        exportParts: (0, $349c9fb388419550$export$9c8d678629b3d3),
        part: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        prefix: null,
        property: null,
        results: (0, $349c9fb388419550$export$98e628dec113755e),
        security: null,
        unselectable: null
    },
    space: 'html',
    transform: (0, $4cb8e4d3866567f6$export$32b9e4cec9c208e1)
});





const $534a45a5dabfe0a4$export$7ed1367e7fa1ad68 = (0, $daa89ff492231150$export$185802fd694ee1f5)({
    attributes: {
        accentHeight: 'accent-height',
        alignmentBaseline: 'alignment-baseline',
        arabicForm: 'arabic-form',
        baselineShift: 'baseline-shift',
        capHeight: 'cap-height',
        className: 'class',
        clipPath: 'clip-path',
        clipRule: 'clip-rule',
        colorInterpolation: 'color-interpolation',
        colorInterpolationFilters: 'color-interpolation-filters',
        colorProfile: 'color-profile',
        colorRendering: 'color-rendering',
        crossOrigin: 'crossorigin',
        dataType: 'datatype',
        dominantBaseline: 'dominant-baseline',
        enableBackground: 'enable-background',
        fillOpacity: 'fill-opacity',
        fillRule: 'fill-rule',
        floodColor: 'flood-color',
        floodOpacity: 'flood-opacity',
        fontFamily: 'font-family',
        fontSize: 'font-size',
        fontSizeAdjust: 'font-size-adjust',
        fontStretch: 'font-stretch',
        fontStyle: 'font-style',
        fontVariant: 'font-variant',
        fontWeight: 'font-weight',
        glyphName: 'glyph-name',
        glyphOrientationHorizontal: 'glyph-orientation-horizontal',
        glyphOrientationVertical: 'glyph-orientation-vertical',
        hrefLang: 'hreflang',
        horizAdvX: 'horiz-adv-x',
        horizOriginX: 'horiz-origin-x',
        horizOriginY: 'horiz-origin-y',
        imageRendering: 'image-rendering',
        letterSpacing: 'letter-spacing',
        lightingColor: 'lighting-color',
        markerEnd: 'marker-end',
        markerMid: 'marker-mid',
        markerStart: 'marker-start',
        maskType: 'mask-type',
        navDown: 'nav-down',
        navDownLeft: 'nav-down-left',
        navDownRight: 'nav-down-right',
        navLeft: 'nav-left',
        navNext: 'nav-next',
        navPrev: 'nav-prev',
        navRight: 'nav-right',
        navUp: 'nav-up',
        navUpLeft: 'nav-up-left',
        navUpRight: 'nav-up-right',
        onAbort: 'onabort',
        onActivate: 'onactivate',
        onAfterPrint: 'onafterprint',
        onBeforePrint: 'onbeforeprint',
        onBegin: 'onbegin',
        onCancel: 'oncancel',
        onCanPlay: 'oncanplay',
        onCanPlayThrough: 'oncanplaythrough',
        onChange: 'onchange',
        onClick: 'onclick',
        onClose: 'onclose',
        onCopy: 'oncopy',
        onCueChange: 'oncuechange',
        onCut: 'oncut',
        onDblClick: 'ondblclick',
        onDrag: 'ondrag',
        onDragEnd: 'ondragend',
        onDragEnter: 'ondragenter',
        onDragExit: 'ondragexit',
        onDragLeave: 'ondragleave',
        onDragOver: 'ondragover',
        onDragStart: 'ondragstart',
        onDrop: 'ondrop',
        onDurationChange: 'ondurationchange',
        onEmptied: 'onemptied',
        onEnd: 'onend',
        onEnded: 'onended',
        onError: 'onerror',
        onFocus: 'onfocus',
        onFocusIn: 'onfocusin',
        onFocusOut: 'onfocusout',
        onHashChange: 'onhashchange',
        onInput: 'oninput',
        onInvalid: 'oninvalid',
        onKeyDown: 'onkeydown',
        onKeyPress: 'onkeypress',
        onKeyUp: 'onkeyup',
        onLoad: 'onload',
        onLoadedData: 'onloadeddata',
        onLoadedMetadata: 'onloadedmetadata',
        onLoadStart: 'onloadstart',
        onMessage: 'onmessage',
        onMouseDown: 'onmousedown',
        onMouseEnter: 'onmouseenter',
        onMouseLeave: 'onmouseleave',
        onMouseMove: 'onmousemove',
        onMouseOut: 'onmouseout',
        onMouseOver: 'onmouseover',
        onMouseUp: 'onmouseup',
        onMouseWheel: 'onmousewheel',
        onOffline: 'onoffline',
        onOnline: 'ononline',
        onPageHide: 'onpagehide',
        onPageShow: 'onpageshow',
        onPaste: 'onpaste',
        onPause: 'onpause',
        onPlay: 'onplay',
        onPlaying: 'onplaying',
        onPopState: 'onpopstate',
        onProgress: 'onprogress',
        onRateChange: 'onratechange',
        onRepeat: 'onrepeat',
        onReset: 'onreset',
        onResize: 'onresize',
        onScroll: 'onscroll',
        onSeeked: 'onseeked',
        onSeeking: 'onseeking',
        onSelect: 'onselect',
        onShow: 'onshow',
        onStalled: 'onstalled',
        onStorage: 'onstorage',
        onSubmit: 'onsubmit',
        onSuspend: 'onsuspend',
        onTimeUpdate: 'ontimeupdate',
        onToggle: 'ontoggle',
        onUnload: 'onunload',
        onVolumeChange: 'onvolumechange',
        onWaiting: 'onwaiting',
        onZoom: 'onzoom',
        overlinePosition: 'overline-position',
        overlineThickness: 'overline-thickness',
        paintOrder: 'paint-order',
        panose1: 'panose-1',
        pointerEvents: 'pointer-events',
        referrerPolicy: 'referrerpolicy',
        renderingIntent: 'rendering-intent',
        shapeRendering: 'shape-rendering',
        stopColor: 'stop-color',
        stopOpacity: 'stop-opacity',
        strikethroughPosition: 'strikethrough-position',
        strikethroughThickness: 'strikethrough-thickness',
        strokeDashArray: 'stroke-dasharray',
        strokeDashOffset: 'stroke-dashoffset',
        strokeLineCap: 'stroke-linecap',
        strokeLineJoin: 'stroke-linejoin',
        strokeMiterLimit: 'stroke-miterlimit',
        strokeOpacity: 'stroke-opacity',
        strokeWidth: 'stroke-width',
        tabIndex: 'tabindex',
        textAnchor: 'text-anchor',
        textDecoration: 'text-decoration',
        textRendering: 'text-rendering',
        transformOrigin: 'transform-origin',
        typeOf: 'typeof',
        underlinePosition: 'underline-position',
        underlineThickness: 'underline-thickness',
        unicodeBidi: 'unicode-bidi',
        unicodeRange: 'unicode-range',
        unitsPerEm: 'units-per-em',
        vAlphabetic: 'v-alphabetic',
        vHanging: 'v-hanging',
        vIdeographic: 'v-ideographic',
        vMathematical: 'v-mathematical',
        vectorEffect: 'vector-effect',
        vertAdvY: 'vert-adv-y',
        vertOriginX: 'vert-origin-x',
        vertOriginY: 'vert-origin-y',
        wordSpacing: 'word-spacing',
        writingMode: 'writing-mode',
        xHeight: 'x-height',
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: 'playbackorder',
        timelineBegin: 'timelinebegin'
    },
    properties: {
        about: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        accentHeight: (0, $349c9fb388419550$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $349c9fb388419550$export$98e628dec113755e),
        amplitude: (0, $349c9fb388419550$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $349c9fb388419550$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $349c9fb388419550$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $349c9fb388419550$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $349c9fb388419550$export$98e628dec113755e),
        className: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $349c9fb388419550$export$98e628dec113755e),
        diffuseConstant: (0, $349c9fb388419550$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $349c9fb388419550$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $349c9fb388419550$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $349c9fb388419550$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $349c9fb388419550$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $349c9fb388419550$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $349c9fb388419550$export$9c8d678629b3d3),
        g2: (0, $349c9fb388419550$export$9c8d678629b3d3),
        glyphName: (0, $349c9fb388419550$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $349c9fb388419550$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $349c9fb388419550$export$98e628dec113755e),
        horizOriginX: (0, $349c9fb388419550$export$98e628dec113755e),
        horizOriginY: (0, $349c9fb388419550$export$98e628dec113755e),
        id: null,
        ideographic: (0, $349c9fb388419550$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $349c9fb388419550$export$98e628dec113755e),
        k: (0, $349c9fb388419550$export$98e628dec113755e),
        k1: (0, $349c9fb388419550$export$98e628dec113755e),
        k2: (0, $349c9fb388419550$export$98e628dec113755e),
        k3: (0, $349c9fb388419550$export$98e628dec113755e),
        k4: (0, $349c9fb388419550$export$98e628dec113755e),
        kernelMatrix: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $349c9fb388419550$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskType: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $349c9fb388419550$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $349c9fb388419550$export$98e628dec113755e),
        overlineThickness: (0, $349c9fb388419550$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $349c9fb388419550$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $349c9fb388419550$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $349c9fb388419550$export$98e628dec113755e),
        pointsAtY: (0, $349c9fb388419550$export$98e628dec113755e),
        pointsAtZ: (0, $349c9fb388419550$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        rev: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        requiredFonts: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        requiredFormats: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $349c9fb388419550$export$98e628dec113755e),
        specularExponent: (0, $349c9fb388419550$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $349c9fb388419550$export$98e628dec113755e),
        strikethroughThickness: (0, $349c9fb388419550$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $349c9fb388419550$export$98e628dec113755e),
        strokeOpacity: (0, $349c9fb388419550$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $349c9fb388419550$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        tabIndex: (0, $349c9fb388419550$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $349c9fb388419550$export$98e628dec113755e),
        targetY: (0, $349c9fb388419550$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $349c9fb388419550$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        transformOrigin: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $349c9fb388419550$export$98e628dec113755e),
        underlineThickness: (0, $349c9fb388419550$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $349c9fb388419550$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $349c9fb388419550$export$98e628dec113755e),
        vMathematical: (0, $349c9fb388419550$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $349c9fb388419550$export$98e628dec113755e),
        vIdeographic: (0, $349c9fb388419550$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $349c9fb388419550$export$98e628dec113755e),
        vertOriginX: (0, $349c9fb388419550$export$98e628dec113755e),
        vertOriginY: (0, $349c9fb388419550$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $349c9fb388419550$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    },
    space: 'svg',
    transform: (0, $9e791619eb9056d4$export$5b10b3bc32d7efbc)
});



const $fc46c587b07688ce$export$2bd1230ec7600845 = (0, $daa89ff492231150$export$185802fd694ee1f5)({
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    },
    space: 'xlink',
    transform (_, property) {
        return 'xlink:' + property.slice(5).toLowerCase();
    }
});




const $6b815d985da00455$export$e20c24a128671213 = (0, $daa89ff492231150$export$185802fd694ee1f5)({
    attributes: {
        xmlnsxlink: 'xmlns:xlink'
    },
    properties: {
        xmlnsXLink: null,
        xmlns: null
    },
    space: 'xmlns',
    transform: (0, $4cb8e4d3866567f6$export$32b9e4cec9c208e1)
});



const $bc9776729047ec1e$export$f2913fe8983302e = (0, $daa89ff492231150$export$185802fd694ee1f5)({
    properties: {
        xmlBase: null,
        xmlLang: null,
        xmlSpace: null
    },
    space: 'xml',
    transform (_, property) {
        return 'xml:' + property.slice(3).toLowerCase();
    }
});





const $feaeacb7ffdf79d9$export$c0bb0b647f701bb5 = (0, $488631ebec1f60b8$export$4950aa0f605343fb)([
    (0, $c5b18158769213d4$export$4d2d26490572750a),
    (0, $22ae6f0dc9a21236$export$c0bb0b647f701bb5),
    (0, $fc46c587b07688ce$export$2bd1230ec7600845),
    (0, $6b815d985da00455$export$e20c24a128671213),
    (0, $bc9776729047ec1e$export$f2913fe8983302e)
], 'html');
const $feaeacb7ffdf79d9$export$7ed1367e7fa1ad68 = (0, $488631ebec1f60b8$export$4950aa0f605343fb)([
    (0, $c5b18158769213d4$export$4d2d26490572750a),
    (0, $534a45a5dabfe0a4$export$7ed1367e7fa1ad68),
    (0, $fc46c587b07688ce$export$2bd1230ec7600845),
    (0, $6b815d985da00455$export$e20c24a128671213),
    (0, $bc9776729047ec1e$export$f2913fe8983302e)
], 'svg');


/**
 * Parse space-separated tokens to an array of strings.
 *
 * @param {string} value
 *   Space-separated tokens.
 * @returns {Array<string>}
 *   List of tokens.
 */ function $c6983841bd75322b$export$98e6a39c04603d36(value) {
    const input = String(value || '').trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $c6983841bd75322b$export$fac44ee5b035f737(values) {
    return values.join(' ').trim();
}


var $a965fe19f1873b5a$exports = {};
"use strict";
var $a965fe19f1873b5a$var$__importDefault = $a965fe19f1873b5a$exports && $a965fe19f1873b5a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};

var $a965fe19f1873b5a$var$style_to_object_1 = $a965fe19f1873b5a$var$__importDefault((parcelRequire("fwKGi")));
var $5d2cdce6e0f1f6c8$exports = {};
"use strict";
Object.defineProperty($5d2cdce6e0f1f6c8$exports, "__esModule", {
    value: true
});
$5d2cdce6e0f1f6c8$exports.camelCase = void 0;
var $5d2cdce6e0f1f6c8$var$CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
var $5d2cdce6e0f1f6c8$var$HYPHEN_REGEX = /-([a-z])/g;
var $5d2cdce6e0f1f6c8$var$NO_HYPHEN_REGEX = /^[^-]+$/;
var $5d2cdce6e0f1f6c8$var$VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
var $5d2cdce6e0f1f6c8$var$MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
/**
 * Checks whether to skip camelCase.
 */ var $5d2cdce6e0f1f6c8$var$skipCamelCase = function(property) {
    return !property || $5d2cdce6e0f1f6c8$var$NO_HYPHEN_REGEX.test(property) || $5d2cdce6e0f1f6c8$var$CUSTOM_PROPERTY_REGEX.test(property);
};
/**
 * Replacer that capitalizes first character.
 */ var $5d2cdce6e0f1f6c8$var$capitalize = function(match, character) {
    return character.toUpperCase();
};
/**
 * Replacer that removes beginning hyphen of vendor prefix property.
 */ var $5d2cdce6e0f1f6c8$var$trimHyphen = function(match, prefix) {
    return "".concat(prefix, "-");
};
/**
 * CamelCases a CSS property.
 */ var $5d2cdce6e0f1f6c8$var$camelCase = function(property, options) {
    if (options === void 0) options = {};
    if ($5d2cdce6e0f1f6c8$var$skipCamelCase(property)) return property;
    property = property.toLowerCase();
    if (options.reactCompat) // `-ms` vendor prefix should not be capitalized
    property = property.replace($5d2cdce6e0f1f6c8$var$MS_VENDOR_PREFIX_REGEX, $5d2cdce6e0f1f6c8$var$trimHyphen);
    else // for non-React, remove first hyphen so vendor prefix is not capitalized
    property = property.replace($5d2cdce6e0f1f6c8$var$VENDOR_PREFIX_REGEX, $5d2cdce6e0f1f6c8$var$trimHyphen);
    return property.replace($5d2cdce6e0f1f6c8$var$HYPHEN_REGEX, $5d2cdce6e0f1f6c8$var$capitalize);
};
$5d2cdce6e0f1f6c8$exports.camelCase = $5d2cdce6e0f1f6c8$var$camelCase;


/**
 * Parses CSS inline style to JavaScript object (camelCased).
 */ function $a965fe19f1873b5a$var$StyleToJS(style, options) {
    var output = {};
    if (!style || typeof style !== 'string') return output;
    (0, $a965fe19f1873b5a$var$style_to_object_1.default)(style, function(property, value) {
        // skip CSS comment
        if (property && value) output[(0, $5d2cdce6e0f1f6c8$exports.camelCase)(property, options)] = value;
    });
    return output;
}
$a965fe19f1873b5a$var$StyleToJS.default = $a965fe19f1873b5a$var$StyleToJS;
$a965fe19f1873b5a$exports = $a965fe19f1873b5a$var$StyleToJS;


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $0eeac8e369d29245$export$da309cdce9dc2a25 = $0eeac8e369d29245$var$point('end');
const $0eeac8e369d29245$export$771bf3e4949bfbee = $0eeac8e369d29245$var$point('start');
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $0eeac8e369d29245$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === 'number' && point.line > 0 && typeof point.column === 'number' && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === 'number' && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $0eeac8e369d29245$export$5880b8b5730aff45(node) {
    const start = $0eeac8e369d29245$export$771bf3e4949bfbee(node);
    const end = $0eeac8e369d29245$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @import {Node, Point, Position} from 'unist'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $e99db7c1b572955b$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $e99db7c1b572955b$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $e99db7c1b572955b$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $e99db7c1b572955b$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $e99db7c1b572955b$var$point(point) {
    return $e99db7c1b572955b$var$index(point && point.line) + ':' + $e99db7c1b572955b$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $e99db7c1b572955b$var$position(pos) {
    return $e99db7c1b572955b$var$point(pos && pos.start) + '-' + $e99db7c1b572955b$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $e99db7c1b572955b$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


class $73959e4640e8f655$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === 'string') {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = '';
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ('line' in optionsOrParentOrPlace && 'column' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('start' in optionsOrParentOrPlace && 'end' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('type' in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = {
                ...optionsOrParentOrPlace
            };
        }
        if (typeof causeOrReason === 'string') reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && 'start' in options.place ? options.place.start : options.place;
        /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file = '';
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $e99db7c1b572955b$export$c304dd45fe166145)(options.place) || '1:1';
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === 'string' ? options.cause.stack : '';
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual = undefined;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected = undefined;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note = undefined;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url = undefined;
    }
}
$73959e4640e8f655$export$752e5c445fe834ef.prototype.file = '';
$73959e4640e8f655$export$752e5c445fe834ef.prototype.name = '';
$73959e4640e8f655$export$752e5c445fe834ef.prototype.reason = '';
$73959e4640e8f655$export$752e5c445fe834ef.prototype.message = '';
$73959e4640e8f655$export$752e5c445fe834ef.prototype.stack = '';
$73959e4640e8f655$export$752e5c445fe834ef.prototype.column = undefined;
$73959e4640e8f655$export$752e5c445fe834ef.prototype.line = undefined;
$73959e4640e8f655$export$752e5c445fe834ef.prototype.ancestors = undefined;
$73959e4640e8f655$export$752e5c445fe834ef.prototype.cause = undefined;
$73959e4640e8f655$export$752e5c445fe834ef.prototype.fatal = undefined;
$73959e4640e8f655$export$752e5c445fe834ef.prototype.place = undefined;
$73959e4640e8f655$export$752e5c445fe834ef.prototype.ruleId = undefined;
$73959e4640e8f655$export$752e5c445fe834ef.prototype.source = undefined;


// To do: next major: `Object.hasOwn`.
const $ab0c7b748f53bf50$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $ab0c7b748f53bf50$var$emptyMap = new Map();
const $ab0c7b748f53bf50$var$cap = /[A-Z]/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $ab0c7b748f53bf50$var$tableElements = new Set([
    'table',
    'tbody',
    'thead',
    'tfoot',
    'tr'
]);
const $ab0c7b748f53bf50$var$tableCellElement = new Set([
    'td',
    'th'
]);
const $ab0c7b748f53bf50$var$docs = 'https://github.com/syntax-tree/hast-util-to-jsx-runtime';
function $ab0c7b748f53bf50$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError('Expected `Fragment` in options');
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== 'function') throw new TypeError('Expected `jsxDEV` in options when `development: true`');
        create = $ab0c7b748f53bf50$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== 'function') throw new TypeError('Expected `jsx` in production options');
        if (typeof options.jsxs !== 'function') throw new TypeError('Expected `jsxs` in production options');
        create = $ab0c7b748f53bf50$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || 'react',
        evaluater: options.createEvaluater ? options.createEvaluater() : undefined,
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === 'svg' ? (0, $feaeacb7ffdf79d9$export$7ed1367e7fa1ad68) : (0, $feaeacb7ffdf79d9$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || 'dom',
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $ab0c7b748f53bf50$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== 'string') return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ab0c7b748f53bf50$var$one(state, node, key) {
    if (node.type === 'element') return $ab0c7b748f53bf50$var$element(state, node, key);
    if (node.type === 'mdxFlowExpression' || node.type === 'mdxTextExpression') return $ab0c7b748f53bf50$var$mdxExpression(state, node);
    if (node.type === 'mdxJsxFlowElement' || node.type === 'mdxJsxTextElement') return $ab0c7b748f53bf50$var$mdxJsxElement(state, node, key);
    if (node.type === 'mdxjsEsm') return $ab0c7b748f53bf50$var$mdxEsm(state, node);
    if (node.type === 'root') return $ab0c7b748f53bf50$var$root(state, node, key);
    if (node.type === 'text') return $ab0c7b748f53bf50$var$text(state, node);
}
/**
 * Handle element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ab0c7b748f53bf50$var$element(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.tagName.toLowerCase() === 'svg' && parentSchema.space === 'html') {
        schema = (0, $feaeacb7ffdf79d9$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = $ab0c7b748f53bf50$var$findComponentFromName(state, node.tagName, false);
    const props = $ab0c7b748f53bf50$var$createElementProps(state, node);
    let children = $ab0c7b748f53bf50$var$createChildren(state, node);
    if ($ab0c7b748f53bf50$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
        return typeof child === 'string' ? !(0, $88c2fb7c1c9376fd$export$7af1228ff777d175)(child) : true;
    });
    $ab0c7b748f53bf50$var$addNode(state, props, type, node);
    $ab0c7b748f53bf50$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle MDX expression.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxFlowExpressionHast | MdxTextExpressionHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ab0c7b748f53bf50$var$mdxExpression(state, node) {
    if (node.data && node.data.estree && state.evaluater) {
        const program = node.data.estree;
        const expression = program.body[0];
        (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
        // Assume result is a child.
        return /** @type {Child | undefined} */ state.evaluater.evaluateExpression(expression.expression);
    }
    $ab0c7b748f53bf50$var$crashEstree(state, node.position);
}
/**
 * Handle MDX ESM.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxjsEsmHast} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ab0c7b748f53bf50$var$mdxEsm(state, node) {
    if (node.data && node.data.estree && state.evaluater) // Assume result is a child.
    return /** @type {Child | undefined} */ state.evaluater.evaluateProgram(node.data.estree);
    $ab0c7b748f53bf50$var$crashEstree(state, node.position);
}
/**
 * Handle MDX JSX.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ab0c7b748f53bf50$var$mdxJsxElement(state, node, key) {
    const parentSchema = state.schema;
    let schema = parentSchema;
    if (node.name === 'svg' && parentSchema.space === 'html') {
        schema = (0, $feaeacb7ffdf79d9$export$7ed1367e7fa1ad68);
        state.schema = schema;
    }
    state.ancestors.push(node);
    const type = node.name === null ? state.Fragment : $ab0c7b748f53bf50$var$findComponentFromName(state, node.name, true);
    const props = $ab0c7b748f53bf50$var$createJsxElementProps(state, node);
    const children = $ab0c7b748f53bf50$var$createChildren(state, node);
    $ab0c7b748f53bf50$var$addNode(state, props, type, node);
    $ab0c7b748f53bf50$var$addChildren(props, children);
    // Restore.
    state.ancestors.pop();
    state.schema = parentSchema;
    return state.create(node, type, props, key);
}
/**
 * Handle root.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Root} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ab0c7b748f53bf50$var$root(state, node, key) {
    /** @type {Props} */ const props = {};
    $ab0c7b748f53bf50$var$addChildren(props, $ab0c7b748f53bf50$var$createChildren(state, node));
    return state.create(node, state.Fragment, props, key);
}
/**
 * Handle text.
 *
 * @param {State} _
 *   Info passed around.
 * @param {Text} node
 *   Current node.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $ab0c7b748f53bf50$var$text(_, node) {
    return node.value;
}
/**
 * Add `node` to props.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Props} props
 *   Props.
 * @param {unknown} type
 *   Type.
 * @param {Element | MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Node.
 * @returns {undefined}
 *   Nothing.
 */ function $ab0c7b748f53bf50$var$addNode(state, props, type, node) {
    // If this is swapped out for a component:
    if (typeof type !== 'string' && type !== state.Fragment && state.passNode) props.node = node;
}
/**
 * Add children to props.
 *
 * @param {Props} props
 *   Props.
 * @param {Array<Child>} children
 *   Children.
 * @returns {undefined}
 *   Nothing.
 */ function $ab0c7b748f53bf50$var$addChildren(props, children) {
    if (children.length > 0) {
        const value = children.length > 1 ? children : children[0];
        if (value) props.children = value;
    }
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $ab0c7b748f53bf50$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $ab0c7b748f53bf50$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $0eeac8e369d29245$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create props from an element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Element} node
 *   Current element.
 * @returns {Props}
 *   Props.
 */ function $ab0c7b748f53bf50$var$createElementProps(state, node) {
    /** @type {Props} */ const props = {};
    /** @type {string | undefined} */ let alignValue;
    /** @type {string} */ let prop;
    for(prop in node.properties)if (prop !== 'children' && $ab0c7b748f53bf50$var$own.call(node.properties, prop)) {
        const result = $ab0c7b748f53bf50$var$createProperty(state, prop, node.properties[prop]);
        if (result) {
            const [key, value] = result;
            if (state.tableCellAlignToStyle && key === 'align' && typeof value === 'string' && $ab0c7b748f53bf50$var$tableCellElement.has(node.tagName)) alignValue = value;
            else props[key] = value;
        }
    }
    if (alignValue) {
        // Assume style is an object.
        const style = /** @type {Style} */ props.style || (props.style = {});
        style[state.stylePropertyNameCase === 'css' ? 'text-align' : 'textAlign'] = alignValue;
    }
    return props;
}
/**
 * Create props from a JSX element.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdxJsxFlowElementHast | MdxJsxTextElementHast} node
 *   Current JSX element.
 * @returns {Props}
 *   Props.
 */ function $ab0c7b748f53bf50$var$createJsxElementProps(state, node) {
    /** @type {Props} */ const props = {};
    for (const attribute of node.attributes)if (attribute.type === 'mdxJsxExpressionAttribute') {
        if (attribute.data && attribute.data.estree && state.evaluater) {
            const program = attribute.data.estree;
            const expression = program.body[0];
            (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
            const objectExpression = expression.expression;
            (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(objectExpression.type === 'ObjectExpression');
            const property = objectExpression.properties[0];
            (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(property.type === 'SpreadElement');
            Object.assign(props, state.evaluater.evaluateExpression(property.argument));
        } else $ab0c7b748f53bf50$var$crashEstree(state, node.position);
    } else {
        // For JSX, the author is responsible of passing in the correct values.
        const name = attribute.name;
        /** @type {unknown} */ let value;
        if (attribute.value && typeof attribute.value === 'object') {
            if (attribute.value.data && attribute.value.data.estree && state.evaluater) {
                const program = attribute.value.data.estree;
                const expression = program.body[0];
                (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(expression.type === 'ExpressionStatement');
                value = state.evaluater.evaluateExpression(expression.expression);
            } else $ab0c7b748f53bf50$var$crashEstree(state, node.position);
        } else value = attribute.value === null ? true : attribute.value;
        // Assume a prop.
        props[name] = /** @type {Props[keyof Props]} */ value;
    }
    return props;
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $ab0c7b748f53bf50$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByName = state.passKeys ? new Map() : $ab0c7b748f53bf50$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys) {
            const name = child.type === 'element' ? child.tagName : child.type === 'mdxJsxFlowElement' || child.type === 'mdxJsxTextElement' ? child.name : undefined;
            if (name) {
                const count = countsByName.get(name) || 0;
                key = name + '-' + count;
                countsByName.set(name, count + 1);
            }
        }
        const result = $ab0c7b748f53bf50$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $ab0c7b748f53bf50$var$createProperty(state, prop, value) {
    const info = (0, $6e85ae16d7a4f080$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === 'number' && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $6d5a88e09f30d747$export$fac44ee5b035f737)(value) : (0, $c6983841bd75322b$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === 'style') {
        let styleObject = typeof value === 'object' ? value : $ab0c7b748f53bf50$var$parseStyle(state, String(value));
        if (state.stylePropertyNameCase === 'css') styleObject = $ab0c7b748f53bf50$var$transformStylesToCssCasing(styleObject);
        return [
            'style',
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === 'react' && info.space ? (0, $f1a9921af0eb0bc3$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $ab0c7b748f53bf50$var$parseStyle(state, value) {
    try {
        return (0, (/*@__PURE__*/$parcel$interopDefault($a965fe19f1873b5a$exports)))(value, {
            reactCompat: true
        });
    } catch (error) {
        if (state.ignoreInvalidStyle) return {};
        const cause = /** @type {Error} */ error;
        const message = new (0, $73959e4640e8f655$export$752e5c445fe834ef)('Cannot parse `style` attribute', {
            ancestors: state.ancestors,
            cause: cause,
            ruleId: 'style',
            source: 'hast-util-to-jsx-runtime'
        });
        message.file = state.filePath || undefined;
        message.url = $ab0c7b748f53bf50$var$docs + '#cannot-parse-style-attribute';
        throw message;
    }
}
/**
 * Create a JSX name from a string.
 *
 * @param {State} state
 *   To do.
 * @param {string} name
 *   Name.
 * @param {boolean} allowExpression
 *   Allow member expressions and identifiers.
 * @returns {unknown}
 *   To do.
 */ function $ab0c7b748f53bf50$var$findComponentFromName(state, name, allowExpression) {
    /** @type {Identifier | Literal | MemberExpression} */ let result;
    if (!allowExpression) result = {
        type: 'Literal',
        value: name
    };
    else if (name.includes('.')) {
        const identifiers = name.split('.');
        let index = -1;
        /** @type {Identifier | Literal | MemberExpression | undefined} */ let node;
        while(++index < identifiers.length){
            /** @type {Identifier | Literal} */ const prop = (0, $9cb8597a102b01f9$export$a8ff84c12d48cfa6)(identifiers[index]) ? {
                type: 'Identifier',
                name: identifiers[index]
            } : {
                type: 'Literal',
                value: identifiers[index]
            };
            node = node ? {
                type: 'MemberExpression',
                object: node,
                property: prop,
                computed: Boolean(index && prop.type === 'Literal'),
                optional: false
            } : prop;
        }
        (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(node, 'always a result');
        result = node;
    } else result = (0, $9cb8597a102b01f9$export$a8ff84c12d48cfa6)(name) && !/^[a-z]/.test(name) ? {
        type: 'Identifier',
        name: name
    } : {
        type: 'Literal',
        value: name
    };
    // Only literals can be passed in `components` currently.
    // No identifiers / member expressions.
    if (result.type === 'Literal') {
        const name = /** @type {string | number} */ result.value;
        return $ab0c7b748f53bf50$var$own.call(state.components, name) ? state.components[name] : name;
    }
    // Assume component.
    if (state.evaluater) return state.evaluater.evaluateExpression(result);
    $ab0c7b748f53bf50$var$crashEstree(state);
}
/**
 * @param {State} state
 * @param {Position | undefined} [place]
 * @returns {never}
 */ function $ab0c7b748f53bf50$var$crashEstree(state, place) {
    const message = new (0, $73959e4640e8f655$export$752e5c445fe834ef)('Cannot handle MDX estrees without `createEvaluater`', {
        ancestors: state.ancestors,
        place: place,
        ruleId: 'mdx-estree',
        source: 'hast-util-to-jsx-runtime'
    });
    message.file = state.filePath || undefined;
    message.url = $ab0c7b748f53bf50$var$docs + '#cannot-handle-mdx-estrees-without-createevaluater';
    throw message;
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $ab0c7b748f53bf50$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($ab0c7b748f53bf50$var$own.call(domCasing, from)) cssCasing[$ab0c7b748f53bf50$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $ab0c7b748f53bf50$var$transformStyleToCssCasing(from) {
    let to = from.replace($ab0c7b748f53bf50$var$cap, $ab0c7b748f53bf50$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === 'ms-') to = '-' + to;
    return to;
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $ab0c7b748f53bf50$var$toDash($0) {
    return '-' + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $0b6d4c42c84ace58$export$de3e062aedff083a = {
    action: [
        'form'
    ],
    cite: [
        'blockquote',
        'del',
        'ins',
        'q'
    ],
    data: [
        'object'
    ],
    formAction: [
        'button',
        'input'
    ],
    href: [
        'a',
        'area',
        'base',
        'link'
    ],
    icon: [
        'menuitem'
    ],
    itemId: null,
    manifest: [
        'html'
    ],
    ping: [
        'a',
        'area'
    ],
    poster: [
        'video'
    ],
    src: [
        'audio',
        'embed',
        'iframe',
        'img',
        'input',
        'script',
        'source',
        'track',
        'video'
    ]
};




var $kYCgE = parcelRequire("kYCgE");
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ /**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $5599e3f3296395bd$var$emptyOptions = {};
function $5599e3f3296395bd$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $5599e3f3296395bd$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $5599e3f3296395bd$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $5599e3f3296395bd$var$one(value, includeImageAlt, includeHtml) {
    if ($5599e3f3296395bd$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $5599e3f3296395bd$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $5599e3f3296395bd$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $5599e3f3296395bd$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $5599e3f3296395bd$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $5599e3f3296395bd$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* global document */ const $3685264c0f8981c7$var$element = document.createElement('i');
function $3685264c0f8981c7$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $3685264c0f8981c7$var$element.innerHTML = characterReference;
    const character = $3685264c0f8981c7$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    return character === characterReference ? false : character;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $e5b58ceb5aa52008$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $e5b58ceb5aa52008$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $e5b58ceb5aa52008$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
const $fdb9f8157a3e06d5$var$hasOwnProperty = {}.hasOwnProperty;
function $fdb9f8157a3e06d5$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$fdb9f8157a3e06d5$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $fdb9f8157a3e06d5$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $fdb9f8157a3e06d5$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$fdb9f8157a3e06d5$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $fdb9f8157a3e06d5$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $fdb9f8157a3e06d5$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $e5b58ceb5aa52008$export$869882364835d202)(existing, 0, 0, before);
}
function $fdb9f8157a3e06d5$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$fdb9f8157a3e06d5$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $fdb9f8157a3e06d5$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $fdb9f8157a3e06d5$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $b6f60b99d7331119$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $0999d37ae063daef$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $0999d37ae063daef$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $0999d37ae063daef$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $7fe1716140a2e698$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $fc82577ff72a448e$export$d65d6b62c24d5436 = $fc82577ff72a448e$var$regexCheck(/[A-Za-z]/);
const $fc82577ff72a448e$export$75c76db11865a9f4 = $fc82577ff72a448e$var$regexCheck(/[\dA-Za-z]/);
const $fc82577ff72a448e$export$4397998b34fe597d = $fc82577ff72a448e$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $fc82577ff72a448e$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $fc82577ff72a448e$export$ca8b5b1a6c320e6e = $fc82577ff72a448e$var$regexCheck(/\d/);
const $fc82577ff72a448e$export$eca2752363989806 = $fc82577ff72a448e$var$regexCheck(/[\dA-Fa-f]/);
const $fc82577ff72a448e$export$35794a7d1db99380 = $fc82577ff72a448e$var$regexCheck(/[!-/:-@[-`{-~]/);
function $fc82577ff72a448e$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $fc82577ff72a448e$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $fc82577ff72a448e$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $fc82577ff72a448e$export$aa04114dd888a7a0 = $fc82577ff72a448e$var$regexCheck(/\p{P}|\p{S}/u);
const $fc82577ff72a448e$export$a0ff789c034ffdf4 = $fc82577ff72a448e$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $fc82577ff72a448e$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}



function $912e7ecc13655adf$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $0999d37ae063daef$export$c564cdbbe6da493)($912e7ecc13655adf$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $912e7ecc13655adf$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $fc82577ff72a448e$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $fc82577ff72a448e$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $f5b8bf95955fe53e$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $f5b8bf95955fe53e$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $f5b8bf95955fe53e$var$protocolSource = /^https?$/i;
function $f5b8bf95955fe53e$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $fdb9f8157a3e06d5$export$eaf8c406dfb0a620)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(head, body);
        head = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($f5b8bf95955fe53e$var$hasOwnProperty.call(handles, kind) && handle) handle.call({
                sliceSerialize: result[index][2].sliceSerialize,
                ...context
            }, result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $0999d37ae063daef$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $7fe1716140a2e698$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $912e7ecc13655adf$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $f5b8bf95955fe53e$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $912e7ecc13655adf$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $f5b8bf95955fe53e$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $7fe1716140a2e698$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$f5b8bf95955fe53e$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $b6f60b99d7331119$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $3685264c0f8981c7$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $912e7ecc13655adf$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $f5b8bf95955fe53e$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $912e7ecc13655adf$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $76338279faffbc6d$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $ced23236c3530cb3$export$a7db06668cad9adb = {
    tokenize: $ced23236c3530cb3$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $ced23236c3530cb3$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 


const $29df799c7404e649$export$5a7bfc01df82fcd1 = {
    tokenize: $29df799c7404e649$var$initializeDocument
};
/** @type {Construct} */ const $29df799c7404e649$var$containerConstruct = {
    tokenize: $29df799c7404e649$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $29df799c7404e649$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $e5b58ceb5aa52008$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($29df799c7404e649$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($29df799c7404e649$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = {
                    ...point
                };
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $e5b58ceb5aa52008$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $29df799c7404e649$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $60aa1f8829c0ecb5$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $60aa1f8829c0ecb5$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $60aa1f8829c0ecb5$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 
/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $2972f6bda9d270cc$export$bd596157370df26e {
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $2972f6bda9d270cc$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $2972f6bda9d270cc$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $2972f6bda9d270cc$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $2972f6bda9d270cc$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $2972f6bda9d270cc$var$chunkedPush(this.left, removed.reverse());
        }
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $2972f6bda9d270cc$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $75866fdb71193737$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $2972f6bda9d270cc$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $75866fdb71193737$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = {
                    ...events.get(lineIndex)[1].start
                };
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $e5b58ceb5aa52008$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $75866fdb71193737$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $8ef64f747d055c82$export$a7db06668cad9adb = {
    resolve: $8ef64f747d055c82$var$resolveContent,
    tokenize: $8ef64f747d055c82$var$tokenizeContent
};
/** @type {Construct} */ const $8ef64f747d055c82$var$continuationConstruct = {
    partial: true,
    tokenize: $8ef64f747d055c82$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $8ef64f747d055c82$var$resolveContent(events) {
    (0, $75866fdb71193737$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $8ef64f747d055c82$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) return effects.check($8ef64f747d055c82$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $8ef64f747d055c82$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $9e4ab433c1da189c$export$ccc7b0636abaffc3 = {
    tokenize: $9e4ab433c1da189c$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $9e4ab433c1da189c$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $60aa1f8829c0ecb5$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $8ef64f747d055c82$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ const $897459be80c96f59$export$50397835cbfdbc24 = {
    resolveAll: $897459be80c96f59$var$createResolver()
};
const $897459be80c96f59$export$22b082955e083ec3 = $897459be80c96f59$var$initializeFactory('string');
const $897459be80c96f59$export$6f093cfa640b7166 = $897459be80c96f59$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $897459be80c96f59$var$initializeFactory(field) {
    return {
        resolveAll: $897459be80c96f59$var$createResolver(field === 'text' ? $897459be80c96f59$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $897459be80c96f59$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $897459be80c96f59$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: {
                    ...data.end
                }
            };
            data.end = {
                ...token.start
            };
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $2dec3a397f56dcbd$exports = {};

$parcel$export($2dec3a397f56dcbd$exports, "document", function () { return $2dec3a397f56dcbd$export$5a7bfc01df82fcd1; });
$parcel$export($2dec3a397f56dcbd$exports, "contentInitial", function () { return $2dec3a397f56dcbd$export$5a2181fb44b58173; });
$parcel$export($2dec3a397f56dcbd$exports, "flowInitial", function () { return $2dec3a397f56dcbd$export$cf8bead395eff824; });
$parcel$export($2dec3a397f56dcbd$exports, "flow", function () { return $2dec3a397f56dcbd$export$ccc7b0636abaffc3; });
$parcel$export($2dec3a397f56dcbd$exports, "string", function () { return $2dec3a397f56dcbd$export$22b082955e083ec3; });
$parcel$export($2dec3a397f56dcbd$exports, "text", function () { return $2dec3a397f56dcbd$export$6f093cfa640b7166; });
$parcel$export($2dec3a397f56dcbd$exports, "insideSpan", function () { return $2dec3a397f56dcbd$export$d44f260a3f9b69f5; });
$parcel$export($2dec3a397f56dcbd$exports, "attentionMarkers", function () { return $2dec3a397f56dcbd$export$b9c0b60d74426aea; });
$parcel$export($2dec3a397f56dcbd$exports, "disable", function () { return $2dec3a397f56dcbd$export$e20fbacbb41798b; });
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
/**
 * @import {Code} from 'micromark-util-types'
 */ 
function $b223e3cdd47b2709$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $fc82577ff72a448e$export$a30284361b3814b7)(code) || (0, $fc82577ff72a448e$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $fc82577ff72a448e$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $f98a1d208f0c9a00$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


const $a5c6b2089f99aa64$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $a5c6b2089f99aa64$var$resolveAllAttention,
    tokenize: $a5c6b2089f99aa64$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $a5c6b2089f99aa64$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = {
                ...events[open][1].end
            };
            const end = {
                ...events[index][1].start
            };
            $a5c6b2089f99aa64$var$movePoint(start, -use);
            $a5c6b2089f99aa64$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: {
                    ...events[open][1].end
                }
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: {
                    ...events[index][1].start
                },
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: {
                    ...events[open][1].end
                },
                end: {
                    ...events[index][1].start
                }
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: {
                    ...openingSequence.start
                },
                end: {
                    ...closingSequence.end
                }
            };
            events[open][1].end = {
                ...openingSequence.start
            };
            events[index][1].start = {
                ...closingSequence.end
            };
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(nextEvents, (0, $f98a1d208f0c9a00$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $e5b58ceb5aa52008$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $a5c6b2089f99aa64$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $b223e3cdd47b2709$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $b223e3cdd47b2709$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $a5c6b2089f99aa64$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $1b2038c602522f77$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $1b2038c602522f77$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1b2038c602522f77$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $fc82577ff72a448e$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $fc82577ff72a448e$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $fc82577ff72a448e$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $fc82577ff72a448e$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $fc82577ff72a448e$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $fc82577ff72a448e$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $1e2a89ebf7b21114$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $1e2a89ebf7b21114$var$tokenizeBlockQuoteContinuation
    },
    exit: $1e2a89ebf7b21114$var$exit,
    name: 'blockQuote',
    tokenize: $1e2a89ebf7b21114$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1e2a89ebf7b21114$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $1e2a89ebf7b21114$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($1e2a89ebf7b21114$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $1e2a89ebf7b21114$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $065278d431b891f5$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $065278d431b891f5$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $065278d431b891f5$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $fc82577ff72a448e$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $01f20493e5a973ce$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $01f20493e5a973ce$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $01f20493e5a973ce$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $fc82577ff72a448e$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $fc82577ff72a448e$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $fc82577ff72a448e$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $fc82577ff72a448e$export$75c76db11865a9f4) && !(0, $3685264c0f8981c7$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/** @type {Construct} */ const $b1f012c159d46eb2$var$nonLazyContinuation = {
    partial: true,
    tokenize: $b1f012c159d46eb2$var$tokenizeNonLazyContinuation
};
const $b1f012c159d46eb2$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $b1f012c159d46eb2$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b1f012c159d46eb2$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($b1f012c159d46eb2$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) return effects.check($b1f012c159d46eb2$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b1f012c159d46eb2$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $d01c63d1c4e48a06$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $d01c63d1c4e48a06$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $d01c63d1c4e48a06$var$furtherStart = {
    partial: true,
    tokenize: $d01c63d1c4e48a06$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d01c63d1c4e48a06$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) return effects.attempt($d01c63d1c4e48a06$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d01c63d1c4e48a06$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
const $fa4f183e9df4d159$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $fa4f183e9df4d159$var$previous,
    resolve: $fa4f183e9df4d159$var$resolveCodeText,
    tokenize: $fa4f183e9df4d159$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $fa4f183e9df4d159$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $fa4f183e9df4d159$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $fa4f183e9df4d159$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $4021c4990af05a62$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $fc82577ff72a448e$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $fc82577ff72a448e$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $fc82577ff72a448e$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $7278413415a7ecd6$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $f014e7827cf44381$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $910cd1e4b9d5ff1a$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $9380fcb8dda3afe2$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $9380fcb8dda3afe2$var$tokenizeDefinition
};
/** @type {Construct} */ const $9380fcb8dda3afe2$var$titleBefore = {
    partial: true,
    tokenize: $9380fcb8dda3afe2$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9380fcb8dda3afe2$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $7278413415a7ecd6$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $7fe1716140a2e698$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $fc82577ff72a448e$export$a30284361b3814b7)(code) ? (0, $910cd1e4b9d5ff1a$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $4021c4990af05a62$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($9380fcb8dda3afe2$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9380fcb8dda3afe2$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $fc82577ff72a448e$export$a30284361b3814b7)(code) ? (0, $910cd1e4b9d5ff1a$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $f014e7827cf44381$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $976f9711008c01d4$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $976f9711008c01d4$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $976f9711008c01d4$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $8320c2037fc218b6$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $8320c2037fc218b6$var$resolveHeadingAtx,
    tokenize: $8320c2037fc218b6$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $8320c2037fc218b6$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $e5b58ceb5aa52008$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $8320c2037fc218b6$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $fc82577ff72a448e$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $fc82577ff72a448e$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $7de994f5e8797339$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $7de994f5e8797339$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $b79f62a162e71230$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $b79f62a162e71230$var$resolveToHtmlFlow,
    tokenize: $b79f62a162e71230$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $b79f62a162e71230$var$blankLineBefore = {
    partial: true,
    tokenize: $b79f62a162e71230$var$tokenizeBlankLineBefore
};
const $b79f62a162e71230$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $b79f62a162e71230$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $b79f62a162e71230$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b79f62a162e71230$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $fc82577ff72a448e$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $7de994f5e8797339$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $7de994f5e8797339$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $fc82577ff72a448e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $fc82577ff72a448e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $fc82577ff72a448e$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($b79f62a162e71230$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($b79f62a162e71230$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $7de994f5e8797339$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b79f62a162e71230$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $b79f62a162e71230$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $60aa1f8829c0ecb5$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $ef83ccafa0d6681b$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $ef83ccafa0d6681b$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ef83ccafa0d6681b$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $fc82577ff72a448e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $fc82577ff72a448e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $fc82577ff72a448e$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $fc82577ff72a448e$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $fc82577ff72a448e$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $fc82577ff72a448e$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $fc82577ff72a448e$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 







const $dac20d34c7be00c3$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $dac20d34c7be00c3$var$resolveAllLabelEnd,
    resolveTo: $dac20d34c7be00c3$var$resolveToLabelEnd,
    tokenize: $dac20d34c7be00c3$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $dac20d34c7be00c3$var$resourceConstruct = {
    tokenize: $dac20d34c7be00c3$var$tokenizeResource
};
/** @type {Construct} */ const $dac20d34c7be00c3$var$referenceFullConstruct = {
    tokenize: $dac20d34c7be00c3$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $dac20d34c7be00c3$var$referenceCollapsedConstruct = {
    tokenize: $dac20d34c7be00c3$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $dac20d34c7be00c3$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $e5b58ceb5aa52008$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $dac20d34c7be00c3$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    const label = {
        type: "label",
        start: {
            ...events[open][1].start
        },
        end: {
            ...events[close][1].end
        }
    };
    const text = {
        type: "labelText",
        start: {
            ...events[open + offset + 2][1].end
        },
        end: {
            ...events[close - 2][1].start
        }
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(media, (0, $f98a1d208f0c9a00$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $e5b58ceb5aa52008$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $dac20d34c7be00c3$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $7fe1716140a2e698$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($dac20d34c7be00c3$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($dac20d34c7be00c3$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($dac20d34c7be00c3$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $dac20d34c7be00c3$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $fc82577ff72a448e$export$a30284361b3814b7)(code) ? (0, $910cd1e4b9d5ff1a$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $4021c4990af05a62$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $fc82577ff72a448e$export$a30284361b3814b7)(code) ? (0, $910cd1e4b9d5ff1a$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $f014e7827cf44381$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $fc82577ff72a448e$export$a30284361b3814b7)(code) ? (0, $910cd1e4b9d5ff1a$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $dac20d34c7be00c3$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $7278413415a7ecd6$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $7fe1716140a2e698$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $dac20d34c7be00c3$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $36a451da6bfc12df$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $dac20d34c7be00c3$export$470a5dafbbf62654).resolveAll,
    tokenize: $36a451da6bfc12df$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $36a451da6bfc12df$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $ae5be1aa8905f8d3$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $dac20d34c7be00c3$export$470a5dafbbf62654).resolveAll,
    tokenize: $ae5be1aa8905f8d3$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ae5be1aa8905f8d3$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $0a1aa98b9802d3e6$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $0a1aa98b9802d3e6$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $0a1aa98b9802d3e6$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $9f1a223b98cd7a2d$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $9f1a223b98cd7a2d$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $9f1a223b98cd7a2d$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $140075d0a48e5c78$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $140075d0a48e5c78$var$tokenizeListContinuation
    },
    exit: $140075d0a48e5c78$var$tokenizeListEnd,
    name: 'list',
    tokenize: $140075d0a48e5c78$var$tokenizeListStart
};
/** @type {Construct} */ const $140075d0a48e5c78$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $140075d0a48e5c78$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $140075d0a48e5c78$var$indentConstruct = {
    partial: true,
    tokenize: $140075d0a48e5c78$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $140075d0a48e5c78$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $fc82577ff72a448e$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $9f1a223b98cd7a2d$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $fc82577ff72a448e$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $60aa1f8829c0ecb5$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($140075d0a48e5c78$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $140075d0a48e5c78$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $60aa1f8829c0ecb5$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($140075d0a48e5c78$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, effects.attempt($140075d0a48e5c78$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $140075d0a48e5c78$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $140075d0a48e5c78$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $140075d0a48e5c78$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $60fef96073856915$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $60fef96073856915$var$resolveToSetextUnderline,
    tokenize: $60fef96073856915$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $60fef96073856915$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: {
            ...events[content][1].start
        },
        end: {
            ...events[events.length - 1][1].end
        }
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = {
            ...events[definition][1].end
        };
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $60fef96073856915$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $fc82577ff72a448e$export$2c6cf65c1127992a)(code) ? (0, $76338279faffbc6d$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $2dec3a397f56dcbd$export$5a7bfc01df82fcd1 = {
    [42]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [43]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [45]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [48]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [49]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [50]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [51]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [52]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [53]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [54]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [55]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [56]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [57]: (0, $140075d0a48e5c78$export$8837f4fc672e936d),
    [62]: (0, $1e2a89ebf7b21114$export$200dcd0a5903c968)
};
const $2dec3a397f56dcbd$export$5a2181fb44b58173 = {
    [91]: (0, $9380fcb8dda3afe2$export$69f215ed977cdb73)
};
const $2dec3a397f56dcbd$export$cf8bead395eff824 = {
    [-2]: (0, $d01c63d1c4e48a06$export$47910b7ab28d1853),
    [-1]: (0, $d01c63d1c4e48a06$export$47910b7ab28d1853),
    [32]: (0, $d01c63d1c4e48a06$export$47910b7ab28d1853)
};
const $2dec3a397f56dcbd$export$ccc7b0636abaffc3 = {
    [35]: (0, $8320c2037fc218b6$export$3871e9deb360695c),
    [42]: (0, $9f1a223b98cd7a2d$export$ba7b13e047416c03),
    [45]: [
        (0, $60fef96073856915$export$e104e2de391dfde9),
        (0, $9f1a223b98cd7a2d$export$ba7b13e047416c03)
    ],
    [60]: (0, $b79f62a162e71230$export$476ac411cb7d0d8f),
    [61]: (0, $60fef96073856915$export$e104e2de391dfde9),
    [95]: (0, $9f1a223b98cd7a2d$export$ba7b13e047416c03),
    [96]: (0, $b1f012c159d46eb2$export$c23e4921f8d87e7c),
    [126]: (0, $b1f012c159d46eb2$export$c23e4921f8d87e7c)
};
const $2dec3a397f56dcbd$export$22b082955e083ec3 = {
    [38]: (0, $01f20493e5a973ce$export$e31905600aaf3d8e),
    [92]: (0, $065278d431b891f5$export$2005478564e78d96)
};
const $2dec3a397f56dcbd$export$6f093cfa640b7166 = {
    [-5]: (0, $0a1aa98b9802d3e6$export$8e62e0ad51c97b2),
    [-4]: (0, $0a1aa98b9802d3e6$export$8e62e0ad51c97b2),
    [-3]: (0, $0a1aa98b9802d3e6$export$8e62e0ad51c97b2),
    [33]: (0, $36a451da6bfc12df$export$3d754936e25aa5f5),
    [38]: (0, $01f20493e5a973ce$export$e31905600aaf3d8e),
    [42]: (0, $a5c6b2089f99aa64$export$45b92471da762af7),
    [60]: [
        (0, $1b2038c602522f77$export$17ddf85e4c916ad6),
        (0, $ef83ccafa0d6681b$export$398af27f284914fe)
    ],
    [91]: (0, $ae5be1aa8905f8d3$export$5c0cee0701a3b584),
    [92]: [
        (0, $976f9711008c01d4$export$86c573ab9e06f418),
        (0, $065278d431b891f5$export$2005478564e78d96)
    ],
    [93]: (0, $dac20d34c7be00c3$export$470a5dafbbf62654),
    [95]: (0, $a5c6b2089f99aa64$export$45b92471da762af7),
    [96]: (0, $fa4f183e9df4d159$export$d24f93e715f9df88)
};
const $2dec3a397f56dcbd$export$d44f260a3f9b69f5 = {
    null: [
        (0, $a5c6b2089f99aa64$export$45b92471da762af7),
        (0, $897459be80c96f59$export$50397835cbfdbc24)
    ]
};
const $2dec3a397f56dcbd$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $2dec3a397f56dcbd$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 


function $dad1c0797351a975$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $e5b58ceb5aa52008$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $f98a1d208f0c9a00$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $dad1c0797351a975$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $dad1c0797351a975$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $fc82577ff72a448e$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $e5b58ceb5aa52008$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $dad1c0797351a975$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $dad1c0797351a975$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $9a796f3512e4ce84$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $fdb9f8157a3e06d5$export$86a865d89ef3c690)([
        $2dec3a397f56dcbd$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $ced23236c3530cb3$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $29df799c7404e649$export$5a7bfc01df82fcd1)),
        flow: create((0, $9e4ab433c1da189c$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $897459be80c96f59$export$22b082955e083ec3)),
        text: create((0, $897459be80c96f59$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $dad1c0797351a975$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $9786572104d7dea0$export$bd0e6e1378a871d7(events) {
    while(!(0, $75866fdb71193737$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $db3e1d3fb292714d$var$search = /[\0\t\n\r]/g;
function $db3e1d3fb292714d$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $db3e1d3fb292714d$var$search.lastIndex = startPosition;
            match = $db3e1d3fb292714d$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $ebc72b7f4d0abf88$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $f5b8bf95955fe53e$export$ef7acd7185315e22)(options)((0, $9786572104d7dea0$export$bd0e6e1378a871d7)((0, $9a796f3512e4ce84$export$98e6a39c04603d36)(options).document().write((0, $db3e1d3fb292714d$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $37a72d3cecdc09a7$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $37a72d3cecdc09a7$export$a0fb664af7d0cc44(value) {
    return value.replace($37a72d3cecdc09a7$var$characterEscapeOrReference, $37a72d3cecdc09a7$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $37a72d3cecdc09a7$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $b6f60b99d7331119$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $3685264c0f8981c7$export$289b6a6320f709b4)($2) || $0;
}





const $be12efbf312c3f41$var$own = {}.hasOwnProperty;
function $be12efbf312c3f41$export$d744d789c09bfde6(value, encoding, options) {
    if (encoding && typeof encoding === 'object') {
        options = encoding;
        encoding = undefined;
    }
    return $be12efbf312c3f41$var$compiler(options)((0, $9786572104d7dea0$export$bd0e6e1378a871d7)((0, $9a796f3512e4ce84$export$98e6a39c04603d36)(options).document().write((0, $db3e1d3fb292714d$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $be12efbf312c3f41$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $be12efbf312c3f41$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($be12efbf312c3f41$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $be12efbf312c3f41$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $be12efbf312c3f41$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $be12efbf312c3f41$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $be12efbf312c3f41$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $e99db7c1b572955b$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $be12efbf312c3f41$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $be12efbf312c3f41$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $5599e3f3296395bd$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $7fe1716140a2e698$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $be12efbf312c3f41$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $be12efbf312c3f41$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $be12efbf312c3f41$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $37a72d3cecdc09a7$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $7fe1716140a2e698$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $7fe1716140a2e698$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $b6f60b99d7331119$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $3685264c0f8981c7$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $be12efbf312c3f41$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $be12efbf312c3f41$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $be12efbf312c3f41$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $be12efbf312c3f41$var$configure(combined, value);
        else $be12efbf312c3f41$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $be12efbf312c3f41$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($be12efbf312c3f41$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $be12efbf312c3f41$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $e99db7c1b572955b$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $e99db7c1b572955b$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $e99db7c1b572955b$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}


function $14d76c4581083238$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $be12efbf312c3f41$export$d744d789c09bfde6)(doc, {
            ...self.data('settings'),
            ...options,
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data('micromarkExtensions') || [],
            mdastExtensions: self.data('fromMarkdownExtensions') || []
        });
    }
}


/**
 * @import {Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {Options as ToHastOptions} from 'mdast-util-to-hast'
 * @import {Processor} from 'unified'
 * @import {VFile} from 'vfile'
 */ /**
 * @typedef {Omit<ToHastOptions, 'file'>} Options
 *
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ /**
 * @import {Nodes as HastNodes} from 'hast'
 * @import {Nodes as MdastNodes} from 'mdast'
 * @import {Options} from './state.js'
 */ 
/**
 * @import {ElementContent, Element} from 'hast'
 * @import {State} from './state.js'
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ const $9a5b1cfd7f2b3bd5$export$1cd1943b3a73bbe8 = -1;
const $9a5b1cfd7f2b3bd5$export$a44b4f3d5b73db95 = 0;
const $9a5b1cfd7f2b3bd5$export$b119f07080a207ba = 1;
const $9a5b1cfd7f2b3bd5$export$8b8a958a7f6f130c = 2;
const $9a5b1cfd7f2b3bd5$export$501a7fac1df67a49 = 3;
const $9a5b1cfd7f2b3bd5$export$cd2b220b1ea851b2 = 4;
const $9a5b1cfd7f2b3bd5$export$ce970371e0e850bc = 5;
const $9a5b1cfd7f2b3bd5$export$5e8f180ef0142226 = 6;
const $9a5b1cfd7f2b3bd5$export$103bedf43ba882db = 7;
const $9a5b1cfd7f2b3bd5$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $35f5cee76b194183$var$env = typeof self === 'object' ? self : globalThis;
const $35f5cee76b194183$var$guard = (name, init)=>{
    switch(name){
        case 'Function':
        case 'SharedWorker':
        case 'Worker':
        case 'eval':
        case 'setInterval':
        case 'setTimeout':
            throw new TypeError('unable to deserialize ' + name);
    }
    return new $35f5cee76b194183$var$env[name](init);
};
const $35f5cee76b194183$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $9a5b1cfd7f2b3bd5$export$a44b4f3d5b73db95:
            case 0, $9a5b1cfd7f2b3bd5$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $9a5b1cfd7f2b3bd5$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $9a5b1cfd7f2b3bd5$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $9a5b1cfd7f2b3bd5$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $9a5b1cfd7f2b3bd5$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $9a5b1cfd7f2b3bd5$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $9a5b1cfd7f2b3bd5$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $9a5b1cfd7f2b3bd5$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as($35f5cee76b194183$var$guard(name, message), index);
                }
            case 0, $9a5b1cfd7f2b3bd5$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case 'BigInt':
                return as(Object(BigInt(value)), index);
            case 'ArrayBuffer':
                return as(new Uint8Array(value).buffer, value);
            case 'DataView':
                {
                    const { buffer: buffer } = new Uint8Array(value);
                    return as(new DataView(buffer), value);
                }
        }
        return as($35f5cee76b194183$var$guard(type, value), index);
    };
    return unpair;
};
const $35f5cee76b194183$export$efcd34ab6248d3cd = (serialized)=>$35f5cee76b194183$var$deserializer(new Map, serialized)(0);



const $6abfb44a52146fa9$var$EMPTY = '';
const { toString: $6abfb44a52146fa9$var$toString } = {};
const { keys: $6abfb44a52146fa9$var$keys } = Object;
const $6abfb44a52146fa9$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== 'object' || !value) return [
        (0, $9a5b1cfd7f2b3bd5$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $6abfb44a52146fa9$var$toString.call(value).slice(8, -1);
    switch(asString){
        case 'Array':
            return [
                (0, $9a5b1cfd7f2b3bd5$export$b119f07080a207ba),
                $6abfb44a52146fa9$var$EMPTY
            ];
        case 'Object':
            return [
                (0, $9a5b1cfd7f2b3bd5$export$8b8a958a7f6f130c),
                $6abfb44a52146fa9$var$EMPTY
            ];
        case 'Date':
            return [
                (0, $9a5b1cfd7f2b3bd5$export$501a7fac1df67a49),
                $6abfb44a52146fa9$var$EMPTY
            ];
        case 'RegExp':
            return [
                (0, $9a5b1cfd7f2b3bd5$export$cd2b220b1ea851b2),
                $6abfb44a52146fa9$var$EMPTY
            ];
        case 'Map':
            return [
                (0, $9a5b1cfd7f2b3bd5$export$ce970371e0e850bc),
                $6abfb44a52146fa9$var$EMPTY
            ];
        case 'Set':
            return [
                (0, $9a5b1cfd7f2b3bd5$export$5e8f180ef0142226),
                $6abfb44a52146fa9$var$EMPTY
            ];
        case 'DataView':
            return [
                (0, $9a5b1cfd7f2b3bd5$export$b119f07080a207ba),
                asString
            ];
    }
    if (asString.includes('Array')) return [
        (0, $9a5b1cfd7f2b3bd5$export$b119f07080a207ba),
        asString
    ];
    if (asString.includes('Error')) return [
        (0, $9a5b1cfd7f2b3bd5$export$103bedf43ba882db),
        asString
    ];
    return [
        (0, $9a5b1cfd7f2b3bd5$export$8b8a958a7f6f130c),
        asString
    ];
};
const $6abfb44a52146fa9$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $9a5b1cfd7f2b3bd5$export$a44b4f3d5b73db95) && (type === 'function' || type === 'symbol');
const $6abfb44a52146fa9$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $6abfb44a52146fa9$var$typeOf(value);
        switch(TYPE){
            case 0, $9a5b1cfd7f2b3bd5$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case 'bigint':
                            TYPE = (0, $9a5b1cfd7f2b3bd5$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case 'function':
                        case 'symbol':
                            if (strict) throw new TypeError('unable to serialize ' + type);
                            entry = null;
                            break;
                        case 'undefined':
                            return as([
                                (0, $9a5b1cfd7f2b3bd5$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $9a5b1cfd7f2b3bd5$export$b119f07080a207ba:
                {
                    if (type) {
                        let spread = value;
                        if (type === 'DataView') spread = new Uint8Array(value.buffer);
                        else if (type === 'ArrayBuffer') spread = new Uint8Array(value);
                        return as([
                            type,
                            [
                                ...spread
                            ]
                        ], value);
                    }
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $9a5b1cfd7f2b3bd5$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case 'BigInt':
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case 'Boolean':
                        case 'Number':
                        case 'String':
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && 'toJSON' in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $6abfb44a52146fa9$var$keys(value))if (strict || !$6abfb44a52146fa9$var$shouldSkip($6abfb44a52146fa9$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $9a5b1cfd7f2b3bd5$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    isNaN(value.getTime()) ? $6abfb44a52146fa9$var$EMPTY : value.toISOString()
                ], value);
            case 0, $9a5b1cfd7f2b3bd5$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $9a5b1cfd7f2b3bd5$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($6abfb44a52146fa9$var$shouldSkip($6abfb44a52146fa9$var$typeOf(key)) || $6abfb44a52146fa9$var$shouldSkip($6abfb44a52146fa9$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $9a5b1cfd7f2b3bd5$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$6abfb44a52146fa9$var$shouldSkip($6abfb44a52146fa9$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $6abfb44a52146fa9$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $6abfb44a52146fa9$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $8069d08b96be121d$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ('json' in options || 'lossy' in options) ? (0, $35f5cee76b194183$export$efcd34ab6248d3cd)((0, $6abfb44a52146fa9$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $35f5cee76b194183$export$efcd34ab6248d3cd)((0, $6abfb44a52146fa9$export$dfdc1655ccc5b9cb)(any, options));



function $ae4ef5a669697905$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: 'text',
            value: "\u21A9"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            {
                type: 'text',
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $ae4ef5a669697905$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return 'Back to reference ' + (referenceIndex + 1) + (rereferenceIndex > 1 ? '-' + rereferenceIndex : '');
}
function $ae4ef5a669697905$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const footnoteBackContent = state.options.footnoteBackContent || $ae4ef5a669697905$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $ae4ef5a669697905$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || 'Footnotes';
    const footnoteLabelTagName = state.options.footnoteLabelTagName || 'h2';
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            'sr-only'
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const definition = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!definition) continue;
        const content = state.all(definition);
        const id = String(definition.identifier).toUpperCase();
        const safeId = (0, $912e7ecc13655adf$export$e42a3e39590d28b5)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: 'text',
                value: ' '
            });
            let children = typeof footnoteBackContent === 'string' ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === 'string') children = {
                type: 'text',
                value: children
            };
            backReferences.push({
                type: 'element',
                tagName: 'a',
                properties: {
                    href: '#' + clobberPrefix + 'fnref-' + safeId + (rereferenceIndex > 1 ? '-' + rereferenceIndex : ''),
                    dataFootnoteBackref: '',
                    ariaLabel: typeof footnoteBackLabel === 'string' ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        'data-footnote-backref'
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === 'element' && tail.tagName === 'p') {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === 'text') tailTail.value += ' ';
            else tail.children.push({
                type: 'text',
                value: ' '
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: 'element',
            tagName: 'li',
            properties: {
                id: clobberPrefix + 'fn-' + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(definition, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: 'element',
        tagName: 'section',
        properties: {
            dataFootnotes: true,
            className: [
                'footnotes'
            ]
        },
        children: [
            {
                type: 'element',
                tagName: footnoteLabelTagName,
                properties: {
                    ...(0, $8069d08b96be121d$export$2e2bcd8739ae039)(footnoteLabelProperties),
                    id: 'footnote-label'
                },
                children: [
                    {
                        type: 'text',
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: 'text',
                value: '\n'
            },
            {
                type: 'element',
                tagName: 'ol',
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: 'text',
                value: '\n'
            }
        ]
    };
}


/**
 * @import {
 *   ElementContent as HastElementContent,
 *   Element as HastElement,
 *   Nodes as HastNodes,
 *   Properties as HastProperties,
 *   RootContent as HastRootContent,
 *   Text as HastText
 * } from 'hast'
 * @import {
 *   Definition as MdastDefinition,
 *   FootnoteDefinition as MdastFootnoteDefinition,
 *   Nodes as MdastNodes,
 *   Parents as MdastParents
 * } from 'mdast'
 * @import {VFile} from 'vfile'
 * @import {
 *   FootnoteBackContentTemplate,
 *   FootnoteBackLabelTemplate
 * } from './footer.js'
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {VFile | null | undefined} [file]
 *   Corresponding virtual file representing the input document (optional).
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 * @import {VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<any>
 *   ? MatchesOne<Value, Check[number]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $8b875585db4979eb$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $8b875585db4979eb$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$8b875585db4979eb$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $8b875585db4979eb$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $8b875585db4979eb$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $8b875585db4979eb$var$ok;
    if (typeof test === 'function') return $8b875585db4979eb$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $8b875585db4979eb$var$anyFactory(test) : // narrows to `Array`.
    $8b875585db4979eb$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $8b875585db4979eb$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $8b875585db4979eb$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $8b875585db4979eb$export$9c68d69a4c5bbcf9(tests[index]);
    return $8b875585db4979eb$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $8b875585db4979eb$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $8b875585db4979eb$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $8b875585db4979eb$var$typeFactory(check) {
    return $8b875585db4979eb$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $8b875585db4979eb$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($8b875585db4979eb$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $8b875585db4979eb$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $8b875585db4979eb$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $6f91f7bd6da1d5c0$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $3118d24b56b8b681$var$empty = [];
const $3118d24b56b8b681$export$f4d8133c446fe484 = true;
const $3118d24b56b8b681$export$7f100f842f565dc9 = false;
const $3118d24b56b8b681$export$8773f85c2fb2c116 = 'skip';
function $3118d24b56b8b681$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $8b875585db4979eb$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $6f91f7bd6da1d5c0$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $3118d24b56b8b681$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $3118d24b56b8b681$var$toResult(visitor(node, parents));
                if (result[0] === $3118d24b56b8b681$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $3118d24b56b8b681$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $3118d24b56b8b681$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $3118d24b56b8b681$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $3118d24b56b8b681$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $3118d24b56b8b681$var$empty : [
        value
    ];
}


function $dbdffc71d651d80a$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $3118d24b56b8b681$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @import {Handlers} from '../state.js'
 */ /**
 * @import {Element} from 'hast'
 * @import {Blockquote} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `blockquote` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Blockquote} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $9039aa24f6d0cb32$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'blockquote',
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {Break} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `break` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Break} node
 *   mdast node.
 * @returns {Array<Element | Text>}
 *   hast element content.
 */ function $b87d981997825cf9$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'br',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: 'text',
            value: '\n'
        }
    ];
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Code} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `code` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Code} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $3a5212ff646c65ad$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + '\n' : '';
    /** @type {Properties} */ const properties = {};
    // Someone can write `js&#x20;python&#x9;ruby`.
    const language = node.lang ? node.lang.split(/\s+/) : [];
    // GH/CM still drop the non-first languages.
    if (language.length > 0) properties.className = [
        'language-' + language[0]
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: 'element',
        tagName: 'code',
        properties: properties,
        children: [
            {
                type: 'text',
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: 'element',
        tagName: 'pre',
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @import {Element} from 'hast'
 * @import {Delete} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `delete` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Delete} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $4d6d82e6dd212f54$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'del',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Emphasis} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `emphasis` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Emphasis} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $8d4ef87649788434$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'em',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {FootnoteReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $fbce1f182d2eda25$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === 'string' ? state.options.clobberPrefix : 'user-content-';
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $912e7ecc13655adf$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: 'element',
        tagName: 'a',
        properties: {
            href: '#' + clobberPrefix + 'fn-' + safeId,
            id: clobberPrefix + 'fnref-' + safeId + (reuseCounter > 1 ? '-' + reuseCounter : ''),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                'footnote-label'
            ]
        },
        children: [
            {
                type: 'text',
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: 'element',
        tagName: 'sup',
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @import {Element} from 'hast'
 * @import {Heading} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `heading` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Heading} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $dc7de91d2d498c88$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'h' + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Html} from 'mdast'
 * @import {State} from '../state.js'
 * @import {Raw} from '../../index.js'
 */ /**
 * Turn an mdast `html` node into hast (`raw` node in dangerous mode, otherwise
 * nothing).
 *
 * @param {State} state
 *   Info passed around.
 * @param {Html} node
 *   mdast node.
 * @returns {Element | Raw | undefined}
 *   hast node.
 */ function $ee99ebc3df2f764f$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: 'raw',
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ImageReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 
/**
 * @import {ElementContent} from 'hast'
 * @import {Reference, Nodes} from 'mdast'
 * @import {State} from './state.js'
 */ /**
 * Return the content of a reference without definition as plain text.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Extract<Nodes, Reference>} node
 *   Reference node (image, link).
 * @returns {Array<ElementContent>}
 *   hast content.
 */ function $036036729fb8e115$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = ']';
    if (subtype === 'collapsed') suffix += '[]';
    else if (subtype === 'full') suffix += '[' + (node.label || node.identifier) + ']';
    if (node.type === 'imageReference') return [
        {
            type: 'text',
            value: '![' + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === 'text') head.value = '[' + head.value;
    else contents.unshift({
        type: 'text',
        value: '['
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === 'text') tail.value += suffix;
    else contents.push({
        type: 'text',
        value: suffix
    });
    return contents;
}


function $609a346b476f0467$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $036036729fb8e115$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $912e7ecc13655adf$export$e42a3e39590d28b5)(definition.url || ''),
        alt: node.alt
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Image} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $85ff875ca831ff30$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $912e7ecc13655adf$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'img',
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Text} from 'hast'
 * @import {InlineCode} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `inlineCode` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {InlineCode} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $c66656c04cee0c7f$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: 'text',
        value: node.value.replace(/\r?\n|\r/g, ' ')
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'code',
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {LinkReference} from 'mdast'
 * @import {State} from '../state.js'
 */ 

function $dcf762a13dc99bd2$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const definition = state.definitionById.get(id);
    if (!definition) return (0, $036036729fb8e115$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $912e7ecc13655adf$export$e42a3e39590d28b5)(definition.url || '')
    };
    if (definition.title !== null && definition.title !== undefined) properties.title = definition.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {Link} from 'mdast'
 * @import {State} from '../state.js'
 */ 
function $5b020796bb177d48$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $912e7ecc13655adf$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'a',
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {ElementContent, Element, Properties} from 'hast'
 * @import {ListItem, Parents} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `listItem` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ListItem} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $ad6f0d1c95722a3a$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $ad6f0d1c95722a3a$var$listLoose(parent) : $ad6f0d1c95722a3a$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === 'boolean') {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === 'element' && head.tagName === 'p') paragraph = head;
        else {
            paragraph = {
                type: 'element',
                tagName: 'p',
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: 'text',
            value: ' '
        });
        paragraph.children.unshift({
            type: 'element',
            tagName: 'input',
            properties: {
                type: 'checkbox',
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            'task-list-item'
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== 'element' || child.tagName !== 'p') children.push({
            type: 'text',
            value: '\n'
        });
        if (child.type === 'element' && child.tagName === 'p' && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== 'element' || tail.tagName !== 'p')) children.push({
        type: 'text',
        value: '\n'
    });
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'li',
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $ad6f0d1c95722a3a$var$listLoose(node) {
    let loose = false;
    if (node.type === 'list') {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $ad6f0d1c95722a3a$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $ad6f0d1c95722a3a$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @import {Element, Properties} from 'hast'
 * @import {List} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `list` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {List} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $d3f98bb09f25ac8f$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === 'number' && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === 'element' && child.tagName === 'li' && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes('task-list-item')) {
            properties.className = [
                'contains-task-list'
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: node.ordered ? 'ol' : 'ul',
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Paragraph} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `paragraph` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Paragraph} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $f315dca8bc7f57f8$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'p',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Parents as HastParents, Root as HastRoot} from 'hast'
 * @import {Root as MdastRoot} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `root` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastRoot} node
 *   mdast node.
 * @returns {HastParents}
 *   hast node.
 */ function $697940a01b07455a$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: 'root',
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {Strong} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `strong` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Strong} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $dea50812090edbe8$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'strong',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Table} from 'mdast'
 * @import {Element} from 'hast'
 * @import {State} from '../state.js'
 */ 
function $74c7666462bbc6da$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: 'element',
            tagName: 'thead',
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: 'element',
            tagName: 'tbody',
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $0eeac8e369d29245$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $0eeac8e369d29245$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'table',
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element, ElementContent, Properties} from 'hast'
 * @import {Parents, TableRow} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableRow` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableRow} node
 *   mdast node.
 * @param {Parents | undefined} parent
 *   Parent of `node`.
 * @returns {Element}
 *   hast node.
 */ function $df9346cd5639f4fe$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? 'th' : 'td';
    // To do: option to use `style`?
    const align = parent && parent.type === 'table' ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: 'element',
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'tr',
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {TableCell} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `tableCell` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {TableCell} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $745aa7a173e07fbd$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'td',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element as HastElement, Text as HastText} from 'hast'
 * @import {Text as MdastText} from 'mdast'
 * @import {State} from '../state.js'
 */ const $a5a4471b46a1c181$var$tab = 9 /* `\t` */ ;
const $a5a4471b46a1c181$var$space = 32 /* ` ` */ ;
function $a5a4471b46a1c181$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($a5a4471b46a1c181$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($a5a4471b46a1c181$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $a5a4471b46a1c181$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $a5a4471b46a1c181$var$tab || code === $a5a4471b46a1c181$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $a5a4471b46a1c181$var$tab || code === $a5a4471b46a1c181$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}


function $ac35ca130e2a1c55$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: 'text',
        value: (0, $a5a4471b46a1c181$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @import {Element} from 'hast'
 * @import {ThematicBreak} from 'mdast'
 * @import {State} from '../state.js'
 */ /**
 * Turn an mdast `thematicBreak` node into hast.
 *
 * @param {State} state
 *   Info passed around.
 * @param {ThematicBreak} node
 *   mdast node.
 * @returns {Element}
 *   hast node.
 */ function $6c6daf687422cc21$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: 'element',
        tagName: 'hr',
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $34f0ecf0a347cd4b$export$455ce229eb3d2472 = {
    blockquote: $9039aa24f6d0cb32$export$67dc04e652a298ca,
    break: (0, $b87d981997825cf9$export$371da9dd35aba193),
    code: $3a5212ff646c65ad$export$6565f9f03506010b,
    delete: (0, $4d6d82e6dd212f54$export$19426ff118fe8be),
    emphasis: $8d4ef87649788434$export$bef81ba411953b51,
    footnoteReference: $fbce1f182d2eda25$export$7f87ee744075c1ba,
    heading: $dc7de91d2d498c88$export$46e4a324ac90507f,
    html: $ee99ebc3df2f764f$export$c0bb0b647f701bb5,
    imageReference: $609a346b476f0467$export$f281796f6bc3b8db,
    image: $85ff875ca831ff30$export$5c452ff88e35e47d,
    inlineCode: $c66656c04cee0c7f$export$91b9bee19a0d8569,
    linkReference: $dcf762a13dc99bd2$export$e6c469b1b7b2bc6a,
    link: $5b020796bb177d48$export$9c30223ca0a664fb,
    listItem: $ad6f0d1c95722a3a$export$76c7e83ecc9cdf05,
    list: $d3f98bb09f25ac8f$export$8837f4fc672e936d,
    paragraph: $f315dca8bc7f57f8$export$9c206ddddb32a9b,
    root: // @ts-expect-error: root is different, but hard to type.
    $697940a01b07455a$export$e8e78c978b129247,
    strong: $dea50812090edbe8$export$59ae2c325a998f89,
    table: $74c7666462bbc6da$export$9852986a3ec5f6a0,
    tableCell: $745aa7a173e07fbd$export$e1e720e5f4603e6a,
    tableRow: $df9346cd5639f4fe$export$ce666bf02318c957,
    text: $ac35ca130e2a1c55$export$6f093cfa640b7166,
    thematicBreak: $6c6daf687422cc21$export$ba7b13e047416c03,
    toml: $34f0ecf0a347cd4b$var$ignore,
    yaml: $34f0ecf0a347cd4b$var$ignore,
    definition: $34f0ecf0a347cd4b$var$ignore,
    footnoteDefinition: $34f0ecf0a347cd4b$var$ignore
};
// Return nothing for nodes that are ignored.
function $34f0ecf0a347cd4b$var$ignore() {
    return undefined;
}


const $c111d98ae07d9641$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $c111d98ae07d9641$var$emptyOptions = {};
function $c111d98ae07d9641$export$e6a0daad8304de(tree, options) {
    const settings = options || $c111d98ae07d9641$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = {
        ...(0, $34f0ecf0a347cd4b$export$455ce229eb3d2472),
        ...settings.handlers
    };
    /** @type {State} */ const state = {
        all: all,
        applyData: $c111d98ae07d9641$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $c111d98ae07d9641$var$patch,
        wrap: $c111d98ae07d9641$export$4997ffc0176396a6
    };
    (0, $dbdffc71d651d80a$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === 'definition' || node.type === 'footnoteDefinition') {
            const map = node.type === 'definition' ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($c111d98ae07d9641$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ('children' in node) {
                const { children: children, ...shallow } = node;
                const result = (0, $8069d08b96be121d$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $8069d08b96be121d$export$2e2bcd8739ae039)(node);
        }
        const unknown = state.options.unknownHandler || $c111d98ae07d9641$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ('children' in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === 'break') {
                        if (!Array.isArray(result) && result.type === 'text') result.value = $c111d98ae07d9641$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === 'element') {
                            const head = result.children[0];
                            if (head && head.type === 'text') head.value = $c111d98ae07d9641$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $c111d98ae07d9641$var$patch(from, to) {
    if (from.position) to.position = (0, $0eeac8e369d29245$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $c111d98ae07d9641$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === 'string') {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === 'element') result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = 'children' in result ? result.children : [
                    result
                ];
                result = {
                    type: 'element',
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === 'element' && hProperties) Object.assign(result.properties, (0, $8069d08b96be121d$export$2e2bcd8739ae039)(hProperties));
        if ('children' in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $c111d98ae07d9641$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = 'value' in node && !($c111d98ae07d9641$var$own.call(data, 'hProperties') || $c111d98ae07d9641$var$own.call(data, 'hChildren')) ? {
        type: 'text',
        value: node.value
    } : {
        type: 'element',
        tagName: 'div',
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $c111d98ae07d9641$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: 'text',
        value: '\n'
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: 'text',
            value: '\n'
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: 'text',
        value: '\n'
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $c111d98ae07d9641$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $7a14be7d5ddf97f1$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $c111d98ae07d9641$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $ae4ef5a669697905$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: 'root',
        children: node
    } : node || {
        type: 'root',
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)('children' in result);
        result.children.push({
            type: 'text',
            value: '\n'
        }, foot);
    }
    return result;
}


function $03a9f971e47b9c61$export$2e2bcd8739ae039(destination, options) {
    if (destination && 'run' in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $7a14be7d5ddf97f1$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...options
        });
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree, file) {
        // Cast because root in -> root out.
        // To do: in the future, disallow ` || options` fallback.
        // With `unified-engine`, `destination` can be `undefined` but
        // `options` will be the file set.
        // We should not pass that as `options`.
        return /** @type {HastRoot} */ (0, $7a14be7d5ddf97f1$export$c0e4c5cf07538633)(tree, {
            file: file,
            ...destination || options
        });
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@linkcode CompileResultMap}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@linkcode Node}
 *   and {@linkcode VFile} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@linkcode CompileResultMap}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@linkcode VFile} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@linkcode Node}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@linkcode Parser}, this should be
 *       `string`.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@linkcode Transformer}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@linkcode Parser}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@linkcode Compiler}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@linkcode VFile} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@linkcode VFile}.
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $7ecf6a547d2cf11f$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $89faf01b6b76df52$exports = {};
'use strict';
var $89faf01b6b76df52$var$hasOwn = Object.prototype.hasOwnProperty;
var $89faf01b6b76df52$var$toStr = Object.prototype.toString;
var $89faf01b6b76df52$var$defineProperty = Object.defineProperty;
var $89faf01b6b76df52$var$gOPD = Object.getOwnPropertyDescriptor;
var $89faf01b6b76df52$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === 'function') return Array.isArray(arr);
    return $89faf01b6b76df52$var$toStr.call(arr) === '[object Array]';
};
var $89faf01b6b76df52$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $89faf01b6b76df52$var$toStr.call(obj) !== '[object Object]') return false;
    var hasOwnConstructor = $89faf01b6b76df52$var$hasOwn.call(obj, 'constructor');
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $89faf01b6b76df52$var$hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === 'undefined' || $89faf01b6b76df52$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $89faf01b6b76df52$var$setProperty = function setProperty(target, options) {
    if ($89faf01b6b76df52$var$defineProperty && options.name === '__proto__') $89faf01b6b76df52$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $89faf01b6b76df52$var$getProperty = function getProperty(obj, name) {
    if (name === '__proto__') {
        if (!$89faf01b6b76df52$var$hasOwn.call(obj, name)) return void 0;
        else if ($89faf01b6b76df52$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $89faf01b6b76df52$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$89faf01b6b76df52$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== 'object' && typeof target !== 'function') target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $89faf01b6b76df52$var$getProperty(target, name);
            copy = $89faf01b6b76df52$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($89faf01b6b76df52$var$isPlainObject(copy) || (copyIsArray = $89faf01b6b76df52$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $89faf01b6b76df52$var$isArray(src) ? src : [];
                    } else clone = src && $89faf01b6b76df52$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $89faf01b6b76df52$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== 'undefined') $89faf01b6b76df52$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};



function $eaf980014a694f8d$export$2e2bcd8739ae039(value) {
    if (typeof value !== 'object' || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


// To do: remove `void`s
// To do: remove `null` from output of our APIs, allow it as user APIs.
/**
 * @typedef {(error?: Error | null | undefined, ...output: Array<any>) => void} Callback
 *   Callback.
 *
 * @typedef {(...input: Array<any>) => any} Middleware
 *   Ware.
 *
 * @typedef Pipeline
 *   Pipeline.
 * @property {Run} run
 *   Run the pipeline.
 * @property {Use} use
 *   Add middleware.
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 *
 *   Calls `done` on completion with either an error or the output of the
 *   last middleware.
 *
 *   > 👉 **Note**: as the length of input defines whether async functions get a
 *   > `next` function,
 *   > it’s recommended to keep `input` at one value normally.

 *
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 *   Pipeline.
 */ function $62bbe2180ddee166$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== 'function') throw new TypeError('Expected function as last argument, not ' + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error | null | undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $62bbe2180ddee166$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== 'function') throw new TypeError('Expected `middelware` to be a function, not ' + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $62bbe2180ddee166$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result && result.then && typeof result.then === 'function') result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   *
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @import {Node, Point, Position} from 'unist'
 * @import {Options as MessageOptions} from 'vfile-message'
 * @import {Compatible, Data, Map, Options, Value} from 'vfile'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 */ 
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $26c2a9f28b74df44$export$500c965389abde9c = {
    basename: $26c2a9f28b74df44$var$basename,
    dirname: $26c2a9f28b74df44$var$dirname,
    extname: $26c2a9f28b74df44$var$extname,
    join: $26c2a9f28b74df44$var$join,
    sep: '/'
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [extname]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $26c2a9f28b74df44$var$basename(path, extname) {
    if (extname !== undefined && typeof extname !== 'string') throw new TypeError('"ext" argument must be a string');
    $26c2a9f28b74df44$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (extname === undefined || extname.length === 0 || extname.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? '' : path.slice(start, end);
    }
    if (extname === path) return '';
    let firstNonSlashEnd = -1;
    let extnameIndex = extname.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extnameIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === extname.codePointAt(extnameIndex--)) {
                    if (extnameIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extnameIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $26c2a9f28b74df44$var$dirname(path) {
    $26c2a9f28b74df44$var$assertPath(path);
    if (path.length === 0) return '.';
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? '/' : '.' : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? '//' : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $26c2a9f28b74df44$var$extname(path) {
    $26c2a9f28b74df44$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $26c2a9f28b74df44$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $26c2a9f28b74df44$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + '/' + segments[index];
    }
    return joined === undefined ? '.' : $26c2a9f28b74df44$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $26c2a9f28b74df44$var$normalize(path) {
    $26c2a9f28b74df44$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $26c2a9f28b74df44$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = '.';
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += '/';
    return absolute ? '/' + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $26c2a9f28b74df44$var$normalizeString(path, allowAboveRoot) {
    let result = '';
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf('/');
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = '';
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf('/');
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = '';
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + '/..' : '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += '/' + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $26c2a9f28b74df44$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $113f177f4d212849$export$77f0ef6e088922ec = {
    cwd: $113f177f4d212849$var$cwd
};
function $113f177f4d212849$var$cwd() {
    return '/';
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $8dd01c4eb33b46b7$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === 'object' && 'href' in fileUrlOrPath && fileUrlOrPath.href && 'protocol' in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $bea6c3b6151293f4$export$9b2b676c902de799(path) {
    if (typeof path === 'string') path = new URL(path);
    else if (!(0, $8dd01c4eb33b46b7$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + '`');
        error.code = 'ERR_INVALID_ARG_TYPE';
        throw error;
    }
    if (path.protocol !== 'file:') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The URL must be of scheme file');
        error.code = 'ERR_INVALID_URL_SCHEME';
        throw error;
    }
    return $bea6c3b6151293f4$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $bea6c3b6151293f4$var$getPathFromURLPosix(url) {
    if (url.hostname !== '') {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = 'ERR_INVALID_FILE_URL_HOST';
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL path must not include encoded / characters');
            error.code = 'ERR_INVALID_FILE_URL_PATH';
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $2949f70ebb692e3b$var$order = /** @type {const} */ [
    'history',
    'path',
    'basename',
    'stem',
    'extname',
    'dirname'
];
class $2949f70ebb692e3b$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $8dd01c4eb33b46b7$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === 'string' || $2949f70ebb692e3b$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ // Prevent calling `cwd` (which could be expensive) if it’s not needed;
        // the empty string will be overridden in the next block.
        this.cwd = 'cwd' in options ? '' : (0, $113f177f4d212849$export$77f0ef6e088922ec).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $2949f70ebb692e3b$var$order.length){
            const field = $2949f70ebb692e3b$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (field in options && options[field] !== undefined && options[field] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[field] = field === 'history' ? [
                ...options[field]
            ] : options[field];
        }
        /** @type {string} */ let field;
        // Set non-path related properties.
        for(field in options)// @ts-expect-error: fine to set other things.
        if (!$2949f70ebb692e3b$var$order.includes(field)) // @ts-expect-error: fine to set other things.
        this[field] = options[field];
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === 'string' ? (0, $26c2a9f28b74df44$export$500c965389abde9c).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $2949f70ebb692e3b$var$assertNonEmpty(basename, 'basename');
        $2949f70ebb692e3b$var$assertPart(basename, 'basename');
        this.path = (0, $26c2a9f28b74df44$export$500c965389abde9c).join(this.dirname || '', basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === 'string' ? (0, $26c2a9f28b74df44$export$500c965389abde9c).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $2949f70ebb692e3b$var$assertPath(this.basename, 'dirname');
        this.path = (0, $26c2a9f28b74df44$export$500c965389abde9c).join(dirname || '', this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === 'string' ? (0, $26c2a9f28b74df44$export$500c965389abde9c).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $2949f70ebb692e3b$var$assertPart(extname, 'extname');
        $2949f70ebb692e3b$var$assertPath(this.dirname, 'extname');
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error('`extname` must start with `.`');
            if (extname.includes('.', 1)) throw new Error('`extname` cannot contain multiple dots');
        }
        this.path = (0, $26c2a9f28b74df44$export$500c965389abde9c).join(this.dirname, this.stem + (extname || ''));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $8dd01c4eb33b46b7$export$8304a22d431f958)(path)) path = (0, $bea6c3b6151293f4$export$9b2b676c902de799)(path);
        $2949f70ebb692e3b$var$assertNonEmpty(path, 'path');
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === 'string' ? (0, $26c2a9f28b74df44$export$500c965389abde9c).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $2949f70ebb692e3b$var$assertNonEmpty(stem, 'stem');
        $2949f70ebb692e3b$var$assertPart(stem, 'stem');
        this.path = (0, $26c2a9f28b74df44$export$500c965389abde9c).join(this.dirname || '', stem + (this.extname || ''));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $73959e4640e8f655$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ':' + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return '';
        if (typeof this.value === 'string') return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $2949f70ebb692e3b$var$assertPart(part, name) {
    if (part && part.includes((0, $26c2a9f28b74df44$export$500c965389abde9c).sep)) throw new Error('`' + name + '` cannot be a path: did not expect `' + (0, $26c2a9f28b74df44$export$500c965389abde9c).sep + '`');
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $2949f70ebb692e3b$var$assertNonEmpty(part, name) {
    if (!part) throw new Error('`' + name + '` cannot be empty');
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $2949f70ebb692e3b$var$assertPath(path, name) {
    if (!path) throw new Error('Setting `' + name + '` requires `path` to be set too');
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $2949f70ebb692e3b$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}


const $79e7457d62fe0659$export$b7de1db558410812 = /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const value = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    // Not needed for us in `unified`: we only call this on the `copy`
    // function,
    // and we don't need to add its fields (`length`, `name`)
    // over.
    // See also: GH-246.
    // const names = Object.getOwnPropertyNames(value)
    //
    // for (const p of names) {
    //   const descriptor = Object.getOwnPropertyDescriptor(value, p)
    //   if (descriptor) Object.defineProperty(apply, p, descriptor)
    // }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $5e61e07dc18763dc$var$own = {}.hasOwnProperty;
class $5e61e07dc18763dc$export$c30cd198d731db19 extends (0, $79e7457d62fe0659$export$b7de1db558410812) {
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super('copy');
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $62bbe2180ddee166$export$91b56f5ca106aa43)();
    }
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $5e61e07dc18763dc$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($89faf01b6b76df52$exports)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === 'string') {
            // Set `key`.
            if (arguments.length === 2) {
                $5e61e07dc18763dc$var$assertUnfrozen('data', this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $5e61e07dc18763dc$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $5e61e07dc18763dc$var$assertUnfrozen('data', this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === 'function') this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $5e61e07dc18763dc$var$vfile(file);
        const parser = this.parser || this.Parser;
        $5e61e07dc18763dc$var$assertParser('parse', parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $5e61e07dc18763dc$var$assertParser('process', this.parser || this.Parser);
        $5e61e07dc18763dc$var$assertCompiler('process', this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $5e61e07dc18763dc$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($5e61e07dc18763dc$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $5e61e07dc18763dc$var$assertParser('processSync', this.parser || this.Parser);
        $5e61e07dc18763dc$var$assertCompiler('processSync', this.compiler || this.Compiler);
        this.process(file, realDone);
        $5e61e07dc18763dc$var$assertDone('processSync', 'process', complete);
        (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $7ecf6a547d2cf11f$export$dd911e13ecb11e05)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $5e61e07dc18763dc$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === 'function') {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(typeof file !== 'function', "`file` can\u2019t be a `done` anymore, we checked");
            const realFile = $5e61e07dc18763dc$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(done, '`done` is defined if `resolve` is not');
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $5e61e07dc18763dc$var$assertDone('runSync', 'run', complete);
        (0, $86de8631a137d21f$export$dcb8b3f0e2de7e49)(result, 'we either bailed on an error or have a tree');
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $7ecf6a547d2cf11f$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $5e61e07dc18763dc$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $5e61e07dc18763dc$var$assertCompiler('stringify', compiler);
        $5e61e07dc18763dc$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $5e61e07dc18763dc$var$assertUnfrozen('use', this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === 'function') addPlugin(value, parameters);
        else if (typeof value === 'object') {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError('Expected usable value, not `' + value + '`');
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === 'function') addPlugin(value, []);
            else if (typeof value === 'object') {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError('Expected usable value, not `' + value + '`');
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!('plugins' in result) && !('settings' in result)) throw new Error('Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither');
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($89faf01b6b76df52$exports)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError('Expected a list of plugins, not `' + plugins + '`');
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $eaf980014a694f8d$export$2e2bcd8739ae039)(currentPrimary) && (0, $eaf980014a694f8d$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($89faf01b6b76df52$exports)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
}
const $5e61e07dc18763dc$export$7cc1b2fe10c52bb = new $5e61e07dc18763dc$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $5e61e07dc18763dc$var$assertParser(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `parser`');
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $5e61e07dc18763dc$var$assertCompiler(name, value) {
    if (typeof value !== 'function') throw new TypeError('Cannot `' + name + '` without `compiler`');
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $5e61e07dc18763dc$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error('Cannot call `' + name + '` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.');
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $5e61e07dc18763dc$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $eaf980014a694f8d$export$2e2bcd8739ae039)(node) || typeof node.type !== 'string') throw new TypeError('Expected node, got `' + node + '`');
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $5e61e07dc18763dc$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error('`' + name + '` finished async. Use `' + asyncName + '` instead');
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $5e61e07dc18763dc$var$vfile(value) {
    return $5e61e07dc18763dc$var$looksLikeAVFile(value) ? value : new (0, $2949f70ebb692e3b$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $5e61e07dc18763dc$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === 'object' && 'message' in value && 'messages' in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $5e61e07dc18763dc$var$looksLikeAValue(value) {
    return typeof value === 'string' || $5e61e07dc18763dc$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $5e61e07dc18763dc$var$isUint8Array(value) {
    return Boolean(value && typeof value === 'object' && 'byteLength' in value && 'byteOffset' in value);
}




const $f16426ff3cbe874b$var$changelog = 'https://github.com/remarkjs/react-markdown/blob/main/changelog.md';
/** @type {PluggableList} */ const $f16426ff3cbe874b$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $f16426ff3cbe874b$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $f16426ff3cbe874b$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $f16426ff3cbe874b$var$deprecations = [
    {
        from: 'astPlugins',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowDangerousHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'allowNode',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowElement'
    },
    {
        from: 'allowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'allowedElements'
    },
    {
        from: 'className',
        id: 'remove-classname'
    },
    {
        from: 'disallowedTypes',
        id: 'replace-allownode-allowedtypes-and-disallowedtypes',
        to: 'disallowedElements'
    },
    {
        from: 'escapeHtml',
        id: 'remove-buggy-html-in-markdown-parser'
    },
    {
        from: 'includeElementIndex',
        id: '#remove-includeelementindex'
    },
    {
        from: 'includeNodeIndex',
        id: 'change-includenodeindex-to-includeelementindex'
    },
    {
        from: 'linkTarget',
        id: 'remove-linktarget'
    },
    {
        from: 'plugins',
        id: 'change-plugins-to-remarkplugins',
        to: 'remarkPlugins'
    },
    {
        from: 'rawSourcePos',
        id: '#remove-rawsourcepos'
    },
    {
        from: 'renderers',
        id: 'change-renderers-to-components',
        to: 'components'
    },
    {
        from: 'source',
        id: 'change-source-to-children',
        to: 'children'
    },
    {
        from: 'sourcePos',
        id: '#remove-sourcepos'
    },
    {
        from: 'transformImageUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    },
    {
        from: 'transformLinkUri',
        id: '#add-urltransform',
        to: 'urlTransform'
    }
];
function $f16426ff3cbe874b$export$7460c8b7e4ce9582(options) {
    const processor = $f16426ff3cbe874b$var$createProcessor(options);
    const file = $f16426ff3cbe874b$var$createFile(options);
    return $f16426ff3cbe874b$var$post(processor.runSync(processor.parse(file), file), options);
}
async function $f16426ff3cbe874b$export$445edbd7f2c65a8c(options) {
    const processor = $f16426ff3cbe874b$var$createProcessor(options);
    const file = $f16426ff3cbe874b$var$createFile(options);
    const tree = await processor.run(processor.parse(file), file);
    return $f16426ff3cbe874b$var$post(tree, options);
}
function $f16426ff3cbe874b$export$915021c692d253a2(options) {
    const processor = $f16426ff3cbe874b$var$createProcessor(options);
    const [error, setError] = (0, $kYCgE.useState)(/** @type {Error | undefined} */ undefined);
    const [tree, setTree] = (0, $kYCgE.useState)(/** @type {Root | undefined} */ undefined);
    (0, $kYCgE.useEffect)(function() {
        let cancelled = false;
        const file = $f16426ff3cbe874b$var$createFile(options);
        processor.run(processor.parse(file), file, function(error, tree) {
            if (!cancelled) {
                setError(error);
                setTree(tree);
            }
        });
        /**
       * @returns {undefined}
       *   Nothing.
       */ return function() {
            cancelled = true;
        };
    }, [
        options.children,
        options.rehypePlugins,
        options.remarkPlugins,
        options.remarkRehypeOptions
    ]);
    if (error) throw error;
    return tree ? $f16426ff3cbe874b$var$post(tree, options) : options.fallback;
}
/**
 * Set up the `unified` processor.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {Processor<MdastRoot, MdastRoot, Root, undefined, undefined>}
 *   Result.
 */ function $f16426ff3cbe874b$var$createProcessor(options) {
    const rehypePlugins = options.rehypePlugins || $f16426ff3cbe874b$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $f16426ff3cbe874b$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? {
        ...options.remarkRehypeOptions,
        ...$f16426ff3cbe874b$var$emptyRemarkRehypeOptions
    } : $f16426ff3cbe874b$var$emptyRemarkRehypeOptions;
    const processor = (0, $5e61e07dc18763dc$export$7cc1b2fe10c52bb)().use((0, $14d76c4581083238$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $03a9f971e47b9c61$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    return processor;
}
/**
 * Set up the virtual file.
 *
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {VFile}
 *   Result.
 */ function $f16426ff3cbe874b$var$createFile(options) {
    const children = options.children || '';
    const file = new (0, $2949f70ebb692e3b$export$93dff69eb10dc7ce)();
    if (typeof children === 'string') file.value = children;
    else (0, $86de8631a137d21f$export$565e9d9bd6b6e0d4)('Unexpected value `' + children + '` for `children` prop, expected `string`');
    return file;
}
/**
 * Process the result from unified some more.
 *
 * @param {Nodes} tree
 *   Tree.
 * @param {Readonly<Options>} options
 *   Props.
 * @returns {ReactElement}
 *   React element.
 */ function $f16426ff3cbe874b$var$post(tree, options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $f16426ff3cbe874b$export$ca5e94754123e2f3;
    for (const deprecation of $f16426ff3cbe874b$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $86de8631a137d21f$export$565e9d9bd6b6e0d4)('Unexpected `' + deprecation.from + '` prop, ' + (deprecation.to ? 'use `' + deprecation.to + '` instead' : 'remove it') + ' (see <' + $f16426ff3cbe874b$var$changelog + '#' + deprecation.id + '> for more info)');
    if (allowedElements && disallowedElements) (0, $86de8631a137d21f$export$565e9d9bd6b6e0d4)('Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other');
    (0, $dbdffc71d651d80a$export$bf638b60ea8b89b7)(tree, transform);
    return (0, $ab0c7b748f53bf50$export$59c10052b2dee561)(tree, {
        Fragment: $bff2c38a23c12238$exports.Fragment,
        components: components,
        ignoreInvalidStyle: true,
        jsx: $bff2c38a23c12238$exports.jsx,
        jsxs: $bff2c38a23c12238$exports.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {BuildVisitor<Root>} */ function transform(node, index, parent) {
        if (node.type === 'raw' && parent && typeof index === 'number') {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: 'text',
                value: node.value
            };
            return index;
        }
        if (node.type === 'element') {
            /** @type {string} */ let key;
            for(key in 0, $0b6d4c42c84ace58$export$de3e062aedff083a)if (Object.hasOwn((0, $0b6d4c42c84ace58$export$de3e062aedff083a), key) && Object.hasOwn(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $0b6d4c42c84ace58$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ''), key, node);
            }
        }
        if (node.type === 'element') {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === 'number') remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === 'number') {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $f16426ff3cbe874b$export$ca5e94754123e2f3(value) {
    // Same as:
    // <https://github.com/micromark/micromark/blob/929275e/packages/micromark-util-sanitize-uri/dev/index.js#L34>
    // But without the `encode` part.
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon === -1 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash !== -1 && colon > slash || questionMark !== -1 && colon > questionMark || numberSign !== -1 && colon > numberSign || // It is a protocol, it should be allowed.
    $f16426ff3cbe874b$var$safeProtocol.test(value.slice(0, colon))) return value;
    return '';
}



var $bfb603a122701009$export$2e2bcd8739ae039 = ()=>{
    const [text, setText] = (0, $kYCgE.useState)("");
    (0, $kYCgE.useEffect)(()=>{
        // declare the data fetching function
        const fetchData = async ()=>{
            await fetch("/static/carve.md").then((res)=>res.text()).then((t)=>setText(t));
        };
        // call the function
        fetchData()// make sure to catch any error
        .catch(console.error);
    }, []);
    return /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
        className: "container container-text",
        children: text && /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $f16426ff3cbe874b$export$7460c8b7e4ce9582), {
            children: text
        })
    });
};



var $9cc64d8ae9d8cdd0$export$2e2bcd8739ae039 = ()=>{
    return /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
        className: "container-fluid my-5 py-5 text-center",
        children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("h1", {
            children: "404: Page Not Found"
        })
    });
};





var $8410dd59006877e8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("footer", {
        className: "footer fixed-bottom navbar-inverse",
        role: "contentinfo",
        children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("div", {
            className: " align-center",
            children: "carvewizard"
        })
    });



parcelRequire("kYCgE");

var $af2414ca58a8c40d$export$2e2bcd8739ae039 = ()=>{
    return /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("nav", {
        className: "navbar navbar-expand-lg fixed-top",
        children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsxs)("div", {
            className: "container",
            children: [
                /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $083e616e9396c747$export$a6c7ac8248d6e38a), {
                    className: "navbar-brand",
                    "aria-current": "page",
                    to: "/",
                    children: "CarveWizard"
                }),
                /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("ul", {
                    className: "navbar-nav ml-auto",
                    children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)("li", {
                        className: "nav-item",
                        children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $083e616e9396c747$export$a6c7ac8248d6e38a), {
                            className: "nav-link active",
                            "aria-current": "page",
                            to: "/tech",
                            children: "TECH"
                        })
                    })
                })
            ]
        })
    });
};



var $kYCgE = parcelRequire("kYCgE");
class $91bfbb4c0426c11b$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($kYCgE))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, info) {
        // Example "componentStack":
        //   in ComponentThatThrows (created by App)
        //   in ErrorBoundary (created by App)
        //   in div (created by App)
        //   in App
        console.log(error, info.componentStack);
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}
var $91bfbb4c0426c11b$export$2e2bcd8739ae039 = $91bfbb4c0426c11b$var$ErrorBoundary;




var $9ab3f2b6023092d8$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsxs)("div", {
        className: "app",
        children: [
            /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $af2414ca58a8c40d$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsxs)((0, $102f7a9a4f39f387$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $102f7a9a4f39f387$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $813139c09616f284$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $102f7a9a4f39f387$export$e7b0ac011bb776c6), {
                        path: "/tech",
                        element: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $bfb603a122701009$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $102f7a9a4f39f387$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $9cc64d8ae9d8cdd0$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $8410dd59006877e8$export$2e2bcd8739ae039), {})
        ]
    });


const $e43d60df1b521b9d$var$container = document.getElementById("root");
const $e43d60df1b521b9d$var$root = (0, $b72177ec5dfe0822$exports.createRoot)($e43d60df1b521b9d$var$container);
$e43d60df1b521b9d$var$root.render(/*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $083e616e9396c747$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $bff2c38a23c12238$exports.jsx)((0, $9ab3f2b6023092d8$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=carvewizard.c0401f3c.js.map
